import { r as registerInstance, c as createEvent, h, g as getElement } from './index-1f3dee6a.js';
import { I as InsuredEvent, a as Insured } from './insured.model-bd113d5c.js';
import { K as KeyCodes } from './key-codes.util-aef31ac3.js';
import { D as DateInputMask } from './date-mask-38b93df1.js';

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, basedir, module) {
	return module = {
		path: basedir,
		exports: {},
		require: function (path, base) {
			return commonjsRequire();
		}
	}, fn(module, module.exports), module.exports;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var luxon = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, '__esModule', { value: true });

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// these aren't really private, but nor are they really useful to document

/**
 * @private
 */
var LuxonError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(LuxonError, _Error);

  function LuxonError() {
    return _Error.apply(this, arguments) || this;
  }

  return LuxonError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * @private
 */


var InvalidDateTimeError = /*#__PURE__*/function (_LuxonError) {
  _inheritsLoose(InvalidDateTimeError, _LuxonError);

  function InvalidDateTimeError(reason) {
    return _LuxonError.call(this, "Invalid DateTime: " + reason.toMessage()) || this;
  }

  return InvalidDateTimeError;
}(LuxonError);
/**
 * @private
 */

var InvalidIntervalError = /*#__PURE__*/function (_LuxonError2) {
  _inheritsLoose(InvalidIntervalError, _LuxonError2);

  function InvalidIntervalError(reason) {
    return _LuxonError2.call(this, "Invalid Interval: " + reason.toMessage()) || this;
  }

  return InvalidIntervalError;
}(LuxonError);
/**
 * @private
 */

var InvalidDurationError = /*#__PURE__*/function (_LuxonError3) {
  _inheritsLoose(InvalidDurationError, _LuxonError3);

  function InvalidDurationError(reason) {
    return _LuxonError3.call(this, "Invalid Duration: " + reason.toMessage()) || this;
  }

  return InvalidDurationError;
}(LuxonError);
/**
 * @private
 */

var ConflictingSpecificationError = /*#__PURE__*/function (_LuxonError4) {
  _inheritsLoose(ConflictingSpecificationError, _LuxonError4);

  function ConflictingSpecificationError() {
    return _LuxonError4.apply(this, arguments) || this;
  }

  return ConflictingSpecificationError;
}(LuxonError);
/**
 * @private
 */

var InvalidUnitError = /*#__PURE__*/function (_LuxonError5) {
  _inheritsLoose(InvalidUnitError, _LuxonError5);

  function InvalidUnitError(unit) {
    return _LuxonError5.call(this, "Invalid unit " + unit) || this;
  }

  return InvalidUnitError;
}(LuxonError);
/**
 * @private
 */

var InvalidArgumentError = /*#__PURE__*/function (_LuxonError6) {
  _inheritsLoose(InvalidArgumentError, _LuxonError6);

  function InvalidArgumentError() {
    return _LuxonError6.apply(this, arguments) || this;
  }

  return InvalidArgumentError;
}(LuxonError);
/**
 * @private
 */

var ZoneIsAbstractError = /*#__PURE__*/function (_LuxonError7) {
  _inheritsLoose(ZoneIsAbstractError, _LuxonError7);

  function ZoneIsAbstractError() {
    return _LuxonError7.call(this, "Zone is an abstract class") || this;
  }

  return ZoneIsAbstractError;
}(LuxonError);

/**
 * @private
 */
var n = "numeric",
    s = "short",
    l = "long";
var DATE_SHORT = {
  year: n,
  month: n,
  day: n
};
var DATE_MED = {
  year: n,
  month: s,
  day: n
};
var DATE_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s
};
var DATE_FULL = {
  year: n,
  month: l,
  day: n
};
var DATE_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l
};
var TIME_SIMPLE = {
  hour: n,
  minute: n
};
var TIME_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n
};
var TIME_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s
};
var TIME_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l
};
var TIME_24_SIMPLE = {
  hour: n,
  minute: n,
  hourCycle: "h23"
};
var TIME_24_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23"
};
var TIME_24_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: s
};
var TIME_24_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: l
};
var DATETIME_SHORT = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n
};
var DATETIME_SHORT_WITH_SECONDS = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n,
  second: n
};
var DATETIME_MED = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n
};
var DATETIME_MED_WITH_SECONDS = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n,
  second: n
};
var DATETIME_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s,
  hour: n,
  minute: n
};
var DATETIME_FULL = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  timeZoneName: s
};
var DATETIME_FULL_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s
};
var DATETIME_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  timeZoneName: l
};
var DATETIME_HUGE_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l
};

/**
 * @private
 */
// TYPES

function isUndefined(o) {
  return typeof o === "undefined";
}
function isNumber(o) {
  return typeof o === "number";
}
function isInteger(o) {
  return typeof o === "number" && o % 1 === 0;
}
function isString(o) {
  return typeof o === "string";
}
function isDate(o) {
  return Object.prototype.toString.call(o) === "[object Date]";
} // CAPABILITIES

function hasRelative() {
  try {
    return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
  } catch (e) {
    return false;
  }
} // OBJECTS AND ARRAYS

function maybeArray(thing) {
  return Array.isArray(thing) ? thing : [thing];
}
function bestBy(arr, by, compare) {
  if (arr.length === 0) {
    return undefined;
  }

  return arr.reduce(function (best, next) {
    var pair = [by(next), next];

    if (!best) {
      return pair;
    } else if (compare(best[0], pair[0]) === best[0]) {
      return best;
    } else {
      return pair;
    }
  }, null)[1];
}
function pick(obj, keys) {
  return keys.reduce(function (a, k) {
    a[k] = obj[k];
    return a;
  }, {});
}
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
} // NUMBERS AND STRINGS

function integerBetween(thing, bottom, top) {
  return isInteger(thing) && thing >= bottom && thing <= top;
} // x % n but takes the sign of n instead of x

function floorMod(x, n) {
  return x - n * Math.floor(x / n);
}
function padStart(input, n) {
  if (n === void 0) {
    n = 2;
  }

  var minus = input < 0 ? "-" : "";
  var target = minus ? input * -1 : input;
  var result;

  if (target.toString().length < n) {
    result = ("0".repeat(n) + target).slice(-n);
  } else {
    result = target.toString();
  }

  return "" + minus + result;
}
function parseInteger(string) {
  if (isUndefined(string) || string === null || string === "") {
    return undefined;
  } else {
    return parseInt(string, 10);
  }
}
function parseFloating(string) {
  if (isUndefined(string) || string === null || string === "") {
    return undefined;
  } else {
    return parseFloat(string);
  }
}
function parseMillis(fraction) {
  // Return undefined (instead of 0) in these cases, where fraction is not set
  if (isUndefined(fraction) || fraction === null || fraction === "") {
    return undefined;
  } else {
    var f = parseFloat("0." + fraction) * 1000;
    return Math.floor(f);
  }
}
function roundTo(number, digits, towardZero) {
  if (towardZero === void 0) {
    towardZero = false;
  }

  var factor = Math.pow(10, digits),
      rounder = towardZero ? Math.trunc : Math.round;
  return rounder(number * factor) / factor;
} // DATE BASICS

function isLeapYear(year) {
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function daysInYear(year) {
  return isLeapYear(year) ? 366 : 365;
}
function daysInMonth(year, month) {
  var modMonth = floorMod(month - 1, 12) + 1,
      modYear = year + (month - modMonth) / 12;

  if (modMonth === 2) {
    return isLeapYear(modYear) ? 29 : 28;
  } else {
    return [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][modMonth - 1];
  }
} // covert a calendar object to a local timestamp (epoch, but with the offset baked in)

function objToLocalTS(obj) {
  var d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond); // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that

  if (obj.year < 100 && obj.year >= 0) {
    d = new Date(d);
    d.setUTCFullYear(d.getUTCFullYear() - 1900);
  }

  return +d;
}
function weeksInWeekYear(weekYear) {
  var p1 = (weekYear + Math.floor(weekYear / 4) - Math.floor(weekYear / 100) + Math.floor(weekYear / 400)) % 7,
      last = weekYear - 1,
      p2 = (last + Math.floor(last / 4) - Math.floor(last / 100) + Math.floor(last / 400)) % 7;
  return p1 === 4 || p2 === 3 ? 53 : 52;
}
function untruncateYear(year) {
  if (year > 99) {
    return year;
  } else return year > 60 ? 1900 + year : 2000 + year;
} // PARSING

function parseZoneInfo(ts, offsetFormat, locale, timeZone) {
  if (timeZone === void 0) {
    timeZone = null;
  }

  var date = new Date(ts),
      intlOpts = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };

  if (timeZone) {
    intlOpts.timeZone = timeZone;
  }

  var modified = _extends({
    timeZoneName: offsetFormat
  }, intlOpts);

  var parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find(function (m) {
    return m.type.toLowerCase() === "timezonename";
  });
  return parsed ? parsed.value : null;
} // signedOffset('-5', '30') -> -330

function signedOffset(offHourStr, offMinuteStr) {
  var offHour = parseInt(offHourStr, 10); // don't || this because we want to preserve -0

  if (Number.isNaN(offHour)) {
    offHour = 0;
  }

  var offMin = parseInt(offMinuteStr, 10) || 0,
      offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
  return offHour * 60 + offMinSigned;
} // COERCION

function asNumber(value) {
  var numericValue = Number(value);
  if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue)) throw new InvalidArgumentError("Invalid unit value " + value);
  return numericValue;
}
function normalizeObject(obj, normalizer) {
  var normalized = {};

  for (var u in obj) {
    if (hasOwnProperty(obj, u)) {
      var v = obj[u];
      if (v === undefined || v === null) continue;
      normalized[normalizer(u)] = asNumber(v);
    }
  }

  return normalized;
}
function formatOffset(offset, format) {
  var hours = Math.trunc(Math.abs(offset / 60)),
      minutes = Math.trunc(Math.abs(offset % 60)),
      sign = offset >= 0 ? "+" : "-";

  switch (format) {
    case "short":
      return "" + sign + padStart(hours, 2) + ":" + padStart(minutes, 2);

    case "narrow":
      return "" + sign + hours + (minutes > 0 ? ":" + minutes : "");

    case "techie":
      return "" + sign + padStart(hours, 2) + padStart(minutes, 2);

    default:
      throw new RangeError("Value format " + format + " is out of range for property format");
  }
}
function timeObject(obj) {
  return pick(obj, ["hour", "minute", "second", "millisecond"]);
}
var ianaRegex = /[A-Za-z_+-]{1,256}(:?\/[A-Za-z0-9_+-]{1,256}(\/[A-Za-z0-9_+-]{1,256})?)?/;

/**
 * @private
 */


var monthsLong = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
var monthsShort = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
var monthsNarrow = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function months(length) {
  switch (length) {
    case "narrow":
      return [].concat(monthsNarrow);

    case "short":
      return [].concat(monthsShort);

    case "long":
      return [].concat(monthsLong);

    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];

    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];

    default:
      return null;
  }
}
var weekdaysLong = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
var weekdaysShort = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
var weekdaysNarrow = ["M", "T", "W", "T", "F", "S", "S"];
function weekdays(length) {
  switch (length) {
    case "narrow":
      return [].concat(weekdaysNarrow);

    case "short":
      return [].concat(weekdaysShort);

    case "long":
      return [].concat(weekdaysLong);

    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];

    default:
      return null;
  }
}
var meridiems = ["AM", "PM"];
var erasLong = ["Before Christ", "Anno Domini"];
var erasShort = ["BC", "AD"];
var erasNarrow = ["B", "A"];
function eras(length) {
  switch (length) {
    case "narrow":
      return [].concat(erasNarrow);

    case "short":
      return [].concat(erasShort);

    case "long":
      return [].concat(erasLong);

    default:
      return null;
  }
}
function meridiemForDateTime(dt) {
  return meridiems[dt.hour < 12 ? 0 : 1];
}
function weekdayForDateTime(dt, length) {
  return weekdays(length)[dt.weekday - 1];
}
function monthForDateTime(dt, length) {
  return months(length)[dt.month - 1];
}
function eraForDateTime(dt, length) {
  return eras(length)[dt.year < 0 ? 0 : 1];
}
function formatRelativeTime(unit, count, numeric, narrow) {
  if (numeric === void 0) {
    numeric = "always";
  }

  if (narrow === void 0) {
    narrow = false;
  }

  var units = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  };
  var lastable = ["hours", "minutes", "seconds"].indexOf(unit) === -1;

  if (numeric === "auto" && lastable) {
    var isDay = unit === "days";

    switch (count) {
      case 1:
        return isDay ? "tomorrow" : "next " + units[unit][0];

      case -1:
        return isDay ? "yesterday" : "last " + units[unit][0];

      case 0:
        return isDay ? "today" : "this " + units[unit][0];

    }
  }

  var isInPast = Object.is(count, -0) || count < 0,
      fmtValue = Math.abs(count),
      singular = fmtValue === 1,
      lilUnits = units[unit],
      fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
  return isInPast ? fmtValue + " " + fmtUnit + " ago" : "in " + fmtValue + " " + fmtUnit;
}

function stringifyTokens(splits, tokenToString) {
  var s = "";

  for (var _iterator = _createForOfIteratorHelperLoose(splits), _step; !(_step = _iterator()).done;) {
    var token = _step.value;

    if (token.literal) {
      s += token.val;
    } else {
      s += tokenToString(token.val);
    }
  }

  return s;
}

var _macroTokenToFormatOpts = {
  D: DATE_SHORT,
  DD: DATE_MED,
  DDD: DATE_FULL,
  DDDD: DATE_HUGE,
  t: TIME_SIMPLE,
  tt: TIME_WITH_SECONDS,
  ttt: TIME_WITH_SHORT_OFFSET,
  tttt: TIME_WITH_LONG_OFFSET,
  T: TIME_24_SIMPLE,
  TT: TIME_24_WITH_SECONDS,
  TTT: TIME_24_WITH_SHORT_OFFSET,
  TTTT: TIME_24_WITH_LONG_OFFSET,
  f: DATETIME_SHORT,
  ff: DATETIME_MED,
  fff: DATETIME_FULL,
  ffff: DATETIME_HUGE,
  F: DATETIME_SHORT_WITH_SECONDS,
  FF: DATETIME_MED_WITH_SECONDS,
  FFF: DATETIME_FULL_WITH_SECONDS,
  FFFF: DATETIME_HUGE_WITH_SECONDS
};
/**
 * @private
 */

var Formatter = /*#__PURE__*/function () {
  Formatter.create = function create(locale, opts) {
    if (opts === void 0) {
      opts = {};
    }

    return new Formatter(locale, opts);
  };

  Formatter.parseFormat = function parseFormat(fmt) {
    var current = null,
        currentFull = "",
        bracketed = false;
    var splits = [];

    for (var i = 0; i < fmt.length; i++) {
      var c = fmt.charAt(i);

      if (c === "'") {
        if (currentFull.length > 0) {
          splits.push({
            literal: bracketed,
            val: currentFull
          });
        }

        current = null;
        currentFull = "";
        bracketed = !bracketed;
      } else if (bracketed) {
        currentFull += c;
      } else if (c === current) {
        currentFull += c;
      } else {
        if (currentFull.length > 0) {
          splits.push({
            literal: false,
            val: currentFull
          });
        }

        currentFull = c;
        current = c;
      }
    }

    if (currentFull.length > 0) {
      splits.push({
        literal: bracketed,
        val: currentFull
      });
    }

    return splits;
  };

  Formatter.macroTokenToFormatOpts = function macroTokenToFormatOpts(token) {
    return _macroTokenToFormatOpts[token];
  };

  function Formatter(locale, formatOpts) {
    this.opts = formatOpts;
    this.loc = locale;
    this.systemLoc = null;
  }

  var _proto = Formatter.prototype;

  _proto.formatWithSystemDefault = function formatWithSystemDefault(dt, opts) {
    if (this.systemLoc === null) {
      this.systemLoc = this.loc.redefaultToSystem();
    }

    var df = this.systemLoc.dtFormatter(dt, _extends({}, this.opts, opts));
    return df.format();
  };

  _proto.formatDateTime = function formatDateTime(dt, opts) {
    if (opts === void 0) {
      opts = {};
    }

    var df = this.loc.dtFormatter(dt, _extends({}, this.opts, opts));
    return df.format();
  };

  _proto.formatDateTimeParts = function formatDateTimeParts(dt, opts) {
    if (opts === void 0) {
      opts = {};
    }

    var df = this.loc.dtFormatter(dt, _extends({}, this.opts, opts));
    return df.formatToParts();
  };

  _proto.resolvedOptions = function resolvedOptions(dt, opts) {
    if (opts === void 0) {
      opts = {};
    }

    var df = this.loc.dtFormatter(dt, _extends({}, this.opts, opts));
    return df.resolvedOptions();
  };

  _proto.num = function num(n, p) {
    if (p === void 0) {
      p = 0;
    }

    // we get some perf out of doing this here, annoyingly
    if (this.opts.forceSimple) {
      return padStart(n, p);
    }

    var opts = _extends({}, this.opts);

    if (p > 0) {
      opts.padTo = p;
    }

    return this.loc.numberFormatter(opts).format(n);
  };

  _proto.formatDateTimeFromString = function formatDateTimeFromString(dt, fmt) {
    var _this = this;

    var knownEnglish = this.loc.listingMode() === "en",
        useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory",
        string = function string(opts, extract) {
      return _this.loc.extract(dt, opts, extract);
    },
        formatOffset = function formatOffset(opts) {
      if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) {
        return "Z";
      }

      return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
    },
        meridiem = function meridiem() {
      return knownEnglish ? meridiemForDateTime(dt) : string({
        hour: "numeric",
        hourCycle: "h12"
      }, "dayperiod");
    },
        month = function month(length, standalone) {
      return knownEnglish ? monthForDateTime(dt, length) : string(standalone ? {
        month: length
      } : {
        month: length,
        day: "numeric"
      }, "month");
    },
        weekday = function weekday(length, standalone) {
      return knownEnglish ? weekdayForDateTime(dt, length) : string(standalone ? {
        weekday: length
      } : {
        weekday: length,
        month: "long",
        day: "numeric"
      }, "weekday");
    },
        maybeMacro = function maybeMacro(token) {
      var formatOpts = Formatter.macroTokenToFormatOpts(token);

      if (formatOpts) {
        return _this.formatWithSystemDefault(dt, formatOpts);
      } else {
        return token;
      }
    },
        era = function era(length) {
      return knownEnglish ? eraForDateTime(dt, length) : string({
        era: length
      }, "era");
    },
        tokenToString = function tokenToString(token) {
      // Where possible: http://cldr.unicode.org/translation/date-time-1/date-time#TOC-Standalone-vs.-Format-Styles
      switch (token) {
        // ms
        case "S":
          return _this.num(dt.millisecond);

        case "u": // falls through

        case "SSS":
          return _this.num(dt.millisecond, 3);
        // seconds

        case "s":
          return _this.num(dt.second);

        case "ss":
          return _this.num(dt.second, 2);
        // fractional seconds

        case "uu":
          return _this.num(Math.floor(dt.millisecond / 10), 2);

        case "uuu":
          return _this.num(Math.floor(dt.millisecond / 100));
        // minutes

        case "m":
          return _this.num(dt.minute);

        case "mm":
          return _this.num(dt.minute, 2);
        // hours

        case "h":
          return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);

        case "hh":
          return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);

        case "H":
          return _this.num(dt.hour);

        case "HH":
          return _this.num(dt.hour, 2);
        // offset

        case "Z":
          // like +6
          return formatOffset({
            format: "narrow",
            allowZ: _this.opts.allowZ
          });

        case "ZZ":
          // like +06:00
          return formatOffset({
            format: "short",
            allowZ: _this.opts.allowZ
          });

        case "ZZZ":
          // like +0600
          return formatOffset({
            format: "techie",
            allowZ: _this.opts.allowZ
          });

        case "ZZZZ":
          // like EST
          return dt.zone.offsetName(dt.ts, {
            format: "short",
            locale: _this.loc.locale
          });

        case "ZZZZZ":
          // like Eastern Standard Time
          return dt.zone.offsetName(dt.ts, {
            format: "long",
            locale: _this.loc.locale
          });
        // zone

        case "z":
          // like America/New_York
          return dt.zoneName;
        // meridiems

        case "a":
          return meridiem();
        // dates

        case "d":
          return useDateTimeFormatter ? string({
            day: "numeric"
          }, "day") : _this.num(dt.day);

        case "dd":
          return useDateTimeFormatter ? string({
            day: "2-digit"
          }, "day") : _this.num(dt.day, 2);
        // weekdays - standalone

        case "c":
          // like 1
          return _this.num(dt.weekday);

        case "ccc":
          // like 'Tues'
          return weekday("short", true);

        case "cccc":
          // like 'Tuesday'
          return weekday("long", true);

        case "ccccc":
          // like 'T'
          return weekday("narrow", true);
        // weekdays - format

        case "E":
          // like 1
          return _this.num(dt.weekday);

        case "EEE":
          // like 'Tues'
          return weekday("short", false);

        case "EEEE":
          // like 'Tuesday'
          return weekday("long", false);

        case "EEEEE":
          // like 'T'
          return weekday("narrow", false);
        // months - standalone

        case "L":
          // like 1
          return useDateTimeFormatter ? string({
            month: "numeric",
            day: "numeric"
          }, "month") : _this.num(dt.month);

        case "LL":
          // like 01, doesn't seem to work
          return useDateTimeFormatter ? string({
            month: "2-digit",
            day: "numeric"
          }, "month") : _this.num(dt.month, 2);

        case "LLL":
          // like Jan
          return month("short", true);

        case "LLLL":
          // like January
          return month("long", true);

        case "LLLLL":
          // like J
          return month("narrow", true);
        // months - format

        case "M":
          // like 1
          return useDateTimeFormatter ? string({
            month: "numeric"
          }, "month") : _this.num(dt.month);

        case "MM":
          // like 01
          return useDateTimeFormatter ? string({
            month: "2-digit"
          }, "month") : _this.num(dt.month, 2);

        case "MMM":
          // like Jan
          return month("short", false);

        case "MMMM":
          // like January
          return month("long", false);

        case "MMMMM":
          // like J
          return month("narrow", false);
        // years

        case "y":
          // like 2014
          return useDateTimeFormatter ? string({
            year: "numeric"
          }, "year") : _this.num(dt.year);

        case "yy":
          // like 14
          return useDateTimeFormatter ? string({
            year: "2-digit"
          }, "year") : _this.num(dt.year.toString().slice(-2), 2);

        case "yyyy":
          // like 0012
          return useDateTimeFormatter ? string({
            year: "numeric"
          }, "year") : _this.num(dt.year, 4);

        case "yyyyyy":
          // like 000012
          return useDateTimeFormatter ? string({
            year: "numeric"
          }, "year") : _this.num(dt.year, 6);
        // eras

        case "G":
          // like AD
          return era("short");

        case "GG":
          // like Anno Domini
          return era("long");

        case "GGGGG":
          return era("narrow");

        case "kk":
          return _this.num(dt.weekYear.toString().slice(-2), 2);

        case "kkkk":
          return _this.num(dt.weekYear, 4);

        case "W":
          return _this.num(dt.weekNumber);

        case "WW":
          return _this.num(dt.weekNumber, 2);

        case "o":
          return _this.num(dt.ordinal);

        case "ooo":
          return _this.num(dt.ordinal, 3);

        case "q":
          // like 1
          return _this.num(dt.quarter);

        case "qq":
          // like 01
          return _this.num(dt.quarter, 2);

        case "X":
          return _this.num(Math.floor(dt.ts / 1000));

        case "x":
          return _this.num(dt.ts);

        default:
          return maybeMacro(token);
      }
    };

    return stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
  };

  _proto.formatDurationFromString = function formatDurationFromString(dur, fmt) {
    var _this2 = this;

    var tokenToField = function tokenToField(token) {
      switch (token[0]) {
        case "S":
          return "millisecond";

        case "s":
          return "second";

        case "m":
          return "minute";

        case "h":
          return "hour";

        case "d":
          return "day";

        case "M":
          return "month";

        case "y":
          return "year";

        default:
          return null;
      }
    },
        tokenToString = function tokenToString(lildur) {
      return function (token) {
        var mapped = tokenToField(token);

        if (mapped) {
          return _this2.num(lildur.get(mapped), token.length);
        } else {
          return token;
        }
      };
    },
        tokens = Formatter.parseFormat(fmt),
        realTokens = tokens.reduce(function (found, _ref) {
      var literal = _ref.literal,
          val = _ref.val;
      return literal ? found : found.concat(val);
    }, []),
        collapsed = dur.shiftTo.apply(dur, realTokens.map(tokenToField).filter(function (t) {
      return t;
    }));

    return stringifyTokens(tokens, tokenToString(collapsed));
  };

  return Formatter;
}();

var Invalid = /*#__PURE__*/function () {
  function Invalid(reason, explanation) {
    this.reason = reason;
    this.explanation = explanation;
  }

  var _proto = Invalid.prototype;

  _proto.toMessage = function toMessage() {
    if (this.explanation) {
      return this.reason + ": " + this.explanation;
    } else {
      return this.reason;
    }
  };

  return Invalid;
}();

/**
 * @interface
 */

var Zone = /*#__PURE__*/function () {
  function Zone() {}

  var _proto = Zone.prototype;

  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  _proto.offsetName = function offsetName(ts, opts) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  ;

  _proto.formatOffset = function formatOffset(ts, format) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  ;

  _proto.offset = function offset(ts) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  ;

  _proto.equals = function equals(otherZone) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  ;

  _createClass(Zone, [{
    key: "type",
    get:
    /**
     * The type of zone
     * @abstract
     * @type {string}
     */
    function get() {
      throw new ZoneIsAbstractError();
    }
    /**
     * The name of this zone.
     * @abstract
     * @type {string}
     */

  }, {
    key: "name",
    get: function get() {
      throw new ZoneIsAbstractError();
    }
    /**
     * Returns whether the offset is known to be fixed for the whole year.
     * @abstract
     * @type {boolean}
     */

  }, {
    key: "isUniversal",
    get: function get() {
      throw new ZoneIsAbstractError();
    }
  }, {
    key: "isValid",
    get: function get() {
      throw new ZoneIsAbstractError();
    }
  }]);

  return Zone;
}();

var singleton$1 = null;
/**
 * Represents the local zone for this JavaScript environment.
 * @implements {Zone}
 */

var SystemZone = /*#__PURE__*/function (_Zone) {
  _inheritsLoose(SystemZone, _Zone);

  function SystemZone() {
    return _Zone.apply(this, arguments) || this;
  }

  var _proto = SystemZone.prototype;

  /** @override **/
  _proto.offsetName = function offsetName(ts, _ref) {
    var format = _ref.format,
        locale = _ref.locale;
    return parseZoneInfo(ts, format, locale);
  }
  /** @override **/
  ;

  _proto.formatOffset = function formatOffset$1(ts, format) {
    return formatOffset(this.offset(ts), format);
  }
  /** @override **/
  ;

  _proto.offset = function offset(ts) {
    return -new Date(ts).getTimezoneOffset();
  }
  /** @override **/
  ;

  _proto.equals = function equals(otherZone) {
    return otherZone.type === "system";
  }
  /** @override **/
  ;

  _createClass(SystemZone, [{
    key: "type",
    get:
    /** @override **/
    function get() {
      return "system";
    }
    /** @override **/

  }, {
    key: "name",
    get: function get() {
      return new Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    /** @override **/

  }, {
    key: "isUniversal",
    get: function get() {
      return false;
    }
  }, {
    key: "isValid",
    get: function get() {
      return true;
    }
  }], [{
    key: "instance",
    get:
    /**
     * Get a singleton instance of the local zone
     * @return {SystemZone}
     */
    function get() {
      if (singleton$1 === null) {
        singleton$1 = new SystemZone();
      }

      return singleton$1;
    }
  }]);

  return SystemZone;
}(Zone);

var matchingRegex = RegExp("^" + ianaRegex.source + "$");
var dtfCache = {};

function makeDTF(zone) {
  if (!dtfCache[zone]) {
    dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
      hour12: false,
      timeZone: zone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }

  return dtfCache[zone];
}

var typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};

function hackyOffset(dtf, date) {
  var formatted = dtf.format(date).replace(/\u200E/g, ""),
      parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted),
      fMonth = parsed[1],
      fDay = parsed[2],
      fYear = parsed[3],
      fHour = parsed[4],
      fMinute = parsed[5],
      fSecond = parsed[6];
  return [fYear, fMonth, fDay, fHour, fMinute, fSecond];
}

function partsOffset(dtf, date) {
  var formatted = dtf.formatToParts(date),
      filled = [];

  for (var i = 0; i < formatted.length; i++) {
    var _formatted$i = formatted[i],
        type = _formatted$i.type,
        value = _formatted$i.value,
        pos = typeToPos[type];

    if (!isUndefined(pos)) {
      filled[pos] = parseInt(value, 10);
    }
  }

  return filled;
}

var ianaZoneCache = {};
/**
 * A zone identified by an IANA identifier, like America/New_York
 * @implements {Zone}
 */

var IANAZone = /*#__PURE__*/function (_Zone) {
  _inheritsLoose(IANAZone, _Zone);

  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  IANAZone.create = function create(name) {
    if (!ianaZoneCache[name]) {
      ianaZoneCache[name] = new IANAZone(name);
    }

    return ianaZoneCache[name];
  }
  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  ;

  IANAZone.resetCache = function resetCache() {
    ianaZoneCache = {};
    dtfCache = {};
  }
  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Fantasia/Castle") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @return {boolean}
   */
  ;

  IANAZone.isValidSpecifier = function isValidSpecifier(s) {
    return !!(s && s.match(matchingRegex));
  }
  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  ;

  IANAZone.isValidZone = function isValidZone(zone) {
    if (!zone) {
      return false;
    }

    try {
      new Intl.DateTimeFormat("en-US", {
        timeZone: zone
      }).format();
      return true;
    } catch (e) {
      return false;
    }
  };

  function IANAZone(name) {
    var _this;

    _this = _Zone.call(this) || this;
    /** @private **/

    _this.zoneName = name;
    /** @private **/

    _this.valid = IANAZone.isValidZone(name);
    return _this;
  }
  /** @override **/


  var _proto = IANAZone.prototype;

  /** @override **/
  _proto.offsetName = function offsetName(ts, _ref) {
    var format = _ref.format,
        locale = _ref.locale;
    return parseZoneInfo(ts, format, locale, this.name);
  }
  /** @override **/
  ;

  _proto.formatOffset = function formatOffset$1(ts, format) {
    return formatOffset(this.offset(ts), format);
  }
  /** @override **/
  ;

  _proto.offset = function offset(ts) {
    var date = new Date(ts);
    if (isNaN(date)) return NaN;

    var dtf = makeDTF(this.name),
        _ref2 = dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date),
        year = _ref2[0],
        month = _ref2[1],
        day = _ref2[2],
        hour = _ref2[3],
        minute = _ref2[4],
        second = _ref2[5]; // because we're using hour12 and https://bugs.chromium.org/p/chromium/issues/detail?id=1025564&can=2&q=%2224%3A00%22%20datetimeformat


    var adjustedHour = hour === 24 ? 0 : hour;
    var asUTC = objToLocalTS({
      year: year,
      month: month,
      day: day,
      hour: adjustedHour,
      minute: minute,
      second: second,
      millisecond: 0
    });
    var asTS = +date;
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return (asUTC - asTS) / (60 * 1000);
  }
  /** @override **/
  ;

  _proto.equals = function equals(otherZone) {
    return otherZone.type === "iana" && otherZone.name === this.name;
  }
  /** @override **/
  ;

  _createClass(IANAZone, [{
    key: "type",
    get: function get() {
      return "iana";
    }
    /** @override **/

  }, {
    key: "name",
    get: function get() {
      return this.zoneName;
    }
    /** @override **/

  }, {
    key: "isUniversal",
    get: function get() {
      return false;
    }
  }, {
    key: "isValid",
    get: function get() {
      return this.valid;
    }
  }]);

  return IANAZone;
}(Zone);

var singleton = null;
/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */

var FixedOffsetZone = /*#__PURE__*/function (_Zone) {
  _inheritsLoose(FixedOffsetZone, _Zone);

  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  FixedOffsetZone.instance = function instance(offset) {
    return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
  }
  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  ;

  FixedOffsetZone.parseSpecifier = function parseSpecifier(s) {
    if (s) {
      var r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);

      if (r) {
        return new FixedOffsetZone(signedOffset(r[1], r[2]));
      }
    }

    return null;
  };

  function FixedOffsetZone(offset) {
    var _this;

    _this = _Zone.call(this) || this;
    /** @private **/

    _this.fixed = offset;
    return _this;
  }
  /** @override **/


  var _proto = FixedOffsetZone.prototype;

  /** @override **/
  _proto.offsetName = function offsetName() {
    return this.name;
  }
  /** @override **/
  ;

  _proto.formatOffset = function formatOffset$1(ts, format) {
    return formatOffset(this.fixed, format);
  }
  /** @override **/
  ;

  /** @override **/
  _proto.offset = function offset() {
    return this.fixed;
  }
  /** @override **/
  ;

  _proto.equals = function equals(otherZone) {
    return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
  }
  /** @override **/
  ;

  _createClass(FixedOffsetZone, [{
    key: "type",
    get: function get() {
      return "fixed";
    }
    /** @override **/

  }, {
    key: "name",
    get: function get() {
      return this.fixed === 0 ? "UTC" : "UTC" + formatOffset(this.fixed, "narrow");
    }
  }, {
    key: "isUniversal",
    get: function get() {
      return true;
    }
  }, {
    key: "isValid",
    get: function get() {
      return true;
    }
  }], [{
    key: "utcInstance",
    get:
    /**
     * Get a singleton instance of UTC
     * @return {FixedOffsetZone}
     */
    function get() {
      if (singleton === null) {
        singleton = new FixedOffsetZone(0);
      }

      return singleton;
    }
  }]);

  return FixedOffsetZone;
}(Zone);

/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */

var InvalidZone = /*#__PURE__*/function (_Zone) {
  _inheritsLoose(InvalidZone, _Zone);

  function InvalidZone(zoneName) {
    var _this;

    _this = _Zone.call(this) || this;
    /**  @private */

    _this.zoneName = zoneName;
    return _this;
  }
  /** @override **/


  var _proto = InvalidZone.prototype;

  /** @override **/
  _proto.offsetName = function offsetName() {
    return null;
  }
  /** @override **/
  ;

  _proto.formatOffset = function formatOffset() {
    return "";
  }
  /** @override **/
  ;

  _proto.offset = function offset() {
    return NaN;
  }
  /** @override **/
  ;

  _proto.equals = function equals() {
    return false;
  }
  /** @override **/
  ;

  _createClass(InvalidZone, [{
    key: "type",
    get: function get() {
      return "invalid";
    }
    /** @override **/

  }, {
    key: "name",
    get: function get() {
      return this.zoneName;
    }
    /** @override **/

  }, {
    key: "isUniversal",
    get: function get() {
      return false;
    }
  }, {
    key: "isValid",
    get: function get() {
      return false;
    }
  }]);

  return InvalidZone;
}(Zone);

/**
 * @private
 */
function normalizeZone(input, defaultZone) {

  if (isUndefined(input) || input === null) {
    return defaultZone;
  } else if (input instanceof Zone) {
    return input;
  } else if (isString(input)) {
    var lowered = input.toLowerCase();
    if (lowered === "local" || lowered === "system") return defaultZone;else if (lowered === "utc" || lowered === "gmt") return FixedOffsetZone.utcInstance;else if (IANAZone.isValidSpecifier(lowered)) return IANAZone.create(input);else return FixedOffsetZone.parseSpecifier(lowered) || new InvalidZone(input);
  } else if (isNumber(input)) {
    return FixedOffsetZone.instance(input);
  } else if (typeof input === "object" && input.offset && typeof input.offset === "number") {
    // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
  } else {
    return new InvalidZone(input);
  }
}

var now = function now() {
  return Date.now();
},
    defaultZone = "system",
    defaultLocale = null,
    defaultNumberingSystem = null,
    defaultOutputCalendar = null,
    throwOnInvalid;
/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */


var Settings = /*#__PURE__*/function () {
  function Settings() {}

  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  Settings.resetCaches = function resetCaches() {
    Locale.resetCache();
    IANAZone.resetCache();
  };

  _createClass(Settings, null, [{
    key: "now",
    get:
    /**
     * Get the callback for returning the current timestamp.
     * @type {function}
     */
    function get() {
      return now;
    }
    /**
     * Set the callback for returning the current timestamp.
     * The function should return a number, which will be interpreted as an Epoch millisecond count
     * @type {function}
     * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
     * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
     */
    ,
    set: function set(n) {
      now = n;
    }
    /**
     * Set the default time zone to create DateTimes in. Does not affect existing instances.
     * Use the value "system" to reset this value to the system's time zone.
     * @type {string}
     */

  }, {
    key: "defaultZone",
    get:
    /**
     * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
     * The default value is the system's time zone (the one set on the machine that runs this code).
     * @type {Zone}
     */
    function get() {
      return normalizeZone(defaultZone, SystemZone.instance);
    }
    /**
     * Get the default locale to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */
    ,
    set: function set(zone) {
      defaultZone = zone;
    }
  }, {
    key: "defaultLocale",
    get: function get() {
      return defaultLocale;
    }
    /**
     * Set the default locale to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */
    ,
    set: function set(locale) {
      defaultLocale = locale;
    }
    /**
     * Get the default numbering system to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */

  }, {
    key: "defaultNumberingSystem",
    get: function get() {
      return defaultNumberingSystem;
    }
    /**
     * Set the default numbering system to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */
    ,
    set: function set(numberingSystem) {
      defaultNumberingSystem = numberingSystem;
    }
    /**
     * Get the default output calendar to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */

  }, {
    key: "defaultOutputCalendar",
    get: function get() {
      return defaultOutputCalendar;
    }
    /**
     * Set the default output calendar to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */
    ,
    set: function set(outputCalendar) {
      defaultOutputCalendar = outputCalendar;
    }
    /**
     * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
     * @type {boolean}
     */

  }, {
    key: "throwOnInvalid",
    get: function get() {
      return throwOnInvalid;
    }
    /**
     * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
     * @type {boolean}
     */
    ,
    set: function set(t) {
      throwOnInvalid = t;
    }
  }]);

  return Settings;
}();

var _excluded = ["base"];
var intlDTCache = {};

function getCachedDTF(locString, opts) {
  if (opts === void 0) {
    opts = {};
  }

  var key = JSON.stringify([locString, opts]);
  var dtf = intlDTCache[key];

  if (!dtf) {
    dtf = new Intl.DateTimeFormat(locString, opts);
    intlDTCache[key] = dtf;
  }

  return dtf;
}

var intlNumCache = {};

function getCachedINF(locString, opts) {
  if (opts === void 0) {
    opts = {};
  }

  var key = JSON.stringify([locString, opts]);
  var inf = intlNumCache[key];

  if (!inf) {
    inf = new Intl.NumberFormat(locString, opts);
    intlNumCache[key] = inf;
  }

  return inf;
}

var intlRelCache = {};

function getCachedRTF(locString, opts) {
  if (opts === void 0) {
    opts = {};
  }

  var _opts = opts;
      var cacheKeyOpts = _objectWithoutPropertiesLoose(_opts, _excluded); // exclude `base` from the options


  var key = JSON.stringify([locString, cacheKeyOpts]);
  var inf = intlRelCache[key];

  if (!inf) {
    inf = new Intl.RelativeTimeFormat(locString, opts);
    intlRelCache[key] = inf;
  }

  return inf;
}

var sysLocaleCache = null;

function systemLocale() {
  if (sysLocaleCache) {
    return sysLocaleCache;
  } else {
    sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
    return sysLocaleCache;
  }
}

function parseLocaleString(localeStr) {
  // I really want to avoid writing a BCP 47 parser
  // see, e.g. https://github.com/wooorm/bcp-47
  // Instead, we'll do this:
  // a) if the string has no -u extensions, just leave it alone
  // b) if it does, use Intl to resolve everything
  // c) if Intl fails, try again without the -u
  var uIndex = localeStr.indexOf("-u-");

  if (uIndex === -1) {
    return [localeStr];
  } else {
    var options;
    var smaller = localeStr.substring(0, uIndex);

    try {
      options = getCachedDTF(localeStr).resolvedOptions();
    } catch (e) {
      options = getCachedDTF(smaller).resolvedOptions();
    }

    var _options = options,
        numberingSystem = _options.numberingSystem,
        calendar = _options.calendar; // return the smaller one so that we can append the calendar and numbering overrides to it

    return [smaller, numberingSystem, calendar];
  }
}

function intlConfigString(localeStr, numberingSystem, outputCalendar) {
  if (outputCalendar || numberingSystem) {
    localeStr += "-u";

    if (outputCalendar) {
      localeStr += "-ca-" + outputCalendar;
    }

    if (numberingSystem) {
      localeStr += "-nu-" + numberingSystem;
    }

    return localeStr;
  } else {
    return localeStr;
  }
}

function mapMonths(f) {
  var ms = [];

  for (var i = 1; i <= 12; i++) {
    var dt = DateTime.utc(2016, i, 1);
    ms.push(f(dt));
  }

  return ms;
}

function mapWeekdays(f) {
  var ms = [];

  for (var i = 1; i <= 7; i++) {
    var dt = DateTime.utc(2016, 11, 13 + i);
    ms.push(f(dt));
  }

  return ms;
}

function listStuff(loc, length, defaultOK, englishFn, intlFn) {
  var mode = loc.listingMode(defaultOK);

  if (mode === "error") {
    return null;
  } else if (mode === "en") {
    return englishFn(length);
  } else {
    return intlFn(length);
  }
}

function supportsFastNumbers(loc) {
  if (loc.numberingSystem && loc.numberingSystem !== "latn") {
    return false;
  } else {
    return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || new Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn";
  }
}
/**
 * @private
 */


var PolyNumberFormatter = /*#__PURE__*/function () {
  function PolyNumberFormatter(intl, forceSimple, opts) {
    this.padTo = opts.padTo || 0;
    this.floor = opts.floor || false;

    if (!forceSimple) {
      var intlOpts = {
        useGrouping: false
      };
      if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
      this.inf = getCachedINF(intl, intlOpts);
    }
  }

  var _proto = PolyNumberFormatter.prototype;

  _proto.format = function format(i) {
    if (this.inf) {
      var fixed = this.floor ? Math.floor(i) : i;
      return this.inf.format(fixed);
    } else {
      // to match the browser's numberformatter defaults
      var _fixed = this.floor ? Math.floor(i) : roundTo(i, 3);

      return padStart(_fixed, this.padTo);
    }
  };

  return PolyNumberFormatter;
}();
/**
 * @private
 */


var PolyDateFormatter = /*#__PURE__*/function () {
  function PolyDateFormatter(dt, intl, opts) {
    this.opts = opts;
    var z;

    if (dt.zone.isUniversal) {
      // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
      // That is why fixed-offset TZ is set to that unless it is:
      // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
      // 2. Unsupported by the browser:
      //    - some do not support Etc/
      //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
      var gmtOffset = -1 * (dt.offset / 60);
      var offsetZ = gmtOffset >= 0 ? "Etc/GMT+" + gmtOffset : "Etc/GMT" + gmtOffset;

      if (dt.offset !== 0 && IANAZone.create(offsetZ).valid) {
        z = offsetZ;
        this.dt = dt;
      } else {
        // Not all fixed-offset zones like Etc/+4:30 are present in tzdata.
        // So we have to make do. Two cases:
        // 1. The format options tell us to show the zone. We can't do that, so the best
        // we can do is format the date in UTC.
        // 2. The format options don't tell us to show the zone. Then we can adjust them
        // the time and tell the formatter to show it to us in UTC, so that the time is right
        // and the bad zone doesn't show up.
        z = "UTC";

        if (opts.timeZoneName) {
          this.dt = dt;
        } else {
          this.dt = dt.offset === 0 ? dt : DateTime.fromMillis(dt.ts + dt.offset * 60 * 1000);
        }
      }
    } else if (dt.zone.type === "system") {
      this.dt = dt;
    } else {
      this.dt = dt;
      z = dt.zone.name;
    }

    var intlOpts = _extends({}, this.opts);

    if (z) {
      intlOpts.timeZone = z;
    }

    this.dtf = getCachedDTF(intl, intlOpts);
  }

  var _proto2 = PolyDateFormatter.prototype;

  _proto2.format = function format() {
    return this.dtf.format(this.dt.toJSDate());
  };

  _proto2.formatToParts = function formatToParts() {
    return this.dtf.formatToParts(this.dt.toJSDate());
  };

  _proto2.resolvedOptions = function resolvedOptions() {
    return this.dtf.resolvedOptions();
  };

  return PolyDateFormatter;
}();
/**
 * @private
 */


var PolyRelFormatter = /*#__PURE__*/function () {
  function PolyRelFormatter(intl, isEnglish, opts) {
    this.opts = _extends({
      style: "long"
    }, opts);

    if (!isEnglish && hasRelative()) {
      this.rtf = getCachedRTF(intl, opts);
    }
  }

  var _proto3 = PolyRelFormatter.prototype;

  _proto3.format = function format(count, unit) {
    if (this.rtf) {
      return this.rtf.format(count, unit);
    } else {
      return formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    }
  };

  _proto3.formatToParts = function formatToParts(count, unit) {
    if (this.rtf) {
      return this.rtf.formatToParts(count, unit);
    } else {
      return [];
    }
  };

  return PolyRelFormatter;
}();
/**
 * @private
 */


var Locale = /*#__PURE__*/function () {
  Locale.fromOpts = function fromOpts(opts) {
    return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.defaultToEN);
  };

  Locale.create = function create(locale, numberingSystem, outputCalendar, defaultToEN) {
    if (defaultToEN === void 0) {
      defaultToEN = false;
    }

    var specifiedLocale = locale || Settings.defaultLocale; // the system locale is useful for human readable strings but annoying for parsing/formatting known formats

    var localeR = specifiedLocale || (defaultToEN ? "en-US" : systemLocale());
    var numberingSystemR = numberingSystem || Settings.defaultNumberingSystem;
    var outputCalendarR = outputCalendar || Settings.defaultOutputCalendar;
    return new Locale(localeR, numberingSystemR, outputCalendarR, specifiedLocale);
  };

  Locale.resetCache = function resetCache() {
    sysLocaleCache = null;
    intlDTCache = {};
    intlNumCache = {};
    intlRelCache = {};
  };

  Locale.fromObject = function fromObject(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        locale = _ref.locale,
        numberingSystem = _ref.numberingSystem,
        outputCalendar = _ref.outputCalendar;

    return Locale.create(locale, numberingSystem, outputCalendar);
  };

  function Locale(locale, numbering, outputCalendar, specifiedLocale) {
    var _parseLocaleString = parseLocaleString(locale),
        parsedLocale = _parseLocaleString[0],
        parsedNumberingSystem = _parseLocaleString[1],
        parsedOutputCalendar = _parseLocaleString[2];

    this.locale = parsedLocale;
    this.numberingSystem = numbering || parsedNumberingSystem || null;
    this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
    this.intl = intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
    this.weekdaysCache = {
      format: {},
      standalone: {}
    };
    this.monthsCache = {
      format: {},
      standalone: {}
    };
    this.meridiemCache = null;
    this.eraCache = {};
    this.specifiedLocale = specifiedLocale;
    this.fastNumbersCached = null;
  }

  var _proto4 = Locale.prototype;

  _proto4.listingMode = function listingMode(defaultOK) {

    var isActuallyEn = this.isEnglish();
    var hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return isActuallyEn && hasNoWeirdness ? "en" : "intl";
  };

  _proto4.clone = function clone(alts) {
    if (!alts || Object.getOwnPropertyNames(alts).length === 0) {
      return this;
    } else {
      return Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, alts.defaultToEN || false);
    }
  };

  _proto4.redefaultToEN = function redefaultToEN(alts) {
    if (alts === void 0) {
      alts = {};
    }

    return this.clone(_extends({}, alts, {
      defaultToEN: true
    }));
  };

  _proto4.redefaultToSystem = function redefaultToSystem(alts) {
    if (alts === void 0) {
      alts = {};
    }

    return this.clone(_extends({}, alts, {
      defaultToEN: false
    }));
  };

  _proto4.months = function months$1(length, format, defaultOK) {
    var _this = this;

    if (format === void 0) {
      format = false;
    }

    if (defaultOK === void 0) {
      defaultOK = true;
    }

    return listStuff(this, length, defaultOK, months, function () {
      var intl = format ? {
        month: length,
        day: "numeric"
      } : {
        month: length
      },
          formatStr = format ? "format" : "standalone";

      if (!_this.monthsCache[formatStr][length]) {
        _this.monthsCache[formatStr][length] = mapMonths(function (dt) {
          return _this.extract(dt, intl, "month");
        });
      }

      return _this.monthsCache[formatStr][length];
    });
  };

  _proto4.weekdays = function weekdays$1(length, format, defaultOK) {
    var _this2 = this;

    if (format === void 0) {
      format = false;
    }

    if (defaultOK === void 0) {
      defaultOK = true;
    }

    return listStuff(this, length, defaultOK, weekdays, function () {
      var intl = format ? {
        weekday: length,
        year: "numeric",
        month: "long",
        day: "numeric"
      } : {
        weekday: length
      },
          formatStr = format ? "format" : "standalone";

      if (!_this2.weekdaysCache[formatStr][length]) {
        _this2.weekdaysCache[formatStr][length] = mapWeekdays(function (dt) {
          return _this2.extract(dt, intl, "weekday");
        });
      }

      return _this2.weekdaysCache[formatStr][length];
    });
  };

  _proto4.meridiems = function meridiems$1(defaultOK) {
    var _this3 = this;

    if (defaultOK === void 0) {
      defaultOK = true;
    }

    return listStuff(this, undefined, defaultOK, function () {
      return meridiems;
    }, function () {
      // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
      // for AM and PM. This is probably wrong, but it's makes parsing way easier.
      if (!_this3.meridiemCache) {
        var intl = {
          hour: "numeric",
          hourCycle: "h12"
        };
        _this3.meridiemCache = [DateTime.utc(2016, 11, 13, 9), DateTime.utc(2016, 11, 13, 19)].map(function (dt) {
          return _this3.extract(dt, intl, "dayperiod");
        });
      }

      return _this3.meridiemCache;
    });
  };

  _proto4.eras = function eras$1(length, defaultOK) {
    var _this4 = this;

    if (defaultOK === void 0) {
      defaultOK = true;
    }

    return listStuff(this, length, defaultOK, eras, function () {
      var intl = {
        era: length
      }; // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
      // to definitely enumerate them.

      if (!_this4.eraCache[length]) {
        _this4.eraCache[length] = [DateTime.utc(-40, 1, 1), DateTime.utc(2017, 1, 1)].map(function (dt) {
          return _this4.extract(dt, intl, "era");
        });
      }

      return _this4.eraCache[length];
    });
  };

  _proto4.extract = function extract(dt, intlOpts, field) {
    var df = this.dtFormatter(dt, intlOpts),
        results = df.formatToParts(),
        matching = results.find(function (m) {
      return m.type.toLowerCase() === field;
    });
    return matching ? matching.value : null;
  };

  _proto4.numberFormatter = function numberFormatter(opts) {
    if (opts === void 0) {
      opts = {};
    }

    // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
    // (in contrast, the rest of the condition is used heavily)
    return new PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
  };

  _proto4.dtFormatter = function dtFormatter(dt, intlOpts) {
    if (intlOpts === void 0) {
      intlOpts = {};
    }

    return new PolyDateFormatter(dt, this.intl, intlOpts);
  };

  _proto4.relFormatter = function relFormatter(opts) {
    if (opts === void 0) {
      opts = {};
    }

    return new PolyRelFormatter(this.intl, this.isEnglish(), opts);
  };

  _proto4.isEnglish = function isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
  };

  _proto4.equals = function equals(other) {
    return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
  };

  _createClass(Locale, [{
    key: "fastNumbers",
    get: function get() {
      if (this.fastNumbersCached == null) {
        this.fastNumbersCached = supportsFastNumbers(this);
      }

      return this.fastNumbersCached;
    }
  }]);

  return Locale;
}();

/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */

function combineRegexes() {
  for (var _len = arguments.length, regexes = new Array(_len), _key = 0; _key < _len; _key++) {
    regexes[_key] = arguments[_key];
  }

  var full = regexes.reduce(function (f, r) {
    return f + r.source;
  }, "");
  return RegExp("^" + full + "$");
}

function combineExtractors() {
  for (var _len2 = arguments.length, extractors = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    extractors[_key2] = arguments[_key2];
  }

  return function (m) {
    return extractors.reduce(function (_ref, ex) {
      var mergedVals = _ref[0],
          mergedZone = _ref[1],
          cursor = _ref[2];

      var _ex = ex(m, cursor),
          val = _ex[0],
          zone = _ex[1],
          next = _ex[2];

      return [_extends({}, mergedVals, val), mergedZone || zone, next];
    }, [{}, null, 1]).slice(0, 2);
  };
}

function parse(s) {
  if (s == null) {
    return [null, null];
  }

  for (var _len3 = arguments.length, patterns = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    patterns[_key3 - 1] = arguments[_key3];
  }

  for (var _i = 0, _patterns = patterns; _i < _patterns.length; _i++) {
    var _patterns$_i = _patterns[_i],
        regex = _patterns$_i[0],
        extractor = _patterns$_i[1];
    var m = regex.exec(s);

    if (m) {
      return extractor(m);
    }
  }

  return [null, null];
}

function simpleParse() {
  for (var _len4 = arguments.length, keys = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    keys[_key4] = arguments[_key4];
  }

  return function (match, cursor) {
    var ret = {};
    var i;

    for (i = 0; i < keys.length; i++) {
      ret[keys[i]] = parseInteger(match[cursor + i]);
    }

    return [ret, null, cursor + i];
  };
} // ISO and SQL parsing


var offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/,
    isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/,
    isoTimeRegex = RegExp("" + isoTimeBaseRegex.source + offsetRegex.source + "?"),
    isoTimeExtensionRegex = RegExp("(?:T" + isoTimeRegex.source + ")?"),
    isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/,
    isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/,
    isoOrdinalRegex = /(\d{4})-?(\d{3})/,
    extractISOWeekData = simpleParse("weekYear", "weekNumber", "weekDay"),
    extractISOOrdinalData = simpleParse("year", "ordinal"),
    sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/,
    // dumbed-down version of the ISO one
sqlTimeRegex = RegExp(isoTimeBaseRegex.source + " ?(?:" + offsetRegex.source + "|(" + ianaRegex.source + "))?"),
    sqlTimeExtensionRegex = RegExp("(?: " + sqlTimeRegex.source + ")?");

function int(match, pos, fallback) {
  var m = match[pos];
  return isUndefined(m) ? fallback : parseInteger(m);
}

function extractISOYmd(match, cursor) {
  var item = {
    year: int(match, cursor),
    month: int(match, cursor + 1, 1),
    day: int(match, cursor + 2, 1)
  };
  return [item, null, cursor + 3];
}

function extractISOTime(match, cursor) {
  var item = {
    hours: int(match, cursor, 0),
    minutes: int(match, cursor + 1, 0),
    seconds: int(match, cursor + 2, 0),
    milliseconds: parseMillis(match[cursor + 3])
  };
  return [item, null, cursor + 4];
}

function extractISOOffset(match, cursor) {
  var local = !match[cursor] && !match[cursor + 1],
      fullOffset = signedOffset(match[cursor + 1], match[cursor + 2]),
      zone = local ? null : FixedOffsetZone.instance(fullOffset);
  return [{}, zone, cursor + 3];
}

function extractIANAZone(match, cursor) {
  var zone = match[cursor] ? IANAZone.create(match[cursor]) : null;
  return [{}, zone, cursor + 1];
} // ISO time parsing


var isoTimeOnly = RegExp("^T?" + isoTimeBaseRegex.source + "$"); // ISO duration parsing

var isoDuration = /^-?P(?:(?:(-?\d{1,9}(?:\.\d{1,9})?)Y)?(?:(-?\d{1,9}(?:\.\d{1,9})?)M)?(?:(-?\d{1,9}(?:\.\d{1,9})?)W)?(?:(-?\d{1,9}(?:\.\d{1,9})?)D)?(?:T(?:(-?\d{1,9}(?:\.\d{1,9})?)H)?(?:(-?\d{1,9}(?:\.\d{1,9})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,9}))?S)?)?)$/;

function extractISODuration(match) {
  var s = match[0],
      yearStr = match[1],
      monthStr = match[2],
      weekStr = match[3],
      dayStr = match[4],
      hourStr = match[5],
      minuteStr = match[6],
      secondStr = match[7],
      millisecondsStr = match[8];
  var hasNegativePrefix = s[0] === "-";
  var negativeSeconds = secondStr && secondStr[0] === "-";

  var maybeNegate = function maybeNegate(num, force) {
    if (force === void 0) {
      force = false;
    }

    return num !== undefined && (force || num && hasNegativePrefix) ? -num : num;
  };

  return [{
    years: maybeNegate(parseFloating(yearStr)),
    months: maybeNegate(parseFloating(monthStr)),
    weeks: maybeNegate(parseFloating(weekStr)),
    days: maybeNegate(parseFloating(dayStr)),
    hours: maybeNegate(parseFloating(hourStr)),
    minutes: maybeNegate(parseFloating(minuteStr)),
    seconds: maybeNegate(parseFloating(secondStr), secondStr === "-0"),
    milliseconds: maybeNegate(parseMillis(millisecondsStr), negativeSeconds)
  }];
} // These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that


var obsOffsets = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};

function fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
  var result = {
    year: yearStr.length === 2 ? untruncateYear(parseInteger(yearStr)) : parseInteger(yearStr),
    month: monthsShort.indexOf(monthStr) + 1,
    day: parseInteger(dayStr),
    hour: parseInteger(hourStr),
    minute: parseInteger(minuteStr)
  };
  if (secondStr) result.second = parseInteger(secondStr);

  if (weekdayStr) {
    result.weekday = weekdayStr.length > 3 ? weekdaysLong.indexOf(weekdayStr) + 1 : weekdaysShort.indexOf(weekdayStr) + 1;
  }

  return result;
} // RFC 2822/5322


var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;

function extractRFC2822(match) {
  var weekdayStr = match[1],
      dayStr = match[2],
      monthStr = match[3],
      yearStr = match[4],
      hourStr = match[5],
      minuteStr = match[6],
      secondStr = match[7],
      obsOffset = match[8],
      milOffset = match[9],
      offHourStr = match[10],
      offMinuteStr = match[11],
      result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  var offset;

  if (obsOffset) {
    offset = obsOffsets[obsOffset];
  } else if (milOffset) {
    offset = 0;
  } else {
    offset = signedOffset(offHourStr, offMinuteStr);
  }

  return [result, new FixedOffsetZone(offset)];
}

function preprocessRFC2822(s) {
  // Remove comments and folding whitespace and replace multiple-spaces with a single space
  return s.replace(/\([^)]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
} // http date


var rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/,
    rfc850 = /^(Monday|Tuesday|Wedsday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/,
    ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;

function extractRFC1123Or850(match) {
  var weekdayStr = match[1],
      dayStr = match[2],
      monthStr = match[3],
      yearStr = match[4],
      hourStr = match[5],
      minuteStr = match[6],
      secondStr = match[7],
      result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone.utcInstance];
}

function extractASCII(match) {
  var weekdayStr = match[1],
      monthStr = match[2],
      dayStr = match[3],
      hourStr = match[4],
      minuteStr = match[5],
      secondStr = match[6],
      yearStr = match[7],
      result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone.utcInstance];
}

var isoYmdWithTimeExtensionRegex = combineRegexes(isoYmdRegex, isoTimeExtensionRegex);
var isoWeekWithTimeExtensionRegex = combineRegexes(isoWeekRegex, isoTimeExtensionRegex);
var isoOrdinalWithTimeExtensionRegex = combineRegexes(isoOrdinalRegex, isoTimeExtensionRegex);
var isoTimeCombinedRegex = combineRegexes(isoTimeRegex);
var extractISOYmdTimeAndOffset = combineExtractors(extractISOYmd, extractISOTime, extractISOOffset);
var extractISOWeekTimeAndOffset = combineExtractors(extractISOWeekData, extractISOTime, extractISOOffset);
var extractISOOrdinalDateAndTime = combineExtractors(extractISOOrdinalData, extractISOTime, extractISOOffset);
var extractISOTimeAndOffset = combineExtractors(extractISOTime, extractISOOffset);
/**
 * @private
 */

function parseISODate(s) {
  return parse(s, [isoYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset], [isoWeekWithTimeExtensionRegex, extractISOWeekTimeAndOffset], [isoOrdinalWithTimeExtensionRegex, extractISOOrdinalDateAndTime], [isoTimeCombinedRegex, extractISOTimeAndOffset]);
}
function parseRFC2822Date(s) {
  return parse(preprocessRFC2822(s), [rfc2822, extractRFC2822]);
}
function parseHTTPDate(s) {
  return parse(s, [rfc1123, extractRFC1123Or850], [rfc850, extractRFC1123Or850], [ascii, extractASCII]);
}
function parseISODuration(s) {
  return parse(s, [isoDuration, extractISODuration]);
}
var extractISOTimeOnly = combineExtractors(extractISOTime);
function parseISOTimeOnly(s) {
  return parse(s, [isoTimeOnly, extractISOTimeOnly]);
}
var sqlYmdWithTimeExtensionRegex = combineRegexes(sqlYmdRegex, sqlTimeExtensionRegex);
var sqlTimeCombinedRegex = combineRegexes(sqlTimeRegex);
var extractISOYmdTimeOffsetAndIANAZone = combineExtractors(extractISOYmd, extractISOTime, extractISOOffset, extractIANAZone);
var extractISOTimeOffsetAndIANAZone = combineExtractors(extractISOTime, extractISOOffset, extractIANAZone);
function parseSQL(s) {
  return parse(s, [sqlYmdWithTimeExtensionRegex, extractISOYmdTimeOffsetAndIANAZone], [sqlTimeCombinedRegex, extractISOTimeOffsetAndIANAZone]);
}

var INVALID$2 = "Invalid Duration"; // unit conversion constants

var lowOrderMatrix = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1000
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1000
  },
  hours: {
    minutes: 60,
    seconds: 60 * 60,
    milliseconds: 60 * 60 * 1000
  },
  minutes: {
    seconds: 60,
    milliseconds: 60 * 1000
  },
  seconds: {
    milliseconds: 1000
  }
},
    casualMatrix = _extends({
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1000
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1000
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1000
  }
}, lowOrderMatrix),
    daysInYearAccurate = 146097.0 / 400,
    daysInMonthAccurate = 146097.0 / 4800,
    accurateMatrix = _extends({
  years: {
    quarters: 4,
    months: 12,
    weeks: daysInYearAccurate / 7,
    days: daysInYearAccurate,
    hours: daysInYearAccurate * 24,
    minutes: daysInYearAccurate * 24 * 60,
    seconds: daysInYearAccurate * 24 * 60 * 60,
    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1000
  },
  quarters: {
    months: 3,
    weeks: daysInYearAccurate / 28,
    days: daysInYearAccurate / 4,
    hours: daysInYearAccurate * 24 / 4,
    minutes: daysInYearAccurate * 24 * 60 / 4,
    seconds: daysInYearAccurate * 24 * 60 * 60 / 4,
    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1000 / 4
  },
  months: {
    weeks: daysInMonthAccurate / 7,
    days: daysInMonthAccurate,
    hours: daysInMonthAccurate * 24,
    minutes: daysInMonthAccurate * 24 * 60,
    seconds: daysInMonthAccurate * 24 * 60 * 60,
    milliseconds: daysInMonthAccurate * 24 * 60 * 60 * 1000
  }
}, lowOrderMatrix); // units ordered by size

var orderedUnits$1 = ["years", "quarters", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds"];
var reverseUnits = orderedUnits$1.slice(0).reverse(); // clone really means "create another instance just like this one, but with these changes"

function clone$1(dur, alts, clear) {
  if (clear === void 0) {
    clear = false;
  }

  // deep merge for vals
  var conf = {
    values: clear ? alts.values : _extends({}, dur.values, alts.values || {}),
    loc: dur.loc.clone(alts.loc),
    conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy
  };
  return new Duration(conf);
}

function antiTrunc(n) {
  return n < 0 ? Math.floor(n) : Math.ceil(n);
} // NB: mutates parameters


function convert(matrix, fromMap, fromUnit, toMap, toUnit) {
  var conv = matrix[toUnit][fromUnit],
      raw = fromMap[fromUnit] / conv,
      sameSign = Math.sign(raw) === Math.sign(toMap[toUnit]),
      // ok, so this is wild, but see the matrix in the tests
  added = !sameSign && toMap[toUnit] !== 0 && Math.abs(raw) <= 1 ? antiTrunc(raw) : Math.trunc(raw);
  toMap[toUnit] += added;
  fromMap[fromUnit] -= added * conv;
} // NB: mutates parameters


function normalizeValues(matrix, vals) {
  reverseUnits.reduce(function (previous, current) {
    if (!isUndefined(vals[current])) {
      if (previous) {
        convert(matrix, vals, previous, vals, current);
      }

      return current;
    } else {
      return previous;
    }
  }, null);
}
/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime#plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration#fromMillis}, {@link Duration#fromObject}, or {@link Duration#fromISO}.
 * * **Unit values** See the {@link Duration#years}, {@link Duration.months}, {@link Duration#weeks}, {@link Duration#days}, {@link Duration#hours}, {@link Duration#minutes}, {@link Duration#seconds}, {@link Duration#milliseconds} accessors.
 * * **Configuration** See  {@link Duration#locale} and {@link Duration#numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link Duration#plus}, {@link Duration#minus}, {@link Duration#normalize}, {@link Duration#set}, {@link Duration#reconfigure}, {@link Duration#shiftTo}, and {@link Duration#negate}.
 * * **Output** To convert the Duration into other representations, see {@link Duration#as}, {@link Duration#toISO}, {@link Duration#toFormat}, and {@link Duration#toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */


var Duration = /*#__PURE__*/function () {
  /**
   * @private
   */
  function Duration(config) {
    var accurate = config.conversionAccuracy === "longterm" || false;
    /**
     * @access private
     */

    this.values = config.values;
    /**
     * @access private
     */

    this.loc = config.loc || Locale.create();
    /**
     * @access private
     */

    this.conversionAccuracy = accurate ? "longterm" : "casual";
    /**
     * @access private
     */

    this.invalid = config.invalid || null;
    /**
     * @access private
     */

    this.matrix = accurate ? accurateMatrix : casualMatrix;
    /**
     * @access private
     */

    this.isLuxonDuration = true;
  }
  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */


  Duration.fromMillis = function fromMillis(count, opts) {
    return Duration.fromObject({
      milliseconds: count
    }, opts);
  }
  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  ;

  Duration.fromObject = function fromObject(obj, opts) {
    if (opts === void 0) {
      opts = {};
    }

    if (obj == null || typeof obj !== "object") {
      throw new InvalidArgumentError("Duration.fromObject: argument expected to be an object, got " + (obj === null ? "null" : typeof obj));
    }

    return new Duration({
      values: normalizeObject(obj, Duration.normalizeUnit),
      loc: Locale.fromObject(opts),
      conversionAccuracy: opts.conversionAccuracy
    });
  }
  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  ;

  Duration.fromDurationLike = function fromDurationLike(durationLike) {
    if (isNumber(durationLike)) {
      return Duration.fromMillis(durationLike);
    } else if (Duration.isDuration(durationLike)) {
      return durationLike;
    } else if (typeof durationLike === "object") {
      return Duration.fromObject(durationLike);
    } else {
      throw new InvalidArgumentError("Unknown duration argument " + durationLike + " of type " + typeof durationLike);
    }
  }
  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  ;

  Duration.fromISO = function fromISO(text, opts) {
    var _parseISODuration = parseISODuration(text),
        parsed = _parseISODuration[0];

    if (parsed) {
      return Duration.fromObject(parsed, opts);
    } else {
      return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    }
  }
  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  ;

  Duration.fromISOTime = function fromISOTime(text, opts) {
    var _parseISOTimeOnly = parseISOTimeOnly(text),
        parsed = _parseISOTimeOnly[0];

    if (parsed) {
      return Duration.fromObject(parsed, opts);
    } else {
      return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    }
  }
  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  ;

  Duration.invalid = function invalid(reason, explanation) {
    if (explanation === void 0) {
      explanation = null;
    }

    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Duration is invalid");
    }

    var invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);

    if (Settings.throwOnInvalid) {
      throw new InvalidDurationError(invalid);
    } else {
      return new Duration({
        invalid: invalid
      });
    }
  }
  /**
   * @private
   */
  ;

  Duration.normalizeUnit = function normalizeUnit(unit) {
    var normalized = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[unit ? unit.toLowerCase() : unit];
    if (!normalized) throw new InvalidUnitError(unit);
    return normalized;
  }
  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  ;

  Duration.isDuration = function isDuration(o) {
    return o && o.isLuxonDuration || false;
  }
  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  ;

  var _proto = Duration.prototype;

  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */
  _proto.toFormat = function toFormat(fmt, opts) {
    if (opts === void 0) {
      opts = {};
    }

    // reverse-compat since 1.2; we always round down now, never up, and we do it by default
    var fmtOpts = _extends({}, opts, {
      floor: opts.round !== false && opts.floor !== false
    });

    return this.isValid ? Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : INVALID$2;
  }
  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  ;

  _proto.toObject = function toObject() {
    if (!this.isValid) return {};
    return _extends({}, this.values);
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  ;

  _proto.toISO = function toISO() {
    // we could use the formatter, but this is an easier way to get the minimum string
    if (!this.isValid) return null;
    var s = "P";
    if (this.years !== 0) s += this.years + "Y";
    if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
    if (this.weeks !== 0) s += this.weeks + "W";
    if (this.days !== 0) s += this.days + "D";
    if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
    if (this.hours !== 0) s += this.hours + "H";
    if (this.minutes !== 0) s += this.minutes + "M";
    if (this.seconds !== 0 || this.milliseconds !== 0) // this will handle "floating point madness" by removing extra decimal places
      // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
      s += roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
    if (s === "P") s += "T0S";
    return s;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  ;

  _proto.toISOTime = function toISOTime(opts) {
    if (opts === void 0) {
      opts = {};
    }

    if (!this.isValid) return null;
    var millis = this.toMillis();
    if (millis < 0 || millis >= 86400000) return null;
    opts = _extends({
      suppressMilliseconds: false,
      suppressSeconds: false,
      includePrefix: false,
      format: "extended"
    }, opts);
    var value = this.shiftTo("hours", "minutes", "seconds", "milliseconds");
    var fmt = opts.format === "basic" ? "hhmm" : "hh:mm";

    if (!opts.suppressSeconds || value.seconds !== 0 || value.milliseconds !== 0) {
      fmt += opts.format === "basic" ? "ss" : ":ss";

      if (!opts.suppressMilliseconds || value.milliseconds !== 0) {
        fmt += ".SSS";
      }
    }

    var str = value.toFormat(fmt);

    if (opts.includePrefix) {
      str = "T" + str;
    }

    return str;
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  ;

  _proto.toJSON = function toJSON() {
    return this.toISO();
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  ;

  _proto.toString = function toString() {
    return this.toISO();
  }
  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  ;

  _proto.toMillis = function toMillis() {
    return this.as("milliseconds");
  }
  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  ;

  _proto.valueOf = function valueOf() {
    return this.toMillis();
  }
  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  ;

  _proto.plus = function plus(duration) {
    if (!this.isValid) return this;
    var dur = Duration.fromDurationLike(duration),
        result = {};

    for (var _iterator = _createForOfIteratorHelperLoose(orderedUnits$1), _step; !(_step = _iterator()).done;) {
      var k = _step.value;

      if (hasOwnProperty(dur.values, k) || hasOwnProperty(this.values, k)) {
        result[k] = dur.get(k) + this.get(k);
      }
    }

    return clone$1(this, {
      values: result
    }, true);
  }
  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  ;

  _proto.minus = function minus(duration) {
    if (!this.isValid) return this;
    var dur = Duration.fromDurationLike(duration);
    return this.plus(dur.negate());
  }
  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hour" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  ;

  _proto.mapUnits = function mapUnits(fn) {
    if (!this.isValid) return this;
    var result = {};

    for (var _i = 0, _Object$keys = Object.keys(this.values); _i < _Object$keys.length; _i++) {
      var k = _Object$keys[_i];
      result[k] = asNumber(fn(this.values[k], k));
    }

    return clone$1(this, {
      values: result
    }, true);
  }
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  ;

  _proto.get = function get(unit) {
    return this[Duration.normalizeUnit(unit)];
  }
  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  ;

  _proto.set = function set(values) {
    if (!this.isValid) return this;

    var mixed = _extends({}, this.values, normalizeObject(values, Duration.normalizeUnit));

    return clone$1(this, {
      values: mixed
    });
  }
  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  ;

  _proto.reconfigure = function reconfigure(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        locale = _ref.locale,
        numberingSystem = _ref.numberingSystem,
        conversionAccuracy = _ref.conversionAccuracy;

    var loc = this.loc.clone({
      locale: locale,
      numberingSystem: numberingSystem
    }),
        opts = {
      loc: loc
    };

    if (conversionAccuracy) {
      opts.conversionAccuracy = conversionAccuracy;
    }

    return clone$1(this, opts);
  }
  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  ;

  _proto.as = function as(unit) {
    return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
  }
  /**
   * Reduce this Duration to its canonical representation in its current units.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @return {Duration}
   */
  ;

  _proto.normalize = function normalize() {
    if (!this.isValid) return this;
    var vals = this.toObject();
    normalizeValues(this.matrix, vals);
    return clone$1(this, {
      values: vals
    }, true);
  }
  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  ;

  _proto.shiftTo = function shiftTo() {
    for (var _len = arguments.length, units = new Array(_len), _key = 0; _key < _len; _key++) {
      units[_key] = arguments[_key];
    }

    if (!this.isValid) return this;

    if (units.length === 0) {
      return this;
    }

    units = units.map(function (u) {
      return Duration.normalizeUnit(u);
    });
    var built = {},
        accumulated = {},
        vals = this.toObject();
    var lastUnit;

    for (var _iterator2 = _createForOfIteratorHelperLoose(orderedUnits$1), _step2; !(_step2 = _iterator2()).done;) {
      var k = _step2.value;

      if (units.indexOf(k) >= 0) {
        lastUnit = k;
        var own = 0; // anything we haven't boiled down yet should get boiled to this unit

        for (var ak in accumulated) {
          own += this.matrix[ak][k] * accumulated[ak];
          accumulated[ak] = 0;
        } // plus anything that's already in this unit


        if (isNumber(vals[k])) {
          own += vals[k];
        }

        var i = Math.trunc(own);
        built[k] = i;
        accumulated[k] = (own * 1000 - i * 1000) / 1000; // plus anything further down the chain that should be rolled up in to this

        for (var down in vals) {
          if (orderedUnits$1.indexOf(down) > orderedUnits$1.indexOf(k)) {
            convert(this.matrix, vals, down, built, k);
          }
        } // otherwise, keep it in the wings to boil it later

      } else if (isNumber(vals[k])) {
        accumulated[k] = vals[k];
      }
    } // anything leftover becomes the decimal for the last unit
    // lastUnit must be defined since units is not empty


    for (var key in accumulated) {
      if (accumulated[key] !== 0) {
        built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
      }
    }

    return clone$1(this, {
      values: built
    }, true).normalize();
  }
  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  ;

  _proto.negate = function negate() {
    if (!this.isValid) return this;
    var negated = {};

    for (var _i2 = 0, _Object$keys2 = Object.keys(this.values); _i2 < _Object$keys2.length; _i2++) {
      var k = _Object$keys2[_i2];
      negated[k] = -this.values[k];
    }

    return clone$1(this, {
      values: negated
    }, true);
  }
  /**
   * Get the years.
   * @type {number}
   */
  ;

  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  _proto.equals = function equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }

    if (!this.loc.equals(other.loc)) {
      return false;
    }

    function eq(v1, v2) {
      // Consider 0 and undefined as equal
      if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
      return v1 === v2;
    }

    for (var _iterator3 = _createForOfIteratorHelperLoose(orderedUnits$1), _step3; !(_step3 = _iterator3()).done;) {
      var u = _step3.value;

      if (!eq(this.values[u], other.values[u])) {
        return false;
      }
    }

    return true;
  };

  _createClass(Duration, [{
    key: "locale",
    get: function get() {
      return this.isValid ? this.loc.locale : null;
    }
    /**
     * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
     *
     * @type {string}
     */

  }, {
    key: "numberingSystem",
    get: function get() {
      return this.isValid ? this.loc.numberingSystem : null;
    }
  }, {
    key: "years",
    get: function get() {
      return this.isValid ? this.values.years || 0 : NaN;
    }
    /**
     * Get the quarters.
     * @type {number}
     */

  }, {
    key: "quarters",
    get: function get() {
      return this.isValid ? this.values.quarters || 0 : NaN;
    }
    /**
     * Get the months.
     * @type {number}
     */

  }, {
    key: "months",
    get: function get() {
      return this.isValid ? this.values.months || 0 : NaN;
    }
    /**
     * Get the weeks
     * @type {number}
     */

  }, {
    key: "weeks",
    get: function get() {
      return this.isValid ? this.values.weeks || 0 : NaN;
    }
    /**
     * Get the days.
     * @type {number}
     */

  }, {
    key: "days",
    get: function get() {
      return this.isValid ? this.values.days || 0 : NaN;
    }
    /**
     * Get the hours.
     * @type {number}
     */

  }, {
    key: "hours",
    get: function get() {
      return this.isValid ? this.values.hours || 0 : NaN;
    }
    /**
     * Get the minutes.
     * @type {number}
     */

  }, {
    key: "minutes",
    get: function get() {
      return this.isValid ? this.values.minutes || 0 : NaN;
    }
    /**
     * Get the seconds.
     * @return {number}
     */

  }, {
    key: "seconds",
    get: function get() {
      return this.isValid ? this.values.seconds || 0 : NaN;
    }
    /**
     * Get the milliseconds.
     * @return {number}
     */

  }, {
    key: "milliseconds",
    get: function get() {
      return this.isValid ? this.values.milliseconds || 0 : NaN;
    }
    /**
     * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
     * on invalid DateTimes or Intervals.
     * @return {boolean}
     */

  }, {
    key: "isValid",
    get: function get() {
      return this.invalid === null;
    }
    /**
     * Returns an error code if this Duration became invalid, or null if the Duration is valid
     * @return {string}
     */

  }, {
    key: "invalidReason",
    get: function get() {
      return this.invalid ? this.invalid.reason : null;
    }
    /**
     * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
     * @type {string}
     */

  }, {
    key: "invalidExplanation",
    get: function get() {
      return this.invalid ? this.invalid.explanation : null;
    }
  }]);

  return Duration;
}();

var INVALID$1 = "Invalid Interval"; // checks if the start is equal to or before the end

function validateStartEnd(start, end) {
  if (!start || !start.isValid) {
    return Interval.invalid("missing or invalid start");
  } else if (!end || !end.isValid) {
    return Interval.invalid("missing or invalid end");
  } else if (end < start) {
    return Interval.invalid("end before start", "The end of an interval must be after its start, but you had start=" + start.toISO() + " and end=" + end.toISO());
  } else {
    return null;
  }
}
/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link Interval#fromDateTimes}, {@link Interval#after}, {@link Interval#before}, or {@link Interval#fromISO}.
 * * **Accessors** Use {@link Interval#start} and {@link Interval#end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link Interval#count}, {@link Interval#length}, {@link Interval#hasSame}, {@link Interval#contains}, {@link Interval#isAfter}, or {@link Interval#isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link Interval#set}, {@link Interval#splitAt}, {@link Interval#splitBy}, {@link Interval#divideEqually}, {@link Interval#merge}, {@link Interval#xor}, {@link Interval#union}, {@link Interval#intersection}, or {@link Interval#difference}.
 * * **Comparison** To compare this Interval to another one, use {@link Interval#equals}, {@link Interval#overlaps}, {@link Interval#abutsStart}, {@link Interval#abutsEnd}, {@link Interval#engulfs}
 * * **Output** To convert the Interval into other representations, see {@link Interval#toString}, {@link Interval#toISO}, {@link Interval#toISODate}, {@link Interval#toISOTime}, {@link Interval#toFormat}, and {@link Interval#toDuration}.
 */


var Interval = /*#__PURE__*/function () {
  /**
   * @private
   */
  function Interval(config) {
    /**
     * @access private
     */
    this.s = config.start;
    /**
     * @access private
     */

    this.e = config.end;
    /**
     * @access private
     */

    this.invalid = config.invalid || null;
    /**
     * @access private
     */

    this.isLuxonInterval = true;
  }
  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */


  Interval.invalid = function invalid(reason, explanation) {
    if (explanation === void 0) {
      explanation = null;
    }

    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Interval is invalid");
    }

    var invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);

    if (Settings.throwOnInvalid) {
      throw new InvalidIntervalError(invalid);
    } else {
      return new Interval({
        invalid: invalid
      });
    }
  }
  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  ;

  Interval.fromDateTimes = function fromDateTimes(start, end) {
    var builtStart = friendlyDateTime(start),
        builtEnd = friendlyDateTime(end);
    var validateError = validateStartEnd(builtStart, builtEnd);

    if (validateError == null) {
      return new Interval({
        start: builtStart,
        end: builtEnd
      });
    } else {
      return validateError;
    }
  }
  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  ;

  Interval.after = function after(start, duration) {
    var dur = Duration.fromDurationLike(duration),
        dt = friendlyDateTime(start);
    return Interval.fromDateTimes(dt, dt.plus(dur));
  }
  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  ;

  Interval.before = function before(end, duration) {
    var dur = Duration.fromDurationLike(duration),
        dt = friendlyDateTime(end);
    return Interval.fromDateTimes(dt.minus(dur), dt);
  }
  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  ;

  Interval.fromISO = function fromISO(text, opts) {
    var _split = (text || "").split("/", 2),
        s = _split[0],
        e = _split[1];

    if (s && e) {
      var start, startIsValid;

      try {
        start = DateTime.fromISO(s, opts);
        startIsValid = start.isValid;
      } catch (e) {
        startIsValid = false;
      }

      var end, endIsValid;

      try {
        end = DateTime.fromISO(e, opts);
        endIsValid = end.isValid;
      } catch (e) {
        endIsValid = false;
      }

      if (startIsValid && endIsValid) {
        return Interval.fromDateTimes(start, end);
      }

      if (startIsValid) {
        var dur = Duration.fromISO(e, opts);

        if (dur.isValid) {
          return Interval.after(start, dur);
        }
      } else if (endIsValid) {
        var _dur = Duration.fromISO(s, opts);

        if (_dur.isValid) {
          return Interval.before(end, _dur);
        }
      }
    }

    return Interval.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
  }
  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  ;

  Interval.isInterval = function isInterval(o) {
    return o && o.isLuxonInterval || false;
  }
  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  ;

  var _proto = Interval.prototype;

  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  _proto.length = function length(unit) {
    if (unit === void 0) {
      unit = "milliseconds";
    }

    return this.isValid ? this.toDuration.apply(this, [unit]).get(unit) : NaN;
  }
  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @return {number}
   */
  ;

  _proto.count = function count(unit) {
    if (unit === void 0) {
      unit = "milliseconds";
    }

    if (!this.isValid) return NaN;
    var start = this.start.startOf(unit),
        end = this.end.startOf(unit);
    return Math.floor(end.diff(start, unit).get(unit)) + 1;
  }
  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  ;

  _proto.hasSame = function hasSame(unit) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
  }
  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  ;

  _proto.isEmpty = function isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  ;

  _proto.isAfter = function isAfter(dateTime) {
    if (!this.isValid) return false;
    return this.s > dateTime;
  }
  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  ;

  _proto.isBefore = function isBefore(dateTime) {
    if (!this.isValid) return false;
    return this.e <= dateTime;
  }
  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  ;

  _proto.contains = function contains(dateTime) {
    if (!this.isValid) return false;
    return this.s <= dateTime && this.e > dateTime;
  }
  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  ;

  _proto.set = function set(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        start = _ref.start,
        end = _ref.end;

    if (!this.isValid) return this;
    return Interval.fromDateTimes(start || this.s, end || this.e);
  }
  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  ;

  _proto.splitAt = function splitAt() {
    var _this = this;

    if (!this.isValid) return [];

    for (var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++) {
      dateTimes[_key] = arguments[_key];
    }

    var sorted = dateTimes.map(friendlyDateTime).filter(function (d) {
      return _this.contains(d);
    }).sort(),
        results = [];
    var s = this.s,
        i = 0;

    while (s < this.e) {
      var added = sorted[i] || this.e,
          next = +added > +this.e ? this.e : added;
      results.push(Interval.fromDateTimes(s, next));
      s = next;
      i += 1;
    }

    return results;
  }
  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  ;

  _proto.splitBy = function splitBy(duration) {
    var dur = Duration.fromDurationLike(duration);

    if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) {
      return [];
    }

    var s = this.s,
        idx = 1,
        next;
    var results = [];

    while (s < this.e) {
      var added = this.start.plus(dur.mapUnits(function (x) {
        return x * idx;
      }));
      next = +added > +this.e ? this.e : added;
      results.push(Interval.fromDateTimes(s, next));
      s = next;
      idx += 1;
    }

    return results;
  }
  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  ;

  _proto.divideEqually = function divideEqually(numberOfParts) {
    if (!this.isValid) return [];
    return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
  }
  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  ;

  _proto.overlaps = function overlaps(other) {
    return this.e > other.s && this.s < other.e;
  }
  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  ;

  _proto.abutsStart = function abutsStart(other) {
    if (!this.isValid) return false;
    return +this.e === +other.s;
  }
  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  ;

  _proto.abutsEnd = function abutsEnd(other) {
    if (!this.isValid) return false;
    return +other.e === +this.s;
  }
  /**
   * Return whether this Interval engulfs the start and end of the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  ;

  _proto.engulfs = function engulfs(other) {
    if (!this.isValid) return false;
    return this.s <= other.s && this.e >= other.e;
  }
  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  ;

  _proto.equals = function equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }

    return this.s.equals(other.s) && this.e.equals(other.e);
  }
  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  ;

  _proto.intersection = function intersection(other) {
    if (!this.isValid) return this;
    var s = this.s > other.s ? this.s : other.s,
        e = this.e < other.e ? this.e : other.e;

    if (s >= e) {
      return null;
    } else {
      return Interval.fromDateTimes(s, e);
    }
  }
  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  ;

  _proto.union = function union(other) {
    if (!this.isValid) return this;
    var s = this.s < other.s ? this.s : other.s,
        e = this.e > other.e ? this.e : other.e;
    return Interval.fromDateTimes(s, e);
  }
  /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  ;

  Interval.merge = function merge(intervals) {
    var _intervals$sort$reduc = intervals.sort(function (a, b) {
      return a.s - b.s;
    }).reduce(function (_ref2, item) {
      var sofar = _ref2[0],
          current = _ref2[1];

      if (!current) {
        return [sofar, item];
      } else if (current.overlaps(item) || current.abutsStart(item)) {
        return [sofar, current.union(item)];
      } else {
        return [sofar.concat([current]), item];
      }
    }, [[], null]),
        found = _intervals$sort$reduc[0],
        final = _intervals$sort$reduc[1];

    if (final) {
      found.push(final);
    }

    return found;
  }
  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  ;

  Interval.xor = function xor(intervals) {
    var _Array$prototype;

    var start = null,
        currentCount = 0;

    var results = [],
        ends = intervals.map(function (i) {
      return [{
        time: i.s,
        type: "s"
      }, {
        time: i.e,
        type: "e"
      }];
    }),
        flattened = (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, ends),
        arr = flattened.sort(function (a, b) {
      return a.time - b.time;
    });

    for (var _iterator = _createForOfIteratorHelperLoose(arr), _step; !(_step = _iterator()).done;) {
      var i = _step.value;
      currentCount += i.type === "s" ? 1 : -1;

      if (currentCount === 1) {
        start = i.time;
      } else {
        if (start && +start !== +i.time) {
          results.push(Interval.fromDateTimes(start, i.time));
        }

        start = null;
      }
    }

    return Interval.merge(results);
  }
  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  ;

  _proto.difference = function difference() {
    var _this2 = this;

    for (var _len2 = arguments.length, intervals = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      intervals[_key2] = arguments[_key2];
    }

    return Interval.xor([this].concat(intervals)).map(function (i) {
      return _this2.intersection(i);
    }).filter(function (i) {
      return i && !i.isEmpty();
    });
  }
  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  ;

  _proto.toString = function toString() {
    if (!this.isValid) return INVALID$1;
    return "[" + this.s.toISO() + " \u2013 " + this.e.toISO() + ")";
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  ;

  _proto.toISO = function toISO(opts) {
    if (!this.isValid) return INVALID$1;
    return this.s.toISO(opts) + "/" + this.e.toISO(opts);
  }
  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  ;

  _proto.toISODate = function toISODate() {
    if (!this.isValid) return INVALID$1;
    return this.s.toISODate() + "/" + this.e.toISODate();
  }
  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  ;

  _proto.toISOTime = function toISOTime(opts) {
    if (!this.isValid) return INVALID$1;
    return this.s.toISOTime(opts) + "/" + this.e.toISOTime(opts);
  }
  /**
   * Returns a string representation of this Interval formatted according to the specified format string.
   * @param {string} dateFormat - the format string. This string formats the start and end time. See {@link DateTime#toFormat} for details.
   * @param {Object} opts - options
   * @param {string} [opts.separator =  ' – '] - a separator to place between the start and end representations
   * @return {string}
   */
  ;

  _proto.toFormat = function toFormat(dateFormat, _temp2) {
    var _ref3 = _temp2 === void 0 ? {} : _temp2,
        _ref3$separator = _ref3.separator,
        separator = _ref3$separator === void 0 ? " – " : _ref3$separator;

    if (!this.isValid) return INVALID$1;
    return "" + this.s.toFormat(dateFormat) + separator + this.e.toFormat(dateFormat);
  }
  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  ;

  _proto.toDuration = function toDuration(unit, opts) {
    if (!this.isValid) {
      return Duration.invalid(this.invalidReason);
    }

    return this.e.diff(this.s, unit, opts);
  }
  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  ;

  _proto.mapEndpoints = function mapEndpoints(mapFn) {
    return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
  };

  _createClass(Interval, [{
    key: "start",
    get: function get() {
      return this.isValid ? this.s : null;
    }
    /**
     * Returns the end of the Interval
     * @type {DateTime}
     */

  }, {
    key: "end",
    get: function get() {
      return this.isValid ? this.e : null;
    }
    /**
     * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
     * @type {boolean}
     */

  }, {
    key: "isValid",
    get: function get() {
      return this.invalidReason === null;
    }
    /**
     * Returns an error code if this Interval is invalid, or null if the Interval is valid
     * @type {string}
     */

  }, {
    key: "invalidReason",
    get: function get() {
      return this.invalid ? this.invalid.reason : null;
    }
    /**
     * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
     * @type {string}
     */

  }, {
    key: "invalidExplanation",
    get: function get() {
      return this.invalid ? this.invalid.explanation : null;
    }
  }]);

  return Interval;
}();

/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */

var Info = /*#__PURE__*/function () {
  function Info() {}

  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  Info.hasDST = function hasDST(zone) {
    if (zone === void 0) {
      zone = Settings.defaultZone;
    }

    var proto = DateTime.now().setZone(zone).set({
      month: 12
    });
    return !zone.isUniversal && proto.offset !== proto.set({
      month: 6
    }).offset;
  }
  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  ;

  Info.isValidIANAZone = function isValidIANAZone(zone) {
    return IANAZone.isValidSpecifier(zone) && IANAZone.isValidZone(zone);
  }
  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  ;

  Info.normalizeZone = function normalizeZone$1(input) {
    return normalizeZone(input, Settings.defaultZone);
  }
  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  ;

  Info.months = function months(length, _temp) {
    if (length === void 0) {
      length = "long";
    }

    var _ref = _temp === void 0 ? {} : _temp,
        _ref$locale = _ref.locale,
        locale = _ref$locale === void 0 ? null : _ref$locale,
        _ref$numberingSystem = _ref.numberingSystem,
        numberingSystem = _ref$numberingSystem === void 0 ? null : _ref$numberingSystem,
        _ref$locObj = _ref.locObj,
        locObj = _ref$locObj === void 0 ? null : _ref$locObj,
        _ref$outputCalendar = _ref.outputCalendar,
        outputCalendar = _ref$outputCalendar === void 0 ? "gregory" : _ref$outputCalendar;

    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length);
  }
  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  ;

  Info.monthsFormat = function monthsFormat(length, _temp2) {
    if (length === void 0) {
      length = "long";
    }

    var _ref2 = _temp2 === void 0 ? {} : _temp2,
        _ref2$locale = _ref2.locale,
        locale = _ref2$locale === void 0 ? null : _ref2$locale,
        _ref2$numberingSystem = _ref2.numberingSystem,
        numberingSystem = _ref2$numberingSystem === void 0 ? null : _ref2$numberingSystem,
        _ref2$locObj = _ref2.locObj,
        locObj = _ref2$locObj === void 0 ? null : _ref2$locObj,
        _ref2$outputCalendar = _ref2.outputCalendar,
        outputCalendar = _ref2$outputCalendar === void 0 ? "gregory" : _ref2$outputCalendar;

    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
  }
  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  ;

  Info.weekdays = function weekdays(length, _temp3) {
    if (length === void 0) {
      length = "long";
    }

    var _ref3 = _temp3 === void 0 ? {} : _temp3,
        _ref3$locale = _ref3.locale,
        locale = _ref3$locale === void 0 ? null : _ref3$locale,
        _ref3$numberingSystem = _ref3.numberingSystem,
        numberingSystem = _ref3$numberingSystem === void 0 ? null : _ref3$numberingSystem,
        _ref3$locObj = _ref3.locObj,
        locObj = _ref3$locObj === void 0 ? null : _ref3$locObj;

    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length);
  }
  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  ;

  Info.weekdaysFormat = function weekdaysFormat(length, _temp4) {
    if (length === void 0) {
      length = "long";
    }

    var _ref4 = _temp4 === void 0 ? {} : _temp4,
        _ref4$locale = _ref4.locale,
        locale = _ref4$locale === void 0 ? null : _ref4$locale,
        _ref4$numberingSystem = _ref4.numberingSystem,
        numberingSystem = _ref4$numberingSystem === void 0 ? null : _ref4$numberingSystem,
        _ref4$locObj = _ref4.locObj,
        locObj = _ref4$locObj === void 0 ? null : _ref4$locObj;

    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length, true);
  }
  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  ;

  Info.meridiems = function meridiems(_temp5) {
    var _ref5 = _temp5 === void 0 ? {} : _temp5,
        _ref5$locale = _ref5.locale,
        locale = _ref5$locale === void 0 ? null : _ref5$locale;

    return Locale.create(locale).meridiems();
  }
  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  ;

  Info.eras = function eras(length, _temp6) {
    if (length === void 0) {
      length = "short";
    }

    var _ref6 = _temp6 === void 0 ? {} : _temp6,
        _ref6$locale = _ref6.locale,
        locale = _ref6$locale === void 0 ? null : _ref6$locale;

    return Locale.create(locale, null, "gregory").eras(length);
  }
  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * @example Info.features() //=> { relative: false }
   * @return {Object}
   */
  ;

  Info.features = function features() {
    return {
      relative: hasRelative()
    };
  };

  return Info;
}();

function dayDiff(earlier, later) {
  var utcDayStart = function utcDayStart(dt) {
    return dt.toUTC(0, {
      keepLocalTime: true
    }).startOf("day").valueOf();
  },
      ms = utcDayStart(later) - utcDayStart(earlier);

  return Math.floor(Duration.fromMillis(ms).as("days"));
}

function highOrderDiffs(cursor, later, units) {
  var differs = [["years", function (a, b) {
    return b.year - a.year;
  }], ["quarters", function (a, b) {
    return b.quarter - a.quarter;
  }], ["months", function (a, b) {
    return b.month - a.month + (b.year - a.year) * 12;
  }], ["weeks", function (a, b) {
    var days = dayDiff(a, b);
    return (days - days % 7) / 7;
  }], ["days", dayDiff]];
  var results = {};
  var lowestOrder, highWater;

  for (var _i = 0, _differs = differs; _i < _differs.length; _i++) {
    var _differs$_i = _differs[_i],
        unit = _differs$_i[0],
        differ = _differs$_i[1];

    if (units.indexOf(unit) >= 0) {
      var _cursor$plus;

      lowestOrder = unit;
      var delta = differ(cursor, later);
      highWater = cursor.plus((_cursor$plus = {}, _cursor$plus[unit] = delta, _cursor$plus));

      if (highWater > later) {
        var _cursor$plus2;

        cursor = cursor.plus((_cursor$plus2 = {}, _cursor$plus2[unit] = delta - 1, _cursor$plus2));
        delta -= 1;
      } else {
        cursor = highWater;
      }

      results[unit] = delta;
    }
  }

  return [cursor, results, highWater, lowestOrder];
}

function _diff (earlier, later, units, opts) {
  var _highOrderDiffs = highOrderDiffs(earlier, later, units),
      cursor = _highOrderDiffs[0],
      results = _highOrderDiffs[1],
      highWater = _highOrderDiffs[2],
      lowestOrder = _highOrderDiffs[3];

  var remainingMillis = later - cursor;
  var lowerOrderUnits = units.filter(function (u) {
    return ["hours", "minutes", "seconds", "milliseconds"].indexOf(u) >= 0;
  });

  if (lowerOrderUnits.length === 0) {
    if (highWater < later) {
      var _cursor$plus3;

      highWater = cursor.plus((_cursor$plus3 = {}, _cursor$plus3[lowestOrder] = 1, _cursor$plus3));
    }

    if (highWater !== cursor) {
      results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
  }

  var duration = Duration.fromObject(results, opts);

  if (lowerOrderUnits.length > 0) {
    var _Duration$fromMillis;

    return (_Duration$fromMillis = Duration.fromMillis(remainingMillis, opts)).shiftTo.apply(_Duration$fromMillis, lowerOrderUnits).plus(duration);
  } else {
    return duration;
  }
}

var numberingSystems = {
  arab: "[\u0660-\u0669]",
  arabext: "[\u06F0-\u06F9]",
  bali: "[\u1B50-\u1B59]",
  beng: "[\u09E6-\u09EF]",
  deva: "[\u0966-\u096F]",
  fullwide: "[\uFF10-\uFF19]",
  gujr: "[\u0AE6-\u0AEF]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[\u17E0-\u17E9]",
  knda: "[\u0CE6-\u0CEF]",
  laoo: "[\u0ED0-\u0ED9]",
  limb: "[\u1946-\u194F]",
  mlym: "[\u0D66-\u0D6F]",
  mong: "[\u1810-\u1819]",
  mymr: "[\u1040-\u1049]",
  orya: "[\u0B66-\u0B6F]",
  tamldec: "[\u0BE6-\u0BEF]",
  telu: "[\u0C66-\u0C6F]",
  thai: "[\u0E50-\u0E59]",
  tibt: "[\u0F20-\u0F29]",
  latn: "\\d"
};
var numberingSystemsUTF16 = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
};
var hanidecChars = numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function parseDigits(str) {
  var value = parseInt(str, 10);

  if (isNaN(value)) {
    value = "";

    for (var i = 0; i < str.length; i++) {
      var code = str.charCodeAt(i);

      if (str[i].search(numberingSystems.hanidec) !== -1) {
        value += hanidecChars.indexOf(str[i]);
      } else {
        for (var key in numberingSystemsUTF16) {
          var _numberingSystemsUTF = numberingSystemsUTF16[key],
              min = _numberingSystemsUTF[0],
              max = _numberingSystemsUTF[1];

          if (code >= min && code <= max) {
            value += code - min;
          }
        }
      }
    }

    return parseInt(value, 10);
  } else {
    return value;
  }
}
function digitRegex(_ref, append) {
  var numberingSystem = _ref.numberingSystem;

  if (append === void 0) {
    append = "";
  }

  return new RegExp("" + numberingSystems[numberingSystem || "latn"] + append);
}

var MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";

function intUnit(regex, post) {
  if (post === void 0) {
    post = function post(i) {
      return i;
    };
  }

  return {
    regex: regex,
    deser: function deser(_ref) {
      var s = _ref[0];
      return post(parseDigits(s));
    }
  };
}

var NBSP = String.fromCharCode(160);
var spaceOrNBSP = "( |" + NBSP + ")";
var spaceOrNBSPRegExp = new RegExp(spaceOrNBSP, "g");

function fixListRegex(s) {
  // make dots optional and also make them literal
  // make space and non breakable space characters interchangeable
  return s.replace(/\./g, "\\.?").replace(spaceOrNBSPRegExp, spaceOrNBSP);
}

function stripInsensitivities(s) {
  return s.replace(/\./g, "") // ignore dots that were made optional
  .replace(spaceOrNBSPRegExp, " ") // interchange space and nbsp
  .toLowerCase();
}

function oneOf(strings, startIndex) {
  if (strings === null) {
    return null;
  } else {
    return {
      regex: RegExp(strings.map(fixListRegex).join("|")),
      deser: function deser(_ref2) {
        var s = _ref2[0];
        return strings.findIndex(function (i) {
          return stripInsensitivities(s) === stripInsensitivities(i);
        }) + startIndex;
      }
    };
  }
}

function offset(regex, groups) {
  return {
    regex: regex,
    deser: function deser(_ref3) {
      var h = _ref3[1],
          m = _ref3[2];
      return signedOffset(h, m);
    },
    groups: groups
  };
}

function simple(regex) {
  return {
    regex: regex,
    deser: function deser(_ref4) {
      var s = _ref4[0];
      return s;
    }
  };
}

function escapeToken(value) {
  return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}

function unitForToken(token, loc) {
  var one = digitRegex(loc),
      two = digitRegex(loc, "{2}"),
      three = digitRegex(loc, "{3}"),
      four = digitRegex(loc, "{4}"),
      six = digitRegex(loc, "{6}"),
      oneOrTwo = digitRegex(loc, "{1,2}"),
      oneToThree = digitRegex(loc, "{1,3}"),
      oneToSix = digitRegex(loc, "{1,6}"),
      oneToNine = digitRegex(loc, "{1,9}"),
      twoToFour = digitRegex(loc, "{2,4}"),
      fourToSix = digitRegex(loc, "{4,6}"),
      literal = function literal(t) {
    return {
      regex: RegExp(escapeToken(t.val)),
      deser: function deser(_ref5) {
        var s = _ref5[0];
        return s;
      },
      literal: true
    };
  },
      unitate = function unitate(t) {
    if (token.literal) {
      return literal(t);
    }

    switch (t.val) {
      // era
      case "G":
        return oneOf(loc.eras("short", false), 0);

      case "GG":
        return oneOf(loc.eras("long", false), 0);
      // years

      case "y":
        return intUnit(oneToSix);

      case "yy":
        return intUnit(twoToFour, untruncateYear);

      case "yyyy":
        return intUnit(four);

      case "yyyyy":
        return intUnit(fourToSix);

      case "yyyyyy":
        return intUnit(six);
      // months

      case "M":
        return intUnit(oneOrTwo);

      case "MM":
        return intUnit(two);

      case "MMM":
        return oneOf(loc.months("short", true, false), 1);

      case "MMMM":
        return oneOf(loc.months("long", true, false), 1);

      case "L":
        return intUnit(oneOrTwo);

      case "LL":
        return intUnit(two);

      case "LLL":
        return oneOf(loc.months("short", false, false), 1);

      case "LLLL":
        return oneOf(loc.months("long", false, false), 1);
      // dates

      case "d":
        return intUnit(oneOrTwo);

      case "dd":
        return intUnit(two);
      // ordinals

      case "o":
        return intUnit(oneToThree);

      case "ooo":
        return intUnit(three);
      // time

      case "HH":
        return intUnit(two);

      case "H":
        return intUnit(oneOrTwo);

      case "hh":
        return intUnit(two);

      case "h":
        return intUnit(oneOrTwo);

      case "mm":
        return intUnit(two);

      case "m":
        return intUnit(oneOrTwo);

      case "q":
        return intUnit(oneOrTwo);

      case "qq":
        return intUnit(two);

      case "s":
        return intUnit(oneOrTwo);

      case "ss":
        return intUnit(two);

      case "S":
        return intUnit(oneToThree);

      case "SSS":
        return intUnit(three);

      case "u":
        return simple(oneToNine);

      case "uu":
        return simple(oneOrTwo);

      case "uuu":
        return intUnit(one);
      // meridiem

      case "a":
        return oneOf(loc.meridiems(), 0);
      // weekYear (k)

      case "kkkk":
        return intUnit(four);

      case "kk":
        return intUnit(twoToFour, untruncateYear);
      // weekNumber (W)

      case "W":
        return intUnit(oneOrTwo);

      case "WW":
        return intUnit(two);
      // weekdays

      case "E":
      case "c":
        return intUnit(one);

      case "EEE":
        return oneOf(loc.weekdays("short", false, false), 1);

      case "EEEE":
        return oneOf(loc.weekdays("long", false, false), 1);

      case "ccc":
        return oneOf(loc.weekdays("short", true, false), 1);

      case "cccc":
        return oneOf(loc.weekdays("long", true, false), 1);
      // offset/zone

      case "Z":
      case "ZZ":
        return offset(new RegExp("([+-]" + oneOrTwo.source + ")(?::(" + two.source + "))?"), 2);

      case "ZZZ":
        return offset(new RegExp("([+-]" + oneOrTwo.source + ")(" + two.source + ")?"), 2);
      // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
      // because we don't have any way to figure out what they are

      case "z":
        return simple(/[a-z_+-/]{1,256}?/i);

      default:
        return literal(t);
    }
  };

  var unit = unitate(token) || {
    invalidReason: MISSING_FTP
  };
  unit.token = token;
  return unit;
}

var partTypeStyleToTokenVal = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour: {
    numeric: "h",
    "2-digit": "hh"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  }
};

function tokenForPart(part, locale, formatOpts) {
  var type = part.type,
      value = part.value;

  if (type === "literal") {
    return {
      literal: true,
      val: value
    };
  }

  var style = formatOpts[type];
  var val = partTypeStyleToTokenVal[type];

  if (typeof val === "object") {
    val = val[style];
  }

  if (val) {
    return {
      literal: false,
      val: val
    };
  }

  return undefined;
}

function buildRegex(units) {
  var re = units.map(function (u) {
    return u.regex;
  }).reduce(function (f, r) {
    return f + "(" + r.source + ")";
  }, "");
  return ["^" + re + "$", units];
}

function match(input, regex, handlers) {
  var matches = input.match(regex);

  if (matches) {
    var all = {};
    var matchIndex = 1;

    for (var i in handlers) {
      if (hasOwnProperty(handlers, i)) {
        var h = handlers[i],
            groups = h.groups ? h.groups + 1 : 1;

        if (!h.literal && h.token) {
          all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
        }

        matchIndex += groups;
      }
    }

    return [matches, all];
  } else {
    return [matches, {}];
  }
}

function dateTimeFromMatches(matches) {
  var toField = function toField(token) {
    switch (token) {
      case "S":
        return "millisecond";

      case "s":
        return "second";

      case "m":
        return "minute";

      case "h":
      case "H":
        return "hour";

      case "d":
        return "day";

      case "o":
        return "ordinal";

      case "L":
      case "M":
        return "month";

      case "y":
        return "year";

      case "E":
      case "c":
        return "weekday";

      case "W":
        return "weekNumber";

      case "k":
        return "weekYear";

      case "q":
        return "quarter";

      default:
        return null;
    }
  };

  var zone = null;
  var specificOffset;

  if (!isUndefined(matches.z)) {
    zone = IANAZone.create(matches.z);
  }

  if (!isUndefined(matches.Z)) {
    if (!zone) {
      zone = new FixedOffsetZone(matches.Z);
    }

    specificOffset = matches.Z;
  }

  if (!isUndefined(matches.q)) {
    matches.M = (matches.q - 1) * 3 + 1;
  }

  if (!isUndefined(matches.h)) {
    if (matches.h < 12 && matches.a === 1) {
      matches.h += 12;
    } else if (matches.h === 12 && matches.a === 0) {
      matches.h = 0;
    }
  }

  if (matches.G === 0 && matches.y) {
    matches.y = -matches.y;
  }

  if (!isUndefined(matches.u)) {
    matches.S = parseMillis(matches.u);
  }

  var vals = Object.keys(matches).reduce(function (r, k) {
    var f = toField(k);

    if (f) {
      r[f] = matches[k];
    }

    return r;
  }, {});
  return [vals, zone, specificOffset];
}

var dummyDateTimeCache = null;

function getDummyDateTime() {
  if (!dummyDateTimeCache) {
    dummyDateTimeCache = DateTime.fromMillis(1555555555555);
  }

  return dummyDateTimeCache;
}

function maybeExpandMacroToken(token, locale) {
  if (token.literal) {
    return token;
  }

  var formatOpts = Formatter.macroTokenToFormatOpts(token.val);

  if (!formatOpts) {
    return token;
  }

  var formatter = Formatter.create(locale, formatOpts);
  var parts = formatter.formatDateTimeParts(getDummyDateTime());
  var tokens = parts.map(function (p) {
    return tokenForPart(p, locale, formatOpts);
  });

  if (tokens.includes(undefined)) {
    return token;
  }

  return tokens;
}

function expandMacroTokens(tokens, locale) {
  var _Array$prototype;

  return (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, tokens.map(function (t) {
    return maybeExpandMacroToken(t, locale);
  }));
}
/**
 * @private
 */


function explainFromTokens(locale, input, format) {
  var tokens = expandMacroTokens(Formatter.parseFormat(format), locale),
      units = tokens.map(function (t) {
    return unitForToken(t, locale);
  }),
      disqualifyingUnit = units.find(function (t) {
    return t.invalidReason;
  });

  if (disqualifyingUnit) {
    return {
      input: input,
      tokens: tokens,
      invalidReason: disqualifyingUnit.invalidReason
    };
  } else {
    var _buildRegex = buildRegex(units),
        regexString = _buildRegex[0],
        handlers = _buildRegex[1],
        regex = RegExp(regexString, "i"),
        _match = match(input, regex, handlers),
        rawMatches = _match[0],
        matches = _match[1],
        _ref6 = matches ? dateTimeFromMatches(matches) : [null, null, undefined],
        result = _ref6[0],
        zone = _ref6[1],
        specificOffset = _ref6[2];

    if (hasOwnProperty(matches, "a") && hasOwnProperty(matches, "H")) {
      throw new ConflictingSpecificationError("Can't include meridiem when specifying 24-hour format");
    }

    return {
      input: input,
      tokens: tokens,
      regex: regex,
      rawMatches: rawMatches,
      matches: matches,
      result: result,
      zone: zone,
      specificOffset: specificOffset
    };
  }
}
function parseFromTokens(locale, input, format) {
  var _explainFromTokens = explainFromTokens(locale, input, format),
      result = _explainFromTokens.result,
      zone = _explainFromTokens.zone,
      specificOffset = _explainFromTokens.specificOffset,
      invalidReason = _explainFromTokens.invalidReason;

  return [result, zone, specificOffset, invalidReason];
}

var nonLeapLadder = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334],
    leapLadder = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];

function unitOutOfRange(unit, value) {
  return new Invalid("unit out of range", "you specified " + value + " (of type " + typeof value + ") as a " + unit + ", which is invalid");
}

function dayOfWeek(year, month, day) {
  var js = new Date(Date.UTC(year, month - 1, day)).getUTCDay();
  return js === 0 ? 7 : js;
}

function computeOrdinal(year, month, day) {
  return day + (isLeapYear(year) ? leapLadder : nonLeapLadder)[month - 1];
}

function uncomputeOrdinal(year, ordinal) {
  var table = isLeapYear(year) ? leapLadder : nonLeapLadder,
      month0 = table.findIndex(function (i) {
    return i < ordinal;
  }),
      day = ordinal - table[month0];
  return {
    month: month0 + 1,
    day: day
  };
}
/**
 * @private
 */


function gregorianToWeek(gregObj) {
  var year = gregObj.year,
      month = gregObj.month,
      day = gregObj.day,
      ordinal = computeOrdinal(year, month, day),
      weekday = dayOfWeek(year, month, day);
  var weekNumber = Math.floor((ordinal - weekday + 10) / 7),
      weekYear;

  if (weekNumber < 1) {
    weekYear = year - 1;
    weekNumber = weeksInWeekYear(weekYear);
  } else if (weekNumber > weeksInWeekYear(year)) {
    weekYear = year + 1;
    weekNumber = 1;
  } else {
    weekYear = year;
  }

  return _extends({
    weekYear: weekYear,
    weekNumber: weekNumber,
    weekday: weekday
  }, timeObject(gregObj));
}
function weekToGregorian(weekData) {
  var weekYear = weekData.weekYear,
      weekNumber = weekData.weekNumber,
      weekday = weekData.weekday,
      weekdayOfJan4 = dayOfWeek(weekYear, 1, 4),
      yearInDays = daysInYear(weekYear);
  var ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 3,
      year;

  if (ordinal < 1) {
    year = weekYear - 1;
    ordinal += daysInYear(year);
  } else if (ordinal > yearInDays) {
    year = weekYear + 1;
    ordinal -= daysInYear(weekYear);
  } else {
    year = weekYear;
  }

  var _uncomputeOrdinal = uncomputeOrdinal(year, ordinal),
      month = _uncomputeOrdinal.month,
      day = _uncomputeOrdinal.day;

  return _extends({
    year: year,
    month: month,
    day: day
  }, timeObject(weekData));
}
function gregorianToOrdinal(gregData) {
  var year = gregData.year,
      month = gregData.month,
      day = gregData.day;
  var ordinal = computeOrdinal(year, month, day);
  return _extends({
    year: year,
    ordinal: ordinal
  }, timeObject(gregData));
}
function ordinalToGregorian(ordinalData) {
  var year = ordinalData.year,
      ordinal = ordinalData.ordinal;

  var _uncomputeOrdinal2 = uncomputeOrdinal(year, ordinal),
      month = _uncomputeOrdinal2.month,
      day = _uncomputeOrdinal2.day;

  return _extends({
    year: year,
    month: month,
    day: day
  }, timeObject(ordinalData));
}
function hasInvalidWeekData(obj) {
  var validYear = isInteger(obj.weekYear),
      validWeek = integerBetween(obj.weekNumber, 1, weeksInWeekYear(obj.weekYear)),
      validWeekday = integerBetween(obj.weekday, 1, 7);

  if (!validYear) {
    return unitOutOfRange("weekYear", obj.weekYear);
  } else if (!validWeek) {
    return unitOutOfRange("week", obj.week);
  } else if (!validWeekday) {
    return unitOutOfRange("weekday", obj.weekday);
  } else return false;
}
function hasInvalidOrdinalData(obj) {
  var validYear = isInteger(obj.year),
      validOrdinal = integerBetween(obj.ordinal, 1, daysInYear(obj.year));

  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validOrdinal) {
    return unitOutOfRange("ordinal", obj.ordinal);
  } else return false;
}
function hasInvalidGregorianData(obj) {
  var validYear = isInteger(obj.year),
      validMonth = integerBetween(obj.month, 1, 12),
      validDay = integerBetween(obj.day, 1, daysInMonth(obj.year, obj.month));

  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validMonth) {
    return unitOutOfRange("month", obj.month);
  } else if (!validDay) {
    return unitOutOfRange("day", obj.day);
  } else return false;
}
function hasInvalidTimeData(obj) {
  var hour = obj.hour,
      minute = obj.minute,
      second = obj.second,
      millisecond = obj.millisecond;
  var validHour = integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0,
      validMinute = integerBetween(minute, 0, 59),
      validSecond = integerBetween(second, 0, 59),
      validMillisecond = integerBetween(millisecond, 0, 999);

  if (!validHour) {
    return unitOutOfRange("hour", hour);
  } else if (!validMinute) {
    return unitOutOfRange("minute", minute);
  } else if (!validSecond) {
    return unitOutOfRange("second", second);
  } else if (!validMillisecond) {
    return unitOutOfRange("millisecond", millisecond);
  } else return false;
}

var INVALID = "Invalid DateTime";
var MAX_DATE = 8.64e15;

function unsupportedZone(zone) {
  return new Invalid("unsupported zone", "the zone \"" + zone.name + "\" is not supported");
} // we cache week data on the DT object and this intermediates the cache


function possiblyCachedWeekData(dt) {
  if (dt.weekData === null) {
    dt.weekData = gregorianToWeek(dt.c);
  }

  return dt.weekData;
} // clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties


function clone(inst, alts) {
  var current = {
    ts: inst.ts,
    zone: inst.zone,
    c: inst.c,
    o: inst.o,
    loc: inst.loc,
    invalid: inst.invalid
  };
  return new DateTime(_extends({}, current, alts, {
    old: current
  }));
} // find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)


function fixOffset(localTS, o, tz) {
  // Our UTC time is just a guess because our offset is just a guess
  var utcGuess = localTS - o * 60 * 1000; // Test whether the zone matches the offset for this ts

  var o2 = tz.offset(utcGuess); // If so, offset didn't change and we're done

  if (o === o2) {
    return [utcGuess, o];
  } // If not, change the ts by the difference in the offset


  utcGuess -= (o2 - o) * 60 * 1000; // If that gives us the local time we want, we're done

  var o3 = tz.offset(utcGuess);

  if (o2 === o3) {
    return [utcGuess, o2];
  } // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time


  return [localTS - Math.min(o2, o3) * 60 * 1000, Math.max(o2, o3)];
} // convert an epoch timestamp into a calendar object with the given offset


function tsToObj(ts, offset) {
  ts += offset * 60 * 1000;
  var d = new Date(ts);
  return {
    year: d.getUTCFullYear(),
    month: d.getUTCMonth() + 1,
    day: d.getUTCDate(),
    hour: d.getUTCHours(),
    minute: d.getUTCMinutes(),
    second: d.getUTCSeconds(),
    millisecond: d.getUTCMilliseconds()
  };
} // convert a calendar object to a epoch timestamp


function objToTS(obj, offset, zone) {
  return fixOffset(objToLocalTS(obj), offset, zone);
} // create a new DT instance by adding a duration, adjusting for DSTs


function adjustTime(inst, dur) {
  var oPre = inst.o,
      year = inst.c.year + Math.trunc(dur.years),
      month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3,
      c = _extends({}, inst.c, {
    year: year,
    month: month,
    day: Math.min(inst.c.day, daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
  }),
      millisToAdd = Duration.fromObject({
    years: dur.years - Math.trunc(dur.years),
    quarters: dur.quarters - Math.trunc(dur.quarters),
    months: dur.months - Math.trunc(dur.months),
    weeks: dur.weeks - Math.trunc(dur.weeks),
    days: dur.days - Math.trunc(dur.days),
    hours: dur.hours,
    minutes: dur.minutes,
    seconds: dur.seconds,
    milliseconds: dur.milliseconds
  }).as("milliseconds"),
      localTS = objToLocalTS(c);

  var _fixOffset = fixOffset(localTS, oPre, inst.zone),
      ts = _fixOffset[0],
      o = _fixOffset[1];

  if (millisToAdd !== 0) {
    ts += millisToAdd; // that could have changed the offset by going over a DST, but we want to keep the ts the same

    o = inst.zone.offset(ts);
  }

  return {
    ts: ts,
    o: o
  };
} // helper useful in turning the results of parsing into real dates
// by handling the zone options


function parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
  var setZone = opts.setZone,
      zone = opts.zone;

  if (parsed && Object.keys(parsed).length !== 0) {
    var interpretationZone = parsedZone || zone,
        inst = DateTime.fromObject(parsed, _extends({}, opts, {
      zone: interpretationZone,
      specificOffset: specificOffset
    }));
    return setZone ? inst : inst.setZone(zone);
  } else {
    return DateTime.invalid(new Invalid("unparsable", "the input \"" + text + "\" can't be parsed as " + format));
  }
} // if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details


function toTechFormat(dt, format, allowZ) {
  if (allowZ === void 0) {
    allowZ = true;
  }

  return dt.isValid ? Formatter.create(Locale.create("en-US"), {
    allowZ: allowZ,
    forceSimple: true
  }).formatDateTimeFromString(dt, format) : null;
} // technical time formats (e.g. the time part of ISO 8601), take some options
// and this commonizes their handling


function toTechTimeFormat(dt, _ref) {
  var _ref$suppressSeconds = _ref.suppressSeconds,
      suppressSeconds = _ref$suppressSeconds === void 0 ? false : _ref$suppressSeconds,
      _ref$suppressMillisec = _ref.suppressMilliseconds,
      suppressMilliseconds = _ref$suppressMillisec === void 0 ? false : _ref$suppressMillisec,
      includeOffset = _ref.includeOffset,
      _ref$includePrefix = _ref.includePrefix,
      includePrefix = _ref$includePrefix === void 0 ? false : _ref$includePrefix,
      _ref$includeZone = _ref.includeZone,
      includeZone = _ref$includeZone === void 0 ? false : _ref$includeZone,
      _ref$spaceZone = _ref.spaceZone,
      spaceZone = _ref$spaceZone === void 0 ? false : _ref$spaceZone,
      _ref$format = _ref.format,
      format = _ref$format === void 0 ? "extended" : _ref$format;
  var fmt = format === "basic" ? "HHmm" : "HH:mm";

  if (!suppressSeconds || dt.second !== 0 || dt.millisecond !== 0) {
    fmt += format === "basic" ? "ss" : ":ss";

    if (!suppressMilliseconds || dt.millisecond !== 0) {
      fmt += ".SSS";
    }
  }

  if ((includeZone || includeOffset) && spaceZone) {
    fmt += " ";
  }

  if (includeZone) {
    fmt += "z";
  } else if (includeOffset) {
    fmt += format === "basic" ? "ZZZ" : "ZZ";
  }

  var str = toTechFormat(dt, fmt);

  if (includePrefix) {
    str = "T" + str;
  }

  return str;
} // defaults for unspecified units in the supported calendars


var defaultUnitValues = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
},
    defaultWeekUnitValues = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
},
    defaultOrdinalUnitValues = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}; // Units in the supported calendars, sorted by bigness

var orderedUnits = ["year", "month", "day", "hour", "minute", "second", "millisecond"],
    orderedWeekUnits = ["weekYear", "weekNumber", "weekday", "hour", "minute", "second", "millisecond"],
    orderedOrdinalUnits = ["year", "ordinal", "hour", "minute", "second", "millisecond"]; // standardize case and plurality in units

function normalizeUnit(unit) {
  var normalized = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[unit.toLowerCase()];
  if (!normalized) throw new InvalidUnitError(unit);
  return normalized;
} // this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
// this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.


function quickDT(obj, opts) {
  var zone = normalizeZone(opts.zone, Settings.defaultZone),
      loc = Locale.fromObject(opts),
      tsNow = Settings.now();
  var ts, o; // assume we have the higher-order units

  if (!isUndefined(obj.year)) {
    for (var _iterator = _createForOfIteratorHelperLoose(orderedUnits), _step; !(_step = _iterator()).done;) {
      var u = _step.value;

      if (isUndefined(obj[u])) {
        obj[u] = defaultUnitValues[u];
      }
    }

    var invalid = hasInvalidGregorianData(obj) || hasInvalidTimeData(obj);

    if (invalid) {
      return DateTime.invalid(invalid);
    }

    var offsetProvis = zone.offset(tsNow);

    var _objToTS = objToTS(obj, offsetProvis, zone);

    ts = _objToTS[0];
    o = _objToTS[1];
  } else {
    ts = tsNow;
  }

  return new DateTime({
    ts: ts,
    zone: zone,
    loc: loc,
    o: o
  });
}

function diffRelative(start, end, opts) {
  var round = isUndefined(opts.round) ? true : opts.round,
      format = function format(c, unit) {
    c = roundTo(c, round || opts.calendary ? 0 : 2, true);
    var formatter = end.loc.clone(opts).relFormatter(opts);
    return formatter.format(c, unit);
  },
      differ = function differ(unit) {
    if (opts.calendary) {
      if (!end.hasSame(start, unit)) {
        return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
      } else return 0;
    } else {
      return end.diff(start, unit).get(unit);
    }
  };

  if (opts.unit) {
    return format(differ(opts.unit), opts.unit);
  }

  for (var _iterator2 = _createForOfIteratorHelperLoose(opts.units), _step2; !(_step2 = _iterator2()).done;) {
    var unit = _step2.value;
    var count = differ(unit);

    if (Math.abs(count) >= 1) {
      return format(count, unit);
    }
  }

  return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}

function lastOpts(argList) {
  var opts = {},
      args;

  if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
    opts = argList[argList.length - 1];
    args = Array.from(argList).slice(0, argList.length - 1);
  } else {
    args = Array.from(argList);
  }

  return [opts, args];
}
/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link DateTime#local}, {@link DateTime#utc}, and (most flexibly) {@link DateTime#fromObject}. To create one from a standard string format, use {@link DateTime#fromISO}, {@link DateTime#fromHTTP}, and {@link DateTime#fromRFC2822}. To create one from a custom string format, use {@link DateTime#fromFormat}. To create one from a native JS date, use {@link DateTime#fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link DateTime#toObject}), use the {@link DateTime#year}, {@link DateTime#month},
 * {@link DateTime#day}, {@link DateTime#hour}, {@link DateTime#minute}, {@link DateTime#second}, {@link DateTime#millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link DateTime#weekYear}, {@link DateTime#weekNumber}, and {@link DateTime#weekday} accessors.
 * * **Configuration** See the {@link DateTime#locale} and {@link DateTime#numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link DateTime#set}, {@link DateTime#reconfigure}, {@link DateTime#setZone}, {@link DateTime#setLocale}, {@link DateTime.plus}, {@link DateTime#minus}, {@link DateTime#endOf}, {@link DateTime#startOf}, {@link DateTime#toUTC}, and {@link DateTime#toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link DateTime#toRelative}, {@link DateTime#toRelativeCalendar}, {@link DateTime#toJSON}, {@link DateTime#toISO}, {@link DateTime#toHTTP}, {@link DateTime#toObject}, {@link DateTime#toRFC2822}, {@link DateTime#toString}, {@link DateTime#toLocaleString}, {@link DateTime#toFormat}, {@link DateTime#toMillis} and {@link DateTime#toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */


var DateTime = /*#__PURE__*/function () {
  /**
   * @access private
   */
  function DateTime(config) {
    var zone = config.zone || Settings.defaultZone;
    var invalid = config.invalid || (Number.isNaN(config.ts) ? new Invalid("invalid input") : null) || (!zone.isValid ? unsupportedZone(zone) : null);
    /**
     * @access private
     */

    this.ts = isUndefined(config.ts) ? Settings.now() : config.ts;
    var c = null,
        o = null;

    if (!invalid) {
      var unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);

      if (unchanged) {
        var _ref2 = [config.old.c, config.old.o];
        c = _ref2[0];
        o = _ref2[1];
      } else {
        var ot = zone.offset(this.ts);
        c = tsToObj(this.ts, ot);
        invalid = Number.isNaN(c.year) ? new Invalid("invalid input") : null;
        c = invalid ? null : c;
        o = invalid ? null : ot;
      }
    }
    /**
     * @access private
     */


    this._zone = zone;
    /**
     * @access private
     */

    this.loc = config.loc || Locale.create();
    /**
     * @access private
     */

    this.invalid = invalid;
    /**
     * @access private
     */

    this.weekData = null;
    /**
     * @access private
     */

    this.c = c;
    /**
     * @access private
     */

    this.o = o;
    /**
     * @access private
     */

    this.isLuxonDateTime = true;
  } // CONSTRUCT

  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */


  DateTime.now = function now() {
    return new DateTime({});
  }
  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  ;

  DateTime.local = function local() {
    var _lastOpts = lastOpts(arguments),
        opts = _lastOpts[0],
        args = _lastOpts[1],
        year = args[0],
        month = args[1],
        day = args[2],
        hour = args[3],
        minute = args[4],
        second = args[5],
        millisecond = args[6];

    return quickDT({
      year: year,
      month: month,
      day: day,
      hour: hour,
      minute: minute,
      second: second,
      millisecond: millisecond
    }, opts);
  }
  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  ;

  DateTime.utc = function utc() {
    var _lastOpts2 = lastOpts(arguments),
        opts = _lastOpts2[0],
        args = _lastOpts2[1],
        year = args[0],
        month = args[1],
        day = args[2],
        hour = args[3],
        minute = args[4],
        second = args[5],
        millisecond = args[6];

    opts.zone = FixedOffsetZone.utcInstance;
    return quickDT({
      year: year,
      month: month,
      day: day,
      hour: hour,
      minute: minute,
      second: second,
      millisecond: millisecond
    }, opts);
  }
  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  ;

  DateTime.fromJSDate = function fromJSDate(date, options) {
    if (options === void 0) {
      options = {};
    }

    var ts = isDate(date) ? date.valueOf() : NaN;

    if (Number.isNaN(ts)) {
      return DateTime.invalid("invalid input");
    }

    var zoneToUse = normalizeZone(options.zone, Settings.defaultZone);

    if (!zoneToUse.isValid) {
      return DateTime.invalid(unsupportedZone(zoneToUse));
    }

    return new DateTime({
      ts: ts,
      zone: zoneToUse,
      loc: Locale.fromObject(options)
    });
  }
  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */
  ;

  DateTime.fromMillis = function fromMillis(milliseconds, options) {
    if (options === void 0) {
      options = {};
    }

    if (!isNumber(milliseconds)) {
      throw new InvalidArgumentError("fromMillis requires a numerical input, but received a " + typeof milliseconds + " with value " + milliseconds);
    } else if (milliseconds < -MAX_DATE || milliseconds > MAX_DATE) {
      // this isn't perfect because because we can still end up out of range because of additional shifting, but it's a start
      return DateTime.invalid("Timestamp out of range");
    } else {
      return new DateTime({
        ts: milliseconds,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options)
      });
    }
  }
  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */
  ;

  DateTime.fromSeconds = function fromSeconds(seconds, options) {
    if (options === void 0) {
      options = {};
    }

    if (!isNumber(seconds)) {
      throw new InvalidArgumentError("fromSeconds requires a numerical input");
    } else {
      return new DateTime({
        ts: seconds * 1000,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options)
      });
    }
  }
  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @return {DateTime}
   */
  ;

  DateTime.fromObject = function fromObject(obj, opts) {
    if (opts === void 0) {
      opts = {};
    }

    obj = obj || {};
    var zoneToUse = normalizeZone(opts.zone, Settings.defaultZone);

    if (!zoneToUse.isValid) {
      return DateTime.invalid(unsupportedZone(zoneToUse));
    }

    var tsNow = Settings.now(),
        offsetProvis = !isUndefined(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow),
        normalized = normalizeObject(obj, normalizeUnit),
        containsOrdinal = !isUndefined(normalized.ordinal),
        containsGregorYear = !isUndefined(normalized.year),
        containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day),
        containsGregor = containsGregorYear || containsGregorMD,
        definiteWeekDef = normalized.weekYear || normalized.weekNumber,
        loc = Locale.fromObject(opts); // cases:
    // just a weekday -> this week's instance of that weekday, no worries
    // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
    // (gregorian month or day) + ordinal -> error
    // otherwise just use weeks or ordinals or gregorian, depending on what's specified

    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
    }

    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }

    var useWeekData = definiteWeekDef || normalized.weekday && !containsGregor; // configure ourselves to deal with gregorian dates or week stuff

    var units,
        defaultValues,
        objNow = tsToObj(tsNow, offsetProvis);

    if (useWeekData) {
      units = orderedWeekUnits;
      defaultValues = defaultWeekUnitValues;
      objNow = gregorianToWeek(objNow);
    } else if (containsOrdinal) {
      units = orderedOrdinalUnits;
      defaultValues = defaultOrdinalUnitValues;
      objNow = gregorianToOrdinal(objNow);
    } else {
      units = orderedUnits;
      defaultValues = defaultUnitValues;
    } // set default values for missing stuff


    var foundFirst = false;

    for (var _iterator3 = _createForOfIteratorHelperLoose(units), _step3; !(_step3 = _iterator3()).done;) {
      var u = _step3.value;
      var v = normalized[u];

      if (!isUndefined(v)) {
        foundFirst = true;
      } else if (foundFirst) {
        normalized[u] = defaultValues[u];
      } else {
        normalized[u] = objNow[u];
      }
    } // make sure the values we have are in range


    var higherOrderInvalid = useWeekData ? hasInvalidWeekData(normalized) : containsOrdinal ? hasInvalidOrdinalData(normalized) : hasInvalidGregorianData(normalized),
        invalid = higherOrderInvalid || hasInvalidTimeData(normalized);

    if (invalid) {
      return DateTime.invalid(invalid);
    } // compute the actual time


    var gregorian = useWeekData ? weekToGregorian(normalized) : containsOrdinal ? ordinalToGregorian(normalized) : normalized,
        _objToTS2 = objToTS(gregorian, offsetProvis, zoneToUse),
        tsFinal = _objToTS2[0],
        offsetFinal = _objToTS2[1],
        inst = new DateTime({
      ts: tsFinal,
      zone: zoneToUse,
      o: offsetFinal,
      loc: loc
    }); // gregorian data + weekday serves only to validate


    if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) {
      return DateTime.invalid("mismatched weekday", "you can't specify both a weekday of " + normalized.weekday + " and a date of " + inst.toISO());
    }

    return inst;
  }
  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  ;

  DateTime.fromISO = function fromISO(text, opts) {
    if (opts === void 0) {
      opts = {};
    }

    var _parseISODate = parseISODate(text),
        vals = _parseISODate[0],
        parsedZone = _parseISODate[1];

    return parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
  }
  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  ;

  DateTime.fromRFC2822 = function fromRFC2822(text, opts) {
    if (opts === void 0) {
      opts = {};
    }

    var _parseRFC2822Date = parseRFC2822Date(text),
        vals = _parseRFC2822Date[0],
        parsedZone = _parseRFC2822Date[1];

    return parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
  }
  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  ;

  DateTime.fromHTTP = function fromHTTP(text, opts) {
    if (opts === void 0) {
      opts = {};
    }

    var _parseHTTPDate = parseHTTPDate(text),
        vals = _parseHTTPDate[0],
        parsedZone = _parseHTTPDate[1];

    return parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
  }
  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  ;

  DateTime.fromFormat = function fromFormat(text, fmt, opts) {
    if (opts === void 0) {
      opts = {};
    }

    if (isUndefined(text) || isUndefined(fmt)) {
      throw new InvalidArgumentError("fromFormat requires an input string and a format");
    }

    var _opts = opts,
        _opts$locale = _opts.locale,
        locale = _opts$locale === void 0 ? null : _opts$locale,
        _opts$numberingSystem = _opts.numberingSystem,
        numberingSystem = _opts$numberingSystem === void 0 ? null : _opts$numberingSystem,
        localeToUse = Locale.fromOpts({
      locale: locale,
      numberingSystem: numberingSystem,
      defaultToEN: true
    }),
        _parseFromTokens = parseFromTokens(localeToUse, text, fmt),
        vals = _parseFromTokens[0],
        parsedZone = _parseFromTokens[1],
        specificOffset = _parseFromTokens[2],
        invalid = _parseFromTokens[3];

    if (invalid) {
      return DateTime.invalid(invalid);
    } else {
      return parseDataToDateTime(vals, parsedZone, opts, "format " + fmt, text, specificOffset);
    }
  }
  /**
   * @deprecated use fromFormat instead
   */
  ;

  DateTime.fromString = function fromString(text, fmt, opts) {
    if (opts === void 0) {
      opts = {};
    }

    return DateTime.fromFormat(text, fmt, opts);
  }
  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  ;

  DateTime.fromSQL = function fromSQL(text, opts) {
    if (opts === void 0) {
      opts = {};
    }

    var _parseSQL = parseSQL(text),
        vals = _parseSQL[0],
        parsedZone = _parseSQL[1];

    return parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
  }
  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  ;

  DateTime.invalid = function invalid(reason, explanation) {
    if (explanation === void 0) {
      explanation = null;
    }

    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the DateTime is invalid");
    }

    var invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);

    if (Settings.throwOnInvalid) {
      throw new InvalidDateTimeError(invalid);
    } else {
      return new DateTime({
        invalid: invalid
      });
    }
  }
  /**
   * Check if an object is a DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  ;

  DateTime.isDateTime = function isDateTime(o) {
    return o && o.isLuxonDateTime || false;
  } // INFO

  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  ;

  var _proto = DateTime.prototype;

  _proto.get = function get(unit) {
    return this[unit];
  }
  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  ;

  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  _proto.resolvedLocaleOptions = function resolvedLocaleOptions(opts) {
    if (opts === void 0) {
      opts = {};
    }

    var _Formatter$create$res = Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this),
        locale = _Formatter$create$res.locale,
        numberingSystem = _Formatter$create$res.numberingSystem,
        calendar = _Formatter$create$res.calendar;

    return {
      locale: locale,
      numberingSystem: numberingSystem,
      outputCalendar: calendar
    };
  } // TRANSFORM

  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  ;

  _proto.toUTC = function toUTC(offset, opts) {
    if (offset === void 0) {
      offset = 0;
    }

    if (opts === void 0) {
      opts = {};
    }

    return this.setZone(FixedOffsetZone.instance(offset), opts);
  }
  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  ;

  _proto.toLocal = function toLocal() {
    return this.setZone(Settings.defaultZone);
  }
  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  ;

  _proto.setZone = function setZone(zone, _temp) {
    var _ref3 = _temp === void 0 ? {} : _temp,
        _ref3$keepLocalTime = _ref3.keepLocalTime,
        keepLocalTime = _ref3$keepLocalTime === void 0 ? false : _ref3$keepLocalTime,
        _ref3$keepCalendarTim = _ref3.keepCalendarTime,
        keepCalendarTime = _ref3$keepCalendarTim === void 0 ? false : _ref3$keepCalendarTim;

    zone = normalizeZone(zone, Settings.defaultZone);

    if (zone.equals(this.zone)) {
      return this;
    } else if (!zone.isValid) {
      return DateTime.invalid(unsupportedZone(zone));
    } else {
      var newTS = this.ts;

      if (keepLocalTime || keepCalendarTime) {
        var offsetGuess = zone.offset(this.ts);
        var asObj = this.toObject();

        var _objToTS3 = objToTS(asObj, offsetGuess, zone);

        newTS = _objToTS3[0];
      }

      return clone(this, {
        ts: newTS,
        zone: zone
      });
    }
  }
  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  ;

  _proto.reconfigure = function reconfigure(_temp2) {
    var _ref4 = _temp2 === void 0 ? {} : _temp2,
        locale = _ref4.locale,
        numberingSystem = _ref4.numberingSystem,
        outputCalendar = _ref4.outputCalendar;

    var loc = this.loc.clone({
      locale: locale,
      numberingSystem: numberingSystem,
      outputCalendar: outputCalendar
    });
    return clone(this, {
      loc: loc
    });
  }
  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  ;

  _proto.setLocale = function setLocale(locale) {
    return this.reconfigure({
      locale: locale
    });
  }
  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  ;

  _proto.set = function set(values) {
    if (!this.isValid) return this;
    var normalized = normalizeObject(values, normalizeUnit),
        settingWeekStuff = !isUndefined(normalized.weekYear) || !isUndefined(normalized.weekNumber) || !isUndefined(normalized.weekday),
        containsOrdinal = !isUndefined(normalized.ordinal),
        containsGregorYear = !isUndefined(normalized.year),
        containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day),
        containsGregor = containsGregorYear || containsGregorMD,
        definiteWeekDef = normalized.weekYear || normalized.weekNumber;

    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
    }

    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }

    var mixed;

    if (settingWeekStuff) {
      mixed = weekToGregorian(_extends({}, gregorianToWeek(this.c), normalized));
    } else if (!isUndefined(normalized.ordinal)) {
      mixed = ordinalToGregorian(_extends({}, gregorianToOrdinal(this.c), normalized));
    } else {
      mixed = _extends({}, this.toObject(), normalized); // if we didn't set the day but we ended up on an overflow date,
      // use the last day of the right month

      if (isUndefined(normalized.day)) {
        mixed.day = Math.min(daysInMonth(mixed.year, mixed.month), mixed.day);
      }
    }

    var _objToTS4 = objToTS(mixed, this.o, this.zone),
        ts = _objToTS4[0],
        o = _objToTS4[1];

    return clone(this, {
      ts: ts,
      o: o
    });
  }
  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  ;

  _proto.plus = function plus(duration) {
    if (!this.isValid) return this;
    var dur = Duration.fromDurationLike(duration);
    return clone(this, adjustTime(this, dur));
  }
  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
  */
  ;

  _proto.minus = function minus(duration) {
    if (!this.isValid) return this;
    var dur = Duration.fromDurationLike(duration).negate();
    return clone(this, adjustTime(this, dur));
  }
  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  ;

  _proto.startOf = function startOf(unit) {
    if (!this.isValid) return this;
    var o = {},
        normalizedUnit = Duration.normalizeUnit(unit);

    switch (normalizedUnit) {
      case "years":
        o.month = 1;
      // falls through

      case "quarters":
      case "months":
        o.day = 1;
      // falls through

      case "weeks":
      case "days":
        o.hour = 0;
      // falls through

      case "hours":
        o.minute = 0;
      // falls through

      case "minutes":
        o.second = 0;
      // falls through

      case "seconds":
        o.millisecond = 0;
        break;
      // no default, invalid units throw in normalizeUnit()
    }

    if (normalizedUnit === "weeks") {
      o.weekday = 1;
    }

    if (normalizedUnit === "quarters") {
      var q = Math.ceil(this.month / 3);
      o.month = (q - 1) * 3 + 1;
    }

    return this.set(o);
  }
  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  ;

  _proto.endOf = function endOf(unit) {
    var _this$plus;

    return this.isValid ? this.plus((_this$plus = {}, _this$plus[unit] = 1, _this$plus)).startOf(unit).minus(1) : this;
  } // OUTPUT

  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  ;

  _proto.toFormat = function toFormat(fmt, opts) {
    if (opts === void 0) {
      opts = {};
    }

    return this.isValid ? Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : INVALID;
  }
  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString({ locale: 'en-gb' }); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  ;

  _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
    if (formatOpts === void 0) {
      formatOpts = DATE_SHORT;
    }

    if (opts === void 0) {
      opts = {};
    }

    return this.isValid ? Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : INVALID;
  }
  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  ;

  _proto.toLocaleParts = function toLocaleParts(opts) {
    if (opts === void 0) {
      opts = {};
    }

    return this.isValid ? Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */
  ;

  _proto.toISO = function toISO(opts) {
    if (opts === void 0) {
      opts = {};
    }

    if (!this.isValid) {
      return null;
    }

    return this.toISODate(opts) + "T" + this.toISOTime(opts);
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */
  ;

  _proto.toISODate = function toISODate(_temp3) {
    var _ref5 = _temp3 === void 0 ? {} : _temp3,
        _ref5$format = _ref5.format,
        format = _ref5$format === void 0 ? "extended" : _ref5$format;

    var fmt = format === "basic" ? "yyyyMMdd" : "yyyy-MM-dd";

    if (this.year > 9999) {
      fmt = "+" + fmt;
    }

    return toTechFormat(this, fmt);
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  ;

  _proto.toISOWeekDate = function toISOWeekDate() {
    return toTechFormat(this, "kkkk-'W'WW-c");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */
  ;

  _proto.toISOTime = function toISOTime(_temp4) {
    var _ref6 = _temp4 === void 0 ? {} : _temp4,
        _ref6$suppressMillise = _ref6.suppressMilliseconds,
        suppressMilliseconds = _ref6$suppressMillise === void 0 ? false : _ref6$suppressMillise,
        _ref6$suppressSeconds = _ref6.suppressSeconds,
        suppressSeconds = _ref6$suppressSeconds === void 0 ? false : _ref6$suppressSeconds,
        _ref6$includeOffset = _ref6.includeOffset,
        includeOffset = _ref6$includeOffset === void 0 ? true : _ref6$includeOffset,
        _ref6$includePrefix = _ref6.includePrefix,
        includePrefix = _ref6$includePrefix === void 0 ? false : _ref6$includePrefix,
        _ref6$format = _ref6.format,
        format = _ref6$format === void 0 ? "extended" : _ref6$format;

    return toTechTimeFormat(this, {
      suppressSeconds: suppressSeconds,
      suppressMilliseconds: suppressMilliseconds,
      includeOffset: includeOffset,
      includePrefix: includePrefix,
      format: format
    });
  }
  /**
   * Returns an RFC 2822-compatible string representation of this DateTime, always in UTC
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  ;

  _proto.toRFC2822 = function toRFC2822() {
    return toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  ;

  _proto.toHTTP = function toHTTP() {
    return toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */
  ;

  _proto.toSQLDate = function toSQLDate() {
    return toTechFormat(this, "yyyy-MM-dd");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  ;

  _proto.toSQLTime = function toSQLTime(_temp5) {
    var _ref7 = _temp5 === void 0 ? {} : _temp5,
        _ref7$includeOffset = _ref7.includeOffset,
        includeOffset = _ref7$includeOffset === void 0 ? true : _ref7$includeOffset,
        _ref7$includeZone = _ref7.includeZone,
        includeZone = _ref7$includeZone === void 0 ? false : _ref7$includeZone;

    return toTechTimeFormat(this, {
      includeOffset: includeOffset,
      includeZone: includeZone,
      spaceZone: true
    });
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  ;

  _proto.toSQL = function toSQL(opts) {
    if (opts === void 0) {
      opts = {};
    }

    if (!this.isValid) {
      return null;
    }

    return this.toSQLDate() + " " + this.toSQLTime(opts);
  }
  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  ;

  _proto.toString = function toString() {
    return this.isValid ? this.toISO() : INVALID;
  }
  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  ;

  _proto.valueOf = function valueOf() {
    return this.toMillis();
  }
  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  ;

  _proto.toMillis = function toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */
  ;

  _proto.toSeconds = function toSeconds() {
    return this.isValid ? this.ts / 1000 : NaN;
  }
  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  ;

  _proto.toJSON = function toJSON() {
    return this.toISO();
  }
  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  ;

  _proto.toBSON = function toBSON() {
    return this.toJSDate();
  }
  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  ;

  _proto.toObject = function toObject(opts) {
    if (opts === void 0) {
      opts = {};
    }

    if (!this.isValid) return {};

    var base = _extends({}, this.c);

    if (opts.includeConfig) {
      base.outputCalendar = this.outputCalendar;
      base.numberingSystem = this.loc.numberingSystem;
      base.locale = this.loc.locale;
    }

    return base;
  }
  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  ;

  _proto.toJSDate = function toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  } // COMPARE

  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  ;

  _proto.diff = function diff(otherDateTime, unit, opts) {
    if (unit === void 0) {
      unit = "milliseconds";
    }

    if (opts === void 0) {
      opts = {};
    }

    if (!this.isValid || !otherDateTime.isValid) {
      return Duration.invalid("created by diffing an invalid DateTime");
    }

    var durOpts = _extends({
      locale: this.locale,
      numberingSystem: this.numberingSystem
    }, opts);

    var units = maybeArray(unit).map(Duration.normalizeUnit),
        otherIsLater = otherDateTime.valueOf() > this.valueOf(),
        earlier = otherIsLater ? this : otherDateTime,
        later = otherIsLater ? otherDateTime : this,
        diffed = _diff(earlier, later, units, durOpts);

    return otherIsLater ? diffed.negate() : diffed;
  }
  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  ;

  _proto.diffNow = function diffNow(unit, opts) {
    if (unit === void 0) {
      unit = "milliseconds";
    }

    if (opts === void 0) {
      opts = {};
    }

    return this.diff(DateTime.now(), unit, opts);
  }
  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */
  ;

  _proto.until = function until(otherDateTime) {
    return this.isValid ? Interval.fromDateTimes(this, otherDateTime) : this;
  }
  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  ;

  _proto.hasSame = function hasSame(otherDateTime, unit) {
    if (!this.isValid) return false;
    var inputMs = otherDateTime.valueOf();
    var otherZoneDateTime = this.setZone(otherDateTime.zone, {
      keepLocalTime: true
    });
    return otherZoneDateTime.startOf(unit) <= inputMs && inputMs <= otherZoneDateTime.endOf(unit);
  }
  /**
   * Equality check
   * Two DateTimes are equal iff they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  ;

  _proto.equals = function equals(other) {
    return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
  }
  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  ;

  _proto.toRelative = function toRelative(options) {
    if (options === void 0) {
      options = {};
    }

    if (!this.isValid) return null;
    var base = options.base || DateTime.fromObject({}, {
      zone: this.zone
    }),
        padding = options.padding ? this < base ? -options.padding : options.padding : 0;
    var units = ["years", "months", "days", "hours", "minutes", "seconds"];
    var unit = options.unit;

    if (Array.isArray(options.unit)) {
      units = options.unit;
      unit = undefined;
    }

    return diffRelative(base, this.plus(padding), _extends({}, options, {
      numeric: "always",
      units: units,
      unit: unit
    }));
  }
  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  ;

  _proto.toRelativeCalendar = function toRelativeCalendar(options) {
    if (options === void 0) {
      options = {};
    }

    if (!this.isValid) return null;
    return diffRelative(options.base || DateTime.fromObject({}, {
      zone: this.zone
    }), this, _extends({}, options, {
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: true
    }));
  }
  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  ;

  DateTime.min = function min() {
    for (var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++) {
      dateTimes[_key] = arguments[_key];
    }

    if (!dateTimes.every(DateTime.isDateTime)) {
      throw new InvalidArgumentError("min requires all arguments be DateTimes");
    }

    return bestBy(dateTimes, function (i) {
      return i.valueOf();
    }, Math.min);
  }
  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  ;

  DateTime.max = function max() {
    for (var _len2 = arguments.length, dateTimes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      dateTimes[_key2] = arguments[_key2];
    }

    if (!dateTimes.every(DateTime.isDateTime)) {
      throw new InvalidArgumentError("max requires all arguments be DateTimes");
    }

    return bestBy(dateTimes, function (i) {
      return i.valueOf();
    }, Math.max);
  } // MISC

  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  ;

  DateTime.fromFormatExplain = function fromFormatExplain(text, fmt, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        _options$locale = _options.locale,
        locale = _options$locale === void 0 ? null : _options$locale,
        _options$numberingSys = _options.numberingSystem,
        numberingSystem = _options$numberingSys === void 0 ? null : _options$numberingSys,
        localeToUse = Locale.fromOpts({
      locale: locale,
      numberingSystem: numberingSystem,
      defaultToEN: true
    });
    return explainFromTokens(localeToUse, text, fmt);
  }
  /**
   * @deprecated use fromFormatExplain instead
   */
  ;

  DateTime.fromStringExplain = function fromStringExplain(text, fmt, options) {
    if (options === void 0) {
      options = {};
    }

    return DateTime.fromFormatExplain(text, fmt, options);
  } // FORMAT PRESETS

  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  ;

  _createClass(DateTime, [{
    key: "isValid",
    get: function get() {
      return this.invalid === null;
    }
    /**
     * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
     * @type {string}
     */

  }, {
    key: "invalidReason",
    get: function get() {
      return this.invalid ? this.invalid.reason : null;
    }
    /**
     * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
     * @type {string}
     */

  }, {
    key: "invalidExplanation",
    get: function get() {
      return this.invalid ? this.invalid.explanation : null;
    }
    /**
     * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
     *
     * @type {string}
     */

  }, {
    key: "locale",
    get: function get() {
      return this.isValid ? this.loc.locale : null;
    }
    /**
     * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
     *
     * @type {string}
     */

  }, {
    key: "numberingSystem",
    get: function get() {
      return this.isValid ? this.loc.numberingSystem : null;
    }
    /**
     * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
     *
     * @type {string}
     */

  }, {
    key: "outputCalendar",
    get: function get() {
      return this.isValid ? this.loc.outputCalendar : null;
    }
    /**
     * Get the time zone associated with this DateTime.
     * @type {Zone}
     */

  }, {
    key: "zone",
    get: function get() {
      return this._zone;
    }
    /**
     * Get the name of the time zone.
     * @type {string}
     */

  }, {
    key: "zoneName",
    get: function get() {
      return this.isValid ? this.zone.name : null;
    }
    /**
     * Get the year
     * @example DateTime.local(2017, 5, 25).year //=> 2017
     * @type {number}
     */

  }, {
    key: "year",
    get: function get() {
      return this.isValid ? this.c.year : NaN;
    }
    /**
     * Get the quarter
     * @example DateTime.local(2017, 5, 25).quarter //=> 2
     * @type {number}
     */

  }, {
    key: "quarter",
    get: function get() {
      return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
    }
    /**
     * Get the month (1-12).
     * @example DateTime.local(2017, 5, 25).month //=> 5
     * @type {number}
     */

  }, {
    key: "month",
    get: function get() {
      return this.isValid ? this.c.month : NaN;
    }
    /**
     * Get the day of the month (1-30ish).
     * @example DateTime.local(2017, 5, 25).day //=> 25
     * @type {number}
     */

  }, {
    key: "day",
    get: function get() {
      return this.isValid ? this.c.day : NaN;
    }
    /**
     * Get the hour of the day (0-23).
     * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
     * @type {number}
     */

  }, {
    key: "hour",
    get: function get() {
      return this.isValid ? this.c.hour : NaN;
    }
    /**
     * Get the minute of the hour (0-59).
     * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
     * @type {number}
     */

  }, {
    key: "minute",
    get: function get() {
      return this.isValid ? this.c.minute : NaN;
    }
    /**
     * Get the second of the minute (0-59).
     * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
     * @type {number}
     */

  }, {
    key: "second",
    get: function get() {
      return this.isValid ? this.c.second : NaN;
    }
    /**
     * Get the millisecond of the second (0-999).
     * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
     * @type {number}
     */

  }, {
    key: "millisecond",
    get: function get() {
      return this.isValid ? this.c.millisecond : NaN;
    }
    /**
     * Get the week year
     * @see https://en.wikipedia.org/wiki/ISO_week_date
     * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
     * @type {number}
     */

  }, {
    key: "weekYear",
    get: function get() {
      return this.isValid ? possiblyCachedWeekData(this).weekYear : NaN;
    }
    /**
     * Get the week number of the week year (1-52ish).
     * @see https://en.wikipedia.org/wiki/ISO_week_date
     * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
     * @type {number}
     */

  }, {
    key: "weekNumber",
    get: function get() {
      return this.isValid ? possiblyCachedWeekData(this).weekNumber : NaN;
    }
    /**
     * Get the day of the week.
     * 1 is Monday and 7 is Sunday
     * @see https://en.wikipedia.org/wiki/ISO_week_date
     * @example DateTime.local(2014, 11, 31).weekday //=> 4
     * @type {number}
     */

  }, {
    key: "weekday",
    get: function get() {
      return this.isValid ? possiblyCachedWeekData(this).weekday : NaN;
    }
    /**
     * Get the ordinal (meaning the day of the year)
     * @example DateTime.local(2017, 5, 25).ordinal //=> 145
     * @type {number|DateTime}
     */

  }, {
    key: "ordinal",
    get: function get() {
      return this.isValid ? gregorianToOrdinal(this.c).ordinal : NaN;
    }
    /**
     * Get the human readable short month name, such as 'Oct'.
     * Defaults to the system's locale if no locale has been specified
     * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
     * @type {string}
     */

  }, {
    key: "monthShort",
    get: function get() {
      return this.isValid ? Info.months("short", {
        locObj: this.loc
      })[this.month - 1] : null;
    }
    /**
     * Get the human readable long month name, such as 'October'.
     * Defaults to the system's locale if no locale has been specified
     * @example DateTime.local(2017, 10, 30).monthLong //=> October
     * @type {string}
     */

  }, {
    key: "monthLong",
    get: function get() {
      return this.isValid ? Info.months("long", {
        locObj: this.loc
      })[this.month - 1] : null;
    }
    /**
     * Get the human readable short weekday, such as 'Mon'.
     * Defaults to the system's locale if no locale has been specified
     * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
     * @type {string}
     */

  }, {
    key: "weekdayShort",
    get: function get() {
      return this.isValid ? Info.weekdays("short", {
        locObj: this.loc
      })[this.weekday - 1] : null;
    }
    /**
     * Get the human readable long weekday, such as 'Monday'.
     * Defaults to the system's locale if no locale has been specified
     * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
     * @type {string}
     */

  }, {
    key: "weekdayLong",
    get: function get() {
      return this.isValid ? Info.weekdays("long", {
        locObj: this.loc
      })[this.weekday - 1] : null;
    }
    /**
     * Get the UTC offset of this DateTime in minutes
     * @example DateTime.now().offset //=> -240
     * @example DateTime.utc().offset //=> 0
     * @type {number}
     */

  }, {
    key: "offset",
    get: function get() {
      return this.isValid ? +this.o : NaN;
    }
    /**
     * Get the short human name for the zone's current offset, for example "EST" or "EDT".
     * Defaults to the system's locale if no locale has been specified
     * @type {string}
     */

  }, {
    key: "offsetNameShort",
    get: function get() {
      if (this.isValid) {
        return this.zone.offsetName(this.ts, {
          format: "short",
          locale: this.locale
        });
      } else {
        return null;
      }
    }
    /**
     * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
     * Defaults to the system's locale if no locale has been specified
     * @type {string}
     */

  }, {
    key: "offsetNameLong",
    get: function get() {
      if (this.isValid) {
        return this.zone.offsetName(this.ts, {
          format: "long",
          locale: this.locale
        });
      } else {
        return null;
      }
    }
    /**
     * Get whether this zone's offset ever changes, as in a DST.
     * @type {boolean}
     */

  }, {
    key: "isOffsetFixed",
    get: function get() {
      return this.isValid ? this.zone.isUniversal : null;
    }
    /**
     * Get whether the DateTime is in a DST.
     * @type {boolean}
     */

  }, {
    key: "isInDST",
    get: function get() {
      if (this.isOffsetFixed) {
        return false;
      } else {
        return this.offset > this.set({
          month: 1
        }).offset || this.offset > this.set({
          month: 5
        }).offset;
      }
    }
    /**
     * Returns true if this DateTime is in a leap year, false otherwise
     * @example DateTime.local(2016).isInLeapYear //=> true
     * @example DateTime.local(2013).isInLeapYear //=> false
     * @type {boolean}
     */

  }, {
    key: "isInLeapYear",
    get: function get() {
      return isLeapYear(this.year);
    }
    /**
     * Returns the number of days in this DateTime's month
     * @example DateTime.local(2016, 2).daysInMonth //=> 29
     * @example DateTime.local(2016, 3).daysInMonth //=> 31
     * @type {number}
     */

  }, {
    key: "daysInMonth",
    get: function get() {
      return daysInMonth(this.year, this.month);
    }
    /**
     * Returns the number of days in this DateTime's year
     * @example DateTime.local(2016).daysInYear //=> 366
     * @example DateTime.local(2013).daysInYear //=> 365
     * @type {number}
     */

  }, {
    key: "daysInYear",
    get: function get() {
      return this.isValid ? daysInYear(this.year) : NaN;
    }
    /**
     * Returns the number of weeks in this DateTime's year
     * @see https://en.wikipedia.org/wiki/ISO_week_date
     * @example DateTime.local(2004).weeksInWeekYear //=> 53
     * @example DateTime.local(2013).weeksInWeekYear //=> 52
     * @type {number}
     */

  }, {
    key: "weeksInWeekYear",
    get: function get() {
      return this.isValid ? weeksInWeekYear(this.weekYear) : NaN;
    }
  }], [{
    key: "DATE_SHORT",
    get: function get() {
      return DATE_SHORT;
    }
    /**
     * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
     * @type {Object}
     */

  }, {
    key: "DATE_MED",
    get: function get() {
      return DATE_MED;
    }
    /**
     * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
     * @type {Object}
     */

  }, {
    key: "DATE_MED_WITH_WEEKDAY",
    get: function get() {
      return DATE_MED_WITH_WEEKDAY;
    }
    /**
     * {@link DateTime#toLocaleString} format like 'October 14, 1983'
     * @type {Object}
     */

  }, {
    key: "DATE_FULL",
    get: function get() {
      return DATE_FULL;
    }
    /**
     * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
     * @type {Object}
     */

  }, {
    key: "DATE_HUGE",
    get: function get() {
      return DATE_HUGE;
    }
    /**
     * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "TIME_SIMPLE",
    get: function get() {
      return TIME_SIMPLE;
    }
    /**
     * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "TIME_WITH_SECONDS",
    get: function get() {
      return TIME_WITH_SECONDS;
    }
    /**
     * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "TIME_WITH_SHORT_OFFSET",
    get: function get() {
      return TIME_WITH_SHORT_OFFSET;
    }
    /**
     * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "TIME_WITH_LONG_OFFSET",
    get: function get() {
      return TIME_WITH_LONG_OFFSET;
    }
    /**
     * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
     * @type {Object}
     */

  }, {
    key: "TIME_24_SIMPLE",
    get: function get() {
      return TIME_24_SIMPLE;
    }
    /**
     * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
     * @type {Object}
     */

  }, {
    key: "TIME_24_WITH_SECONDS",
    get: function get() {
      return TIME_24_WITH_SECONDS;
    }
    /**
     * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
     * @type {Object}
     */

  }, {
    key: "TIME_24_WITH_SHORT_OFFSET",
    get: function get() {
      return TIME_24_WITH_SHORT_OFFSET;
    }
    /**
     * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
     * @type {Object}
     */

  }, {
    key: "TIME_24_WITH_LONG_OFFSET",
    get: function get() {
      return TIME_24_WITH_LONG_OFFSET;
    }
    /**
     * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "DATETIME_SHORT",
    get: function get() {
      return DATETIME_SHORT;
    }
    /**
     * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "DATETIME_SHORT_WITH_SECONDS",
    get: function get() {
      return DATETIME_SHORT_WITH_SECONDS;
    }
    /**
     * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "DATETIME_MED",
    get: function get() {
      return DATETIME_MED;
    }
    /**
     * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "DATETIME_MED_WITH_SECONDS",
    get: function get() {
      return DATETIME_MED_WITH_SECONDS;
    }
    /**
     * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "DATETIME_MED_WITH_WEEKDAY",
    get: function get() {
      return DATETIME_MED_WITH_WEEKDAY;
    }
    /**
     * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "DATETIME_FULL",
    get: function get() {
      return DATETIME_FULL;
    }
    /**
     * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "DATETIME_FULL_WITH_SECONDS",
    get: function get() {
      return DATETIME_FULL_WITH_SECONDS;
    }
    /**
     * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "DATETIME_HUGE",
    get: function get() {
      return DATETIME_HUGE;
    }
    /**
     * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "DATETIME_HUGE_WITH_SECONDS",
    get: function get() {
      return DATETIME_HUGE_WITH_SECONDS;
    }
  }]);

  return DateTime;
}();
function friendlyDateTime(dateTimeish) {
  if (DateTime.isDateTime(dateTimeish)) {
    return dateTimeish;
  } else if (dateTimeish && dateTimeish.valueOf && isNumber(dateTimeish.valueOf())) {
    return DateTime.fromJSDate(dateTimeish);
  } else if (dateTimeish && typeof dateTimeish === "object") {
    return DateTime.fromObject(dateTimeish);
  } else {
    throw new InvalidArgumentError("Unknown datetime argument: " + dateTimeish + ", of type " + typeof dateTimeish);
  }
}

var VERSION = "2.2.0";

exports.DateTime = DateTime;
exports.Duration = Duration;
exports.FixedOffsetZone = FixedOffsetZone;
exports.IANAZone = IANAZone;
exports.Info = Info;
exports.Interval = Interval;
exports.InvalidZone = InvalidZone;
exports.Settings = Settings;
exports.SystemZone = SystemZone;
exports.VERSION = VERSION;
exports.Zone = Zone;
//# sourceMappingURL=luxon.js.map
});

// Allows a component to return more than one root element
// See https://reactjs.org/docs/fragments.html for more information
// eslint-disable-next-line
const Fragment = (_, children) => [...children];

class FormControl {
  constructor(description, validators, order, touched) {
    this.value = null;
    this.description = description;
    this.validators = validators;
    this.order = order;
    this.touched = touched;
  }
}

const isInternetExplorer11 = () => !!window.MSInputMethodContext && !!document.documentMode;

const convertDollarsToCents = (valueAsDollars) => {
  return valueAsDollars * 100;
};
const convertCentsToDollars = (valueAsCents) => {
  return Math.floor(valueAsCents / 100);
};

const ISO8601_DATE = 'yyyy-MM-dd';
const DISPLAY_DATE = 'MM/dd/yyyy';
const LITEPICKER_DATE = 'MM/DD/YYYY';

function trimRight(text, characters) {
  if (!text) {
    return '';
  }
  return text.replace(new RegExp("[" + characters + "]+$"), "");
}

const cache = [];
function countryAsyncValidator(countryEligibilityUrl, phoneNumberOverride) {
  return {
    validate: async (country) => {
      const validationResult = { isValid: true };
      phoneNumberOverride = phoneNumberOverride ? phoneNumberOverride : '844-411-2487';
      try {
        let foundCountry = cache === null || cache === void 0 ? void 0 : cache.find((cachedCountry) => cachedCountry.checkedEntity.countryIso2 === country.countryIso2);
        if (!foundCountry) {
          foundCountry = await fetch(`${countryEligibilityUrl}${country.countryIso2}`)
            .then(response => response.json())
            .then((countryResponse) => countryResponse.result);
          if (foundCountry) {
            cache.push(foundCountry);
          }
          else {
            throw new Error();
          }
        }
        if (foundCountry.isBlocked == true) {
          validationResult.isValid = false;
          validationResult.errorMessage = `Your destination is not eligible for coverage. Please call ${phoneNumberOverride} for more details.`;
        }
      }
      catch (err) {
        validationResult.isValid = false;
        validationResult.errorMessage = `There was an unknown error. Call us at ${phoneNumberOverride} for assistance.`;
      }
      return validationResult;
    }
  };
}

function dateFormatValidator(errorMessage) {
  return {
    validate: (value) => {
      return value && luxon.DateTime.fromFormat(value, DISPLAY_DATE).isValid ?
        { isValid: true } :
        { isValid: false, errorMessage };
    }
  };
}

function optionalDateFormatValidator(errorMessage) {
  return {
    validate: (value) => {
      if (!value) {
        return { isValid: true };
      }
      else {
        return luxon.DateTime.fromFormat(value, DISPLAY_DATE).isValid ?
          { isValid: true } :
          { isValid: false, errorMessage };
      }
    }
  };
}

function dateMaximumValidator(errorMessage, maxDate) {
  return {
    validate: (value) => {
      const maxDateTime = luxon.DateTime.fromFormat(maxDate, DISPLAY_DATE);
      const valueDateTime = luxon.DateTime.fromFormat(value, DISPLAY_DATE);
      return valueDateTime.isValid && valueDateTime <= maxDateTime ?
        { isValid: true } :
        { isValid: false, errorMessage };
    }
  };
}

function dateMinimumValidator(errorMessage, minDate) {
  return {
    validate: (value) => {
      const minDateTime = luxon.DateTime.fromFormat(minDate, DISPLAY_DATE);
      const valueDateTime = luxon.DateTime.fromFormat(value, DISPLAY_DATE);
      return valueDateTime.isValid && valueDateTime >= minDateTime ?
        { isValid: true } :
        { isValid: false, errorMessage };
    }
  };
}

function dateRangeLengthValidator(errorMessage, beforeDate, maxLength) {
  return {
    validate: (value) => {
      const beforeDateTime = luxon.DateTime.fromFormat(beforeDate, DISPLAY_DATE);
      const afterDateTime = luxon.DateTime.fromFormat(value, DISPLAY_DATE);
      const rangeDiff = afterDateTime.diff(beforeDateTime, 'days');
      return value && rangeDiff.days <= maxLength ?
        { isValid: true } :
        { isValid: false, errorMessage };
    }
  };
}

function dateSameOrAfterValidator(errorMessage, beforeOrSameDate) {
  return {
    validate: (value) => {
      const beforeOrSameDateTime = luxon.DateTime.fromFormat(beforeOrSameDate, DISPLAY_DATE);
      const afterDateTime = luxon.DateTime.fromFormat(value, DISPLAY_DATE);
      return value && afterDateTime >= beforeOrSameDateTime ?
        { isValid: true } :
        { isValid: false, errorMessage };
    }
  };
}

function dateSameOrBeforeValidator(errorMessage, afterOrSameDate) {
  return {
    validate: (value) => {
      const beforeDateTime = luxon.DateTime.fromFormat(value, DISPLAY_DATE);
      const afterOrSameDateTime = luxon.DateTime.fromFormat(afterOrSameDate, DISPLAY_DATE);
      return value && beforeDateTime <= afterOrSameDateTime ?
        { isValid: true } :
        { isValid: false, errorMessage };
    }
  };
}

function emailAddressValidator(errorMessage) {
  // This regex matches what the rest of bhtp.com which is limited by what salesforce allows.
  // Consider reverting back to what Angular uses as that is a more common standard
  // https://github.com/angular/angular/blob/master/packages/forms/src/validators.ts
  const EMAIL_REGEX = /^\S+@\S+\.\S+$/;
  return {
    validate: (value) => {
      return value !== undefined && value !== null && EMAIL_REGEX.test(value) ?
        { isValid: true } :
        { isValid: false, errorMessage };
    }
  };
}

function lengthValidator(errorMessage, minLength, maxLength) {
  return {
    validate: (value) => {
      if (value === undefined || value === null) {
        return { isValid: true };
      }
      else {
        return value.length >= minLength && value.length <= maxLength ?
          { isValid: true } :
          { isValid: false, errorMessage };
      }
    }
  };
}

function maximumValidator(errorMessage, maximumValue) {
  return {
    validate: (value) => {
      return value <= maximumValue ?
        { isValid: true } :
        { isValid: false, errorMessage };
    }
  };
}

function minimumValidator(errorMessage, minimumValue) {
  return {
    validate: (value) => {
      return value >= minimumValue ?
        { isValid: true } :
        { isValid: false, errorMessage };
    }
  };
}

function patternValidator(errorMessage, pattern) {
  return {
    validate: (value) => {
      return value !== undefined && value !== null && pattern.test(value) ?
        { isValid: true } :
        { isValid: false, errorMessage };
    }
  };
}

function postalCodeAsyncValidator(postalCodeValidationUrl, phoneNumberOverride, errorMessage) {
  return {
    validate: async (postalCode) => {
      var _a;
      const validationResult = { isValid: true };
      let jurisdiction = { postalCode };
      phoneNumberOverride = phoneNumberOverride ? phoneNumberOverride : '844-411-2487';
      try {
        const jurisdictionResponse = await fetch(`${postalCodeValidationUrl}${postalCode}`)
          .then(response => response.text())
          .then(text => text.length ? JSON.parse(text) : null);
        if (!jurisdictionResponse || ((_a = jurisdictionResponse.message) === null || _a === void 0 ? void 0 : _a.length) > 0) {
          validationResult.isValid = false;
          validationResult.errorMessage = errorMessage !== null && errorMessage !== void 0 ? errorMessage : `We didn’t recognize this postal code. Please verify or call ${phoneNumberOverride} for assistance.`;
        }
        else {
          jurisdiction = Object.assign({}, jurisdictionResponse);
        }
      }
      catch (err) {
        validationResult.isValid = false;
        validationResult.errorMessage = errorMessage !== null && errorMessage !== void 0 ? errorMessage : `There was an unknown error. Call us at ${phoneNumberOverride} for assistance.`;
      }
      return Object.assign(Object.assign({}, validationResult), { asyncResult: jurisdiction });
    }
  };
}

function requiredValidator(errorMessage) {
  return {
    validate: (value) => {
      return (value !== undefined &&
        value !== null &&
        isNotEmptyString(value) &&
        isNotEmptyArray(value) ?
        { isValid: true } :
        { isValid: false, errorMessage });
    }
  };
  function isNotEmptyString(value) {
    return typeof value === 'string' ? value.match(/^\s*$/) === null : true;
  }
  function isNotEmptyArray(value) {
    return Array.isArray(value) ? value.length > 0 : true;
  }
}

async function validateControl(control, value, formSubmitted) {
  if (control.touched !== false || formSubmitted) {
    for (const validator of control.validators) {
      const { isValid, errorMessage } = await validator.validate(value);
      if (!isValid) {
        return { isValid, errorMessage };
      }
    }
  }
  return { isValid: true, errorMessage: undefined };
}

const Validators = {
  countryAsyncValidator,
  dateFormatValidator,
  optionalDateFormatValidator,
  dateMaximumValidator,
  dateMinimumValidator,
  dateRangeLengthValidator,
  dateSameOrAfterValidator,
  dateSameOrBeforeValidator,
  emailAddressValidator,
  lengthValidator,
  maximumValidator,
  minimumValidator,
  patternValidator,
  postalCodeAsyncValidator,
  requiredValidator,
  validateControl
};

const quoteCtaComponentCss = ".a11y-hidden{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}.bhtp-ui-form-group__input{display:flex;align-items:center}@media (max-width: 599px){.bhtp-ui-form-group__input{flex-direction:column;align-items:stretch}.bhtp-ui-form-group__input.bhtp-ui-form-group__input--inline{flex-direction:row;align-items:center}.bhtp-ui-form-group__input .bhtp-ui-input{padding:0}.bhtp-ui-form-group__input .bhtp-ui-input-prompt{font-size:var(--bhtp-ui-reduced-font-size)}}.bhtp-ui-form-group__inline{display:flex;align-items:center}.bhtp-ui-input-prompt{color:var(--bhtp-ui-text-primary-color);margin-right:1rem;font-weight:bold}.bhtp-ui-input-prompt--post{margin:0 0 0 1rem}.bhtp-ui-input-prompt--center{margin:0 1rem}.bhtp-ui-input-prompt,.bhtp-ui-input{font-size:var(--bhtp-ui-standard-font-size)}.bhtp-ui-input-prompt-tooltip{margin-left:-1rem}.bhtp-ui-input{border:none;border-radius:0;border-bottom:1px solid var(--bhtp-ui-text-secondary-color);font-family:var(--bhtp-ui-primary-font-family);color:var(--bhtp-ui-text-input-color);background-color:transparent;padding:0 0.75rem 0.5rem;outline:none;box-sizing:border-box}.bhtp-ui-input::-moz-placeholder{color:var(--bhtp-ui-text-secondary-color);text-transform:lowercase;overflow:visible}.bhtp-ui-input:-ms-input-placeholder{color:var(--bhtp-ui-text-secondary-color);text-transform:lowercase;overflow:visible}.bhtp-ui-input::placeholder{color:var(--bhtp-ui-text-secondary-color);text-transform:lowercase;overflow:visible}@media (max-width: 599px){.bhtp-ui-input::-moz-placeholder{font-size:1rem}.bhtp-ui-input:-ms-input-placeholder{font-size:1rem}.bhtp-ui-input::placeholder{font-size:1rem}}.bhtp-ui-input.bhtp-ui-input--invalid{color:var(--bhtp-ui-danger-color)}.bhtp-ui-input.bhtp-ui-input--clear-right{padding-right:0}.bhtp-ui-icon-input{display:flex;align-items:stretch;border-bottom:1px solid var(--bhtp-ui-text-secondary-color);position:relative}.bhtp-ui-icon-input .bhtp-ui-input{border-bottom:none}.bhtp-ui-icon-input>bhtp-ui-icon{display:flex;align-items:center}.bhtp-ui-icon-input>bhtp-ui-icon i{color:var(--bhtp-ui-text-secondary-color)}@media (max-width: 599px){.bhtp-ui-icon-input>bhtp-ui-icon{margin-right:0.5rem}}button>bhtp-ui-icon{outline:none}.bhtp-ui-form-label-tooltip{display:flex;align-items:center}@media (max-width: 599px){.bhtp-ui-hide-only-mobile{display:none}.bhtp-ui-form-group.bhtp-ui-show-only-mobile{display:flex}}@media (min-width: 599px){.bhtp-ui-hide-only-mobile{display:flex}.bhtp-ui-form-group.bhtp-ui-show-only-mobile{display:none}}:host{display:block;font-family:var(--bhtp-ui-primary-font-family)}.bhtp-ui-form-group{display:flex;flex-direction:column;flex-grow:1;flex-shrink:0}@media (max-width: 599px){.bhtp-ui-form-group{flex-basis:100%}}.bhtp-ui-form-group.bhtp-ui-form-group--center{align-items:center}.bhtp-ui-form-group:not(:first-child){margin-top:0.5rem}@media (max-width: 599px){.bhtp-ui-form-group:not(:first-child){margin-top:0.5rem}}bhtp-ui-destination-input,bhtp-ui-multi-select-dropdown-input{flex-grow:1}@media (max-width: 599px){bhtp-ui-tooltip-modal{display:flex;align-items:flex-end}}.bhtp-mobile-cost-per-control{padding-bottom:2rem}";

let QuoteCta = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.callToActionSubmitted = createEvent(this, "callToActionSubmitted", 7);
    this.isEditMode = false;
    this.formSubmitted = false;
    this.isFormValid = false;
    // Used to force project to publish if there are changes in webComponents but not this component
    this.increaseToForceBuild = 11;
    this.backupConfig = {
      countries: [{ "countryIso2": "AF", "name": "Afghanistan" }, { "countryIso2": "AL", "name": "Albania" }, { "countryIso2": "DZ", "name": "Algeria" }, { "countryIso2": "AS", "name": "American Samoa" }, { "countryIso2": "AD", "name": "Andorra" }, { "countryIso2": "AO", "name": "Angola" }, { "countryIso2": "AI", "name": "Anguilla" }, { "countryIso2": "AQ", "name": "Antarctica" }, { "countryIso2": "AG", "name": "Antigua & Barbuda" }, { "countryIso2": "AR", "name": "Argentina" }, { "countryIso2": "AM", "name": "Armenia" }, { "countryIso2": "AW", "name": "Aruba" }, { "countryIso2": "AU", "name": "Australia" }, { "countryIso2": "AT", "name": "Austria" }, { "countryIso2": "AZ", "name": "Azerbaijan" }, { "countryIso2": "BS", "name": "Bahamas" }, { "countryIso2": "BH", "name": "Bahrain" }, { "countryIso2": "BD", "name": "Bangladesh" }, { "countryIso2": "BB", "name": "Barbados" }, { "countryIso2": "BY", "name": "Belarus" }, { "countryIso2": "BE", "name": "Belgium" }, { "countryIso2": "BZ", "name": "Belize" }, { "countryIso2": "BJ", "name": "Benin" }, { "countryIso2": "BM", "name": "Bermuda" }, { "countryIso2": "BT", "name": "Bhutan" }, { "countryIso2": "BO", "name": "Bolivia" }, { "countryIso2": "BA", "name": "Bosnia-Herzegovina" }, { "countryIso2": "BW", "name": "Botswana" }, { "countryIso2": "BV", "name": "Bouvet Island" }, { "countryIso2": "BR", "name": "Brazil" }, { "countryIso2": "IO", "name": "British Indian Ocean Terr." }, { "countryIso2": "VG", "name": "British Virgin Islands" }, { "countryIso2": "BN", "name": "Brunei" }, { "countryIso2": "BG", "name": "Bulgaria" }, { "countryIso2": "BF", "name": "Burkina Faso" }, { "countryIso2": "BI", "name": "Burundi" }, { "countryIso2": "KH", "name": "Cambodia" }, { "countryIso2": "CM", "name": "Cameroon" }, { "countryIso2": "CA", "name": "Canada" }, { "countryIso2": "CV", "name": "Cape Verde" }, { "countryIso2": "29", "name": "Caribbean" }, { "countryIso2": "BQ", "name": "Caribbean Netherlands" }, { "countryIso2": "KY", "name": "Cayman Islands" }, { "countryIso2": "CF", "name": "Central African Republic" }, { "countryIso2": "TD", "name": "Chad" }, { "countryIso2": "CL", "name": "Chile" }, { "countryIso2": "CN", "name": "China" }, { "countryIso2": "CX", "name": "Christmas Island" }, { "countryIso2": "CC", "name": "Cocos (Keeling) Islands" }, { "countryIso2": "CO", "name": "Colombia" }, { "countryIso2": "KM", "name": "Comoros" }, { "countryIso2": "CD", "name": "Congo D.R." }, { "countryIso2": "CG", "name": "Congo-Brazzaville" }, { "countryIso2": "CK", "name": "Cook Islands" }, { "countryIso2": "CR", "name": "Costa Rica" }, { "countryIso2": "HR", "name": "Croatia" }, { "countryIso2": "CU", "name": "Cuba" }, { "countryIso2": "CW", "name": "Curaçao" }, { "countryIso2": "CY", "name": "Cyprus" }, { "countryIso2": "CZ", "name": "Czechia" }, { "countryIso2": "CI", "name": "Côte d'Ivoire" }, { "countryIso2": "DK", "name": "Denmark" }, { "countryIso2": "DJ", "name": "Djibouti" }, { "countryIso2": "DM", "name": "Dominica" }, { "countryIso2": "DO", "name": "Dominican Republic" }, { "countryIso2": "EC", "name": "Ecuador" }, { "countryIso2": "EG", "name": "Egypt" }, { "countryIso2": "SV", "name": "El Salvador" }, { "countryIso2": "GQ", "name": "Equatorial Guinea" }, { "countryIso2": "ER", "name": "Eritrea" }, { "countryIso2": "EE", "name": "Estonia" }, { "countryIso2": "SZ", "name": "Eswatini" }, { "countryIso2": "ET", "name": "Ethiopia" }, { "countryIso2": "FK", "name": "Falkland Islands" }, { "countryIso2": "FO", "name": "Faroe Islands" }, { "countryIso2": "FJ", "name": "Fiji" }, { "countryIso2": "FI", "name": "Finland" }, { "countryIso2": "FR", "name": "France" }, { "countryIso2": "GF", "name": "French Guiana" }, { "countryIso2": "PF", "name": "French Polynesia" }, { "countryIso2": "TF", "name": "French Southern Territories" }, { "countryIso2": "GA", "name": "Gabon" }, { "countryIso2": "GM", "name": "Gambia" }, { "countryIso2": "GE", "name": "Georgia" }, { "countryIso2": "DE", "name": "Germany" }, { "countryIso2": "GH", "name": "Ghana" }, { "countryIso2": "GI", "name": "Gibraltar" }, { "countryIso2": "GR", "name": "Greece" }, { "countryIso2": "GL", "name": "Greenland" }, { "countryIso2": "GD", "name": "Grenada" }, { "countryIso2": "GP", "name": "Guadeloupe" }, { "countryIso2": "GU", "name": "Guam" }, { "countryIso2": "GT", "name": "Guatemala" }, { "countryIso2": "GG", "name": "Guernsey" }, { "countryIso2": "GN", "name": "Guinea" }, { "countryIso2": "GW", "name": "Guinea-Bissau" }, { "countryIso2": "GY", "name": "Guyana" }, { "countryIso2": "HT", "name": "Haiti" }, { "countryIso2": "HM", "name": "Heard & McDonald Islands" }, { "countryIso2": "HN", "name": "Honduras" }, { "countryIso2": "HK", "name": "Hong Kong" }, { "countryIso2": "HU", "name": "Hungary" }, { "countryIso2": "IS", "name": "Iceland" }, { "countryIso2": "IN", "name": "India" }, { "countryIso2": "ID", "name": "Indonesia" }, { "countryIso2": "IR", "name": "Iran" }, { "countryIso2": "IQ", "name": "Iraq" }, { "countryIso2": "IE", "name": "Ireland" }, { "countryIso2": "IM", "name": "Isle of Man" }, { "countryIso2": "IL", "name": "Israel" }, { "countryIso2": "IT", "name": "Italy" }, { "countryIso2": "JM", "name": "Jamaica" }, { "countryIso2": "JP", "name": "Japan" }, { "countryIso2": "JE", "name": "Jersey" }, { "countryIso2": "JO", "name": "Jordan" }, { "countryIso2": "KZ", "name": "Kazakhstan" }, { "countryIso2": "KE", "name": "Kenya" }, { "countryIso2": "KI", "name": "Kiribati" }, { "countryIso2": "XK", "name": "Kosovo" }, { "countryIso2": "KW", "name": "Kuwait" }, { "countryIso2": "KG", "name": "Kyrgyzstan" }, { "countryIso2": "LA", "name": "Laos" }, { "countryIso2": "LV", "name": "Latvia" }, { "countryIso2": "LB", "name": "Lebanon" }, { "countryIso2": "LS", "name": "Lesotho" }, { "countryIso2": "LR", "name": "Liberia" }, { "countryIso2": "LY", "name": "Libya" }, { "countryIso2": "LI", "name": "Liechtenstein" }, { "countryIso2": "LT", "name": "Lithuania" }, { "countryIso2": "LU", "name": "Luxembourg" }, { "countryIso2": "MO", "name": "Macau" }, { "countryIso2": "MG", "name": "Madagascar" }, { "countryIso2": "MW", "name": "Malawi" }, { "countryIso2": "MY", "name": "Malaysia" }, { "countryIso2": "MV", "name": "Maldives" }, { "countryIso2": "ML", "name": "Mali" }, { "countryIso2": "MT", "name": "Malta" }, { "countryIso2": "MH", "name": "Marshall Islands" }, { "countryIso2": "MQ", "name": "Martinique" }, { "countryIso2": "MR", "name": "Mauritania" }, { "countryIso2": "MU", "name": "Mauritius" }, { "countryIso2": "YT", "name": "Mayotte" }, { "countryIso2": "MX", "name": "Mexico" }, { "countryIso2": "FM", "name": "Micronesia" }, { "countryIso2": "UM", "name": "Minor Outlying Islands" }, { "countryIso2": "MD", "name": "Moldova" }, { "countryIso2": "MC", "name": "Monaco" }, { "countryIso2": "MN", "name": "Mongolia" }, { "countryIso2": "ME", "name": "Montenegro" }, { "countryIso2": "MS", "name": "Montserrat" }, { "countryIso2": "MA", "name": "Morocco" }, { "countryIso2": "MZ", "name": "Mozambique" }, { "countryIso2": "MM", "name": "Myanmar (Burma)" }, { "countryIso2": "NA", "name": "Namibia" }, { "countryIso2": "NR", "name": "Nauru" }, { "countryIso2": "NP", "name": "Nepal" }, { "countryIso2": "NL", "name": "Netherlands" }, { "countryIso2": "AN", "name": "Netherlands Antilles" }, { "countryIso2": "NC", "name": "New Caledonia" }, { "countryIso2": "NZ", "name": "New Zealand" }, { "countryIso2": "NI", "name": "Nicaragua" }, { "countryIso2": "NE", "name": "Niger" }, { "countryIso2": "NG", "name": "Nigeria" }, { "countryIso2": "NU", "name": "Niue" }, { "countryIso2": "NF", "name": "Norfolk Island" }, { "countryIso2": "KP", "name": "North Korea" }, { "countryIso2": "MP", "name": "Northern Mariana Islands" }, { "countryIso2": "NO", "name": "Norway" }, { "countryIso2": "OM", "name": "Oman" }, { "countryIso2": "PK", "name": "Pakistan" }, { "countryIso2": "PW", "name": "Palau" }, { "countryIso2": "PS", "name": "Palestine" }, { "countryIso2": "PA", "name": "Panama" }, { "countryIso2": "PG", "name": "Papua New Guinea" }, { "countryIso2": "PY", "name": "Paraguay" }, { "countryIso2": "PE", "name": "Peru" }, { "countryIso2": "PH", "name": "Philippines" }, { "countryIso2": "PN", "name": "Pitcairn Islands" }, { "countryIso2": "PL", "name": "Poland" }, { "countryIso2": "PT", "name": "Portugal" }, { "countryIso2": "PR", "name": "Puerto Rico" }, { "countryIso2": "QA", "name": "Qatar" }, { "countryIso2": "MK", "name": "Republic of North Macedonia" }, { "countryIso2": "RO", "name": "Romania" }, { "countryIso2": "RU", "name": "Russia" }, { "countryIso2": "RW", "name": "Rwanda" }, { "countryIso2": "RE", "name": "Réunion" }, { "countryIso2": "BL", "name": "Saint Barthélemy" }, { "countryIso2": "SH", "name": "Saint Helena" }, { "countryIso2": "KN", "name": "Saint Kitts and Nevis" }, { "countryIso2": "LC", "name": "Saint Lucia" }, { "countryIso2": "MF", "name": "Saint Martin" }, { "countryIso2": "PM", "name": "Saint Pierre & Miquelon" }, { "countryIso2": "WS", "name": "Samoa" }, { "countryIso2": "SM", "name": "San Marino" }, { "countryIso2": "SA", "name": "Saudi Arabia" }, { "countryIso2": "SN", "name": "Senegal" }, { "countryIso2": "RS", "name": "Serbia" }, { "countryIso2": "SC", "name": "Seychelles" }, { "countryIso2": "SL", "name": "Sierra Leone" }, { "countryIso2": "SG", "name": "Singapore" }, { "countryIso2": "SX", "name": "Sint Maarten" }, { "countryIso2": "SK", "name": "Slovakia" }, { "countryIso2": "SI", "name": "Slovenia" }, { "countryIso2": "SB", "name": "Solomon Islands" }, { "countryIso2": "SO", "name": "Somalia" }, { "countryIso2": "ZA", "name": "South Africa" }, { "countryIso2": "GS", "name": "South Georgia & Sandwich" }, { "countryIso2": "KR", "name": "South Korea" }, { "countryIso2": "SS", "name": "South Sudan" }, { "countryIso2": "ES", "name": "Spain" }, { "countryIso2": "LK", "name": "Sri Lanka" }, { "countryIso2": "VC", "name": "St Vinc. & Grenadines" }, { "countryIso2": "SD", "name": "Sudan" }, { "countryIso2": "SR", "name": "Suriname" }, { "countryIso2": "SJ", "name": "Svalbard and Jan Mayen" }, { "countryIso2": "SE", "name": "Sweden" }, { "countryIso2": "CH", "name": "Switzerland" }, { "countryIso2": "SY", "name": "Syria" }, { "countryIso2": "ST", "name": "São Tomé & Príncipe" }, { "countryIso2": "TW", "name": "Taiwan" }, { "countryIso2": "TJ", "name": "Tajikistan" }, { "countryIso2": "TZ", "name": "Tanzania" }, { "countryIso2": "TH", "name": "Thailand" }, { "countryIso2": "TL", "name": "Timor-Leste" }, { "countryIso2": "TG", "name": "Togo" }, { "countryIso2": "TK", "name": "Tokelau" }, { "countryIso2": "TO", "name": "Tonga" }, { "countryIso2": "TT", "name": "Trinidad & Tobago" }, { "countryIso2": "TN", "name": "Tunisia" }, { "countryIso2": "TR", "name": "Turkey" }, { "countryIso2": "TM", "name": "Turkmenistan" }, { "countryIso2": "TC", "name": "Turks and Caicos Islands" }, { "countryIso2": "TV", "name": "Tuvalu" }, { "countryIso2": "VI", "name": "U.S. Virgin Islands" }, { "countryIso2": "UG", "name": "Uganda" }, { "countryIso2": "UA", "name": "Ukraine" }, { "countryIso2": "AE", "name": "United Arab Emirates" }, { "countryIso2": "GB", "name": "United Kingdom" }, { "countryIso2": "US", "name": "United States" }, { "countryIso2": "UY", "name": "Uruguay" }, { "countryIso2": "UZ", "name": "Uzbekistan" }, { "countryIso2": "VU", "name": "Vanuatu" }, { "countryIso2": "VA", "name": "Vatican" }, { "countryIso2": "VE", "name": "Venezuela" }, { "countryIso2": "VN", "name": "Vietnam" }, { "countryIso2": "WF", "name": "Wallis and Futuna" }, { "countryIso2": "YE", "name": "Yemen" }, { "countryIso2": "ZM", "name": "Zambia" }, { "countryIso2": "ZW", "name": "Zimbabwe" }, { "countryIso2": "AX", "name": "Åland" }],
      countryEligibilityUrl: `https://${this.getEnvironment()}apps.bhtp.com/consumer-gateway/eligibility/blocks/country/`,
      postalCodeValidationUrl: `https://${this.getEnvironment()}apps.bhtp.com/consumer-gateway/jurisdictions/city/postalcode/`,
      minFlightSegments: 1,
      maxFlightSegments: 10,
      maxTripLength: 364,
      minTripCost: 0,
      maxTripCost: 100000,
      maxTravelerAge: 125,
      minTravelers: 1,
      maxTravelers: 25
    };
  }
  get hasFlights() {
    var _a, _b, _c;
    return (_c = (_b = (_a = this.formControls) === null || _a === void 0 ? void 0 : _a.travelModes) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.includes('Flight');
  }
  get minDepartureDate() {
    return luxon.DateTime.local().plus({ days: 1 }).toFormat(DISPLAY_DATE);
  }
  get maxDepartureDate() {
    return luxon.DateTime.local().plus({ days: 9997 }).toFormat(DISPLAY_DATE);
  }
  get maxDepositDate() {
    return luxon.DateTime.local().toFormat(DISPLAY_DATE);
  }
  get minDateOfBirth() {
    var _a, _b;
    return luxon.DateTime.local().minus({ years: (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.maxTravelerAge) !== null && _b !== void 0 ? _b : 125 }).plus({ days: 1 }).toFormat(DISPLAY_DATE);
  }
  get maxDateOfBirth() {
    return luxon.DateTime.local().minus({ days: 1 }).toFormat(DISPLAY_DATE);
  }
  keydownListener(event) {
    if (event.key === "Enter") {
      this.handleSubmit(event);
    }
  }
  async componentWillLoad() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    this.formControls = {
      destinationCountry: new FormControl('Destination Country', [
        Validators.requiredValidator('Destination country is required.'),
        Validators.countryAsyncValidator((_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.countryEligibilityUrl) !== null && _b !== void 0 ? _b : this.backupConfig.countryEligibilityUrl, (_c = this.config) === null || _c === void 0 ? void 0 : _c.phoneNumberOverride)
      ], 0, false),
      departureDate: new FormControl('Departure Date', [
        Validators.requiredValidator('Trip departure and return dates are required.'),
        Validators.dateFormatValidator(`Depature date must be in ${DISPLAY_DATE.toLowerCase()} format.`),
        Validators.dateSameOrAfterValidator(`Departure date must be on or after ${this.minDepartureDate}.`, this.minDepartureDate),
        Validators.dateMaximumValidator(`Departure date must be before ${this.maxDepartureDate}.`, this.maxDepartureDate)
      ], 1),
      returnDate: new FormControl('Return Date', [
        Validators.requiredValidator('Trip departure and return dates are required.'),
        Validators.dateFormatValidator(`Return date must be in ${DISPLAY_DATE.toLowerCase()} format.`)
      ], 1),
      initialDepositDate: new FormControl('Initial Payment Date', [
        Validators.requiredValidator('Initial payment date is required.'),
        Validators.dateFormatValidator(`Initial payment date must be in ${DISPLAY_DATE.toLowerCase()} format.`),
        Validators.dateSameOrBeforeValidator(`Initial payment date must be on or before ${this.maxDepositDate}.`, this.maxDepositDate)
      ], 2),
      travelModes: new FormControl('Travel Modes', [
        Validators.requiredValidator('One travel mode must be selected.')
      ], 3),
      postalCode: new FormControl('Postal Code', [
        Validators.requiredValidator('Postal code is required.'),
        Validators.lengthValidator('Postal code must be 5 digits.', 5, 5),
        Validators.patternValidator('Postal code must contain only 5 digits.', /[0-9]{5}/)
      ], 4, false),
      numberOfTravelers: {
        description: 'Number of Travelers',
        value: 1,
        validators: [
          Validators.requiredValidator(`At least ${(_e = (_d = this.config) === null || _d === void 0 ? void 0 : _d.minTravelers) !== null && _e !== void 0 ? _e : this.backupConfig.minTravelers} traveler is required.`),
          Validators.minimumValidator(`At least ${(_g = (_f = this.config) === null || _f === void 0 ? void 0 : _f.minTravelers) !== null && _g !== void 0 ? _g : this.backupConfig.minTravelers} traveler is required.`, (_j = (_h = this.config) === null || _h === void 0 ? void 0 : _h.minTravelers) !== null && _j !== void 0 ? _j : this.backupConfig.minTravelers),
          Validators.maximumValidator(`Maximum number of travelers is ${(_l = (_k = this.config) === null || _k === void 0 ? void 0 : _k.maxTravelers) !== null && _l !== void 0 ? _l : this.backupConfig.maxTravelers}.`, (_o = (_m = this.config) === null || _m === void 0 ? void 0 : _m.maxTravelers) !== null && _o !== void 0 ? _o : this.backupConfig.maxTravelers)
        ],
        order: 5,
        touched: false
      },
      primaryTravelerDateOfBirth: new FormControl('Primary Traveler Date of Birth', [
        Validators.requiredValidator('Date of birth is required.'),
        Validators.dateFormatValidator(`Date of birth must be in ${DISPLAY_DATE.toLowerCase()} format.`),
        Validators.dateMinimumValidator(`Date of birth must be after ${this.minDateOfBirth}.`, this.minDateOfBirth),
        Validators.dateMaximumValidator(`Date of birth must be before ${this.maxDateOfBirth}.`, this.maxDateOfBirth)
      ], 6),
      primaryTravelerTripCost: new FormControl('Primary Traveler Trip Cost', [
        Validators.requiredValidator('Trip cost is required.'),
        Validators.maximumValidator(`Trip cost per traveler must be less than $${(_q = (_p = this.config) === null || _p === void 0 ? void 0 : _p.maxTripCost) !== null && _q !== void 0 ? _q : this.backupConfig.maxTripCost}.`, (_s = (_r = this.config) === null || _r === void 0 ? void 0 : _r.maxTripCost) !== null && _s !== void 0 ? _s : this.backupConfig.maxTripCost)
      ], 7, false),
      emailAddress: new FormControl('Email Address', [
        Validators.requiredValidator('Email address is required.'),
        Validators.emailAddressValidator('Email address must be in correct format name@email.com.')
      ], 9, false),
      workingWithPartnerAdvisor: new FormControl('Are you working with a partner or advisor?', [], // Optional field, no validators
      10, false),
      partnerNumber: new FormControl('Partner number (optional)', [
        Validators.lengthValidator('Partner number cannot exceed 12 characters.', 0, 12)
      ], 11, false)
    };
    if (this.insuredEvent) {
      if (this.insuredEvent.destinations && this.insuredEvent.destinations.length > 0) {
        const country = {
          name: this.insuredEvent.destinations[0].destination,
          countryIso2: this.insuredEvent.destinations[0].countryIso2
        };
        await this.updateValueAndValidity('destinationCountry', country, true);
      }
      if (this.insuredEvent.startDate) {
        const formattedStartDate = luxon.DateTime.fromFormat(this.insuredEvent.startDate, ISO8601_DATE).toFormat(DISPLAY_DATE);
        await this.handleStartDateChanged(formattedStartDate);
      }
      if (this.insuredEvent.endDate) {
        const formattedEndDate = luxon.DateTime.fromFormat(this.insuredEvent.endDate, ISO8601_DATE).toFormat(DISPLAY_DATE);
        await this.updateValueAndValidity('returnDate', formattedEndDate, true);
      }
      if (this.insuredEvent.initialDepositDate) {
        const formattedDepositDate = luxon.DateTime.fromFormat(this.insuredEvent.initialDepositDate, ISO8601_DATE).toFormat(DISPLAY_DATE);
        await this.updateValueAndValidity('initialDepositDate', formattedDepositDate, true);
      }
      if (this.insuredEvent.attributes) {
        const travelModes = this.insuredEvent.attributes.find(a => a.name === 'travelModes');
        if (travelModes) {
          await this.handleTravelModeSelected(travelModes.value);
        }
        const flightSegments = this.insuredEvent.attributes.find(a => a.name === 'flightSegments');
        if (flightSegments && this.formControls.flightSegments) {
          await this.updateValueAndValidity('flightSegments', flightSegments.value, true);
        }
        // Load partner/advisor data if available
        if ((_t = this.config) === null || _t === void 0 ? void 0 : _t.showPartnerAdvisorField) {
          const workingWithPartnerAdvisor = this.insuredEvent.workingWithPartnerAdvisor;
          if (workingWithPartnerAdvisor && this.formControls.workingWithPartnerAdvisor) {
            await this.updateValueAndValidity('workingWithPartnerAdvisor', workingWithPartnerAdvisor ? 'yes' : 'no', true);
          }
          const partnerNumber = this.insuredEvent.partnerNumber;
          if (partnerNumber && this.formControls.partnerNumber) {
            await this.updateValueAndValidity('partnerNumber', partnerNumber, true);
          }
        }
      }
      if (this.insuredEvent.postalCode) {
        await this.updatePostalCodeValueAndValidity(this.insuredEvent.postalCode);
      }
      if (this.insuredEvent.insureds) {
        await this.updateValueAndValidity('numberOfTravelers', this.insuredEvent.insureds.length, true);
        await this.updateAdditionalTravelerControls(this.insuredEvent.insureds.length);
        for (let i = 0; i < this.insuredEvent.insureds.length; i++) {
          if (i === 0) {
            await this.updateValueAndValidity('emailAddress', this.insuredEvent.insureds[0].email, true);
            await this.updatePrimaryTravelerTripCost(convertCentsToDollars(this.insuredEvent.insureds[0].insurableCost), true);
            const formattedDateOfBirth = luxon.DateTime.fromFormat(this.insuredEvent.insureds[0].dateOfBirth, ISO8601_DATE).toFormat(DISPLAY_DATE);
            await this.updateValueAndValidity('primaryTravelerDateOfBirth', formattedDateOfBirth, true);
          }
          else {
            const travelerDateOfBirthKey = `traveler${i + 1}DateOfBirth`;
            const travelerTripCostKey = `traveler${i + 1}TripCost`;
            await this.updateAdditionalTravelerTripCost(travelerTripCostKey, convertCentsToDollars(this.insuredEvent.insureds[i].insurableCost), true);
            const formattedDateOfBirth = luxon.DateTime.fromFormat(this.insuredEvent.insureds[i].dateOfBirth, ISO8601_DATE).toFormat(DISPLAY_DATE);
            await this.updateValueAndValidity(travelerDateOfBirthKey, formattedDateOfBirth, true);
          }
        }
      }
    }
  }
  render() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73;
    return (h("form", { onSubmit: (event) => this.handleSubmit(event) }, h("p", { hidden: true }, this.increaseToForceBuild), h("div", { class: "bhtp-ui-form-group" }, h("div", { class: "bhtp-ui-form-group__inline" }, h("bhtp-ui-destination-input", { isValid: (_a = this.formControls) === null || _a === void 0 ? void 0 : _a.destinationCountry.isValid, value: (_b = this.formControls) === null || _b === void 0 ? void 0 : _b.destinationCountry.value, countries: (_d = (_c = this.config) === null || _c === void 0 ? void 0 : _c.countries) !== null && _d !== void 0 ? _d : this.backupConfig.countries, ref: (element) => this.formControls.destinationCountry.component = element, onBlur: () => this.updateValueAndValidity('destinationCountry', this.formControls.destinationCountry.value, true), onCountrySelected: (event) => this.updateValueAndValidity('destinationCountry', event.detail), onCountryUnselected: () => this.updateValueAndValidity('destinationCountry', null) }, h("bhtp-ui-tooltip-modal", { slot: "prompt-tooltip", class: "bhtp-ui-input-prompt-tooltip", modalId: "quote-cta-destination-modal", ariaLabel: "More information about destination country", message: "Please select your primary destination. If more than one, choose the one where you will spend the most time." }))), h("bhtp-ui-form-error", { formSubmitted: this.formSubmitted, formControl: (_e = this.formControls) === null || _e === void 0 ? void 0 : _e.destinationCountry })), h("div", { class: "bhtp-ui-form-group" }, h("bhtp-ui-date-range-input", { startDateInputId: "quote-cta-departure-date", startDateDescription: (_f = this.formControls) === null || _f === void 0 ? void 0 : _f.departureDate.description, startDateIsValid: (!((_g = this.formControls) === null || _g === void 0 ? void 0 : _g.departureDate.isValid) && !this.formSubmitted) || ((_h = this.formControls) === null || _h === void 0 ? void 0 : _h.departureDate.isValid), startDateValue: (_j = this.formControls) === null || _j === void 0 ? void 0 : _j.departureDate.value, endDateInputId: "quote-cta-return-date", endDateDescription: (_k = this.formControls) === null || _k === void 0 ? void 0 : _k.returnDate.description, endDateIsValid: (!((_l = this.formControls) === null || _l === void 0 ? void 0 : _l.returnDate.isValid) && !this.formSubmitted) || ((_m = this.formControls) === null || _m === void 0 ? void 0 : _m.returnDate.isValid), endDateValue: (_o = this.formControls) === null || _o === void 0 ? void 0 : _o.returnDate.value, required: true, minDate: this.minDepartureDate, maxDays: (_q = (_p = this.config) === null || _p === void 0 ? void 0 : _p.maxTripLength) !== null && _q !== void 0 ? _q : this.backupConfig.maxTripLength, prompt: "The trip dates are", ref: (element) => {
        this.formControls.departureDate.component = element;
        this.formControls.returnDate.component = element;
      }, onBlur: () => {
        this.updateValueAndValidity('departureDate', this.formControls.departureDate.value);
        this.updateValueAndValidity('returnDate', this.formControls.returnDate.value);
      }, onStartDateChanged: (event) => this.handleStartDateChanged(event.detail), onEndDateChanged: (event) => this.updateValueAndValidity('returnDate', event.detail) }, h("bhtp-ui-tooltip-modal", { slot: "prompt-tooltip", class: "bhtp-ui-input-prompt-tooltip", modalId: "quote-cta-trip-dates-modal", ariaLabel: "More information about trip dates", message: "Your trip dates are the specific departure and return dates which must match the exact dates listed in your travel documents received prior to your departure." })), h("bhtp-ui-form-error", { formSubmitted: this.formSubmitted, formControls: [(_r = this.formControls) === null || _r === void 0 ? void 0 : _r.departureDate, (_s = this.formControls) === null || _s === void 0 ? void 0 : _s.returnDate] })), h("div", { class: "bhtp-ui-form-group" }, h("div", { class: "bhtp-ui-form-group__inline" }, h("bhtp-ui-date-input", { inputId: "quote-cta-deposit-date", description: (_t = this.formControls) === null || _t === void 0 ? void 0 : _t.initialDepositDate.description, prompt: "I booked my trip on", enablePicker: true, required: true, iconName: 'calendar', value: (_u = this.formControls) === null || _u === void 0 ? void 0 : _u.initialDepositDate.value, isValid: (!((_v = this.formControls) === null || _v === void 0 ? void 0 : _v.initialDepositDate.isValid) && !this.formSubmitted) || ((_w = this.formControls) === null || _w === void 0 ? void 0 : _w.initialDepositDate.isValid), ref: (element) => this.formControls.initialDepositDate.component = element, onBlur: () => this.updateValueAndValidity('initialDepositDate', this.formControls.initialDepositDate.value), onDateChanged: (event) => this.updateValueAndValidity('initialDepositDate', event.detail) }, h("bhtp-ui-tooltip-modal", { slot: "prompt-tooltip", class: "bhtp-ui-input-prompt-tooltip", modalId: "quote-cta-deposit-date-modal", ariaLabel: "More information about deposit date", message: "Select the date you made your first deposit \u2013 either paid in full or partial. If you are using loyalty points to cover your trip cost and have a $0 trip cost, please enter the date you booked your trip." }))), h("bhtp-ui-form-error", { formSubmitted: this.formSubmitted, formControl: (_x = this.formControls) === null || _x === void 0 ? void 0 : _x.initialDepositDate })), h("div", { class: "bhtp-ui-form-group" }, h("div", { class: "bhtp-ui-form-group__inline" }, h("bhtp-ui-multi-select-dropdown-input", { description: (_y = this.formControls) === null || _y === void 0 ? void 0 : _y.travelModes.description, isValid: (_z = this.formControls) === null || _z === void 0 ? void 0 : _z.travelModes.isValid, inputId: "quote-cta-travel-modes-input", placeholder: "travel mode(s)", prompt: "I'll be traveling via", required: true, value: (_0 = this.formControls) === null || _0 === void 0 ? void 0 : _0.travelModes.value, options: ['Flight', 'Cruise', 'Automobile'], ref: (element) => this.formControls.travelModes.component = element, onBlur: () => this.updateValueAndValidity('travelModes', this.formControls.travelModes.value), onItemsSelected: (event) => this.handleTravelModeSelected(event.detail) }, h("bhtp-ui-tooltip-modal", { slot: "prompt-tooltip", class: "bhtp-ui-input-prompt-tooltip", modalId: "quote-cta-travel-modes-modal", ariaLabel: "More information about travel modes", message: `You should select "automobile" if you plan to take a road trip or plan on using a rental car. However, if you're only driving to the airport, you don't need to select "automobile."` }))), h("bhtp-ui-form-error", { formSubmitted: this.formSubmitted, formControl: (_1 = this.formControls) === null || _1 === void 0 ? void 0 : _1.travelModes })), this.hasFlights &&
      h("div", { class: "bhtp-ui-form-group" }, h("div", { class: "bhtp-ui-form-group__inline" }, h("bhtp-ui-number-input", { inputId: "quote-cta-flight-count", description: (_2 = this.formControls) === null || _2 === void 0 ? void 0 : _2.flightSegments.description, isValid: (!((_3 = this.formControls) === null || _3 === void 0 ? void 0 : _3.flightSegments.isValid) && !this.formSubmitted) || ((_4 = this.formControls) === null || _4 === void 0 ? void 0 : _4.flightSegments.isValid), value: (_5 = this.formControls) === null || _5 === void 0 ? void 0 : _5.flightSegments.value, required: this.hasFlights, size: 2, enableSteppers: true, prePrompt: "There will be", postPrompt: "flight segment(s)", minValue: (_7 = (_6 = this.config) === null || _6 === void 0 ? void 0 : _6.minFlightSegments) !== null && _7 !== void 0 ? _7 : this.backupConfig.minFlightSegments, maxValue: (_9 = (_8 = this.config) === null || _8 === void 0 ? void 0 : _8.maxFlightSegments) !== null && _9 !== void 0 ? _9 : this.backupConfig.maxFlightSegments, ref: (element) => this.formControls.flightSegments && (this.formControls.flightSegments.component = element), onBlur: () => this.updateValueAndValidity('flightSegments', this.formControls.flightSegments.value, true), onValueChanged: (event) => this.updateValueAndValidity('flightSegments', event.detail) }, h("bhtp-ui-tooltip-modal", { slot: "prompt-tooltip", class: "bhtp-ui-input-prompt-tooltip", modalId: "quote-cta-flight-count-modal", ariaLabel: "More information about flight segments", message: "A flight segment is a single takeoff and landing by an aircraft. It can also refer to a scheduled nonstop flight between two airports, or a flight between two cities." }))), h("bhtp-ui-form-error", { formSubmitted: this.formSubmitted, formControl: (_10 = this.formControls) === null || _10 === void 0 ? void 0 : _10.flightSegments })), h("div", { class: "bhtp-ui-form-group" }, h("bhtp-ui-text-input", { inputId: "quote-cta-postal-code", description: (_11 = this.formControls) === null || _11 === void 0 ? void 0 : _11.postalCode.description, placeholder: "12345", widthRem: 5, prompt: "My postal code is", inputPattern: /^[0-9]$/, inputMode: 'numeric', required: true, value: (_12 = this.formControls) === null || _12 === void 0 ? void 0 : _12.postalCode.value, isValid: (!((_13 = this.formControls) === null || _13 === void 0 ? void 0 : _13.postalCode.isValid) && !this.formSubmitted) || ((_14 = this.formControls) === null || _14 === void 0 ? void 0 : _14.postalCode.isValid), ref: (element) => this.formControls.postalCode.component = element, onValueChanged: (event) => {
        this.updatePostalCodeValueAndValidity(event.detail);
      } }), h("bhtp-ui-form-error", { formSubmitted: this.formSubmitted, formControl: (_15 = this.formControls) === null || _15 === void 0 ? void 0 : _15.postalCode })), h("div", { class: "bhtp-ui-form-group" }, h("bhtp-ui-number-input", { inputId: "quote-cta-number-of-travelers", description: (_16 = this.formControls) === null || _16 === void 0 ? void 0 : _16.numberOfTravelers.description, isValid: (!((_17 = this.formControls) === null || _17 === void 0 ? void 0 : _17.numberOfTravelers.isValid) && !this.formSubmitted) || ((_18 = this.formControls) === null || _18 === void 0 ? void 0 : _18.numberOfTravelers.isValid), value: (_19 = this.formControls) === null || _19 === void 0 ? void 0 : _19.numberOfTravelers.value, required: true, size: 2, enableSteppers: true, prePrompt: "There will be", postPrompt: "traveler(s)", minValue: (_21 = (_20 = this.config) === null || _20 === void 0 ? void 0 : _20.minTravelers) !== null && _21 !== void 0 ? _21 : this.backupConfig.minTravelers, maxValue: (_23 = (_22 = this.config) === null || _22 === void 0 ? void 0 : _22.maxTravelers) !== null && _23 !== void 0 ? _23 : this.backupConfig.maxTravelers, ref: (element) => this.formControls.numberOfTravelers.component = element, onBlur: () => {
        this.updateValueAndValidity('numberOfTravelers', this.formControls.numberOfTravelers.value, true);
        this.updateAdditionalTravelerControls(this.formControls.numberOfTravelers.value);
      }, onValueChanged: (event) => {
        this.updateValueAndValidity('numberOfTravelers', event.detail);
        this.updateAdditionalTravelerControls(event.detail);
      } }), h("bhtp-ui-form-error", { formSubmitted: this.formSubmitted, formControl: (_24 = this.formControls) === null || _24 === void 0 ? void 0 : _24.numberOfTravelers })), h("div", { class: "bhtp-ui-form-group" }, h("bhtp-ui-date-input", { inputId: "quote-cta-primary-traveler-date-of-birth", description: (_25 = this.formControls) === null || _25 === void 0 ? void 0 : _25.primaryTravelerDateOfBirth.description, prompt: "My date of birth is", iconName: "gift", required: true, value: (_26 = this.formControls) === null || _26 === void 0 ? void 0 : _26.primaryTravelerDateOfBirth.value, isValid: (!((_27 = this.formControls) === null || _27 === void 0 ? void 0 : _27.primaryTravelerDateOfBirth.isValid) && !this.formSubmitted) || ((_28 = this.formControls) === null || _28 === void 0 ? void 0 : _28.primaryTravelerDateOfBirth.isValid), ref: (element) => this.formControls.primaryTravelerDateOfBirth.component = element, onBlur: () => this.updateValueAndValidity('primaryTravelerDateOfBirth', this.formControls.primaryTravelerDateOfBirth.value), onDateChanged: (event) => this.updateValueAndValidity('primaryTravelerDateOfBirth', event.detail) }), h("bhtp-ui-form-error", { formSubmitted: this.formSubmitted, formControl: (_29 = this.formControls) === null || _29 === void 0 ? void 0 : _29.primaryTravelerDateOfBirth })), h("div", { class: "bhtp-ui-form-group" }, h("div", { class: "bhtp-ui-form-group__inline" }, h("bhtp-ui-number-input", { inputId: "quote-cta-primary-traveler-trip-cost", description: (_30 = this.formControls) === null || _30 === void 0 ? void 0 : _30.primaryTravelerTripCost.description, isValid: (!((_31 = this.formControls) === null || _31 === void 0 ? void 0 : _31.primaryTravelerTripCost.isValid) && !this.formSubmitted) || ((_32 = this.formControls) === null || _32 === void 0 ? void 0 : _32.primaryTravelerTripCost.isValid), value: (_33 = this.formControls) === null || _33 === void 0 ? void 0 : _33.primaryTravelerTripCost.value, required: true, prePrompt: "My trip cost is", iconName: "fa-dollar", inline: false, size: 7, minValue: (_35 = (_34 = this.config) === null || _34 === void 0 ? void 0 : _34.minTripCost) !== null && _35 !== void 0 ? _35 : 0, maxValue: (_37 = (_36 = this.config) === null || _36 === void 0 ? void 0 : _36.maxTripCost) !== null && _37 !== void 0 ? _37 : 100000, ref: (element) => this.formControls.primaryTravelerTripCost.component = element, onBlur: () => this.updatePrimaryTravelerTripCost(this.formControls.primaryTravelerTripCost.value, true), onValueChanged: (event) => this.updatePrimaryTravelerTripCost(event.detail, false) }, h("bhtp-ui-tooltip-modal", { slot: "prompt-tooltip", class: "bhtp-ui-input-prompt-tooltip", modalId: "quote-cta-trip-cost-modal", ariaLabel: "More information about trip cost", message: "Your total trip cost should include non-refundable reservations. This includes flights, hotels or resort, vacation rental, cruise deposits, tours, excursions, rental car, meals, etc." })), ((_39 = (_38 = this.formControls) === null || _38 === void 0 ? void 0 : _38.numberOfTravelers) === null || _39 === void 0 ? void 0 : _39.value) > 1 && this.formControls.costPerTraveler &&
      h("div", { class: "bhtp-ui-hide-only-mobile" }, h("bhtp-ui-dropdown-input", { inputId: "trip-cost-per-traveler", description: (_40 = this.formControls) === null || _40 === void 0 ? void 0 : _40.costPerTraveler.description, prompt: "and is", required: true, hideSelectOption: true, value: (_41 = this.formControls) === null || _41 === void 0 ? void 0 : _41.costPerTraveler.value, options: [{ key: 'the same cost per traveler', value: 'same' }, { key: 'different cost per traveler', value: 'different' }], isValid: (!((_42 = this.formControls) === null || _42 === void 0 ? void 0 : _42.costPerTraveler.isValid) && !this.formSubmitted) || ((_43 = this.formControls) === null || _43 === void 0 ? void 0 : _43.costPerTraveler.isValid), ref: (element) => this.formControls.costPerTraveler && (this.formControls.costPerTraveler.component = element), onValueSelected: (event) => this.updateCostPerTraveler(event.detail, false, true /* update travelers */), onBlur: () => this.updateCostPerTraveler(this.formControls.costPerTraveler.value, true, true /* update travelers */) }))), h("bhtp-ui-form-error", { formSubmitted: this.formSubmitted, formControl: (_44 = this.formControls) === null || _44 === void 0 ? void 0 : _44.primaryTravelerTripCost })), ((_46 = (_45 = this.formControls) === null || _45 === void 0 ? void 0 : _45.numberOfTravelers) === null || _46 === void 0 ? void 0 : _46.value) > 1 && this.formControls.costPerTraveler &&
      h("div", { class: "bhtp-ui-form-group bhtp-ui-show-only-mobile bhtp-mobile-cost-per-control" }, h("div", { class: "bhtp-ui-form-group__inline" }, h("bhtp-ui-dropdown-input", { inputId: "trip-cost-per-traveler", description: (_47 = this.formControls) === null || _47 === void 0 ? void 0 : _47.costPerTraveler.description, prompt: "and is", required: true, hideSelectOption: true, value: (_48 = this.formControls) === null || _48 === void 0 ? void 0 : _48.costPerTraveler.value, options: [{ key: 'the same cost per traveler', value: 'same' }, { key: 'different cost per traveler', value: 'different' }], isValid: (!((_49 = this.formControls) === null || _49 === void 0 ? void 0 : _49.costPerTraveler.isValid) && !this.formSubmitted) || ((_50 = this.formControls) === null || _50 === void 0 ? void 0 : _50.costPerTraveler.isValid), ref: (element) => this.formControls.costPerTraveler && (this.formControls.costPerTraveler.component = element), onValueSelected: (event) => this.updateCostPerTraveler(event.detail, false, true /* update travelers */), onBlur: () => this.updateCostPerTraveler(this.formControls.costPerTraveler.value, true, true /* update travelers */) }))), ((_52 = (_51 = this.formControls) === null || _51 === void 0 ? void 0 : _51.numberOfTravelers) === null || _52 === void 0 ? void 0 : _52.value) > 1 && [...Array(this.formControls.numberOfTravelers.value - 1)].map((_, index) => {
      var _a, _b, _c, _d;
      const travelerNumber = index + 2;
      const travelerDateOfBirthKey = `traveler${travelerNumber}DateOfBirth`;
      const travelerTripCostKey = `traveler${travelerNumber}TripCost`;
      return travelerDateOfBirthKey in this.formControls && travelerTripCostKey in this.formControls ?
        (h(Fragment, { key: travelerNumber }, h("div", { class: "bhtp-ui-form-group" }, h("bhtp-ui-date-input", { inputId: `quote-cta-additional-traveler-${travelerNumber}-date-of-birth`, description: this.formControls[travelerDateOfBirthKey].description, prompt: `Traveler ${travelerNumber} date of birth is`, iconName: "gift", required: true, value: this.formControls[travelerDateOfBirthKey].value, isValid: (!this.formControls[travelerDateOfBirthKey].isValid && !this.formSubmitted) || (this.formControls[travelerDateOfBirthKey].isValid), ref: (element) => this.formControls[travelerDateOfBirthKey] && (this.formControls[travelerDateOfBirthKey].component = element), onBlur: () => this.updateValueAndValidity(travelerDateOfBirthKey, this.formControls[travelerDateOfBirthKey].value), onDateChanged: (event) => this.updateValueAndValidity(travelerDateOfBirthKey, event.detail) }), h("bhtp-ui-form-error", { formSubmitted: this.formSubmitted, formControl: this.formControls[travelerDateOfBirthKey] })), h("div", { class: "bhtp-ui-form-group" }, h("div", { class: "bhtp-ui-form-group__inline" }, h("bhtp-ui-number-input", { inputId: `quote-cta-additional-traveler-${travelerNumber}-trip-cost`, description: this.formControls[travelerTripCostKey].description, isValid: (!this.formControls[travelerTripCostKey].isValid && !this.formSubmitted) || (this.formControls[travelerTripCostKey].isValid), value: this.formControls[travelerTripCostKey].value, required: true, prePrompt: `Traveler ${travelerNumber} trip cost is`, iconName: "fa-dollar", size: 7, minValue: (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.minTripCost) !== null && _b !== void 0 ? _b : 0, maxValue: (_d = (_c = this.config) === null || _c === void 0 ? void 0 : _c.maxTripCost) !== null && _d !== void 0 ? _d : 100000, ref: (element) => this.formControls[travelerTripCostKey] && (this.formControls[travelerTripCostKey].component = element), onBlur: () => this.updateAdditionalTravelerTripCost(travelerTripCostKey, this.formControls[travelerTripCostKey].value, true), onValueChanged: (event) => this.updateAdditionalTravelerTripCost(travelerTripCostKey, event.detail, false) }, h("bhtp-ui-tooltip-modal", { slot: "prompt-tooltip", class: "bhtp-ui-input-prompt-tooltip", modalId: `quote-cta-additional-traveler-${travelerNumber}-trip-cost-modal`, ariaLabel: "More information about trip cost", message: "Your total trip cost should include non-refundable reservations. This includes flights, hotels or resort, vacation rental, cruise deposits, tours, excursions, rental car, meals, etc." }))), h("bhtp-ui-form-error", { formSubmitted: this.formSubmitted, formControl: this.formControls[travelerTripCostKey] })))) :
        null;
    }), ((_54 = (_53 = this.formControls) === null || _53 === void 0 ? void 0 : _53.numberOfTravelers) === null || _54 === void 0 ? void 0 : _54.value) > 1 &&
      h("div", { class: "bhtp-ui-form-group" }, h("bhtp-ui-number-input", { inputId: "total-trip-cost-all-travelers", description: "Total trip cost for all travelers", prePrompt: "The total trip cost is", iconName: "fa-dollar", disabled: true, value: this.getTotalTripCost() }), h("bhtp-ui-form-error", { formSubmitted: this.formSubmitted })), h("div", { class: "bhtp-ui-form-group" }, h("bhtp-ui-text-input", { inputId: "quote-cta-email-address", description: (_55 = this.formControls) === null || _55 === void 0 ? void 0 : _55.emailAddress.description, placeholder: "name@email.com", inputMode: "email", widthRem: 25, prompt: "My email address is", required: true, value: (_56 = this.formControls) === null || _56 === void 0 ? void 0 : _56.emailAddress.value, isValid: (!((_57 = this.formControls) === null || _57 === void 0 ? void 0 : _57.emailAddress.isValid) && !this.formSubmitted) || ((_58 = this.formControls) === null || _58 === void 0 ? void 0 : _58.emailAddress.isValid), ref: (element) => this.formControls.emailAddress.component = element, onBlur: () => this.updateValueAndValidity('emailAddress', this.formControls.emailAddress.value, true), onValueChanged: (event) => this.updateValueAndValidity('emailAddress', event.detail) }), h("bhtp-ui-form-error", { formSubmitted: this.formSubmitted, formControl: (_59 = this.formControls) === null || _59 === void 0 ? void 0 : _59.emailAddress })), ((_60 = this.config) === null || _60 === void 0 ? void 0 : _60.showPartnerAdvisorField) &&
      h("div", { class: "bhtp-ui-form-group" }, h("div", { class: "bhtp-ui-form-group__inline" }, h("bhtp-ui-dropdown-input", { inputId: "quote-cta-working-with-partner-advisor", description: (_61 = this.formControls) === null || _61 === void 0 ? void 0 : _61.workingWithPartnerAdvisor.description, prompt: "Are you working with a partner or advisor?", placeholder: "select an item", required: false, hideSelectOption: false, value: (_62 = this.formControls) === null || _62 === void 0 ? void 0 : _62.workingWithPartnerAdvisor.value, options: [{ key: 'Yes', value: 'yes' }, { key: 'No', value: 'no' }], isValid: (!((_63 = this.formControls) === null || _63 === void 0 ? void 0 : _63.workingWithPartnerAdvisor.isValid) && !this.formSubmitted) || ((_64 = this.formControls) === null || _64 === void 0 ? void 0 : _64.workingWithPartnerAdvisor.isValid), ref: (element) => this.formControls.workingWithPartnerAdvisor && (this.formControls.workingWithPartnerAdvisor.component = element), onValueSelected: (event) => this.handlePartnerAdvisorChanged(event.detail), onBlur: () => this.updateValueAndValidity('workingWithPartnerAdvisor', this.formControls.workingWithPartnerAdvisor.value, true) }, h("bhtp-ui-tooltip-modal", { slot: "prompt-tooltip", class: "bhtp-ui-input-prompt-tooltip", modalId: "quote-cta-partner-advisor-modal", ariaLabel: "More information about partner or advisor", message: "If you're working with a travel advisor or partner, they may have provided you with a Partner Number or a customer Partner ID. If you're not sure, please contact your advisor to confirm." }))), h("bhtp-ui-form-error", { formSubmitted: this.formSubmitted, formControl: (_65 = this.formControls) === null || _65 === void 0 ? void 0 : _65.workingWithPartnerAdvisor })), ((_66 = this.config) === null || _66 === void 0 ? void 0 : _66.showPartnerAdvisorField) && ((_68 = (_67 = this.formControls) === null || _67 === void 0 ? void 0 : _67.workingWithPartnerAdvisor) === null || _68 === void 0 ? void 0 : _68.value) === 'yes' &&
      h("div", { class: "bhtp-ui-form-group" }, h("bhtp-ui-text-input", { inputId: "quote-cta-partner-number", description: (_69 = this.formControls) === null || _69 === void 0 ? void 0 : _69.partnerNumber.description, placeholder: "partner number", widthRem: 15, prompt: "Partner number (optional)", required: false, value: (_70 = this.formControls) === null || _70 === void 0 ? void 0 : _70.partnerNumber.value, isValid: (!((_71 = this.formControls) === null || _71 === void 0 ? void 0 : _71.partnerNumber.isValid) && !this.formSubmitted) || ((_72 = this.formControls) === null || _72 === void 0 ? void 0 : _72.partnerNumber.isValid), ref: (element) => this.formControls.partnerNumber && (this.formControls.partnerNumber.component = element), onBlur: () => this.updateValueAndValidity('partnerNumber', this.formControls.partnerNumber.value, true), onValueChanged: (event) => this.updateValueAndValidity('partnerNumber', event.detail) }), h("bhtp-ui-form-error", { formSubmitted: this.formSubmitted, formControl: (_73 = this.formControls) === null || _73 === void 0 ? void 0 : _73.partnerNumber })), h("div", { class: "bhtp-ui-form-group bhtp-ui-form-group--center" }, h("bhtp-ui-button", { styleType: "success", buttonType: "submit", text: this.isEditMode ? "Save" : "Check our prices" }))));
  }
  getTotalTripCost() {
    let total = 0;
    if (this.formControls.primaryTravelerTripCost && this.formControls.primaryTravelerTripCost.value) {
      total += this.formControls.primaryTravelerTripCost.value;
    }
    if (this.formControls.numberOfTravelers.value > 1) {
      for (let i = 2; i <= this.formControls.numberOfTravelers.value; i++) {
        const travelerTripCostKey = `traveler${i}TripCost`;
        if (this.formControls[travelerTripCostKey] && this.formControls[travelerTripCostKey].value) {
          total += this.formControls[travelerTripCostKey].value;
        }
      }
    }
    return total;
  }
  async updateValueAndValidity(controlName, value, touched) {
    if (touched === true) {
      this.formControls[controlName].touched = true;
    }
    const validationResult = await Validators.validateControl(this.formControls[controlName], value, this.formSubmitted);
    this.formControls = Object.assign(Object.assign({}, this.formControls), { [controlName]: Object.assign(Object.assign(Object.assign({}, this.formControls[controlName]), { value }), validationResult) });
    return validationResult;
  }
  async updatePostalCodeValueAndValidity(postalCode) {
    var _a, _b, _c;
    let validationResult = await Validators.validateControl(this.formControls.postalCode, postalCode, this.formSubmitted);
    if (validationResult.isValid && /^[0-9]{5}$/.test(postalCode)) {
      const postalCodeValidator = Validators.postalCodeAsyncValidator((_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.postalCodeValidationUrl) !== null && _b !== void 0 ? _b : this.backupConfig.postalCodeValidationUrl, (_c = this.config) === null || _c === void 0 ? void 0 : _c.phoneNumberOverride);
      const jurisdictionValidationResult = await postalCodeValidator.validate(postalCode);
      validationResult = {
        isValid: jurisdictionValidationResult.isValid,
        errorMessage: jurisdictionValidationResult.errorMessage
      };
      if (jurisdictionValidationResult.asyncResult) {
        this.jurisdiction = jurisdictionValidationResult.asyncResult;
      }
    }
    this.formControls = Object.assign(Object.assign({}, this.formControls), { postalCode: Object.assign(Object.assign(Object.assign({}, this.formControls.postalCode), { value: postalCode }), validationResult) });
    return validationResult;
  }
  async updateCostPerTraveler(newValue, touched, updateTravelers) {
    if (this.formControls.costPerTraveler && this.formControls.costPerTraveler.value !== newValue) {
      await this.updateValueAndValidity('costPerTraveler', newValue, touched);
      if (updateTravelers && newValue === 'same' && this.formControls.primaryTravelerTripCost.value !== null) {
        await this.synchronizeAdditionalTripCosts(this.formControls.primaryTravelerTripCost.value, false);
      }
      else if (updateTravelers && newValue === 'different' && this.formControls.numberOfTravelers.value > 1) {
        for (let i = 2; i <= this.formControls.numberOfTravelers.value; i++) {
          const travelerTripCostKey = `traveler${i}TripCost`;
          await this.updateValueAndValidity(travelerTripCostKey, null, touched);
        }
      }
    }
  }
  async updatePrimaryTravelerTripCost(newValue, touched) {
    await this.updateValueAndValidity('primaryTravelerTripCost', newValue, touched);
    if (newValue !== null) {
      await this.synchronizeAdditionalTripCosts(newValue, false);
    }
  }
  async updateAdditionalTravelerTripCost(controlKey, newValue, touched) {
    await this.updateValueAndValidity(controlKey, newValue, touched);
    if (newValue !== this.formControls.primaryTravelerTripCost.value) {
      await this.updateCostPerTraveler('different', false, false /* don't update travelers again */);
    }
  }
  async synchronizeAdditionalTripCosts(primaryTripCost, touched) {
    var _a;
    if (this.formControls.numberOfTravelers.value > 1 && ((_a = this.formControls.costPerTraveler) === null || _a === void 0 ? void 0 : _a.value) === 'same') {
      for (let i = 2; i <= this.formControls.numberOfTravelers.value; i++) {
        const travelerTripCostKey = `traveler${i}TripCost`;
        await this.updateValueAndValidity(travelerTripCostKey, primaryTripCost, touched);
      }
    }
  }
  async handleSubmit(event) {
    var _a;
    event.preventDefault();
    this.formSubmitted = true;
    this.isFormValid = true;
    const invalidControls = [];
    for (const controlName in this.formControls) {
      const control = this.formControls[controlName];
      let validationResult = { isValid: true, errorMessage: undefined };
      if (controlName !== 'postalCode') {
        validationResult = await this.updateValueAndValidity(controlName, control.value);
      }
      else if (controlName === 'postalCode') {
        validationResult = await this.updatePostalCodeValueAndValidity(control.value);
      }
      this.isFormValid = this.isFormValid && validationResult.isValid;
      if (validationResult.isValid === false) {
        invalidControls.push(control);
      }
    }
    if (this.isFormValid) {
      const insuredEvent = this.mapFormToInsuredEvent();
      this.callToActionSubmitted.emit(insuredEvent);
    }
    else {
      const firstInvalidControl = invalidControls.reduce(function (prev, curr) {
        return prev.order < curr.order ? prev : curr;
      });
      (_a = firstInvalidControl === null || firstInvalidControl === void 0 ? void 0 : firstInvalidControl.component) === null || _a === void 0 ? void 0 : _a.focusInput();
    }
  }
  async handleTravelModeSelected(travelModes) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    if (travelModes.includes('Flight')) {
      this.formControls = Object.assign(Object.assign({}, this.formControls), { flightSegments: ((_a = this.formControls) === null || _a === void 0 ? void 0 : _a.flightSegments) || {
          description: 'Number of Flight Segments',
          value: 2,
          validators: [
            Validators.requiredValidator('Flight segment(s) are required.'),
            Validators.minimumValidator(`At least ${(_c = (_b = this.config) === null || _b === void 0 ? void 0 : _b.minFlightSegments) !== null && _c !== void 0 ? _c : this.backupConfig.minFlightSegments} flight segment is required.`, (_e = (_d = this.config) === null || _d === void 0 ? void 0 : _d.minFlightSegments) !== null && _e !== void 0 ? _e : this.backupConfig.minFlightSegments),
            Validators.maximumValidator(`Maximum number of flight segments is ${(_g = (_f = this.config) === null || _f === void 0 ? void 0 : _f.maxFlightSegments) !== null && _g !== void 0 ? _g : this.backupConfig.maxFlightSegments}.`, (_j = (_h = this.config) === null || _h === void 0 ? void 0 : _h.maxFlightSegments) !== null && _j !== void 0 ? _j : this.backupConfig.maxFlightSegments)
          ],
          isValid: undefined,
          errorMessage: undefined,
          touched: false
        } });
    }
    else {
      const stateCopy = Object.assign({}, this.formControls);
      delete stateCopy.flightSegments;
      this.formControls = stateCopy;
    }
    await this.updateValueAndValidity('travelModes', travelModes);
  }
  async handleStartDateChanged(startDate) {
    var _a, _b, _c, _d;
    let validators = [
      Validators.requiredValidator('Trip departure and return dates are required.'),
      Validators.dateFormatValidator(`Return date must be in ${DISPLAY_DATE.toLowerCase()} format.`)
    ];
    if (startDate) {
      validators = [
        ...validators,
        Validators.dateSameOrAfterValidator('Return date must be on or after departure date.', startDate),
        Validators.dateRangeLengthValidator(`Trip length must be ${(_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.maxTripLength) !== null && _b !== void 0 ? _b : this.backupConfig.maxTripLength} days or less.`, startDate, (_d = (_c = this.config) === null || _c === void 0 ? void 0 : _c.maxTripLength) !== null && _d !== void 0 ? _d : this.backupConfig.maxTripLength)
      ];
    }
    this.formControls = Object.assign(Object.assign({}, this.formControls), { returnDate: Object.assign(Object.assign({}, this.formControls.returnDate), { validators }) });
    await this.updateValueAndValidity('departureDate', startDate);
  }
  updateAdditionalTravelerControls(numberOfTravelers) {
    var _a, _b, _c, _d, _e, _f;
    if (numberOfTravelers !== null) {
      if (numberOfTravelers > 1) {
        this.formControls.costPerTraveler = this.formControls.costPerTraveler || new FormControl('Trip Cost Per Traveler', [], 7, false);
        if (!this.formControls.costPerTraveler.value) {
          this.formControls.costPerTraveler.value = 'same';
        }
      }
      else {
        delete this.formControls.costPerTraveler;
      }
      const maxTravelers = (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.maxTravelers) !== null && _b !== void 0 ? _b : this.backupConfig.maxTravelers;
      for (let i = 2; i <= maxTravelers; i++) {
        const travelerDateOfBirthKey = `traveler${i}DateOfBirth`;
        const travelerTripCostKey = `traveler${i}TripCost`;
        const additionalTravelerControlGroupOrder = 8;
        const travelerDateOfBirthControlOrder = additionalTravelerControlGroupOrder + i / 10; // 8.2, 8.3, etc
        const travelerTripCostControlOrder = additionalTravelerControlGroupOrder + i / 10 + 0.01; // 8.21, 8.31, etc
        if (i <= numberOfTravelers) {
          this.formControls[travelerDateOfBirthKey] = this.formControls[travelerDateOfBirthKey] || new FormControl(`Additional Traveler ${i} Date of Birth`, [
            Validators.requiredValidator('Date of birth is required.'),
            Validators.dateFormatValidator(`Date of birth must be in ${DISPLAY_DATE.toLowerCase()} format.`),
            Validators.dateMinimumValidator(`Date of birth must after ${this.minDateOfBirth}.`, this.minDateOfBirth),
            Validators.dateMaximumValidator(`Date of birth must before ${this.maxDateOfBirth}.`, this.maxDateOfBirth)
          ], travelerDateOfBirthControlOrder);
          this.formControls[travelerTripCostKey] = this.formControls[travelerTripCostKey] || new FormControl(`Additional Traveler ${i} Trip Cost`, [
            Validators.requiredValidator('Trip cost is required.'),
            Validators.maximumValidator(`Trip cost per traveler must be less than $${(_d = (_c = this.config) === null || _c === void 0 ? void 0 : _c.maxTripCost) !== null && _d !== void 0 ? _d : this.backupConfig.maxTripCost}.`, (_f = (_e = this.config) === null || _e === void 0 ? void 0 : _e.maxTripCost) !== null && _f !== void 0 ? _f : this.backupConfig.maxTripCost)
          ], travelerTripCostControlOrder, false);
          if (this.formControls.costPerTraveler && this.formControls.costPerTraveler.value === 'same') {
            this.formControls[travelerTripCostKey].value = this.formControls.primaryTravelerTripCost.value;
          }
        }
        else {
          delete this.formControls[travelerDateOfBirthKey];
          delete this.formControls[travelerTripCostKey];
        }
      }
    }
  }
  mapFormToInsuredEvent() {
    var _a, _b, _c;
    let totalInsurableCostInDollars = 0;
    const insuredEvent = new InsuredEvent();
    insuredEvent.destinations = [{
        countryIso2: this.formControls.destinationCountry.value.countryIso2,
        destination: this.formControls.destinationCountry.value.name
      }];
    insuredEvent.attributes = [
      { name: 'travelModes', value: [...this.formControls.travelModes.value] }
    ];
    if (this.formControls.flightSegments) {
      insuredEvent.attributes.push({ name: 'flightSegments', value: this.formControls.flightSegments.value });
    }
    // Add partner/advisor attributes if the field is enabled and has values
    if ((_a = this.config) === null || _a === void 0 ? void 0 : _a.showPartnerAdvisorField) {
      insuredEvent.workingWithPartnerAdvisor = ((_b = this.formControls.workingWithPartnerAdvisor) === null || _b === void 0 ? void 0 : _b.value) === 'yes';
      if ((_c = this.formControls.partnerNumber) === null || _c === void 0 ? void 0 : _c.value) {
        insuredEvent.partnerNumber = this.formControls.partnerNumber.value;
      }
    }
    insuredEvent.startDate = luxon.DateTime.fromFormat(this.formControls.departureDate.value, DISPLAY_DATE).toISODate();
    insuredEvent.endDate = luxon.DateTime.fromFormat(this.formControls.returnDate.value, DISPLAY_DATE).toISODate();
    insuredEvent.initialDepositDate = luxon.DateTime.fromFormat(this.formControls.initialDepositDate.value, DISPLAY_DATE).toISODate();
    insuredEvent.city = this.jurisdiction.city;
    insuredEvent.stateIso2 = this.jurisdiction.stateOrProvinceIso2;
    insuredEvent.postalCode = this.jurisdiction.postalCode;
    insuredEvent.countryIso2 = this.jurisdiction.countryIso2;
    insuredEvent.insureds = [{
        isPrimary: true,
        dateOfBirth: luxon.DateTime.fromFormat(this.formControls.primaryTravelerDateOfBirth.value, DISPLAY_DATE).toISODate(),
        insurableCost: convertDollarsToCents(this.formControls.primaryTravelerTripCost.value),
        city: this.jurisdiction.city,
        stateIso2: this.jurisdiction.stateOrProvinceIso2,
        postalCode: this.jurisdiction.postalCode,
        countryIso2: this.jurisdiction.countryIso2,
        email: this.formControls.emailAddress.value
      }];
    totalInsurableCostInDollars += this.formControls.primaryTravelerTripCost.value;
    for (let i = 2; i <= this.formControls.numberOfTravelers.value; i++) {
      const travelerDateOfBirthKey = `traveler${i}DateOfBirth`;
      const travelerTripCostKey = `traveler${i}TripCost`;
      const additionalTraveler = new Insured();
      additionalTraveler.dateOfBirth = luxon.DateTime.fromFormat(this.formControls[travelerDateOfBirthKey].value, DISPLAY_DATE).toISODate();
      additionalTraveler.insurableCost = convertDollarsToCents(this.formControls[travelerTripCostKey].value);
      additionalTraveler.isPrimary = false;
      totalInsurableCostInDollars += this.formControls[travelerTripCostKey].value;
      insuredEvent.insureds.push(additionalTraveler);
    }
    insuredEvent.totalInsurableCost = convertDollarsToCents(totalInsurableCostInDollars);
    insuredEvent.agencyCode = 'BHTP';
    insuredEvent.agentCode = 'BHTP';
    return insuredEvent;
  }
  getEnvironment() {
    try {
      // Use url to determine environment
      const currentUrl = window.location.href;
      const urlWithoutProtocol = currentUrl.replace(/(^\w+:|^)\/\//, '');
      const environmentUrlParts = urlWithoutProtocol.split('-');
      const environment = environmentUrlParts.length > 1 && environmentUrlParts[0].length <= 3 ? environmentUrlParts[0] : '';
      const envPrefix = environment ? `${environment}-` : '';
      return envPrefix.toLowerCase();
    }
    catch (error) {
      // We will default to production if there is an error
      return '';
    }
  }
  handlePartnerAdvisorChanged(value) {
    this.updateValueAndValidity('workingWithPartnerAdvisor', value);
    if (!value || value === 'no') {
      this.updateValueAndValidity('partnerNumber', '');
    }
  }
};
QuoteCta.style = quoteCtaComponentCss;

const buttonComponentCss = ":host{display:block}.bhtp-ui-button{font-family:var(--bhtp-ui-primary-font-family);font-size:var(--bhtp-ui-reduced-font-size);font-weight:bold;text-transform:uppercase;line-height:1;border:none;border-radius:7px;padding:0.8rem 3rem}.bhtp-ui-button.bhtp-ui-button--primary{color:var(--bhtp-ui-white-color);background-color:var(--bhtp-ui-primary-color);border:2px solid var(--bhtp-ui-primary-color)}.bhtp-ui-button.bhtp-ui-button--primary:hover{background-color:var(--bhtp-ui-primary-dark-color);border:2px solid var(--bhtp-ui-primary-dark-color)}.bhtp-ui-button.bhtp-ui-button--primary:focus{border:2px solid var(--bhtp-ui-primary-dark-color)}.bhtp-ui-button.bhtp-ui-button--secondary{color:var(--bhtp-ui-white-color);background-color:var(--bhtp-ui-text-secondary-color);border:2px solid var(--bhtp-ui-text-secondary-color)}.bhtp-ui-button.bhtp-ui-button--secondary:hover{background-color:var(--bhtp-ui-text-secondary-dark-color);border:2px solid var(--bhtp-ui-text-secondary-dark-color)}.bhtp-ui-button.bhtp-ui-button--secondary:focus{border:2px solid var(--bhtp-ui-text-secondary-dark-color)}.bhtp-ui-button.bhtp-ui-button--success{color:var(--bhtp-ui-primary-color);background-color:var(--bhtp-ui-success-color);border:2px solid var(--bhtp-ui-success-color)}.bhtp-ui-button.bhtp-ui-button--success:hover{background-color:var(--bhtp-ui-success-dark-color);border:2px solid var(--bhtp-ui-success-dark-color)}.bhtp-ui-button.bhtp-ui-button--success:focus{border:2px solid var(--bhtp-ui-success-dark-color)}.bhtp-ui-button.bhtp-ui-button--icon{border-radius:0;padding:5px;color:var(--bhtp-ui-secondary-color);background-color:unset;outline:none}.bhtp-ui-button.bhtp-ui-button--icon:hover,.bhtp-ui-button.bhtp-ui-button--icon:focus{color:var(--bhtp-ui-primary-color)}";

let Button = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.styleType = 'primary';
    this.buttonType = 'button';
    this.text = '';
  }
  render() {
    return (h("button", { class: `bhtp-ui-button bhtp-ui-button--${this.styleType}`, type: this.buttonType, "aria-label": this.ariaLabel }, h("slot", { name: "button-icon" }), this.text));
  }
};
Button.style = buttonComponentCss;

var main = createCommonjsModule(function (module, exports) {
/*! For license information please see main.js.LICENSE.txt */
!function(t,e){module.exports=e();}(self,(function(){return function(){var t={645:function(t){t.exports=function(t){var e=[];return e.toString=function(){return this.map((function(e){var i="",n=void 0!==e[5];return e[4]&&(i+="@supports (".concat(e[4],") {")),e[2]&&(i+="@media ".concat(e[2]," {")),n&&(i+="@layer".concat(e[5].length>0?" ".concat(e[5]):""," {")),i+=t(e),n&&(i+="}"),e[2]&&(i+="}"),e[4]&&(i+="}"),i})).join("")},e.i=function(t,i,n,o,s){"string"==typeof t&&(t=[[null,t,void 0]]);var a={};if(n)for(var r=0;r<this.length;r++){var l=this[r][0];null!=l&&(a[l]=!0);}for(var c=0;c<t.length;c++){var h=[].concat(t[c]);n&&a[h[0]]||(void 0!==s&&(void 0===h[5]||(h[1]="@layer".concat(h[5].length>0?" ".concat(h[5]):""," {").concat(h[1],"}")),h[5]=s),i&&(h[2]?(h[1]="@media ".concat(h[2]," {").concat(h[1],"}"),h[2]=i):h[2]=i),o&&(h[4]?(h[1]="@supports (".concat(h[4],") {").concat(h[1],"}"),h[4]=o):h[4]="".concat(o)),e.push(h));}},e};},81:function(t){t.exports=function(t){return t[1]};},533:function(t,e,i){i.d(e,{AK:function(){return r},Md:function(){return l},a$:function(){return c},Y8:function(){return h},kV:function(){return d},d4:function(){return p},Id:function(){return u},he:function(){return m},$6:function(){return f},O8:function(){return g},NN:function(){return k},E5:function(){return y},vu:function(){return D},Ph:function(){return b},o4:function(){return w},lH:function(){return v},zZ:function(){return x},$v:function(){return M},OE:function(){return T},zk:function(){return _},p1:function(){return S},hT:function(){return E},mh:function(){return L},Fz:function(){return I},LK:function(){return B},aK:function(){return C},b7:function(){return P},mQ:function(){return N},tP:function(){return R},m$:function(){return A},US:function(){return F},fR:function(){return O},ct:function(){return Y},Ls:function(){return H}});var n=i(81),o=i.n(n),s=i(645),a=i.n(s)()(o());a.push([t.id,':root{--litepickerBgColor: #fff;--litepickerMonthHeaderTextColor: #333;--litepickerMonthButton: #9e9e9e;--litepickerMonthButtonHover: #2196f3;--litepickerMonthWidth: calc(var(--litepickerDayWidth) * 7);--litepickerMonthWeekdayColor: #9e9e9e;--litepickerDayColor: #333;--litepickerDayColorHover: #2196f3;--litepickerDayIsTodayColor: #f44336;--litepickerDayIsInRange: #bbdefb;--litepickerDayIsLockedColor: #9e9e9e;--litepickerDayIsBookedColor: #9e9e9e;--litepickerDayIsStartColor: #fff;--litepickerDayIsStartBg: #2196f3;--litepickerDayIsEndColor: #fff;--litepickerDayIsEndBg: #2196f3;--litepickerDayWidth: 38px;--litepickerButtonCancelColor: #fff;--litepickerButtonCancelBg: #9e9e9e;--litepickerButtonApplyColor: #fff;--litepickerButtonApplyBg: #2196f3;--litepickerButtonResetBtn: #909090;--litepickerButtonResetBtnHover: #2196f3\n}.show-week-numbers{--litepickerMonthWidth: calc(var(--litepickerDayWidth) * 8)}.litepicker{font-family:-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;font-size:0.8rem;display:none}.litepicker .container__months{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;background-color:var(--litepickerBgColor);border-radius:5px;-webkit-box-shadow:0 0 5px #ddd;box-shadow:0 0 5px #ddd;width:calc(var(--litepickerMonthWidth) + 10px);-webkit-box-sizing:content-box;box-sizing:content-box}.litepicker .container__months.columns-2{width:calc((var(--litepickerMonthWidth) * 2) + 20px)}.litepicker .container__months.columns-3{width:calc((var(--litepickerMonthWidth) * 3) + 30px)}.litepicker .container__months.columns-4{width:calc((var(--litepickerMonthWidth) * 4) + 40px)}.litepicker .container__months.split-view .month-item-header .button-previous-month,.litepicker .container__months.split-view .month-item-header .button-next-month{visibility:visible}.litepicker .container__months .month-item{padding:5px;width:var(--litepickerMonthWidth);-webkit-box-sizing:content-box;box-sizing:content-box}.litepicker .container__months .month-item-header{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly;font-weight:500;padding:10px 5px;text-align:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:var(--litepickerMonthHeaderTextColor)}.litepicker .container__months .month-item-header div>.month-item-name{margin-right:5px}.litepicker .container__months .month-item-header div>.month-item-year{padding:0}.litepicker .container__months .month-item-header .reset-button{position:absolute;left:20px;color:var(--litepickerButtonResetBtn)}.litepicker .container__months .month-item-header .reset-button>svg,.litepicker .container__months .month-item-header .reset-button>img{fill:var(--litepickerButtonResetBtn);pointer-events:none}.litepicker .container__months .month-item-header .reset-button:hover{color:var(--litepickerButtonResetBtnHover)}.litepicker .container__months .month-item-header .reset-button:hover>svg{fill:var(--litepickerButtonResetBtnHover)}.litepicker .container__months .month-item-header .button-previous-month,.litepicker .container__months .month-item-header .button-next-month{visibility:hidden;text-decoration:none;color:var(--litepickerMonthButton);padding:3px 5px;border-radius:3px;-webkit-transition:color 0.3s, border 0.3s;transition:color 0.3s, border 0.3s;cursor:default}.litepicker .container__months .month-item-header .button-previous-month>svg,.litepicker .container__months .month-item-header .button-previous-month>img,.litepicker .container__months .month-item-header .button-next-month>svg,.litepicker .container__months .month-item-header .button-next-month>img{fill:var(--litepickerMonthButton);pointer-events:none}.litepicker .container__months .month-item-header .button-previous-month:hover,.litepicker .container__months .month-item-header .button-next-month:hover{color:var(--litepickerMonthButtonHover)}.litepicker .container__months .month-item-header .button-previous-month:hover>svg,.litepicker .container__months .month-item-header .button-next-month:hover>svg{fill:var(--litepickerMonthButtonHover)}.litepicker .container__months .month-item-weekdays-row{display:-webkit-box;display:-ms-flexbox;display:flex;justify-self:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;color:var(--litepickerMonthWeekdayColor)}.litepicker .container__months .month-item-weekdays-row>div{padding:5px 0;font-size:85%;-webkit-box-flex:1;-ms-flex:1;flex:1;width:var(--litepickerDayWidth);text-align:center}.litepicker .container__months .month-item:first-child .button-previous-month{visibility:visible}.litepicker .container__months .month-item:last-child .button-next-month{visibility:visible}.litepicker .container__months .month-item.no-previous-month .button-previous-month{visibility:hidden}.litepicker .container__months .month-item.no-next-month .button-next-month{visibility:hidden}.litepicker .container__days{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;justify-self:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;text-align:center;-webkit-box-sizing:content-box;box-sizing:content-box}.litepicker .container__days>div,.litepicker .container__days>a{padding:5px 0;width:var(--litepickerDayWidth)}.litepicker .container__days .day-item{color:var(--litepickerDayColor);text-align:center;text-decoration:none;border-radius:3px;-webkit-transition:color 0.3s, border 0.3s;transition:color 0.3s, border 0.3s;cursor:default}.litepicker .container__days .day-item:hover{color:var(--litepickerDayColorHover);-webkit-box-shadow:inset 0 0 0 1px var(--litepickerDayColorHover);box-shadow:inset 0 0 0 1px var(--litepickerDayColorHover)}.litepicker .container__days .day-item.is-today{color:var(--litepickerDayIsTodayColor)}.litepicker .container__days .day-item.is-locked{color:var(--litepickerDayIsLockedColor);pointer-events:none}.litepicker .container__days .day-item.is-locked:hover{color:var(--litepickerDayIsLockedColor);-webkit-box-shadow:none;box-shadow:none;cursor:default}.litepicker .container__days .day-item.is-booked{color:var(--litepickerDayIsBookedColor);pointer-events:none}.litepicker .container__days .day-item.is-booked:hover{color:var(--litepickerDayIsBookedColor);-webkit-box-shadow:none;box-shadow:none;cursor:default}.litepicker .container__days .day-item.is-in-range{background-color:var(--litepickerDayIsInRange);border-radius:0}.litepicker .container__days .day-item.is-start-date{color:var(--litepickerDayIsStartColor);background-color:var(--litepickerDayIsStartBg);border-top-left-radius:5px;border-bottom-left-radius:5px;border-top-right-radius:0;border-bottom-right-radius:0}.litepicker .container__days .day-item.is-start-date.is-flipped{border-top-left-radius:0;border-bottom-left-radius:0;border-top-right-radius:5px;border-bottom-right-radius:5px}.litepicker .container__days .day-item.is-end-date{color:var(--litepickerDayIsEndColor);background-color:var(--litepickerDayIsEndBg);border-top-left-radius:0;border-bottom-left-radius:0;border-top-right-radius:5px;border-bottom-right-radius:5px}.litepicker .container__days .day-item.is-end-date.is-flipped{border-top-left-radius:5px;border-bottom-left-radius:5px;border-top-right-radius:0;border-bottom-right-radius:0}.litepicker .container__days .day-item.is-start-date.is-end-date{border-top-left-radius:5px;border-bottom-left-radius:5px;border-top-right-radius:5px;border-bottom-right-radius:5px}.litepicker .container__days .week-number{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#9e9e9e;font-size:85%}.litepicker .container__footer{text-align:right;padding:10px 5px;margin:0 5px;background-color:#fafafa;-webkit-box-shadow:inset 0px 3px 3px 0px #ddd;box-shadow:inset 0px 3px 3px 0px #ddd;border-bottom-left-radius:5px;border-bottom-right-radius:5px}.litepicker .container__footer .preview-date-range{margin-right:10px;font-size:90%}.litepicker .container__footer .button-cancel{background-color:var(--litepickerButtonCancelBg);color:var(--litepickerButtonCancelColor);border:0;padding:3px 7px 4px;border-radius:3px}.litepicker .container__footer .button-cancel>svg,.litepicker .container__footer .button-cancel>img{pointer-events:none}.litepicker .container__footer .button-apply{background-color:var(--litepickerButtonApplyBg);color:var(--litepickerButtonApplyColor);border:0;padding:3px 7px 4px;border-radius:3px;margin-left:10px;margin-right:10px}.litepicker .container__footer .button-apply:disabled{opacity:0.7}.litepicker .container__footer .button-apply>svg,.litepicker .container__footer .button-apply>img{pointer-events:none}.litepicker .container__tooltip{position:absolute;margin-top:-4px;padding:4px 8px;border-radius:4px;background-color:#fff;-webkit-box-shadow:0 1px 3px rgba(0,0,0,0.25);box-shadow:0 1px 3px rgba(0,0,0,0.25);white-space:nowrap;font-size:11px;pointer-events:none;visibility:hidden}.litepicker .container__tooltip:before{position:absolute;bottom:-5px;left:calc(50% - 5px);border-top:5px solid rgba(0,0,0,0.12);border-right:5px solid transparent;border-left:5px solid transparent;content:""}.litepicker .container__tooltip:after{position:absolute;bottom:-4px;left:calc(50% - 4px);border-top:4px solid #fff;border-right:4px solid transparent;border-left:4px solid transparent;content:""}.litepicker-open{overflow:hidden}.litepicker-backdrop{display:none;background-color:#000;opacity:0.3;position:fixed;top:0;right:0;bottom:0;left:0}\n',""]);var r="show-week-numbers",l="litepicker",c="container__months",h="columns-2",d="columns-3",p="columns-4",u="split-view",m="month-item-header",f="button-previous-month",g="button-next-month",k="month-item",y="month-item-name",D="month-item-year",b="reset-button",w="month-item-weekdays-row",v="no-previous-month",x="no-next-month",M="container__days",T="day-item",_="is-today",S="is-locked",E="is-booked",L="is-in-range",I="is-start-date",B="is-flipped",C="is-end-date",P="week-number",N="container__footer",R="preview-date-range",A="button-cancel",F="button-apply",O="container__tooltip",Y="litepicker-open",H="litepicker-backdrop";e.ZP=a;},703:function(t,e,i){i.r(e),i.d(e,{buttonApply:function(){return f.US},buttonCancel:function(){return f.m$},buttonNextMonth:function(){return f.O8},buttonPreviousMonth:function(){return f.$6},columns2:function(){return f.Y8},columns3:function(){return f.kV},columns4:function(){return f.d4},containerDays:function(){return f.$v},containerFooter:function(){return f.mQ},containerMonths:function(){return f.a$},containerTooltip:function(){return f.fR},dayItem:function(){return f.OE},isBooked:function(){return f.hT},isEndDate:function(){return f.aK},isFlipped:function(){return f.LK},isInRange:function(){return f.mh},isLocked:function(){return f.p1},isStartDate:function(){return f.Fz},isToday:function(){return f.zk},litepicker:function(){return f.Md},litepickerBackdrop:function(){return f.Ls},litepickerOpen:function(){return f.ct},monthItem:function(){return f.NN},monthItemHeader:function(){return f.he},monthItemName:function(){return f.E5},monthItemWeekdaysRow:function(){return f.o4},monthItemYear:function(){return f.vu},noNextMonth:function(){return f.zZ},noPreviousMonth:function(){return f.lH},previewDateRange:function(){return f.tP},resetButton:function(){return f.Ph},showWeekNumbers:function(){return f.AK},splitView:function(){return f.Id},weekNumber:function(){return f.b7}});var n=i(379),o=i.n(n),s=i(795),a=i.n(s),r=i(569),l=i.n(r),c=i(565),h=i.n(c),d=i(216),p=i.n(d),u=i(589),m=i.n(u),f=i(533),g={};g.styleTagTransform=m(),g.setAttributes=h(),g.insert=l().bind(null,"head"),g.domAPI=a(),g.insertStyleElement=p(),o()(f.ZP,g),e.default=f.ZP&&f.ZP.locals?f.ZP.locals:void 0;},379:function(t){var e=[];function i(t){for(var i=-1,n=0;n<e.length;n++)if(e[n].identifier===t){i=n;break}return i}function n(t,n){for(var s={},a=[],r=0;r<t.length;r++){var l=t[r],c=n.base?l[0]+n.base:l[0],h=s[c]||0,d="".concat(c," ").concat(h);s[c]=h+1;var p=i(d),u={css:l[1],media:l[2],sourceMap:l[3],supports:l[4],layer:l[5]};if(-1!==p)e[p].references++,e[p].updater(u);else {var m=o(u,n);n.byIndex=r,e.splice(r,0,{identifier:d,updater:m,references:1});}a.push(d);}return a}function o(t,e){var i=e.domAPI(e);return i.update(t),function(e){if(e){if(e.css===t.css&&e.media===t.media&&e.sourceMap===t.sourceMap&&e.supports===t.supports&&e.layer===t.layer)return;i.update(t=e);}else i.remove();}}t.exports=function(t,o){var s=n(t=t||[],o=o||{});return function(t){t=t||[];for(var a=0;a<s.length;a++){var r=i(s[a]);e[r].references--;}for(var l=n(t,o),c=0;c<s.length;c++){var h=i(s[c]);0===e[h].references&&(e[h].updater(),e.splice(h,1));}s=l;}};},569:function(t){var e={};t.exports=function(t,i){var n=function(t){if(void 0===e[t]){var i=document.querySelector(t);if(window.HTMLIFrameElement&&i instanceof window.HTMLIFrameElement)try{i=i.contentDocument.head;}catch(t){i=null;}e[t]=i;}return e[t]}(t);if(!n)throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");n.appendChild(i);};},216:function(t){t.exports=function(t){var e=document.createElement("style");return t.setAttributes(e,t.attributes),t.insert(e,t.options),e};},565:function(t,e,i){t.exports=function(t){var e=i.nc;e&&t.setAttribute("nonce",e);};},795:function(t){t.exports=function(t){var e=t.insertStyleElement(t);return {update:function(i){!function(t,e,i){var n="";i.supports&&(n+="@supports (".concat(i.supports,") {")),i.media&&(n+="@media ".concat(i.media," {"));var o=void 0!==i.layer;o&&(n+="@layer".concat(i.layer.length>0?" ".concat(i.layer):""," {")),n+=i.css,o&&(n+="}"),i.media&&(n+="}"),i.supports&&(n+="}");var s=i.sourceMap;s&&"undefined"!=typeof btoa&&(n+="\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(s))))," */")),e.styleTagTransform(n,t,e.options);}(e,t,i);},remove:function(){!function(t){if(null===t.parentNode)return !1;t.parentNode.removeChild(t);}(e);}}};},589:function(t){t.exports=function(t,e){if(e.styleSheet)e.styleSheet.cssText=t;else {for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(t));}};},722:function(t,e,i){Object.defineProperty(e,"__esModule",{value:!0}),e.Calendar=void 0;const n=i(939),o=i(703),s=i(601);e.Calendar=class{constructor(){this.options={element:null,elementEnd:null,parentEl:null,firstDay:1,format:"YYYY-MM-DD",lang:"en-US",numberOfMonths:1,numberOfColumns:1,startDate:null,endDate:null,zIndex:9999,verticalOffset:0,horizontalOffset:0,minDate:null,maxDate:null,minDays:null,maxDays:null,selectForward:!1,selectBackward:!1,splitView:!1,inlineMode:!1,singleMode:!0,autoApply:!0,allowRepick:!1,showWeekNumbers:!1,showTooltip:!0,hotelMode:!1,disableWeekends:!1,scrollToDate:!0,mobileFriendly:!0,useResetBtn:!1,lockDaysFormat:"YYYY-MM-DD",lockDays:[],disallowLockDaysInRange:!1,lockDaysInclusivity:"[]",bookedDaysFormat:"YYYY-MM-DD",bookedDays:[],disallowBookedDaysInRange:!1,bookedDaysInclusivity:"[]",anyBookedDaysAsCheckout:!1,trace:!1,dropdowns:{minYear:1990,maxYear:null,months:!1,years:!1},buttonText:{apply:"Apply",cancel:"Cancel",previousMonth:'<svg width="11" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M7.919 0l2.748 2.667L5.333 8l5.334 5.333L7.919 16 0 8z" fill-rule="nonzero"/></svg>',nextMonth:'<svg width="11" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M2.748 16L0 13.333 5.333 8 0 2.667 2.748 0l7.919 8z" fill-rule="nonzero"/></svg>',reset:'<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">\n        <path d="M0 0h24v24H0z" fill="none"/>\n        <path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"/>\n      </svg>'},tooltipText:{one:"day",other:"days"},onShow:null,onHide:null,onSelect:null,onError:null,onRender:null,onChangeMonth:null,onChangeYear:null,onStartDateChange:null,onEndDateChange:null,resetBtnCallback:null},this.calendars=[],this.datePicked=[];}render(){const t=document.createElement("div");t.className=o.containerMonths,o[`columns${this.options.numberOfColumns}`]&&(t.classList.remove(o.columns2,o.columns3,o.columns4),t.classList.add(o[`columns${this.options.numberOfColumns}`])),this.options.splitView&&t.classList.add(o.splitView),this.options.showWeekNumbers&&t.classList.add(o.showWeekNumbers);const e=this.calendars[0].clone(),i=e.getMonth(),n=e.getMonth()+this.options.numberOfMonths;let s=0;for(let o=i;o<n;o+=1){let i=e.clone();i.setDate(1),this.options.splitView?i=this.calendars[s].clone():i.setMonth(o),t.appendChild(this.renderMonth(i)),s+=1;}this.picker.setAttribute("role","dialog"),this.picker.setAttribute("aria-modal","true"),this.picker.innerHTML="",this.picker.appendChild(t),this.options.autoApply&&!this.options.footerHTML||this.picker.appendChild(this.renderFooter()),this.options.showTooltip&&this.picker.appendChild(this.renderTooltip()),"function"==typeof this.options.onRender&&this.options.onRender.call(this);}renderMonth(t){const e=t.clone(),i=32-new Date(e.getFullYear(),e.getMonth(),32).getDate(),a=document.createElement("div");a.className=o.monthItem;const r=document.createElement("div");r.className=o.monthItemHeader;const l=document.createElement("div");if(this.options.dropdowns.months){const e=document.createElement("select");e.className=o.monthItemName;for(let i=0;i<12;i+=1){const o=document.createElement("option"),s=new n.DateTime(new Date(t.getFullYear(),i,1,0,0,0));o.value=String(i),o.text=s.toLocaleString(this.options.lang,{month:"long"}),o.disabled=this.options.minDate&&s.isBefore(new n.DateTime(this.options.minDate),"month")||this.options.maxDate&&s.isBefore(new n.DateTime(this.options.maxDate),"month"),o.selected=s.getMonth()===t.getMonth(),e.appendChild(o);}e.addEventListener("change",(t=>{const e=t.target;let i=0;if(this.options.splitView){const t=e.closest(`.${o.monthItem}`);i=[...t.parentNode.childNodes].findIndex((e=>e===t));}this.calendars[i].setMonth(Number(e.value)),this.render(),"function"==typeof this.options.onChangeMonth&&this.options.onChangeMonth.call(this,this.calendars[i],i);})),l.appendChild(e);}else {const e=document.createElement("strong");e.className=o.monthItemName,e.innerHTML=t.toLocaleString(this.options.lang,{month:"long"}),l.appendChild(e);}if(this.options.dropdowns.years){const e=document.createElement("select");e.className=o.monthItemYear;const i=this.options.dropdowns.minYear,s=this.options.dropdowns.maxYear?this.options.dropdowns.maxYear:(new Date).getFullYear();if(t.getFullYear()>s){const i=document.createElement("option");i.value=String(t.getFullYear()),i.text=String(t.getFullYear()),i.selected=!0,i.disabled=!0,e.appendChild(i);}for(let o=s;o>=i;o-=1){const i=document.createElement("option"),s=new n.DateTime(new Date(o,0,1,0,0,0));i.value=o,i.text=o,i.disabled=this.options.minDate&&s.isBefore(new n.DateTime(this.options.minDate),"month")||this.options.maxDate&&s.isBefore(new n.DateTime(this.options.maxDate),"month"),i.selected=t.getFullYear()===o,e.appendChild(i);}e.addEventListener("change",(t=>{const e=t.target;let i=0;if(this.options.splitView){const t=e.closest(`.${o.monthItem}`);i=[...t.parentNode.childNodes].findIndex((e=>e===t));}this.calendars[i].setFullYear(Number(e.value)),this.render(),"function"==typeof this.options.onChangeYear&&this.options.onChangeYear.call(this,this.calendars[i],i);})),l.appendChild(e);}else {const e=document.createElement("span");e.className=o.monthItemYear,e.innerHTML=String(t.getFullYear()),l.appendChild(e);}const c=document.createElement("a");c.href="#",c.className=o.buttonPreviousMonth,c.innerHTML=this.options.buttonText.previousMonth,c.tabIndex=s.MONTH_BUTTON_TAB_INDEX;const h=document.createElement("a");h.href="#",h.className=o.buttonNextMonth,h.innerHTML=this.options.buttonText.nextMonth,h.tabIndex=s.MONTH_BUTTON_TAB_INDEX;const d=document.createElement("span");d.className=o.resetButton,d.innerHTML=this.options.buttonText.reset,r.appendChild(c),r.appendChild(l),r.appendChild(h),this.options.useResetBtn&&(d.addEventListener("click",this.options.resetBtnCallback),r.appendChild(d)),this.options.minDate&&e.isSameOrBefore(new n.DateTime(this.options.minDate),"month")&&(a.classList.add(o.noPreviousMonth),c.tabIndex=-1),this.options.maxDate&&e.isSameOrAfter(new n.DateTime(this.options.maxDate),"month")&&(a.classList.add(o.noNextMonth),h.tabIndex=-1);const p=document.createElement("div");p.className=o.monthItemWeekdaysRow,this.options.showWeekNumbers&&(p.innerHTML="<div>W</div>");for(let t=1;t<=7;t+=1){const e=3+this.options.firstDay+t,i=document.createElement("div");i.innerHTML=this.weekdayName(e),i.title=this.weekdayName(e,"long"),p.appendChild(i);}const u=document.createElement("div");u.className=o.containerDays;const m=this.calcSkipDays(e);this.options.showWeekNumbers&&m&&u.appendChild(this.renderWeekNumber(e));for(let t=0;t<m;t+=1){const t=document.createElement("div");u.appendChild(t);}for(let t=1;t<=i;t+=1)e.setDate(t),this.options.showWeekNumbers&&e.getDay()===this.options.firstDay&&u.appendChild(this.renderWeekNumber(e)),u.appendChild(this.renderDay(e));return a.appendChild(r),a.appendChild(p),a.appendChild(u),a}renderDay(t){var e;const i=document.createElement("a");if(i.href="#",i.className=o.dayItem,i.innerHTML=String(t.getDate()),i.dataset.time=String(n.DateTime.getDateZeroTime(t.toJSDate()).getTime()),(null==t?void 0:t.toDateString())===(new Date).toDateString()&&i.classList.add(o.isToday),this.datePicked.length?((null===(e=this.datePicked[0])||void 0===e?void 0:e.toDateString())===t.toDateString()&&(i.classList.add(o.isStartDate),this.options.singleMode&&i.classList.add(o.isEndDate)),2===this.datePicked.length&&this.datePicked[1].toDateString()===t.toDateString()&&i.classList.add(o.isEndDate),2===this.datePicked.length&&t.isBetween(this.datePicked[0],this.datePicked[1])&&i.classList.add(o.isInRange)):this.options.startDate&&(this.options.startDate.toDateString()===t.toDateString()&&(i.classList.add(o.isStartDate),this.options.singleMode&&i.classList.add(o.isEndDate)),this.options.endDate&&this.options.endDate.toDateString()===t.toDateString()&&i.classList.add(o.isEndDate),this.options.startDate&&this.options.endDate&&t.isBetween(this.options.startDate,this.options.endDate)&&i.classList.add(o.isInRange)),this.options.minDate&&t.isBefore(new n.DateTime(this.options.minDate))&&i.classList.add(o.isLocked),this.options.maxDate&&t.isAfter(new n.DateTime(this.options.maxDate))&&i.classList.add(o.isLocked),this.options.minDays&&1===this.datePicked.length){const e=this.datePicked[0].clone().subtract(this.options.minDays,"day"),n=this.datePicked[0].clone().add(this.options.minDays,"day");t.isBetween(e,this.datePicked[0],"(]")&&i.classList.add(o.isLocked),t.isBetween(this.datePicked[0],n,"[)")&&i.classList.add(o.isLocked);}if(this.options.maxDays&&1===this.datePicked.length){const e=this.datePicked[0].clone().subtract(this.options.maxDays,"day"),n=this.datePicked[0].clone().add(this.options.maxDays,"day");t.isBefore(e)&&i.classList.add(o.isLocked),t.isAfter(n)&&i.classList.add(o.isLocked);}if(this.options.selectForward&&1===this.datePicked.length&&t.isBefore(this.datePicked[0])&&i.classList.add(o.isLocked),this.options.selectBackward&&1===this.datePicked.length&&t.isAfter(this.datePicked[0])&&i.classList.add(o.isLocked),this.options.lockDays.length&&this.options.lockDays.filter((e=>e instanceof Array?t.isBetween(e[0],e[1],this.options.lockDaysInclusivity):e.isSame(t,"day"))).length&&i.classList.add(o.isLocked),this.datePicked.length<=1&&this.options.bookedDays.length){let e=this.options.bookedDaysInclusivity;this.options.hotelMode&&1===this.datePicked.length&&(e="()");const n=t.clone();n.subtract(1,"day"),t.clone().add(1,"day");const s=this.dateIsBooked(t,e),a=this.dateIsBooked(n,"[]"),r=this.dateIsBooked(t,"(]"),l=0===this.datePicked.length&&s||1===this.datePicked.length&&a&&s||1===this.datePicked.length&&a&&r,c=this.options.anyBookedDaysAsCheckout&&1===this.datePicked.length;l&&!c&&i.classList.add(o.isBooked);}return !this.options.disableWeekends||6!==t.getDay()&&0!==t.getDay()||i.classList.add(o.isLocked),i.tabIndex=i.classList.contains("is-locked")?-1:s.DAY_BUTTON_TAB_INDEX,i}renderFooter(){const t=document.createElement("div");if(t.className=o.containerFooter,this.options.footerHTML?t.innerHTML=this.options.footerHTML:t.innerHTML=`\n      <span class="${o.previewDateRange}"></span>\n      <button type="button" class="${o.buttonCancel}">${this.options.buttonText.cancel}</button>\n      <button type="button" class="${o.buttonApply}">${this.options.buttonText.apply}</button>\n      `,this.options.singleMode){if(1===this.datePicked.length){const e=this.datePicked[0].format(this.options.format,this.options.lang);t.querySelector(`.${o.previewDateRange}`).innerHTML=e;}}else if(1===this.datePicked.length&&t.querySelector(`.${o.buttonApply}`).setAttribute("disabled",""),2===this.datePicked.length){const e=this.datePicked[0].format(this.options.format,this.options.lang),i=this.datePicked[1].format(this.options.format,this.options.lang);t.querySelector(`.${o.previewDateRange}`).innerHTML=`${e} - ${i}`;}return t}renderWeekNumber(t){const e=document.createElement("div"),i=t.getWeek(this.options.firstDay);return e.className=o.weekNumber,e.innerHTML=53===i&&0===t.getMonth()?"53 / 1":i,e}renderTooltip(){const t=document.createElement("div");return t.className=o.containerTooltip,t}dateIsBooked(t,e){return this.options.bookedDays.filter((i=>i instanceof Array?t.isBetween(i[0],i[1],e):i.isSame(t,"day"))).length}weekdayName(t,e="short"){return new Date(1970,0,t,12,0,0,0).toLocaleString(this.options.lang,{weekday:e})}calcSkipDays(t){let e=t.getDay()-this.options.firstDay;return e<0&&(e+=7),e}};},601:function(t,e){Object.defineProperty(e,"__esModule",{value:!0}),e.DAY_BUTTON_TAB_INDEX=e.MONTH_BUTTON_TAB_INDEX=void 0,e.MONTH_BUTTON_TAB_INDEX=1,e.DAY_BUTTON_TAB_INDEX=2;},939:function(t,e){Object.defineProperty(e,"__esModule",{value:!0}),e.DateTime=void 0;class i{constructor(t=null,e=null,n="en-US"){this.dateInstance="object"==typeof e&&null!==e?e.parse(t instanceof i?t.clone().toJSDate():t):"string"==typeof e?i.parseDateTime(t,e,n):t?i.parseDateTime(t):i.parseDateTime(new Date),this.lang=n;}static parseDateTime(t,e="YYYY-MM-DD",n="en-US"){if(!t)return new Date(NaN);if(t instanceof Date)return new Date(t);if(t instanceof i)return t.clone().toJSDate();if(/^-?\d{10,}$/.test(t))return i.getDateZeroTime(new Date(Number(t)));if("string"==typeof t){const o=[];let s=null;for(;null!=(s=i.regex.exec(e));)"\\"!==s[1]&&o.push(s);if(o.length){const e={year:null,month:null,shortMonth:null,longMonth:null,day:null,value:""};o[0].index>0&&(e.value+=".*?");for(const[t,s]of Object.entries(o)){const o=Number(t),{group:a,pattern:r}=i.formatPatterns(s[0],n);e[a]=o+1,e.value+=r,e.value+=".*?";}const s=new RegExp(`^${e.value}$`);if(s.test(t)){const o=s.exec(t),a=Number(o[e.year]);let r=null;e.month?r=Number(o[e.month])-1:e.shortMonth?r=i.shortMonths(n).indexOf(o[e.shortMonth]):e.longMonth&&(r=i.longMonths(n).indexOf(o[e.longMonth]));const l=Number(o[e.day])||1;return new Date(a,r,l,0,0,0,0)}}}return i.getDateZeroTime(new Date(t))}static convertArray(t,e){return t.map((t=>t instanceof Array?t.map((t=>new i(t,e))):new i(t,e)))}static getDateZeroTime(t){return new Date(t.getFullYear(),t.getMonth(),t.getDate(),0,0,0,0)}static shortMonths(t){return i.MONTH_JS.map((e=>new Date(2019,e).toLocaleString(t,{month:"short"})))}static longMonths(t){return i.MONTH_JS.map((e=>new Date(2019,e).toLocaleString(t,{month:"long"})))}static formatPatterns(t,e){switch(t){case"YY":case"YYYY":return {group:"year",pattern:`(\\d{${t.length}})`};case"M":return {group:"month",pattern:"(\\d{1,2})"};case"MM":return {group:"month",pattern:"(\\d{2})"};case"MMM":return {group:"shortMonth",pattern:`(${i.shortMonths(e).join("|")})`};case"MMMM":return {group:"longMonth",pattern:`(${i.longMonths(e).join("|")})`};case"D":return {group:"day",pattern:"(\\d{1,2})"};case"DD":return {group:"day",pattern:"(\\d{2})"}}}toJSDate(){return this.dateInstance}toLocaleString(t,e){return this.dateInstance.toLocaleString(t,e)}toDateString(){return this.dateInstance.toDateString()}getSeconds(){return this.dateInstance.getSeconds()}getDay(){return this.dateInstance.getDay()}getTime(){return this.dateInstance.getTime()}getDate(){return this.dateInstance.getDate()}getMonth(){return this.dateInstance.getMonth()}getFullYear(){return this.dateInstance.getFullYear()}setMonth(t){return this.dateInstance.setMonth(t)}setHours(t=0,e=0,i=0,n=0){this.dateInstance.setHours(t,e,i,n);}setSeconds(t){return this.dateInstance.setSeconds(t)}setDate(t){return this.dateInstance.setDate(t)}setFullYear(t){return this.dateInstance.setFullYear(t)}getWeek(t){const e=new Date(this.timestamp()),i=(this.getDay()+(7-t))%7;e.setDate(e.getDate()-i);const n=e.getTime();return e.setMonth(0,1),e.getDay()!==t&&e.setMonth(0,1+(4-e.getDay()+7)%7),1+Math.ceil((n-e.getTime())/6048e5)}clone(){return new i(this.toJSDate())}isBetween(t,e,i="()"){switch(i){default:case"()":return this.timestamp()>t.getTime()&&this.timestamp()<e.getTime();case"[)":return this.timestamp()>=t.getTime()&&this.timestamp()<e.getTime();case"(]":return this.timestamp()>t.getTime()&&this.timestamp()<=e.getTime();case"[]":return this.timestamp()>=t.getTime()&&this.timestamp()<=e.getTime()}}isBefore(t,e="seconds"){switch(e){case"second":case"seconds":return t.getTime()>this.getTime();case"day":case"days":return new Date(t.getFullYear(),t.getMonth(),t.getDate()).getTime()>new Date(this.getFullYear(),this.getMonth(),this.getDate()).getTime();case"month":case"months":return new Date(t.getFullYear(),t.getMonth(),1).getTime()>new Date(this.getFullYear(),this.getMonth(),1).getTime();case"year":case"years":return t.getFullYear()>this.getFullYear()}throw new Error("isBefore: Invalid unit!")}isSameOrBefore(t,e="seconds"){switch(e){case"second":case"seconds":return t.getTime()>=this.getTime();case"day":case"days":return new Date(t.getFullYear(),t.getMonth(),t.getDate()).getTime()>=new Date(this.getFullYear(),this.getMonth(),this.getDate()).getTime();case"month":case"months":return new Date(t.getFullYear(),t.getMonth(),1).getTime()>=new Date(this.getFullYear(),this.getMonth(),1).getTime()}throw new Error("isSameOrBefore: Invalid unit!")}isAfter(t,e="seconds"){switch(e){case"second":case"seconds":return this.getTime()>t.getTime();case"day":case"days":return new Date(this.getFullYear(),this.getMonth(),this.getDate()).getTime()>new Date(t.getFullYear(),t.getMonth(),t.getDate()).getTime();case"month":case"months":return new Date(this.getFullYear(),this.getMonth(),1).getTime()>new Date(t.getFullYear(),t.getMonth(),1).getTime();case"year":case"years":return this.getFullYear()>t.getFullYear()}throw new Error("isAfter: Invalid unit!")}isSameOrAfter(t,e="seconds"){switch(e){case"second":case"seconds":return this.getTime()>=t.getTime();case"day":case"days":return new Date(this.getFullYear(),this.getMonth(),this.getDate()).getTime()>=new Date(t.getFullYear(),t.getMonth(),t.getDate()).getTime();case"month":case"months":return new Date(this.getFullYear(),this.getMonth(),1).getTime()>=new Date(t.getFullYear(),t.getMonth(),1).getTime()}throw new Error("isSameOrAfter: Invalid unit!")}isSame(t,e="seconds"){switch(e){case"second":case"seconds":return this.getTime()===t.getTime();case"day":case"days":return new Date(this.getFullYear(),this.getMonth(),this.getDate()).getTime()===new Date(t.getFullYear(),t.getMonth(),t.getDate()).getTime();case"month":case"months":return new Date(this.getFullYear(),this.getMonth(),1).getTime()===new Date(t.getFullYear(),t.getMonth(),1).getTime()}throw new Error("isSame: Invalid unit!")}add(t,e="seconds"){switch(e){case"second":case"seconds":this.setSeconds(this.getSeconds()+t);break;case"day":case"days":this.setDate(this.getDate()+t);break;case"month":case"months":this.setMonth(this.getMonth()+t);}return this}subtract(t,e="seconds"){switch(e){case"second":case"seconds":this.setSeconds(this.getSeconds()-t);break;case"day":case"days":this.setDate(this.getDate()-t);break;case"month":case"months":this.setMonth(this.getMonth()-t);}return this}diff(t,e="seconds"){switch(e){default:case"second":case"seconds":return this.getTime()-t.getTime();case"day":case"days":return Math.round((this.timestamp()-t.getTime())/864e5);case"month":case"months":}}format(t,e="en-US"){if("object"==typeof t)return t.output(this.clone().toJSDate());let n="";const o=[];let s=null;for(;null!=(s=i.regex.exec(t));)"\\"!==s[1]&&o.push(s);if(o.length){o[0].index>0&&(n+=t.substring(0,o[0].index));for(const[i,s]of Object.entries(o)){const a=Number(i);n+=this.formatTokens(s[0],e),o[a+1]&&(n+=t.substring(s.index+s[0].length,o[a+1].index)),a===o.length-1&&(n+=t.substring(s.index+s[0].length));}}return n.replace(/\\/g,"")}timestamp(){return new Date(this.getFullYear(),this.getMonth(),this.getDate(),0,0,0,0).getTime()}formatTokens(t,e){switch(t){case"YY":return String(this.getFullYear()).slice(-2);case"YYYY":return String(this.getFullYear());case"M":return String(this.getMonth()+1);case"MM":return `0${this.getMonth()+1}`.slice(-2);case"MMM":return i.shortMonths(e)[this.getMonth()];case"MMMM":return i.longMonths(e)[this.getMonth()];case"D":return String(this.getDate());case"DD":return `0${this.getDate()}`.slice(-2);default:return ""}}}e.DateTime=i,i.regex=/(\\)?(Y{2,4}|M{1,4}|D{1,2}|d{1,4})/g,i.MONTH_JS=[0,1,2,3,4,5,6,7,8,9,10,11];},630:function(t,e){Object.defineProperty(e,"__esModule",{value:!0}),e.KeyCodes=void 0;class i{}e.KeyCodes=i,i.ARROW_UP="ArrowUp",i.ARROW_DOWN="ArrowDown",i.ARROW_LEFT="ArrowLeft",i.ARROW_RIGHT="ArrowRight",i.ENTER="Enter",i.TAB="Tab",i.ESCAPE="Escape",i.SPACEBAR="Space";},338:function(t,e,i){Object.defineProperty(e,"__esModule",{value:!0}),e.handleArrowLeftRight=e.handleArrowUpDown=e.handleSelection=e.dayButtonTabSelector=e.dayButtonTabIndex=e.monthButtonTabSelector=e.monthButtonTabIndex=void 0;const n=i(630);function o(t,i){const n=t?".button-next-month":".button-previous-month",o=i.querySelector(`${n}${e.monthButtonTabSelector}`);o&&o.dispatchEvent(new Event("click")),setTimeout((()=>{const n=Array.from(i.querySelectorAll(e.dayButtonTabSelector));let o=null;if(!t&&n&&n.length>0?o=n[n.length-1]:t&&(o=i.querySelector(e.dayButtonTabSelector)),o)return o.focus(),o}));}function s(t,i,n){const o=Array.from(t.querySelectorAll(`.day-item${e.dayButtonTabSelector}`)),s=o.indexOf(i);return o.filter(((t,i)=>n(t,i,s)&&t.tabIndex===e.dayButtonTabIndex))[0]}function a(t){return t.classList.contains("day-item")}function r(t){return c(t)||l(t)}function l(t){return t.classList.contains("button-next-month")}function c(t){return t.classList.contains("button-previous-month")}e.monthButtonTabIndex=1,e.monthButtonTabSelector=`[tabindex="${e.monthButtonTabIndex}"]`,e.dayButtonTabIndex=2,e.dayButtonTabSelector=`[tabindex="${e.dayButtonTabIndex}"]`,e.handleSelection=function(t,e,i){a(t)?(e.preventDefault(),e.stopPropagation(),t.dispatchEvent(new Event("click"))):r(t)&&(e.preventDefault(),o(l(t),i));},e.handleArrowUpDown=function(t,i,o,l){if(a(t)){i.preventDefault();const a=t.closest(".month-item"),r=s(o,t,((t,e,o)=>e===(o=i.code===n.KeyCodes.ARROW_UP?o-7:o+7)&&(i.code===n.KeyCodes.ARROW_DOWN||a===t.closest(".month-item"))));if(r)return r.focus(),r;if(i.code===n.KeyCodes.ARROW_UP){const i=o.querySelector(`.month-item:last-child .button-next-month${e.monthButtonTabSelector}`),n=o.querySelector(`.month-item:first-child .button-previous-month${e.monthButtonTabSelector}`);if(1===l)i?i.focus():n&&n.focus();else {const e=o.querySelector(".month-item:last-child"),s=o.querySelector(".month-item:first-child"),a=t.closest(".month-item");a&&a===e&&i?i.focus():a&&a===s&&n&&n.focus();}}}else if(i.code===n.KeyCodes.ARROW_DOWN&&r(t)){const t=o.querySelector(e.dayButtonTabSelector);if(t)return t.focus(),t}},e.handleArrowLeftRight=function(t,i,r){if(a(t)){i.preventDefault();const e=s(r,t,((t,e,o)=>e===(i.code===n.KeyCodes.ARROW_LEFT?o-1:o+1)));if(e)return e.focus(),e;if(!(i.code===n.KeyCodes.ARROW_LEFT&&Boolean(r.querySelector(".no-previous-month"))||i.code===n.KeyCodes.ARROW_RIGHT&&Boolean(r.querySelector(".no-next-month"))))return o(i.code===n.KeyCodes.ARROW_RIGHT,r)}else if(l(t)){if(i.code===n.KeyCodes.ARROW_RIGHT)return o(!0,r);{const t=r.querySelector(`.month-item:first-child .button-previous-month${e.monthButtonTabSelector}`);t&&t.focus();}}else if(c(t)){if(i.code===n.KeyCodes.ARROW_LEFT)return o(!1,r);{const t=r.querySelector(`.month-item:last-child  .button-next-month${e.monthButtonTabSelector}`);t&&t.focus();}}};},506:function(t,e,i){Object.defineProperty(e,"__esModule",{value:!0}),e.Litepicker=void 0;const n=i(722),o=i(601),s=i(939),a=i(703);class r extends n.Calendar{constructor(t){super(),this.currentState="init",this.options=Object.assign(Object.assign({},this.options),t),(this.options.allowRepick&&this.options.inlineMode||!this.options.elementEnd)&&(this.options.allowRepick=!1),this.options.lockDays.length&&(this.options.lockDays=s.DateTime.convertArray(this.options.lockDays,this.options.lockDaysFormat)),this.options.bookedDays.length&&(this.options.bookedDays=s.DateTime.convertArray(this.options.bookedDays,this.options.bookedDaysFormat)),this.options.hotelMode&&!("bookedDaysInclusivity"in t)&&(this.options.bookedDaysInclusivity="[)"),this.options.hotelMode&&!("disallowBookedDaysInRange"in t)&&(this.options.disallowBookedDaysInRange=!0),this.options.hotelMode&&!("selectForward"in t)&&(this.options.selectForward=!0);let[e,i]=this.parseInput();this.options.startDate&&(e=new s.DateTime(this.options.startDate,this.options.format,this.options.lang)),this.options.endDate&&(i=new s.DateTime(this.options.endDate,this.options.format,this.options.lang)),e instanceof s.DateTime&&!isNaN(e.getTime())&&(this.options.startDate=new s.DateTime(e,this.options.format,this.options.lang)),i instanceof s.DateTime&&!isNaN(i.getTime())&&(this.options.endDate=new s.DateTime(i,this.options.format,this.options.lang)),!this.options.singleMode||this.options.startDate instanceof s.DateTime||(this.options.startDate=null),this.options.singleMode||(this.options.startDate instanceof s.DateTime||(this.options.startDate=null),this.options.endDate instanceof s.DateTime||(this.options.endDate=null));for(let t=0;t<this.options.numberOfMonths;t+=1){const e=this.options.startDate instanceof Date?this.options.startDate.clone():new s.DateTime;e.setDate(1),e.setMonth(e.getMonth()+t),this.calendars[t]=e;}this.onInit();}traceForVisability(t){this.options.trace&&console.log(t);}setSingleModeIfLostFocus(){(this.options.element instanceof HTMLInputElement&&this.options.element.value||this.options.elementEnd instanceof HTMLInputElement&&this.options.elementEnd.value)&&(this.traceForVisability("Entering single mode because of lost focus"),this.options.onHide=null,this.options.singleMode=!0);}onInit(){document.addEventListener("click",(t=>this.onClick(t,!0,"document")),!0),this.options.onHide=this.setSingleModeIfLostFocus.bind(this),this.picker=document.createElement("div"),this.picker.className=a.litepicker,this.picker.tabIndex=-1,this.picker.style.display="none",this.picker.addEventListener("mouseenter",(t=>this.onMouseEnter(t)),!0),this.picker.addEventListener("mouseleave",(t=>this.onMouseLeave(t)),!1),this.options.element instanceof HTMLElement&&this.options.element.addEventListener("change",(t=>this.onInput(t)),!0),this.options.elementEnd instanceof HTMLElement&&this.options.elementEnd.addEventListener("change",(t=>this.onInput(t)),!0),this.render(),Array.from(this.picker.querySelectorAll([".month-item:first-child:not(.no-previous-month) .button-previous-month",".month-item:last-child:not(.no-next-month) .button-next-month",".reset-button","select"].join(","))).forEach((t=>t.tabIndex=o.MONTH_BUTTON_TAB_INDEX)),this.options.parentEl?this.options.parentEl instanceof HTMLElement?this.options.parentEl.appendChild(this.picker):document.querySelector(this.options.parentEl).appendChild(this.picker):this.options.inlineMode?this.options.element instanceof HTMLInputElement?this.options.element.parentNode.appendChild(this.picker):this.options.element.appendChild(this.picker):document.body.appendChild(this.picker),this.options.useResetBtn&&!this.options.resetBtnCallback&&(this.options.resetBtnCallback=this.clearSelection.bind(this)),this.options.mobileFriendly&&(this.backdrop=document.createElement("div"),this.backdrop.className=a.litepickerBackdrop,this.backdrop.addEventListener("click",this.hide()),this.options.element&&this.options.element.parentNode&&this.options.element.parentNode.appendChild(this.backdrop),window.addEventListener("orientationchange",(()=>{if(this.options.mobileFriendly&&this.isShowing()){switch(screen.orientation.angle){case-90:case 90:this.options.numberOfMonths=2,this.options.numberOfColumns=2;break;default:this.options.numberOfMonths=1,this.options.numberOfColumns=1;}this.render();const t=this.picker.getBoundingClientRect();this.picker.style.top=`calc(50% - ${t.height/2}px)`,this.picker.style.left=`calc(50% - ${t.width/2}px)`;}}))),this.options.inlineMode&&this.show(),this.updateInput(),this.initializeKeypressHandling(this.picker,this.options.element);}parseInput(){if(this.traceForVisability("parse Input"),this.options.elementEnd){let t,e;return this.options.element instanceof HTMLInputElement&&this.options.element.value.length&&(t=new s.DateTime(this.options.element.value)),this.options.elementEnd instanceof HTMLInputElement&&this.options.elementEnd.value.length&&(e=new s.DateTime(this.options.elementEnd.value)),[t,e]}if(this.options.singleMode){if(this.options.element instanceof HTMLInputElement&&this.options.element.value.length)return [new s.DateTime(this.options.element.value)]}else if(/\s\-\s/.test(this.options.element.value)){const t=this.options.element.value.split(" - ");if(2===t.length)return [new s.DateTime(t[0]),new s.DateTime(t[1])]}return []}updateInput(){if(this.options.element instanceof HTMLInputElement)if(this.options.singleMode)this.options.startDate&&""!=this.options.startDate&&this.updateElementValue(this.options.startDate.format(this.options.format,this.options.lang)),this.options.endDate&&""!=this.options.endDate&&this.updateElementEndValue(this.options.endDate.format(this.options.format,this.options.lang));else if(!this.options.singleMode){let t,e;this.options.startDate&&(t=this.options.startDate.format(this.options.format,this.options.lang)),this.options.endDate&&(e=this.options.endDate.format(this.options.format,this.options.lang)),this.options.elementEnd?(this.updateElementValue(t||""),this.updateElementEndValue(e||"")):t&&e&&this.updateElementValue(`${t} - ${e}`);}}isSamePicker(t){return t.closest(`.${a.litepicker}`)===this.picker}shouldShow(t){return t===this.options.element||this.options.elementEnd&&t===this.options.elementEnd}shouldResetDatePicked(){return this.options.singleMode||2===this.datePicked.length}shouldSwapDatePicked(){var t,e;return 2===this.datePicked.length&&(null===(t=this.datePicked[0])||void 0===t?void 0:t.getTime())>(null===(e=this.datePicked[1])||void 0===e?void 0:e.getTime())}shouldCheckLockDays(){return this.options.disallowLockDaysInRange&&this.options.lockDays.length&&2===this.datePicked.length}shouldCheckBookedDays(){return this.options.disallowBookedDaysInRange&&this.options.bookedDays.length&&2===this.datePicked.length}onClick(t,e,i){const n=t.target;if("element"!==i&&"elementEnd"!==i||(this.currentState=i,"elementEnd"===i&&(this.traceForVisability("Entering single mode because of field 2 click"),this.options.singleMode=!0)),n&&this.picker){if(this.shouldShow(n))return this.traceForVisability(`Click on ${i}`),void(e||this.show(n));if(!n.closest(`.${a.litepicker}`))return this.traceForVisability("Click outside picker"),void this.hide();if(n.classList.contains(a.dayItem)){if(this.traceForVisability("Click on date"),this.traceForVisability(this.currentState),t.preventDefault(),!this.isSamePicker(n))return;if(n.classList.contains(a.isLocked))return;if(n.classList.contains(a.isBooked))return;if(this.shouldResetDatePicked()&&(this.datePicked.length=0),this.traceForVisability(this.datePicked.length),"elementEnd"===this.currentState&&(this.traceForVisability("currentState === elementEnd"),this.options.startDate?(this.traceForVisability("Was A start Date"),this.datePicked[0]=this.options.startDate):(this.traceForVisability("this.datePicked = [null]"),this.datePicked=[null])),this.traceForVisability(this.datePicked.length),this.datePicked[this.datePicked.length]=new s.DateTime(n.dataset.time),this.traceForVisability("shouldSwapDatePicked"),this.shouldSwapDatePicked()){this.currentState="datesSwaped";const t=this.datePicked[1].clone();this.datePicked[1]=this.datePicked[0].clone(),this.datePicked[0]=t.clone();}if(this.traceForVisability("shouldCheckLockDays"),this.shouldCheckLockDays()){const t=this.options.lockDaysInclusivity;this.options.lockDays.filter((e=>e instanceof Array?e[0].isBetween(this.datePicked[0],this.datePicked[1],t)||e[1].isBetween(this.datePicked[0],this.datePicked[1],t):e.isBetween(this.datePicked[0],this.datePicked[1],t))).length&&(this.datePicked.length=0,"function"==typeof this.options.onError&&this.options.onError.call(this,"INVALID_RANGE"));}if(this.traceForVisability("shouldCheckBookedDays"),this.shouldCheckBookedDays()){let t=this.options.bookedDaysInclusivity;this.options.hotelMode&&2===this.datePicked.length&&(t="()");const e=this.options.bookedDays.filter((e=>e instanceof Array?e[0].isBetween(this.datePicked[0],this.datePicked[1],t)||e[1].isBetween(this.datePicked[0],this.datePicked[1],t):e.isBetween(this.datePicked[0],this.datePicked[1]))).length,i=this.options.anyBookedDaysAsCheckout&&1===this.datePicked.length;e&&!i&&(this.datePicked.length=0,"function"==typeof this.options.onError&&this.options.onError.call(this,"INVALID_RANGE"));}return this.traceForVisability("Render"),this.render(),this.traceForVisability(`single mode ${this.options.singleMode}`),this.traceForVisability(`length ${this.datePicked.length}`),this.traceForVisability(`current state ${this.currentState}`),void(this.options.autoApply&&(this.options.singleMode&&1==this.datePicked.length&&"element"===this.currentState?(this.traceForVisability("singlemode datePicked.length == 1 element"),this.setStartDate(this.datePicked[0]),this.hide()):this.options.singleMode&&2==this.datePicked.length&&"elementEnd"===this.currentState?(this.traceForVisability("singlemode datePicked.length == 2 elementEnd"),this.setEndDate(this.datePicked[1]),this.hide()):this.options.singleMode&&2==this.datePicked.length&&"datesSwaped"===this.currentState?(this.traceForVisability("singlemode datePicked.length == 2 datesSwaped"),this.setDateRange(this.datePicked[0],this.datePicked[1]),this.hide()):(this.options.singleMode||1!==this.datePicked.length||(this.traceForVisability("NOT singlemode and single date"),this.setStartDate(this.datePicked[0]),this.focusRelevantDay()),this.options.singleMode||2!==this.datePicked.length||(this.traceForVisability("NOT singlemode and 2 dates "),this.setDateRange(this.datePicked[0],this.datePicked[1]),this.hide()))))}if(n.classList.contains(a.buttonPreviousMonth)){if(t.preventDefault(),!this.isSamePicker(n))return;let e=0,i=this.options.numberOfMonths;if(this.options.splitView){const t=n.closest(`.${a.monthItem}`);e=[...t.parentNode.childNodes].findIndex((e=>e===t)),i=1;}return this.calendars[e].setMonth(this.calendars[e].getMonth()-i),this.gotoDate(this.calendars[e],e),void("function"==typeof this.options.onChangeMonth&&this.options.onChangeMonth.call(this,this.calendars[e],e))}if(n.classList.contains(a.buttonNextMonth)){if(t.preventDefault(),!this.isSamePicker(n))return;let e=0,i=this.options.numberOfMonths;if(this.options.splitView){const t=n.closest(`.${a.monthItem}`);e=[...t.parentNode.childNodes].findIndex((e=>e===t)),i=1;}return this.calendars[e].setMonth(this.calendars[e].getMonth()+i),this.gotoDate(this.calendars[e],e),void("function"==typeof this.options.onChangeMonth&&this.options.onChangeMonth.call(this,this.calendars[e],e))}if(n.classList.contains(a.buttonCancel)){if(t.preventDefault(),!this.isSamePicker(n))return;this.hide();}if(n.classList.contains(a.buttonApply)){if(t.preventDefault(),!this.isSamePicker(n))return;this.options.singleMode&&this.datePicked.length?this.setDate(this.datePicked[0]):this.options.singleMode||2!==this.datePicked.length||this.setDateRange(this.datePicked[0],this.datePicked[1]),this.hide();}}}showTooltip(t,e){const i=this.picker.querySelector(`.${a.containerTooltip}`);i.style.visibility="visible",i.innerHTML=e;const n=this.picker.getBoundingClientRect(),o=i.getBoundingClientRect(),s=t.getBoundingClientRect();let r=s.top,l=s.left;if(this.options.inlineMode&&this.options.parentEl){const t=this.picker.parentNode.getBoundingClientRect();r-=t.top,l-=t.left;}else r-=n.top,l-=n.left;r-=o.height,l-=o.width/2,l+=s.width/2,i.style.top=`${r}px`,i.style.left=`${l}px`;}hideTooltip(){this.picker.querySelector(`.${a.containerTooltip}`).style.visibility="hidden";}shouldAllowMouseEnter(t){return !this.options.singleMode&&t.classList.contains(a.dayItem)&&!t.classList.contains(a.isLocked)&&!t.classList.contains(a.isBooked)}shouldAllowRepick(){return this.options.elementEnd&&this.options.allowRepick&&this.options.startDate&&this.options.endDate}onMouseEnter(t){const e=t.target;this.highlightDateRange(e);}highlightDateRange(t){if(this.shouldAllowMouseEnter(t)){if(this.shouldAllowRepick()&&(this.triggerElement===this.options.element?this.datePicked[0]=this.options.endDate.clone():this.datePicked[0]=this.options.startDate.clone()),1!==this.datePicked.length)return;const e=this.picker.querySelector(`.${a.dayItem}[data-time="${this.datePicked[0].getTime()}"]`);let i=this.datePicked[0].clone(),n=new s.DateTime(t.dataset.time),o=!1;if(i.getTime()>n.getTime()){const t=i.clone();i=n.clone(),n=t.clone(),o=!0;}if([...this.picker.querySelectorAll(`.${a.dayItem}`)].forEach((t=>{const e=new s.DateTime(t.dataset.time),o=this.renderDay(e);e.isBetween(i,n)&&o.classList.add(a.isInRange),t.className=o.className;})),t.classList.add(a.isEndDate),o?(e&&e.classList.add(a.isFlipped),t.classList.add(a.isFlipped)):(e&&e.classList.remove(a.isFlipped),t.classList.remove(a.isFlipped)),this.options.showTooltip){const e=new Intl.PluralRules(this.options.lang);let o=n.diff(i,"day");if(this.options.hotelMode||(o+=1),o>0){const i=e.select(o),n=`${o} ${this.options.tooltipText[i]?this.options.tooltipText[i]:`[${i}]`}`;this.showTooltip(t,n);}else this.hideTooltip();}}}onMouseLeave(t){this.options.allowRepick&&(this.datePicked.length=0,this.render());}onInput(t){this.traceForVisability("on input");const[e,i]=this.parseInput();if(e instanceof s.DateTime&&!isNaN(e.getTime())?this.options.startDate=new s.DateTime(e,this.options.format,this.options.lang):this.options.startDate="",i instanceof s.DateTime&&!isNaN(i.getTime())?this.options.endDate=new s.DateTime(i,this.options.format,this.options.lang):this.options.endDate="",this.options.startDate&&this.options.endDate&&this.options.startDate.getTime()>this.options.endDate.getTime()){const t=this.options.startDate.clone();this.options.startDate=this.options.endDate.clone(),this.options.endDate=t.clone();}this.updateInput(),this.render();}updateElementValue(t){this.options.element instanceof HTMLInputElement&&t!==this.options.element.value&&(this.options.element.value=t,"function"==typeof this.options.onStartDateChange&&this.options.onStartDateChange.call(this,t));}updateElementEndValue(t){this.options.elementEnd instanceof HTMLInputElement&&t!==this.options.elementEnd.value&&(this.options.elementEnd.value=t,"function"==typeof this.options.onEndDateChange&&this.options.onEndDateChange.call(this,t));}}e.Litepicker=r;},997:function(t,e,i){Object.defineProperty(e,"__esModule",{value:!0});const n=i(939),o=i(630),s=i(506),a=i(338),r=i(703),l=i(593);s.Litepicker.prototype.show=function(t=null){if(this.options.inlineMode)return this.picker.style.position="static",this.picker.style.display="inline-block",this.picker.style.top=null,this.picker.style.left=null,this.picker.style.bottom=null,void(this.picker.style.right=null);const e=t||this.options.element;if(this.triggerElement=e,e!==this.options.element&&e!==this.options.elementEnd||(this.currentState=e===this.options.element?"element":"elementEnd",e===this.options.elementEnd&&(this.traceForVisability("Entering single mode because of field 2 click"),this.options.singleMode=!0)),this.options.scrollToDate)if(!this.options.startDate||t&&t!==this.options.element){if(t&&this.options.endDate&&t===this.options.elementEnd){const t=this.options.endDate.clone();t.setDate(1),this.options.numberOfMonths>1&&t.setMonth(t.getMonth()-(this.options.numberOfMonths-1)),this.calendars[0]=t.clone();}}else {const t=this.options.startDate.clone();t.setDate(1),this.calendars[0]=t.clone();}if(this.options.mobileFriendly&&(0, l.isMobile)()){this.picker.style.position="fixed",this.picker.style.display="block","portrait"===(0, l.getOrientation)()?(this.options.numberOfMonths=1,this.options.numberOfColumns=1):(this.options.numberOfMonths=2,this.options.numberOfColumns=2),this.render();const e=this.picker.getBoundingClientRect();return this.picker.style.top=`calc(50% - ${e.height/2}px)`,this.picker.style.left=`calc(50% - ${e.width/2}px)`,this.picker.style.right=null,this.picker.style.bottom=null,this.picker.style.zIndex=this.options.zIndex,this.backdrop.style.display="block",this.backdrop.style.zIndex=this.options.zIndex-1,document.body.classList.add(r.litepickerOpen),this.focusRelevantDay(),"function"==typeof this.options.onShow&&this.options.onShow.call(this),void(t?t.blur():this.options.element.blur())}this.render(),this.picker.style.position="absolute",this.picker.style.display="block",this.picker.style.zIndex=this.options.zIndex;const i=e.getBoundingClientRect(),n=this.picker.getBoundingClientRect();let o=i.bottom,s=i.left,a=0,c=0,h=0,d=0;if(this.options.parentEl){const t=this.picker.parentNode.getBoundingClientRect();o-=t.bottom,o+=i.height,o+n.height>window.innerHeight&&i.top-t.top-i.height>0&&(h=i.top-t.top-i.height),s-=t.left,s+n.width>window.innerWidth&&i.right-t.right-n.width>0&&(d=i.right-t.right-n.width);}else a=window.scrollX,c=window.scrollY,o+n.height>window.innerHeight&&i.top-n.height>0&&(h=i.top-n.height),s+n.width>window.innerWidth&&i.right-n.width>0&&(d=i.right-n.width);this.picker.style.top=`${(h||o)+c+this.options.verticalOffset}px`,this.picker.style.left=`${(d||s)+a+this.options.horizontalOffset}px`,this.picker.style.right=null,this.picker.style.bottom=null,this.focusRelevantDay(),"function"==typeof this.options.onShow&&this.options.onShow.call(this);},s.Litepicker.prototype.hide=function(){this.isShowing()&&(!this.options.singleMode&&2===this.datePicked.length&&this.options.elementEnd?this.options.elementEnd.focus():this.triggerElement&&this.triggerElement.focus(),this.datePicked.length=0,this.onInput(),this.options.inlineMode?this.render():(this.picker.style.display="none","function"==typeof this.options.onHide&&this.options.onHide.call(this),this.options.mobileFriendly&&(document.body.classList.remove(r.litepickerOpen),this.backdrop.style.display="none")));},s.Litepicker.prototype.isShowing=function(){return this.picker&&"none"!==this.picker.style.display},s.Litepicker.prototype.getDate=function(){return this.getStartDate()},s.Litepicker.prototype.getStartDate=function(){return this.options.startDate?this.options.startDate.clone():null},s.Litepicker.prototype.getEndDate=function(){return this.options.endDate?this.options.endDate.clone():null},s.Litepicker.prototype.setDate=function(t){this.setStartDate(t),"function"==typeof this.options.onSelect&&this.options.onSelect.call(this,this.getDate());},s.Litepicker.prototype.setStartDate=function(t){t&&(this.options.startDate=new n.DateTime(t,this.options.format,this.options.lang),this.updateInput());},s.Litepicker.prototype.setEndDate=function(t){t&&(this.options.endDate=new n.DateTime(t,this.options.format,this.options.lang),this.options.startDate&&this.options.startDate.getTime()>this.options.endDate.getTime()&&(this.options.endDate=this.options.startDate.clone(),this.options.startDate=new n.DateTime(t,this.options.format,this.options.lang)),this.updateInput());},s.Litepicker.prototype.setDateRange=function(t,e){this.setStartDate(t),this.setEndDate(e),this.updateInput(),"function"==typeof this.options.onSelect&&this.options.onSelect.call(this,this.getStartDate(),this.getEndDate());},s.Litepicker.prototype.gotoDate=function(t,e=0){const i=new n.DateTime(t);i.setDate(1),this.calendars[e]=i.clone(),this.render();},s.Litepicker.prototype.setLockDays=function(t){this.options.lockDays=n.DateTime.convertArray(t,this.options.lockDaysFormat),this.render();},s.Litepicker.prototype.setBookedDays=function(t){this.options.bookedDays=n.DateTime.convertArray(t,this.options.bookedDaysFormat),this.render();},s.Litepicker.prototype.setOptions=function(t){delete t.element,delete t.elementEnd,delete t.parentEl,t.startDate&&(t.startDate=new n.DateTime(t.startDate,this.options.format,this.options.lang)),t.endDate&&(t.endDate=new n.DateTime(t.endDate,this.options.format,this.options.lang)),this.options=Object.assign(Object.assign({},this.options),t),!this.options.singleMode||this.options.startDate instanceof n.DateTime||(this.options.startDate=null,this.options.endDate=null),this.options.singleMode||this.options.startDate instanceof n.DateTime&&this.options.endDate instanceof n.DateTime||(this.options.startDate=null,this.options.endDate=null);for(let t=0;t<this.options.numberOfMonths;t+=1){const e=this.options.startDate?this.options.startDate.clone():new n.DateTime;e.setDate(1),e.setMonth(e.getMonth()+t),this.calendars[t]=e;}this.options.lockDays.length&&(this.options.lockDays=n.DateTime.convertArray(this.options.lockDays,this.options.lockDaysFormat)),this.options.bookedDays.length&&(this.options.bookedDays=n.DateTime.convertArray(this.options.bookedDays,this.options.bookedDaysFormat)),this.render(),this.options.inlineMode&&this.show(),this.updateInput();},s.Litepicker.prototype.clearSelection=function(){this.options.startDate=null,this.options.endDate=null,this.datePicked.length=0,this.updateInput(),this.isShowing()&&this.render();},s.Litepicker.prototype.destroy=function(){this.picker&&this.picker.parentNode&&(this.picker.parentNode.removeChild(this.picker),this.picker=null),this.backdrop&&this.backdrop.parentNode&&this.backdrop.parentNode.removeChild(this.backdrop);},s.Litepicker.prototype.initializeKeypressHandling=function(t,e){if(!t||!this.picker)throw new Error("Litepicker must be initialized before handling keyboard input");t.onkeydown=i=>{const n=i.target;switch(i.code){case o.KeyCodes.ARROW_UP:case o.KeyCodes.ARROW_DOWN:const s=(0, a.handleArrowUpDown)(n,i,t,this.options.numberOfMonths);s&&this.highlightDateRange(s);break;case o.KeyCodes.ARROW_LEFT:case o.KeyCodes.ARROW_RIGHT:const r=(0, a.handleArrowLeftRight)(n,i,t);r&&this.highlightDateRange(r);break;case o.KeyCodes.ENTER:case o.KeyCodes.SPACEBAR:(0, a.handleSelection)(n,i,t);break;case o.KeyCodes.ESCAPE:this.picker.hide(),e&&setTimeout((()=>e.focus()),0);}};},s.Litepicker.prototype.focusRelevantDay=function(){let t;this.triggerElement===this.options.element?t=this.getStartDate():this.triggerElement===this.options.elementEnd&&(t=this.getEndDate());let e=null;if(t){const i=t.toJSDate().getTime();e=this.picker.querySelector(`${a.dayButtonTabSelector}[data-time="${i}"]`);}e||(e=this.picker.querySelector(`.is-today${a.dayButtonTabSelector}`)),e||(e=this.picker.querySelector(a.dayButtonTabSelector)),e&&e.focus();};},593:function(t,e){function i(){return window.matchMedia("(orientation: portrait)").matches?"portrait":"landscape"}Object.defineProperty(e,"__esModule",{value:!0}),e.getOrientation=e.isMobile=void 0,e.isMobile=function(){const t="portrait"===i();return window.matchMedia(`(max-device-${t?"width":"height"}: 480px)`).matches},e.getOrientation=i;}},e={};function i(n){var o=e[n];if(void 0!==o)return o.exports;var s=e[n]={id:n,exports:{}};return t[n](s,s.exports,i),s.exports}i.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return i.d(e,{a:e}),e},i.d=function(t,e){for(var n in e)i.o(e,n)&&!i.o(t,n)&&Object.defineProperty(t,n,{enumerable:!0,get:e[n]});},i.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},i.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0});};var n={};return function(){var t=n;t.Litepicker=void 0;const e=i(506);Object.defineProperty(t,"Litepicker",{enumerable:!0,get:function(){return e.Litepicker}}),i(997),e.Litepicker;}(),n.Litepicker}()}));
});

const Litepicker = /*@__PURE__*/getDefaultExportFromCjs(main);

const dateInputComponentCss = ".a11y-hidden{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}.bhtp-ui-form-group__input{display:flex;align-items:center}@media (max-width: 599px){.bhtp-ui-form-group__input{flex-direction:column;align-items:stretch}.bhtp-ui-form-group__input.bhtp-ui-form-group__input--inline{flex-direction:row;align-items:center}.bhtp-ui-form-group__input .bhtp-ui-input{padding:0}.bhtp-ui-form-group__input .bhtp-ui-input-prompt{font-size:var(--bhtp-ui-reduced-font-size)}}.bhtp-ui-form-group__inline{display:flex;align-items:center}.bhtp-ui-input-prompt{color:var(--bhtp-ui-text-primary-color);margin-right:1rem;font-weight:bold}.bhtp-ui-input-prompt--post{margin:0 0 0 1rem}.bhtp-ui-input-prompt--center{margin:0 1rem}.bhtp-ui-input-prompt,.bhtp-ui-input{font-size:var(--bhtp-ui-standard-font-size)}.bhtp-ui-input-prompt-tooltip{margin-left:-1rem}.bhtp-ui-input{border:none;border-radius:0;border-bottom:1px solid var(--bhtp-ui-text-secondary-color);font-family:var(--bhtp-ui-primary-font-family);color:var(--bhtp-ui-text-input-color);background-color:transparent;padding:0 0.75rem 0.5rem;outline:none;box-sizing:border-box}.bhtp-ui-input::-moz-placeholder{color:var(--bhtp-ui-text-secondary-color);text-transform:lowercase;overflow:visible}.bhtp-ui-input:-ms-input-placeholder{color:var(--bhtp-ui-text-secondary-color);text-transform:lowercase;overflow:visible}.bhtp-ui-input::placeholder{color:var(--bhtp-ui-text-secondary-color);text-transform:lowercase;overflow:visible}@media (max-width: 599px){.bhtp-ui-input::-moz-placeholder{font-size:1rem}.bhtp-ui-input:-ms-input-placeholder{font-size:1rem}.bhtp-ui-input::placeholder{font-size:1rem}}.bhtp-ui-input.bhtp-ui-input--invalid{color:var(--bhtp-ui-danger-color)}.bhtp-ui-input.bhtp-ui-input--clear-right{padding-right:0}.bhtp-ui-icon-input{display:flex;align-items:stretch;border-bottom:1px solid var(--bhtp-ui-text-secondary-color);position:relative}.bhtp-ui-icon-input .bhtp-ui-input{border-bottom:none}.bhtp-ui-icon-input>bhtp-ui-icon{display:flex;align-items:center}.bhtp-ui-icon-input>bhtp-ui-icon i{color:var(--bhtp-ui-text-secondary-color)}@media (max-width: 599px){.bhtp-ui-icon-input>bhtp-ui-icon{margin-right:0.5rem}}button>bhtp-ui-icon{outline:none}.bhtp-ui-form-label-tooltip{display:flex;align-items:center}@media (max-width: 599px){.bhtp-ui-hide-only-mobile{display:none}.bhtp-ui-form-group.bhtp-ui-show-only-mobile{display:flex}}@media (min-width: 599px){.bhtp-ui-hide-only-mobile{display:flex}.bhtp-ui-form-group.bhtp-ui-show-only-mobile{display:none}}:host{display:block;font-family:var(--bhtp-ui-primary-font-family)}.bhtp-ui-icon-input:focus-within{border-bottom:1px solid var(--bhtp-ui-primary-color)}.bhtp-ui-date-icon-non-interactive{color:var(--bhtp-ui-text-primary-color)}.bhtp-ui-date-icon-non-interactive{padding-left:5px;padding-right:5px}";

let DateInput = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.dateChanged = createEvent(this, "dateChanged", 7);
    this.enablePicker = false;
    this.iconName = 'calendar';
    this.dateButtonAria = 'Choose date';
  }
  async focusInput() {
    this.inputRef.scrollIntoView({ block: "center" });
    setTimeout(() => {
      this.inputRef.focus();
    }, 100);
  }
  componentWillRender() {
    this.dateMask && this.dateMask.removeListeners();
  }
  componentDidRender() {
    if (this.enablePicker === true) {
      this.initializeDatepicker();
    }
  }
  componentDidLoad() {
    if (this.description) {
      this.dateButtonAria = `Choose ${this.description}`;
    }
  }
  disconnectedCallback() {
    var _a;
    if (this.enablePicker === true) {
      (_a = this.litepickerInstance) === null || _a === void 0 ? void 0 : _a.destroy();
    }
  }
  render() {
    return (h("div", { class: "bhtp-ui-form-group__input" }, h("div", { class: "bhtp-ui-form-label-tooltip" }, h("span", { class: "bhtp-ui-input-prompt" }, this.prompt), h("slot", { name: "prompt-tooltip" })), h("div", { class: "bhtp-ui-form-group__inline" }, h("div", { class: "bhtp-ui-icon-input" }, h("label", { class: "a11y-hidden", htmlFor: this.inputId }, this.description), this.enablePicker ?
      h("bhtp-ui-button", { styleType: "icon", buttonType: "button", ariaLabel: this.dateButtonAria, onKeyDown: (e) => this.handleCalendarKeyDown(e, e.keyCode), onClick: () => this.handleCalendarButtonClick() }, this.getIcon()) :
      h("span", { class: "bhtp-ui-date-icon-non-interactive" }, this.getIcon()), h("input", { ref: (element) => {
        this.inputRef = element;
        this.dateMask = DateInputMask.mask(element);
      }, id: this.inputId, class: `bhtp-ui-input${this.isValid === false && this.value ? ' bhtp-ui-input--invalid' : ''}`, type: "text", inputMode: "numeric", size: 11, maxLength: 10, value: this.value, placeholder: DISPLAY_DATE, "aria-required": (this.required === true).toString(), "aria-invalid": (this.isValid === false).toString(), onBlur: (event) => this.handleOnBlur(event), onChange: (event) => this.handleOnDateChange(event.target.value) })))));
  }
  getIcon() {
    return this.iconName === 'calendar' ?
      h("bhtp-ui-icon-calendar", { slot: "button-icon" }) :
      h("bhtp-ui-icon-birthday-cake", { slot: "button-icon" });
  }
  handleCalendarKeyDown(event, keyCode) {
    if (keyCode == KeyCodes.ENTER) {
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }
      this.handleCalendarButtonClick();
    }
  }
  handleCalendarButtonClick() {
    var _a, _b, _c;
    if ((_a = this.litepickerInstance) === null || _a === void 0 ? void 0 : _a.isShowing()) {
      (_b = this.litepickerInstance) === null || _b === void 0 ? void 0 : _b.hide();
    }
    else if (this.enablePicker) {
      (_c = this.litepickerInstance) === null || _c === void 0 ? void 0 : _c.show();
    }
  }
  handleOnBlur(event) {
    if (this.enablePicker === true && !isInternetExplorer11()) {
      const newFocusedElementInsideComponentOrLitepicker = (event.composedPath && event.composedPath()[0] && this.litepickerInstance.picker.contains(event.composedPath()[0]));
      if (!newFocusedElementInsideComponentOrLitepicker) {
        this.litepickerInstance.hide();
      }
    }
  }
  handleOnDateChange(date) {
    this.dateChanged.emit(date);
    if (date) {
      this.dateButtonAria = `Choose ${this.description ? this.description : 'date'}, ${date} selected`;
    }
    else {
      this.dateButtonAria = `Choose ${this.description ? this.description : 'date'}`;
    }
  }
  initializeDatepicker() {
    var _a;
    if (!isInternetExplorer11() && !this.litepickerInstance) {
      // @ts-ignore
      this.litepickerInstance = new Litepicker({
        element: (_a = this.hostElement.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(`#${this.inputId}`),
        numberOfMonths: 1,
        singleMode: true,
        firstDay: 0,
        format: LITEPICKER_DATE,
        minDate: this.minDate,
        maxDate: this.maxDate,
        numberOfColumns: 1,
        verticalOffset: 5,
        horizontalOffset: -15,
        onStartDateChange: (date) => {
          this.handleOnDateChange(date);
        }
      });
      if (this.value && luxon.DateTime.fromFormat(this.value, DISPLAY_DATE).isValid) {
        this.litepickerInstance.setDate(this.value);
      }
    }
  }
  get hostElement() { return getElement(this); }
};
DateInput.style = dateInputComponentCss;

const dateRangeInputComponentCss = ".a11y-hidden{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}.bhtp-ui-form-group__input{display:flex;align-items:center}@media (max-width: 599px){.bhtp-ui-form-group__input{flex-direction:column;align-items:stretch}.bhtp-ui-form-group__input.bhtp-ui-form-group__input--inline{flex-direction:row;align-items:center}.bhtp-ui-form-group__input .bhtp-ui-input{padding:0}.bhtp-ui-form-group__input .bhtp-ui-input-prompt{font-size:var(--bhtp-ui-reduced-font-size)}}.bhtp-ui-form-group__inline{display:flex;align-items:center}.bhtp-ui-input-prompt{color:var(--bhtp-ui-text-primary-color);margin-right:1rem;font-weight:bold}.bhtp-ui-input-prompt--post{margin:0 0 0 1rem}.bhtp-ui-input-prompt--center{margin:0 1rem}.bhtp-ui-input-prompt,.bhtp-ui-input{font-size:var(--bhtp-ui-standard-font-size)}.bhtp-ui-input-prompt-tooltip{margin-left:-1rem}.bhtp-ui-input{border:none;border-radius:0;border-bottom:1px solid var(--bhtp-ui-text-secondary-color);font-family:var(--bhtp-ui-primary-font-family);color:var(--bhtp-ui-text-input-color);background-color:transparent;padding:0 0.75rem 0.5rem;outline:none;box-sizing:border-box}.bhtp-ui-input::-moz-placeholder{color:var(--bhtp-ui-text-secondary-color);text-transform:lowercase;overflow:visible}.bhtp-ui-input:-ms-input-placeholder{color:var(--bhtp-ui-text-secondary-color);text-transform:lowercase;overflow:visible}.bhtp-ui-input::placeholder{color:var(--bhtp-ui-text-secondary-color);text-transform:lowercase;overflow:visible}@media (max-width: 599px){.bhtp-ui-input::-moz-placeholder{font-size:1rem}.bhtp-ui-input:-ms-input-placeholder{font-size:1rem}.bhtp-ui-input::placeholder{font-size:1rem}}.bhtp-ui-input.bhtp-ui-input--invalid{color:var(--bhtp-ui-danger-color)}.bhtp-ui-input.bhtp-ui-input--clear-right{padding-right:0}.bhtp-ui-icon-input{display:flex;align-items:stretch;border-bottom:1px solid var(--bhtp-ui-text-secondary-color);position:relative}.bhtp-ui-icon-input .bhtp-ui-input{border-bottom:none}.bhtp-ui-icon-input>bhtp-ui-icon{display:flex;align-items:center}.bhtp-ui-icon-input>bhtp-ui-icon i{color:var(--bhtp-ui-text-secondary-color)}@media (max-width: 599px){.bhtp-ui-icon-input>bhtp-ui-icon{margin-right:0.5rem}}button>bhtp-ui-icon{outline:none}.bhtp-ui-form-label-tooltip{display:flex;align-items:center}@media (max-width: 599px){.bhtp-ui-hide-only-mobile{display:none}.bhtp-ui-form-group.bhtp-ui-show-only-mobile{display:flex}}@media (min-width: 599px){.bhtp-ui-hide-only-mobile{display:flex}.bhtp-ui-form-group.bhtp-ui-show-only-mobile{display:none}}:host{display:block;font-family:var(--bhtp-ui-primary-font-family)}:host .calendar-button{border:none;background-color:transparent;outline:none}.bhtp-ui-icon-input:focus-within{border-bottom:1px solid var(--bhtp-ui-primary-color)}@media (max-width: 400px){.bhtp-ui-icon-input{width:130px}}";

let DateRangeInput = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.startDateChanged = createEvent(this, "startDateChanged", 7);
    this.endDateChanged = createEvent(this, "endDateChanged", 7);
    this.startDateButtonAria = 'Choose date range';
    this.endDateButtonAria = 'Choose end date';
  }
  async focusInput() {
    this.startDateInput.scrollIntoView({ block: "center" });
    setTimeout(() => {
      this.startDateInput.focus();
    }, 100);
  }
  componentWillRender() {
    this.startDateMask && this.startDateMask.removeListeners();
    this.endDateMask && this.endDateMask.removeListeners();
  }
  componentDidRender() {
    this.initializeDatepicker();
  }
  disconnectedCallback() {
    var _a;
    (_a = this.litepickerInstance) === null || _a === void 0 ? void 0 : _a.destroy();
  }
  componentDidLoad() {
    if (this.startDateDescription) {
      this.startDateButtonAria = `Choose ${this.startDateDescription}`;
    }
    if (this.endDateDescription) {
      this.endDateButtonAria = `Choose ${this.endDateDescription}`;
    }
  }
  render() {
    return (h("div", { class: "bhtp-ui-form-group__input" }, h("div", { class: "bhtp-ui-form-label-tooltip" }, h("span", { class: "bhtp-ui-input-prompt" }, this.prompt), h("slot", { name: "prompt-tooltip" })), h("div", { class: "bhtp-ui-form-group__inline" }, h("div", { class: "bhtp-ui-icon-input" }, h("label", { class: "a11y-hidden", htmlFor: this.startDateInputId }, this.startDateDescription), h("bhtp-ui-button", { styleType: "icon", buttonType: "button", ariaLabel: this.startDateButtonAria, onKeyDown: (event) => this.handleCalendarKeyDown(this.startDateInput, event, event.keyCode), onClick: () => this.handleCalendarButtonClick(this.startDateInput) }, h("bhtp-ui-icon-calendar", { slot: "button-icon" })), h("input", { ref: (element) => {
        this.startDateInput = element;
        this.startDateMask = DateInputMask.mask(this.startDateInput);
      }, id: this.startDateInputId, class: `bhtp-ui-input${this.startDateIsValid === false && this.startDateValue ? ' bhtp-ui-input--invalid' : ''}`, type: "text", size: 11, maxLength: 10, placeholder: DISPLAY_DATE, value: this.startDateValue, inputmode: "numeric", "aria-required": (this.required === true).toString(), "aria-invalid": (this.startDateIsValid === false).toString(), onBlur: (event) => this.handleOnBlur(event), onChange: (event) => this.handleOnStartDateChange(event.target.value) })), h("span", { class: "bhtp-ui-input-prompt bhtp-ui-input-prompt--center" }, "to"), h("div", { class: "bhtp-ui-icon-input" }, h("label", { class: "a11y-hidden", htmlFor: this.endDateInputId }, this.endDateDescription), h("bhtp-ui-button", { styleType: "icon", buttonType: "button", ariaLabel: this.endDateButtonAria, onKeyDown: (event) => this.handleCalendarKeyDown(this.endDateInput, event, event.keyCode), onClick: () => this.handleCalendarButtonClick(this.endDateInput) }, h("bhtp-ui-icon-calendar", { slot: "button-icon" })), h("input", { ref: (element) => {
        this.endDateInput = element;
        this.endDateMask = DateInputMask.mask(this.endDateInput);
      }, id: this.endDateInputId, class: `bhtp-ui-input${this.endDateIsValid === false && this.endDateValue ? ' bhtp-ui-input--invalid' : ''}`, type: "text", size: 11, maxLength: 10, placeholder: DISPLAY_DATE, value: this.endDateValue, inputMode: "numeric", "aria-required": (this.required === true).toString(), "aria-invalid": (this.endDateIsValid === false).toString(), onBlur: (event) => this.handleOnBlur(event), onChange: (event) => this.handleOnEndDateChange(event.target.value) })))));
  }
  handleCalendarKeyDown(element, event, keyCode) {
    if (keyCode == KeyCodes.ENTER) {
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }
      this.handleCalendarButtonClick(element);
    }
  }
  handleCalendarButtonClick(element) {
    var _a, _b, _c;
    if ((_a = this.litepickerInstance) === null || _a === void 0 ? void 0 : _a.isShowing()) {
      (_b = this.litepickerInstance) === null || _b === void 0 ? void 0 : _b.hide();
    }
    else {
      (_c = this.litepickerInstance) === null || _c === void 0 ? void 0 : _c.show(element);
    }
  }
  handleOnBlur(event) {
    if (!isInternetExplorer11()) {
      const newFocusedElementInsideLitepicker = (event.composedPath && event.composedPath()[0] && this.litepickerInstance.picker.contains(event.composedPath()[0]));
      if (!newFocusedElementInsideLitepicker) {
        this.litepickerInstance.hide();
      }
    }
  }
  handleOnStartDateChange(startDate) {
    this.startDateChanged.emit(startDate);
    const startDateLabel = `Choose ${this.startDateDescription ? this.startDateDescription : 'start date'}`;
    if (startDate) {
      this.startDateButtonAria = `${startDateLabel}, ${startDate} selected`;
    }
    else {
      this.startDateButtonAria = startDateLabel;
    }
  }
  handleOnEndDateChange(endDate) {
    this.endDateChanged.emit(endDate);
    const endDateLabel = `Choose ${this.endDateDescription ? this.endDateDescription : 'end date'}`;
    if (endDate) {
      this.endDateButtonAria = `${endDateLabel}, ${endDate} selected`;
    }
    else {
      this.endDateButtonAria = endDateLabel;
    }
  }
  initializeDatepicker() {
    if (!isInternetExplorer11() && !this.litepickerInstance) {
      // @ts-ignore
      this.litepickerInstance = new Litepicker({
        element: this.startDateInput,
        elementEnd: this.endDateInput,
        numberOfMonths: 2,
        singleMode: false,
        firstDay: 0,
        format: LITEPICKER_DATE,
        minDate: this.minDate,
        maxDays: this.maxDays,
        numberOfColumns: 2,
        verticalOffset: 5,
        horizontalOffset: -15,
        autoApply: true,
        autoRefresh: true,
        onStartDateChange: (startDate) => {
          this.handleOnStartDateChange(startDate);
        },
        onEndDateChange: (endDate) => {
          this.handleOnEndDateChange(endDate);
        }
      });
      if (this.startDateValue && luxon.DateTime.fromFormat(this.startDateValue, DISPLAY_DATE).isValid) {
        this.litepickerInstance.setStartDate(this.startDateValue);
      }
      if (this.endDateValue && luxon.DateTime.fromFormat(this.endDateValue, DISPLAY_DATE).isValid) {
        this.litepickerInstance.setEndDate(this.endDateValue);
      }
    }
  }
  get hostElement() { return getElement(this); }
};
DateRangeInput.style = dateRangeInputComponentCss;

const destinationInputComponentCss = ".a11y-hidden{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}.bhtp-ui-form-group__input{display:flex;align-items:center}@media (max-width: 599px){.bhtp-ui-form-group__input{flex-direction:column;align-items:stretch}.bhtp-ui-form-group__input.bhtp-ui-form-group__input--inline{flex-direction:row;align-items:center}.bhtp-ui-form-group__input .bhtp-ui-input{padding:0}.bhtp-ui-form-group__input .bhtp-ui-input-prompt{font-size:var(--bhtp-ui-reduced-font-size)}}.bhtp-ui-form-group__inline{display:flex;align-items:center}.bhtp-ui-input-prompt{color:var(--bhtp-ui-text-primary-color);margin-right:1rem;font-weight:bold}.bhtp-ui-input-prompt--post{margin:0 0 0 1rem}.bhtp-ui-input-prompt--center{margin:0 1rem}.bhtp-ui-input-prompt,.bhtp-ui-input{font-size:var(--bhtp-ui-standard-font-size)}.bhtp-ui-input-prompt-tooltip{margin-left:-1rem}.bhtp-ui-input{border:none;border-radius:0;border-bottom:1px solid var(--bhtp-ui-text-secondary-color);font-family:var(--bhtp-ui-primary-font-family);color:var(--bhtp-ui-text-input-color);background-color:transparent;padding:0 0.75rem 0.5rem;outline:none;box-sizing:border-box}.bhtp-ui-input::-moz-placeholder{color:var(--bhtp-ui-text-secondary-color);text-transform:lowercase;overflow:visible}.bhtp-ui-input:-ms-input-placeholder{color:var(--bhtp-ui-text-secondary-color);text-transform:lowercase;overflow:visible}.bhtp-ui-input::placeholder{color:var(--bhtp-ui-text-secondary-color);text-transform:lowercase;overflow:visible}@media (max-width: 599px){.bhtp-ui-input::-moz-placeholder{font-size:1rem}.bhtp-ui-input:-ms-input-placeholder{font-size:1rem}.bhtp-ui-input::placeholder{font-size:1rem}}.bhtp-ui-input.bhtp-ui-input--invalid{color:var(--bhtp-ui-danger-color)}.bhtp-ui-input.bhtp-ui-input--clear-right{padding-right:0}.bhtp-ui-icon-input{display:flex;align-items:stretch;border-bottom:1px solid var(--bhtp-ui-text-secondary-color);position:relative}.bhtp-ui-icon-input .bhtp-ui-input{border-bottom:none}.bhtp-ui-icon-input>bhtp-ui-icon{display:flex;align-items:center}.bhtp-ui-icon-input>bhtp-ui-icon i{color:var(--bhtp-ui-text-secondary-color)}@media (max-width: 599px){.bhtp-ui-icon-input>bhtp-ui-icon{margin-right:0.5rem}}button>bhtp-ui-icon{outline:none}.bhtp-ui-form-label-tooltip{display:flex;align-items:center}@media (max-width: 599px){.bhtp-ui-hide-only-mobile{display:none}.bhtp-ui-form-group.bhtp-ui-show-only-mobile{display:flex}}@media (min-width: 599px){.bhtp-ui-hide-only-mobile{display:flex}.bhtp-ui-form-group.bhtp-ui-show-only-mobile{display:none}}.bhtp-ui-multi-select-dropdown-input{position:relative}.bhtp-ui-multi-select-dropdown-input .bhtp-ui-multi-select-dropdown-menu{display:flex;flex-direction:column;align-items:flex-start;padding:0;margin:0;list-style:none;position:absolute;left:0;right:0;z-index:100;background-color:var(--bhtp-ui-white-color);border:1px solid var(--bhtp-ui-text-secondary-color);border-top:none;border-radius:0 0 5px 5px}.bhtp-ui-multi-select-dropdown-input .bhtp-ui-multi-select-dropdown-menu--allow-hover .bhtp-ui-multi-select-dropdown-item:hover{background-color:rgba(54, 79, 120, 0.2)}.bhtp-ui-multi-select-dropdown-input .bhtp-ui-multi-select-dropdown-item{border:none;width:100%}.bhtp-ui-multi-select-dropdown-input .bhtp-ui-multi-select-dropdown-item button{text-align:left;outline:none;border:none;color:var(--bhtp-ui-text-primary-color);font-family:var(--bhtp-ui-primary-font-family);font-size:var(--bhtp-ui-standard-font-size);width:100%;padding:0.25rem 0.5rem;background-color:transparent}.bhtp-ui-multi-select-dropdown-input .bhtp-ui-multi-select-dropdown-item.bhtp-ui-multi-select-dropdown-item--active{background-color:rgba(54, 79, 120, 0.2)}:host{display:block;font-family:var(--bhtp-ui-primary-font-family)}bhtp-ui-typeahead{flex-grow:1}";

let DestinationInput = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.countrySelected = createEvent(this, "countrySelected", 7);
    this.countryUnselected = createEvent(this, "countryUnselected", 7);
    this.prompt = `I'll be traveling to`;
    this.placeholder = `destination country`;
  }
  async focusInput() {
    this.typeaheadRef.focusInput();
  }
  render() {
    var _a;
    return (h("div", { class: "bhtp-ui-form-group__input" }, h("div", { class: "bhtp-ui-form-label-tooltip" }, h("span", { class: "bhtp-ui-input-prompt" }, this.prompt), h("label", { class: "a11y-hidden", htmlFor: "bhtp-ui-destination-input" }, "Enter your Destination Country"), h("slot", { name: "prompt-tooltip" })), h("bhtp-ui-typeahead", { inputId: "bhtp-ui-destination-input", required: true, invalid: (this.isValid === false), text: (_a = this.value) === null || _a === void 0 ? void 0 : _a.name, value: this.value, placeholder: this.placeholder, cssClasses: {
        'input': `bhtp-ui-input${this.isValid === false && this.value ? ' bhtp-ui-input--invalid' : ''}`,
        'wrapper': 'bhtp-ui-multi-select-dropdown-input',
        'suggestions': 'bhtp-ui-multi-select-dropdown-menu',
        'suggestion': 'bhtp-ui-multi-select-dropdown-item',
        'active': 'bhtp-ui-multi-select-dropdown-item--active'
      }, ref: (element) => this.typeaheadRef = element, onSelected: (event) => this.handleCountrySelected(event), onUnselected: () => this.handleCountryUnselected(), suggestionGenerator: (text) => this.suggestionGenerator(text) })));
  }
  handleCountrySelected(event) {
    var _a;
    if ((_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.value) {
      this.value = event.detail.value;
      this.countrySelected.emit(this.value);
    }
  }
  handleCountryUnselected() {
    this.value = undefined;
    this.countryUnselected.emit();
  }
  suggestionGenerator(searchText) {
    let suggestions = [];
    if ((searchText === null || searchText === void 0 ? void 0 : searchText.length) > 0) {
      const matches = this.countries
        .filter(country => country === null || country === void 0 ? void 0 : country.name)
        .filter(country => country.name.toLowerCase().startsWith(searchText.toLowerCase()));
      suggestions = matches.map((match) => ({ text: match.name, value: match }));
    }
    return Promise.resolve(suggestions);
  }
};
DestinationInput.style = destinationInputComponentCss;

const dropdownInputComponentCss = ".a11y-hidden{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}.bhtp-ui-form-group__input{display:flex;align-items:center}@media (max-width: 599px){.bhtp-ui-form-group__input{flex-direction:column;align-items:stretch}.bhtp-ui-form-group__input.bhtp-ui-form-group__input--inline{flex-direction:row;align-items:center}.bhtp-ui-form-group__input .bhtp-ui-input{padding:0}.bhtp-ui-form-group__input .bhtp-ui-input-prompt{font-size:var(--bhtp-ui-reduced-font-size)}}.bhtp-ui-form-group__inline{display:flex;align-items:center}.bhtp-ui-input-prompt{color:var(--bhtp-ui-text-primary-color);margin-right:1rem;font-weight:bold}.bhtp-ui-input-prompt--post{margin:0 0 0 1rem}.bhtp-ui-input-prompt--center{margin:0 1rem}.bhtp-ui-input-prompt,.bhtp-ui-input{font-size:var(--bhtp-ui-standard-font-size)}.bhtp-ui-input-prompt-tooltip{margin-left:-1rem}.bhtp-ui-input{border:none;border-radius:0;border-bottom:1px solid var(--bhtp-ui-text-secondary-color);font-family:var(--bhtp-ui-primary-font-family);color:var(--bhtp-ui-text-input-color);background-color:transparent;padding:0 0.75rem 0.5rem;outline:none;box-sizing:border-box}.bhtp-ui-input::-moz-placeholder{color:var(--bhtp-ui-text-secondary-color);text-transform:lowercase;overflow:visible}.bhtp-ui-input:-ms-input-placeholder{color:var(--bhtp-ui-text-secondary-color);text-transform:lowercase;overflow:visible}.bhtp-ui-input::placeholder{color:var(--bhtp-ui-text-secondary-color);text-transform:lowercase;overflow:visible}@media (max-width: 599px){.bhtp-ui-input::-moz-placeholder{font-size:1rem}.bhtp-ui-input:-ms-input-placeholder{font-size:1rem}.bhtp-ui-input::placeholder{font-size:1rem}}.bhtp-ui-input.bhtp-ui-input--invalid{color:var(--bhtp-ui-danger-color)}.bhtp-ui-input.bhtp-ui-input--clear-right{padding-right:0}.bhtp-ui-icon-input{display:flex;align-items:stretch;border-bottom:1px solid var(--bhtp-ui-text-secondary-color);position:relative}.bhtp-ui-icon-input .bhtp-ui-input{border-bottom:none}.bhtp-ui-icon-input>bhtp-ui-icon{display:flex;align-items:center}.bhtp-ui-icon-input>bhtp-ui-icon i{color:var(--bhtp-ui-text-secondary-color)}@media (max-width: 599px){.bhtp-ui-icon-input>bhtp-ui-icon{margin-right:0.5rem}}button>bhtp-ui-icon{outline:none}.bhtp-ui-form-label-tooltip{display:flex;align-items:center}@media (max-width: 599px){.bhtp-ui-hide-only-mobile{display:none}.bhtp-ui-form-group.bhtp-ui-show-only-mobile{display:flex}}@media (min-width: 599px){.bhtp-ui-hide-only-mobile{display:flex}.bhtp-ui-form-group.bhtp-ui-show-only-mobile{display:none}}.bhtp-ui-multi-select-dropdown-input{position:relative}.bhtp-ui-multi-select-dropdown-input .bhtp-ui-multi-select-dropdown-menu{display:flex;flex-direction:column;align-items:flex-start;padding:0;margin:0;list-style:none;position:absolute;left:0;right:0;z-index:100;background-color:var(--bhtp-ui-white-color);border:1px solid var(--bhtp-ui-text-secondary-color);border-top:none;border-radius:0 0 5px 5px}.bhtp-ui-multi-select-dropdown-input .bhtp-ui-multi-select-dropdown-menu--allow-hover .bhtp-ui-multi-select-dropdown-item:hover{background-color:rgba(54, 79, 120, 0.2)}.bhtp-ui-multi-select-dropdown-input .bhtp-ui-multi-select-dropdown-item{border:none;width:100%}.bhtp-ui-multi-select-dropdown-input .bhtp-ui-multi-select-dropdown-item button{text-align:left;outline:none;border:none;color:var(--bhtp-ui-text-primary-color);font-family:var(--bhtp-ui-primary-font-family);font-size:var(--bhtp-ui-standard-font-size);width:100%;padding:0.25rem 0.5rem;background-color:transparent}.bhtp-ui-multi-select-dropdown-input .bhtp-ui-multi-select-dropdown-item.bhtp-ui-multi-select-dropdown-item--active{background-color:rgba(54, 79, 120, 0.2)}:host{display:block;font-family:var(--bhtp-ui-primary-font-family)}.bhtp-ui-dropdown-input{display:flex;align-items:stretch;border-bottom:1px solid var(--bhtp-ui-text-secondary-color);position:relative;flex-grow:1}.bhtp-ui-dropdown-input .bhtp-ui-input{width:100%;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border-bottom:none;text-overflow:ellipsis}@media (max-width: 599px){.bhtp-ui-dropdown-input .bhtp-ui-input{font-size:1.3rem;text-align:center}}.bhtp-ui-dropdown-input .bhtp-ui-dropdown-menu{top:calc(100% + 1px)}.bhtp-ui-dropdown-input:focus-within{border-bottom:1px solid var(--bhtp-ui-primary-color)}bhtp-ui-icon.dropdown-icon{display:flex;align-items:center;cursor:pointer}bhtp-ui-icon.dropdown-icon i{color:var(--bhtp-ui-text-secondary-color)}.bhtp-ui-dropdown-item button{display:flex;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.bhtp-ui-dropdown-item button i{margin-right:0.5rem;width:1rem}.bhtp-ui-input-dropdown-default{color:var(--bhtp-ui-text-secondary-color)}.bhtp-ui-input-dropdown-default option{color:var(--bhtp-ui-text-primary-color)}";

let DropdownInput = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.valueSelected = createEvent(this, "valueSelected", 7);
    this.hideSelectOption = false;
    this.documentClickEventHandler = (event) => {
      var _a;
      if (!((_a = this.hostElement.shadowRoot) === null || _a === void 0 ? void 0 : _a.contains(event.composedPath()[0]))) {
        this.handleClose();
      }
    };
  }
  get selectId() {
    return `${this.inputId}--select`;
  }
  async focusInput() {
    this.inputRef.scrollIntoView({ block: "center" });
    setTimeout(() => {
      this.inputRef.focus();
    }, 100);
  }
  render() {
    var _a;
    return (h("div", { class: "bhtp-ui-form-group__input" }, h("div", { class: "bhtp-ui-input-prompt" }, this.prompt), h("label", { class: "a11y-hidden", htmlFor: this.inputId }, this.description), h("slot", { name: "prompt-tooltip" }), h("div", { class: `bhtp-ui-dropdown-input ${this.hasFocus ? 'bhtp-ui-input__focused' : ''}`, role: "select", "aria-expanded": this.hasFocus, "aria-owns": this.selectId, "aria-haspopup": "select" }, h("select", { id: this.inputId, class: {
        "bhtp-ui-input": true,
        "bhtp-ui-input-dropdown-default": !this.value
      }, ref: (element) => this.inputRef = element, "aria-controls": this.selectId, "aria-required": (this.required === true).toString(), "aria-invalid": (this.isValid === false).toString(), onBlur: (event) => this.handleBlur(event), onFocus: () => this.handleFocus(), onInput: (event) => this.handleSelect(event) }, !this.hideSelectOption &&
      h("option", { role: "option", value: "" }, this.placeholder ? this.placeholder : 'Select'), (_a = this.options) === null || _a === void 0 ? void 0 :
      _a.map((opt, index) => (h("option", { role: "option", key: index, value: opt.value, selected: this.value === opt.value, "aria-selected": this.value === opt.value }, opt.key)))))));
  }
  handleSelect(event) {
    var _a;
    this.value = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value;
    this.valueSelected.emit(this.value);
  }
  handleFocus() {
    if (!this.hasFocus) {
      this.hasFocus = true;
      document.addEventListener('click', this.documentClickEventHandler);
    }
  }
  handleBlur(event) {
    var _a, _b;
    const hostContainsNewFocusedElement = (!((_a = this.hostElement.shadowRoot) === null || _a === void 0 ? void 0 : _a.contains(event.composedPath()[0]))) ||
      (event.relatedTarget && !((_b = this.hostElement.shadowRoot) === null || _b === void 0 ? void 0 : _b.contains(event.relatedTarget)));
    if (hostContainsNewFocusedElement) {
      this.handleClose();
    }
  }
  handleClose() {
    this.hasFocus = false;
    document.removeEventListener('click', this.documentClickEventHandler);
  }
  get hostElement() { return getElement(this); }
};
DropdownInput.style = dropdownInputComponentCss;

const formErrorComponentCss = ":host{display:block;font-family:var(--bhtp-ui-primary-font-family)}.bhtp-ui-form-group--error{display:flex;justify-content:flex-start;text-align:center;margin:0.25rem 0;color:var(--bhtp-ui-danger-color);min-height:1.5rem}.bhtp-ui-form-group--error span{font-family:var(--bhtp-ui-secondary-font-family);font-size:1rem;display:flex;align-items:center}.bhtp-ui-form-group--error bhtp-ui-icon i{margin-right:1em;font-size:var(--bhtp-ui-reduced-font-size)}@media (max-width: 599px){.bhtp-ui-form-group--error{justify-content:flex-start;text-align:left}.bhtp-ui-form-group--error span{font-size:var(--bhtp-ui-small-font-size)}}";

let FormError = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  get isInvalid() {
    var _a;
    if (this.formControl && this.formSubmitted) {
      return this.formControl.isValid === false;
    }
    else if (((_a = this.formControls) === null || _a === void 0 ? void 0 : _a.length) && this.formSubmitted) {
      return this.formControls.some(control => control.isValid === false);
    }
    else {
      return false;
    }
  }
  get errorMessage() {
    var _a;
    if (this.formControl) {
      return this.formControl.errorMessage;
    }
    else if ((_a = this.formControls) === null || _a === void 0 ? void 0 : _a.length) {
      return this.formControls
        .filter(control => control.isValid === false && control.errorMessage)
        .map(control => trimRight(control.errorMessage, '.'))
        .filter((message, index, messages) => messages.indexOf(message) === index) // Get rid of duplicate messages
        .join(', ') + '.';
    }
  }
  render() {
    return (
    // Always render the container to prevent form from shifting when error appears
    h("div", { class: "bhtp-ui-form-group--error" }, this.isInvalid ?
      h("span", { role: "alert" }, this.errorMessage) : null));
  }
};
FormError.style = formErrorComponentCss;

const iconComponentCss = "/*!\n *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */@font-face{font-family:'FontAwesome';src:url('../fonts/fontawesome-webfont.eot?v=4.7.0');src:url('../fonts/fontawesome-webfont.eot?#iefix&v=4.7.0') format('embedded-opentype'),url('../fonts/fontawesome-webfont.woff2?v=4.7.0') format('woff2'),url('../fonts/fontawesome-webfont.woff?v=4.7.0') format('woff'),url('../fonts/fontawesome-webfont.ttf?v=4.7.0') format('truetype'),url('../fonts/fontawesome-webfont.svg?v=4.7.0#fontawesomeregular') format('svg');font-weight:normal;font-style:normal}.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-lg{font-size:1.33333333em;line-height:.75em;vertical-align:-15%}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-fw{width:1.28571429em;text-align:center}.fa-ul{padding-left:0;margin-left:2.14285714em;list-style-type:none}.fa-ul>li{position:relative}.fa-li{position:absolute;left:-2.14285714em;width:2.14285714em;top:.14285714em;text-align:center}.fa-li.fa-lg{left:-1.85714286em}.fa-border{padding:.2em .25em .15em;border:solid .08em #eee;border-radius:.1em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left{margin-right:.3em}.fa.fa-pull-right{margin-left:.3em}.pull-right{float:right}.pull-left{float:left}.fa.pull-left{margin-right:.3em}.fa.pull-right{margin-left:.3em}.fa-spin{-webkit-animation:fa-spin 2s infinite linear;animation:fa-spin 2s infinite linear}.fa-pulse{-webkit-animation:fa-spin 1s infinite steps(8);animation:fa-spin 1s infinite steps(8)}@-webkit-keyframes fa-spin{0%{transform:rotate(0deg)}100%{transform:rotate(359deg)}}@keyframes fa-spin{0%{transform:rotate(0deg)}100%{transform:rotate(359deg)}}.fa-rotate-90{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";transform:rotate(90deg)}.fa-rotate-180{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";transform:rotate(180deg)}.fa-rotate-270{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";transform:rotate(270deg)}.fa-flip-horizontal{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";transform:scale(-1, 1)}.fa-flip-vertical{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";transform:scale(1, -1)}:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270,:root .fa-flip-horizontal,:root .fa-flip-vertical{filter:none}.fa-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.fa-stack-1x,.fa-stack-2x{position:absolute;left:0;width:100%;text-align:center}.fa-stack-1x{line-height:inherit}.fa-stack-2x{font-size:2em}.fa-inverse{color:#fff}.fa-glass:before{content:\"\\f000\"}.fa-music:before{content:\"\\f001\"}.fa-search:before{content:\"\\f002\"}.fa-envelope-o:before{content:\"\\f003\"}.fa-heart:before{content:\"\\f004\"}.fa-star:before{content:\"\\f005\"}.fa-star-o:before{content:\"\\f006\"}.fa-user:before{content:\"\\f007\"}.fa-film:before{content:\"\\f008\"}.fa-th-large:before{content:\"\\f009\"}.fa-th:before{content:\"\\f00a\"}.fa-th-list:before{content:\"\\f00b\"}.fa-check:before{content:\"\\f00c\"}.fa-remove:before,.fa-close:before,.fa-times:before{content:\"\\f00d\"}.fa-search-plus:before{content:\"\\f00e\"}.fa-search-minus:before{content:\"\\f010\"}.fa-power-off:before{content:\"\\f011\"}.fa-signal:before{content:\"\\f012\"}.fa-gear:before,.fa-cog:before{content:\"\\f013\"}.fa-trash-o:before{content:\"\\f014\"}.fa-home:before{content:\"\\f015\"}.fa-file-o:before{content:\"\\f016\"}.fa-clock-o:before{content:\"\\f017\"}.fa-road:before{content:\"\\f018\"}.fa-download:before{content:\"\\f019\"}.fa-arrow-circle-o-down:before{content:\"\\f01a\"}.fa-arrow-circle-o-up:before{content:\"\\f01b\"}.fa-inbox:before{content:\"\\f01c\"}.fa-play-circle-o:before{content:\"\\f01d\"}.fa-rotate-right:before,.fa-repeat:before{content:\"\\f01e\"}.fa-refresh:before{content:\"\\f021\"}.fa-list-alt:before{content:\"\\f022\"}.fa-lock:before{content:\"\\f023\"}.fa-flag:before{content:\"\\f024\"}.fa-headphones:before{content:\"\\f025\"}.fa-volume-off:before{content:\"\\f026\"}.fa-volume-down:before{content:\"\\f027\"}.fa-volume-up:before{content:\"\\f028\"}.fa-qrcode:before{content:\"\\f029\"}.fa-barcode:before{content:\"\\f02a\"}.fa-tag:before{content:\"\\f02b\"}.fa-tags:before{content:\"\\f02c\"}.fa-book:before{content:\"\\f02d\"}.fa-bookmark:before{content:\"\\f02e\"}.fa-print:before{content:\"\\f02f\"}.fa-camera:before{content:\"\\f030\"}.fa-font:before{content:\"\\f031\"}.fa-bold:before{content:\"\\f032\"}.fa-italic:before{content:\"\\f033\"}.fa-text-height:before{content:\"\\f034\"}.fa-text-width:before{content:\"\\f035\"}.fa-align-left:before{content:\"\\f036\"}.fa-align-center:before{content:\"\\f037\"}.fa-align-right:before{content:\"\\f038\"}.fa-align-justify:before{content:\"\\f039\"}.fa-list:before{content:\"\\f03a\"}.fa-dedent:before,.fa-outdent:before{content:\"\\f03b\"}.fa-indent:before{content:\"\\f03c\"}.fa-video-camera:before{content:\"\\f03d\"}.fa-photo:before,.fa-image:before,.fa-picture-o:before{content:\"\\f03e\"}.fa-pencil:before{content:\"\\f040\"}.fa-map-marker:before{content:\"\\f041\"}.fa-adjust:before{content:\"\\f042\"}.fa-tint:before{content:\"\\f043\"}.fa-edit:before,.fa-pencil-square-o:before{content:\"\\f044\"}.fa-share-square-o:before{content:\"\\f045\"}.fa-check-square-o:before{content:\"\\f046\"}.fa-arrows:before{content:\"\\f047\"}.fa-step-backward:before{content:\"\\f048\"}.fa-fast-backward:before{content:\"\\f049\"}.fa-backward:before{content:\"\\f04a\"}.fa-play:before{content:\"\\f04b\"}.fa-pause:before{content:\"\\f04c\"}.fa-stop:before{content:\"\\f04d\"}.fa-forward:before{content:\"\\f04e\"}.fa-fast-forward:before{content:\"\\f050\"}.fa-step-forward:before{content:\"\\f051\"}.fa-eject:before{content:\"\\f052\"}.fa-chevron-left:before{content:\"\\f053\"}.fa-chevron-right:before{content:\"\\f054\"}.fa-plus-circle:before{content:\"\\f055\"}.fa-minus-circle:before{content:\"\\f056\"}.fa-times-circle:before{content:\"\\f057\"}.fa-check-circle:before{content:\"\\f058\"}.fa-question-circle:before{content:\"\\f059\"}.fa-info-circle:before{content:\"\\f05a\"}.fa-crosshairs:before{content:\"\\f05b\"}.fa-times-circle-o:before{content:\"\\f05c\"}.fa-check-circle-o:before{content:\"\\f05d\"}.fa-ban:before{content:\"\\f05e\"}.fa-arrow-left:before{content:\"\\f060\"}.fa-arrow-right:before{content:\"\\f061\"}.fa-arrow-up:before{content:\"\\f062\"}.fa-arrow-down:before{content:\"\\f063\"}.fa-mail-forward:before,.fa-share:before{content:\"\\f064\"}.fa-expand:before{content:\"\\f065\"}.fa-compress:before{content:\"\\f066\"}.fa-plus:before{content:\"\\f067\"}.fa-minus:before{content:\"\\f068\"}.fa-asterisk:before{content:\"\\f069\"}.fa-exclamation-circle:before{content:\"\\f06a\"}.fa-gift:before{content:\"\\f06b\"}.fa-leaf:before{content:\"\\f06c\"}.fa-fire:before{content:\"\\f06d\"}.fa-eye:before{content:\"\\f06e\"}.fa-eye-slash:before{content:\"\\f070\"}.fa-warning:before,.fa-exclamation-triangle:before{content:\"\\f071\"}.fa-plane:before{content:\"\\f072\"}.fa-calendar:before{content:\"\\f073\"}.fa-random:before{content:\"\\f074\"}.fa-comment:before{content:\"\\f075\"}.fa-magnet:before{content:\"\\f076\"}.fa-chevron-up:before{content:\"\\f077\"}.fa-chevron-down:before{content:\"\\f078\"}.fa-retweet:before{content:\"\\f079\"}.fa-shopping-cart:before{content:\"\\f07a\"}.fa-folder:before{content:\"\\f07b\"}.fa-folder-open:before{content:\"\\f07c\"}.fa-arrows-v:before{content:\"\\f07d\"}.fa-arrows-h:before{content:\"\\f07e\"}.fa-bar-chart-o:before,.fa-bar-chart:before{content:\"\\f080\"}.fa-twitter-square:before{content:\"\\f081\"}.fa-facebook-square:before{content:\"\\f082\"}.fa-camera-retro:before{content:\"\\f083\"}.fa-key:before{content:\"\\f084\"}.fa-gears:before,.fa-cogs:before{content:\"\\f085\"}.fa-comments:before{content:\"\\f086\"}.fa-thumbs-o-up:before{content:\"\\f087\"}.fa-thumbs-o-down:before{content:\"\\f088\"}.fa-star-half:before{content:\"\\f089\"}.fa-heart-o:before{content:\"\\f08a\"}.fa-sign-out:before{content:\"\\f08b\"}.fa-linkedin-square:before{content:\"\\f08c\"}.fa-thumb-tack:before{content:\"\\f08d\"}.fa-external-link:before{content:\"\\f08e\"}.fa-sign-in:before{content:\"\\f090\"}.fa-trophy:before{content:\"\\f091\"}.fa-github-square:before{content:\"\\f092\"}.fa-upload:before{content:\"\\f093\"}.fa-lemon-o:before{content:\"\\f094\"}.fa-phone:before{content:\"\\f095\"}.fa-square-o:before{content:\"\\f096\"}.fa-bookmark-o:before{content:\"\\f097\"}.fa-phone-square:before{content:\"\\f098\"}.fa-twitter:before{content:\"\\f099\"}.fa-facebook-f:before,.fa-facebook:before{content:\"\\f09a\"}.fa-github:before{content:\"\\f09b\"}.fa-unlock:before{content:\"\\f09c\"}.fa-credit-card:before{content:\"\\f09d\"}.fa-feed:before,.fa-rss:before{content:\"\\f09e\"}.fa-hdd-o:before{content:\"\\f0a0\"}.fa-bullhorn:before{content:\"\\f0a1\"}.fa-bell:before{content:\"\\f0f3\"}.fa-certificate:before{content:\"\\f0a3\"}.fa-hand-o-right:before{content:\"\\f0a4\"}.fa-hand-o-left:before{content:\"\\f0a5\"}.fa-hand-o-up:before{content:\"\\f0a6\"}.fa-hand-o-down:before{content:\"\\f0a7\"}.fa-arrow-circle-left:before{content:\"\\f0a8\"}.fa-arrow-circle-right:before{content:\"\\f0a9\"}.fa-arrow-circle-up:before{content:\"\\f0aa\"}.fa-arrow-circle-down:before{content:\"\\f0ab\"}.fa-globe:before{content:\"\\f0ac\"}.fa-wrench:before{content:\"\\f0ad\"}.fa-tasks:before{content:\"\\f0ae\"}.fa-filter:before{content:\"\\f0b0\"}.fa-briefcase:before{content:\"\\f0b1\"}.fa-arrows-alt:before{content:\"\\f0b2\"}.fa-group:before,.fa-users:before{content:\"\\f0c0\"}.fa-chain:before,.fa-link:before{content:\"\\f0c1\"}.fa-cloud:before{content:\"\\f0c2\"}.fa-flask:before{content:\"\\f0c3\"}.fa-cut:before,.fa-scissors:before{content:\"\\f0c4\"}.fa-copy:before,.fa-files-o:before{content:\"\\f0c5\"}.fa-paperclip:before{content:\"\\f0c6\"}.fa-save:before,.fa-floppy-o:before{content:\"\\f0c7\"}.fa-square:before{content:\"\\f0c8\"}.fa-navicon:before,.fa-reorder:before,.fa-bars:before{content:\"\\f0c9\"}.fa-list-ul:before{content:\"\\f0ca\"}.fa-list-ol:before{content:\"\\f0cb\"}.fa-strikethrough:before{content:\"\\f0cc\"}.fa-underline:before{content:\"\\f0cd\"}.fa-table:before{content:\"\\f0ce\"}.fa-magic:before{content:\"\\f0d0\"}.fa-truck:before{content:\"\\f0d1\"}.fa-pinterest:before{content:\"\\f0d2\"}.fa-pinterest-square:before{content:\"\\f0d3\"}.fa-google-plus-square:before{content:\"\\f0d4\"}.fa-google-plus:before{content:\"\\f0d5\"}.fa-money:before{content:\"\\f0d6\"}.fa-caret-down:before{content:\"\\f0d7\"}.fa-caret-up:before{content:\"\\f0d8\"}.fa-caret-left:before{content:\"\\f0d9\"}.fa-caret-right:before{content:\"\\f0da\"}.fa-columns:before{content:\"\\f0db\"}.fa-unsorted:before,.fa-sort:before{content:\"\\f0dc\"}.fa-sort-down:before,.fa-sort-desc:before{content:\"\\f0dd\"}.fa-sort-up:before,.fa-sort-asc:before{content:\"\\f0de\"}.fa-envelope:before{content:\"\\f0e0\"}.fa-linkedin:before{content:\"\\f0e1\"}.fa-rotate-left:before,.fa-undo:before{content:\"\\f0e2\"}.fa-legal:before,.fa-gavel:before{content:\"\\f0e3\"}.fa-dashboard:before,.fa-tachometer:before{content:\"\\f0e4\"}.fa-comment-o:before{content:\"\\f0e5\"}.fa-comments-o:before{content:\"\\f0e6\"}.fa-flash:before,.fa-bolt:before{content:\"\\f0e7\"}.fa-sitemap:before{content:\"\\f0e8\"}.fa-umbrella:before{content:\"\\f0e9\"}.fa-paste:before,.fa-clipboard:before{content:\"\\f0ea\"}.fa-lightbulb-o:before{content:\"\\f0eb\"}.fa-exchange:before{content:\"\\f0ec\"}.fa-cloud-download:before{content:\"\\f0ed\"}.fa-cloud-upload:before{content:\"\\f0ee\"}.fa-user-md:before{content:\"\\f0f0\"}.fa-stethoscope:before{content:\"\\f0f1\"}.fa-suitcase:before{content:\"\\f0f2\"}.fa-bell-o:before{content:\"\\f0a2\"}.fa-coffee:before{content:\"\\f0f4\"}.fa-cutlery:before{content:\"\\f0f5\"}.fa-file-text-o:before{content:\"\\f0f6\"}.fa-building-o:before{content:\"\\f0f7\"}.fa-hospital-o:before{content:\"\\f0f8\"}.fa-ambulance:before{content:\"\\f0f9\"}.fa-medkit:before{content:\"\\f0fa\"}.fa-fighter-jet:before{content:\"\\f0fb\"}.fa-beer:before{content:\"\\f0fc\"}.fa-h-square:before{content:\"\\f0fd\"}.fa-plus-square:before{content:\"\\f0fe\"}.fa-angle-double-left:before{content:\"\\f100\"}.fa-angle-double-right:before{content:\"\\f101\"}.fa-angle-double-up:before{content:\"\\f102\"}.fa-angle-double-down:before{content:\"\\f103\"}.fa-angle-left:before{content:\"\\f104\"}.fa-angle-right:before{content:\"\\f105\"}.fa-angle-up:before{content:\"\\f106\"}.fa-angle-down:before{content:\"\\f107\"}.fa-desktop:before{content:\"\\f108\"}.fa-laptop:before{content:\"\\f109\"}.fa-tablet:before{content:\"\\f10a\"}.fa-mobile-phone:before,.fa-mobile:before{content:\"\\f10b\"}.fa-circle-o:before{content:\"\\f10c\"}.fa-quote-left:before{content:\"\\f10d\"}.fa-quote-right:before{content:\"\\f10e\"}.fa-spinner:before{content:\"\\f110\"}.fa-circle:before{content:\"\\f111\"}.fa-mail-reply:before,.fa-reply:before{content:\"\\f112\"}.fa-github-alt:before{content:\"\\f113\"}.fa-folder-o:before{content:\"\\f114\"}.fa-folder-open-o:before{content:\"\\f115\"}.fa-smile-o:before{content:\"\\f118\"}.fa-frown-o:before{content:\"\\f119\"}.fa-meh-o:before{content:\"\\f11a\"}.fa-gamepad:before{content:\"\\f11b\"}.fa-keyboard-o:before{content:\"\\f11c\"}.fa-flag-o:before{content:\"\\f11d\"}.fa-flag-checkered:before{content:\"\\f11e\"}.fa-terminal:before{content:\"\\f120\"}.fa-code:before{content:\"\\f121\"}.fa-mail-reply-all:before,.fa-reply-all:before{content:\"\\f122\"}.fa-star-half-empty:before,.fa-star-half-full:before,.fa-star-half-o:before{content:\"\\f123\"}.fa-location-arrow:before{content:\"\\f124\"}.fa-crop:before{content:\"\\f125\"}.fa-code-fork:before{content:\"\\f126\"}.fa-unlink:before,.fa-chain-broken:before{content:\"\\f127\"}.fa-question:before{content:\"\\f128\"}.fa-info:before{content:\"\\f129\"}.fa-exclamation:before{content:\"\\f12a\"}.fa-superscript:before{content:\"\\f12b\"}.fa-subscript:before{content:\"\\f12c\"}.fa-eraser:before{content:\"\\f12d\"}.fa-puzzle-piece:before{content:\"\\f12e\"}.fa-microphone:before{content:\"\\f130\"}.fa-microphone-slash:before{content:\"\\f131\"}.fa-shield:before{content:\"\\f132\"}.fa-calendar-o:before{content:\"\\f133\"}.fa-fire-extinguisher:before{content:\"\\f134\"}.fa-rocket:before{content:\"\\f135\"}.fa-maxcdn:before{content:\"\\f136\"}.fa-chevron-circle-left:before{content:\"\\f137\"}.fa-chevron-circle-right:before{content:\"\\f138\"}.fa-chevron-circle-up:before{content:\"\\f139\"}.fa-chevron-circle-down:before{content:\"\\f13a\"}.fa-html5:before{content:\"\\f13b\"}.fa-css3:before{content:\"\\f13c\"}.fa-anchor:before{content:\"\\f13d\"}.fa-unlock-alt:before{content:\"\\f13e\"}.fa-bullseye:before{content:\"\\f140\"}.fa-ellipsis-h:before{content:\"\\f141\"}.fa-ellipsis-v:before{content:\"\\f142\"}.fa-rss-square:before{content:\"\\f143\"}.fa-play-circle:before{content:\"\\f144\"}.fa-ticket:before{content:\"\\f145\"}.fa-minus-square:before{content:\"\\f146\"}.fa-minus-square-o:before{content:\"\\f147\"}.fa-level-up:before{content:\"\\f148\"}.fa-level-down:before{content:\"\\f149\"}.fa-check-square:before{content:\"\\f14a\"}.fa-pencil-square:before{content:\"\\f14b\"}.fa-external-link-square:before{content:\"\\f14c\"}.fa-share-square:before{content:\"\\f14d\"}.fa-compass:before{content:\"\\f14e\"}.fa-toggle-down:before,.fa-caret-square-o-down:before{content:\"\\f150\"}.fa-toggle-up:before,.fa-caret-square-o-up:before{content:\"\\f151\"}.fa-toggle-right:before,.fa-caret-square-o-right:before{content:\"\\f152\"}.fa-euro:before,.fa-eur:before{content:\"\\f153\"}.fa-gbp:before{content:\"\\f154\"}.fa-dollar:before,.fa-usd:before{content:\"\\f155\"}.fa-rupee:before,.fa-inr:before{content:\"\\f156\"}.fa-cny:before,.fa-rmb:before,.fa-yen:before,.fa-jpy:before{content:\"\\f157\"}.fa-ruble:before,.fa-rouble:before,.fa-rub:before{content:\"\\f158\"}.fa-won:before,.fa-krw:before{content:\"\\f159\"}.fa-bitcoin:before,.fa-btc:before{content:\"\\f15a\"}.fa-file:before{content:\"\\f15b\"}.fa-file-text:before{content:\"\\f15c\"}.fa-sort-alpha-asc:before{content:\"\\f15d\"}.fa-sort-alpha-desc:before{content:\"\\f15e\"}.fa-sort-amount-asc:before{content:\"\\f160\"}.fa-sort-amount-desc:before{content:\"\\f161\"}.fa-sort-numeric-asc:before{content:\"\\f162\"}.fa-sort-numeric-desc:before{content:\"\\f163\"}.fa-thumbs-up:before{content:\"\\f164\"}.fa-thumbs-down:before{content:\"\\f165\"}.fa-youtube-square:before{content:\"\\f166\"}.fa-youtube:before{content:\"\\f167\"}.fa-xing:before{content:\"\\f168\"}.fa-xing-square:before{content:\"\\f169\"}.fa-youtube-play:before{content:\"\\f16a\"}.fa-dropbox:before{content:\"\\f16b\"}.fa-stack-overflow:before{content:\"\\f16c\"}.fa-instagram:before{content:\"\\f16d\"}.fa-flickr:before{content:\"\\f16e\"}.fa-adn:before{content:\"\\f170\"}.fa-bitbucket:before{content:\"\\f171\"}.fa-bitbucket-square:before{content:\"\\f172\"}.fa-tumblr:before{content:\"\\f173\"}.fa-tumblr-square:before{content:\"\\f174\"}.fa-long-arrow-down:before{content:\"\\f175\"}.fa-long-arrow-up:before{content:\"\\f176\"}.fa-long-arrow-left:before{content:\"\\f177\"}.fa-long-arrow-right:before{content:\"\\f178\"}.fa-apple:before{content:\"\\f179\"}.fa-windows:before{content:\"\\f17a\"}.fa-android:before{content:\"\\f17b\"}.fa-linux:before{content:\"\\f17c\"}.fa-dribbble:before{content:\"\\f17d\"}.fa-skype:before{content:\"\\f17e\"}.fa-foursquare:before{content:\"\\f180\"}.fa-trello:before{content:\"\\f181\"}.fa-female:before{content:\"\\f182\"}.fa-male:before{content:\"\\f183\"}.fa-gittip:before,.fa-gratipay:before{content:\"\\f184\"}.fa-sun-o:before{content:\"\\f185\"}.fa-moon-o:before{content:\"\\f186\"}.fa-archive:before{content:\"\\f187\"}.fa-bug:before{content:\"\\f188\"}.fa-vk:before{content:\"\\f189\"}.fa-weibo:before{content:\"\\f18a\"}.fa-renren:before{content:\"\\f18b\"}.fa-pagelines:before{content:\"\\f18c\"}.fa-stack-exchange:before{content:\"\\f18d\"}.fa-arrow-circle-o-right:before{content:\"\\f18e\"}.fa-arrow-circle-o-left:before{content:\"\\f190\"}.fa-toggle-left:before,.fa-caret-square-o-left:before{content:\"\\f191\"}.fa-dot-circle-o:before{content:\"\\f192\"}.fa-wheelchair:before{content:\"\\f193\"}.fa-vimeo-square:before{content:\"\\f194\"}.fa-turkish-lira:before,.fa-try:before{content:\"\\f195\"}.fa-plus-square-o:before{content:\"\\f196\"}.fa-space-shuttle:before{content:\"\\f197\"}.fa-slack:before{content:\"\\f198\"}.fa-envelope-square:before{content:\"\\f199\"}.fa-wordpress:before{content:\"\\f19a\"}.fa-openid:before{content:\"\\f19b\"}.fa-institution:before,.fa-bank:before,.fa-university:before{content:\"\\f19c\"}.fa-mortar-board:before,.fa-graduation-cap:before{content:\"\\f19d\"}.fa-yahoo:before{content:\"\\f19e\"}.fa-google:before{content:\"\\f1a0\"}.fa-reddit:before{content:\"\\f1a1\"}.fa-reddit-square:before{content:\"\\f1a2\"}.fa-stumbleupon-circle:before{content:\"\\f1a3\"}.fa-stumbleupon:before{content:\"\\f1a4\"}.fa-delicious:before{content:\"\\f1a5\"}.fa-digg:before{content:\"\\f1a6\"}.fa-pied-piper-pp:before{content:\"\\f1a7\"}.fa-pied-piper-alt:before{content:\"\\f1a8\"}.fa-drupal:before{content:\"\\f1a9\"}.fa-joomla:before{content:\"\\f1aa\"}.fa-language:before{content:\"\\f1ab\"}.fa-fax:before{content:\"\\f1ac\"}.fa-building:before{content:\"\\f1ad\"}.fa-child:before{content:\"\\f1ae\"}.fa-paw:before{content:\"\\f1b0\"}.fa-spoon:before{content:\"\\f1b1\"}.fa-cube:before{content:\"\\f1b2\"}.fa-cubes:before{content:\"\\f1b3\"}.fa-behance:before{content:\"\\f1b4\"}.fa-behance-square:before{content:\"\\f1b5\"}.fa-steam:before{content:\"\\f1b6\"}.fa-steam-square:before{content:\"\\f1b7\"}.fa-recycle:before{content:\"\\f1b8\"}.fa-automobile:before,.fa-car:before{content:\"\\f1b9\"}.fa-cab:before,.fa-taxi:before{content:\"\\f1ba\"}.fa-tree:before{content:\"\\f1bb\"}.fa-spotify:before{content:\"\\f1bc\"}.fa-deviantart:before{content:\"\\f1bd\"}.fa-soundcloud:before{content:\"\\f1be\"}.fa-database:before{content:\"\\f1c0\"}.fa-file-pdf-o:before{content:\"\\f1c1\"}.fa-file-word-o:before{content:\"\\f1c2\"}.fa-file-excel-o:before{content:\"\\f1c3\"}.fa-file-powerpoint-o:before{content:\"\\f1c4\"}.fa-file-photo-o:before,.fa-file-picture-o:before,.fa-file-image-o:before{content:\"\\f1c5\"}.fa-file-zip-o:before,.fa-file-archive-o:before{content:\"\\f1c6\"}.fa-file-sound-o:before,.fa-file-audio-o:before{content:\"\\f1c7\"}.fa-file-movie-o:before,.fa-file-video-o:before{content:\"\\f1c8\"}.fa-file-code-o:before{content:\"\\f1c9\"}.fa-vine:before{content:\"\\f1ca\"}.fa-codepen:before{content:\"\\f1cb\"}.fa-jsfiddle:before{content:\"\\f1cc\"}.fa-life-bouy:before,.fa-life-buoy:before,.fa-life-saver:before,.fa-support:before,.fa-life-ring:before{content:\"\\f1cd\"}.fa-circle-o-notch:before{content:\"\\f1ce\"}.fa-ra:before,.fa-resistance:before,.fa-rebel:before{content:\"\\f1d0\"}.fa-ge:before,.fa-empire:before{content:\"\\f1d1\"}.fa-git-square:before{content:\"\\f1d2\"}.fa-git:before{content:\"\\f1d3\"}.fa-y-combinator-square:before,.fa-yc-square:before,.fa-hacker-news:before{content:\"\\f1d4\"}.fa-tencent-weibo:before{content:\"\\f1d5\"}.fa-qq:before{content:\"\\f1d6\"}.fa-wechat:before,.fa-weixin:before{content:\"\\f1d7\"}.fa-send:before,.fa-paper-plane:before{content:\"\\f1d8\"}.fa-send-o:before,.fa-paper-plane-o:before{content:\"\\f1d9\"}.fa-history:before{content:\"\\f1da\"}.fa-circle-thin:before{content:\"\\f1db\"}.fa-header:before{content:\"\\f1dc\"}.fa-paragraph:before{content:\"\\f1dd\"}.fa-sliders:before{content:\"\\f1de\"}.fa-share-alt:before{content:\"\\f1e0\"}.fa-share-alt-square:before{content:\"\\f1e1\"}.fa-bomb:before{content:\"\\f1e2\"}.fa-soccer-ball-o:before,.fa-futbol-o:before{content:\"\\f1e3\"}.fa-tty:before{content:\"\\f1e4\"}.fa-binoculars:before{content:\"\\f1e5\"}.fa-plug:before{content:\"\\f1e6\"}.fa-slideshare:before{content:\"\\f1e7\"}.fa-twitch:before{content:\"\\f1e8\"}.fa-yelp:before{content:\"\\f1e9\"}.fa-newspaper-o:before{content:\"\\f1ea\"}.fa-wifi:before{content:\"\\f1eb\"}.fa-calculator:before{content:\"\\f1ec\"}.fa-paypal:before{content:\"\\f1ed\"}.fa-google-wallet:before{content:\"\\f1ee\"}.fa-cc-visa:before{content:\"\\f1f0\"}.fa-cc-mastercard:before{content:\"\\f1f1\"}.fa-cc-discover:before{content:\"\\f1f2\"}.fa-cc-amex:before{content:\"\\f1f3\"}.fa-cc-paypal:before{content:\"\\f1f4\"}.fa-cc-stripe:before{content:\"\\f1f5\"}.fa-bell-slash:before{content:\"\\f1f6\"}.fa-bell-slash-o:before{content:\"\\f1f7\"}.fa-trash:before{content:\"\\f1f8\"}.fa-copyright:before{content:\"\\f1f9\"}.fa-at:before{content:\"\\f1fa\"}.fa-eyedropper:before{content:\"\\f1fb\"}.fa-paint-brush:before{content:\"\\f1fc\"}.fa-birthday-cake:before{content:\"\\f1fd\"}.fa-area-chart:before{content:\"\\f1fe\"}.fa-pie-chart:before{content:\"\\f200\"}.fa-line-chart:before{content:\"\\f201\"}.fa-lastfm:before{content:\"\\f202\"}.fa-lastfm-square:before{content:\"\\f203\"}.fa-toggle-off:before{content:\"\\f204\"}.fa-toggle-on:before{content:\"\\f205\"}.fa-bicycle:before{content:\"\\f206\"}.fa-bus:before{content:\"\\f207\"}.fa-ioxhost:before{content:\"\\f208\"}.fa-angellist:before{content:\"\\f209\"}.fa-cc:before{content:\"\\f20a\"}.fa-shekel:before,.fa-sheqel:before,.fa-ils:before{content:\"\\f20b\"}.fa-meanpath:before{content:\"\\f20c\"}.fa-buysellads:before{content:\"\\f20d\"}.fa-connectdevelop:before{content:\"\\f20e\"}.fa-dashcube:before{content:\"\\f210\"}.fa-forumbee:before{content:\"\\f211\"}.fa-leanpub:before{content:\"\\f212\"}.fa-sellsy:before{content:\"\\f213\"}.fa-shirtsinbulk:before{content:\"\\f214\"}.fa-simplybuilt:before{content:\"\\f215\"}.fa-skyatlas:before{content:\"\\f216\"}.fa-cart-plus:before{content:\"\\f217\"}.fa-cart-arrow-down:before{content:\"\\f218\"}.fa-diamond:before{content:\"\\f219\"}.fa-ship:before{content:\"\\f21a\"}.fa-user-secret:before{content:\"\\f21b\"}.fa-motorcycle:before{content:\"\\f21c\"}.fa-street-view:before{content:\"\\f21d\"}.fa-heartbeat:before{content:\"\\f21e\"}.fa-venus:before{content:\"\\f221\"}.fa-mars:before{content:\"\\f222\"}.fa-mercury:before{content:\"\\f223\"}.fa-intersex:before,.fa-transgender:before{content:\"\\f224\"}.fa-transgender-alt:before{content:\"\\f225\"}.fa-venus-double:before{content:\"\\f226\"}.fa-mars-double:before{content:\"\\f227\"}.fa-venus-mars:before{content:\"\\f228\"}.fa-mars-stroke:before{content:\"\\f229\"}.fa-mars-stroke-v:before{content:\"\\f22a\"}.fa-mars-stroke-h:before{content:\"\\f22b\"}.fa-neuter:before{content:\"\\f22c\"}.fa-genderless:before{content:\"\\f22d\"}.fa-facebook-official:before{content:\"\\f230\"}.fa-pinterest-p:before{content:\"\\f231\"}.fa-whatsapp:before{content:\"\\f232\"}.fa-server:before{content:\"\\f233\"}.fa-user-plus:before{content:\"\\f234\"}.fa-user-times:before{content:\"\\f235\"}.fa-hotel:before,.fa-bed:before{content:\"\\f236\"}.fa-viacoin:before{content:\"\\f237\"}.fa-train:before{content:\"\\f238\"}.fa-subway:before{content:\"\\f239\"}.fa-medium:before{content:\"\\f23a\"}.fa-yc:before,.fa-y-combinator:before{content:\"\\f23b\"}.fa-optin-monster:before{content:\"\\f23c\"}.fa-opencart:before{content:\"\\f23d\"}.fa-expeditedssl:before{content:\"\\f23e\"}.fa-battery-4:before,.fa-battery:before,.fa-battery-full:before{content:\"\\f240\"}.fa-battery-3:before,.fa-battery-three-quarters:before{content:\"\\f241\"}.fa-battery-2:before,.fa-battery-half:before{content:\"\\f242\"}.fa-battery-1:before,.fa-battery-quarter:before{content:\"\\f243\"}.fa-battery-0:before,.fa-battery-empty:before{content:\"\\f244\"}.fa-mouse-pointer:before{content:\"\\f245\"}.fa-i-cursor:before{content:\"\\f246\"}.fa-object-group:before{content:\"\\f247\"}.fa-object-ungroup:before{content:\"\\f248\"}.fa-sticky-note:before{content:\"\\f249\"}.fa-sticky-note-o:before{content:\"\\f24a\"}.fa-cc-jcb:before{content:\"\\f24b\"}.fa-cc-diners-club:before{content:\"\\f24c\"}.fa-clone:before{content:\"\\f24d\"}.fa-balance-scale:before{content:\"\\f24e\"}.fa-hourglass-o:before{content:\"\\f250\"}.fa-hourglass-1:before,.fa-hourglass-start:before{content:\"\\f251\"}.fa-hourglass-2:before,.fa-hourglass-half:before{content:\"\\f252\"}.fa-hourglass-3:before,.fa-hourglass-end:before{content:\"\\f253\"}.fa-hourglass:before{content:\"\\f254\"}.fa-hand-grab-o:before,.fa-hand-rock-o:before{content:\"\\f255\"}.fa-hand-stop-o:before,.fa-hand-paper-o:before{content:\"\\f256\"}.fa-hand-scissors-o:before{content:\"\\f257\"}.fa-hand-lizard-o:before{content:\"\\f258\"}.fa-hand-spock-o:before{content:\"\\f259\"}.fa-hand-pointer-o:before{content:\"\\f25a\"}.fa-hand-peace-o:before{content:\"\\f25b\"}.fa-trademark:before{content:\"\\f25c\"}.fa-registered:before{content:\"\\f25d\"}.fa-creative-commons:before{content:\"\\f25e\"}.fa-gg:before{content:\"\\f260\"}.fa-gg-circle:before{content:\"\\f261\"}.fa-tripadvisor:before{content:\"\\f262\"}.fa-odnoklassniki:before{content:\"\\f263\"}.fa-odnoklassniki-square:before{content:\"\\f264\"}.fa-get-pocket:before{content:\"\\f265\"}.fa-wikipedia-w:before{content:\"\\f266\"}.fa-safari:before{content:\"\\f267\"}.fa-chrome:before{content:\"\\f268\"}.fa-firefox:before{content:\"\\f269\"}.fa-opera:before{content:\"\\f26a\"}.fa-internet-explorer:before{content:\"\\f26b\"}.fa-tv:before,.fa-television:before{content:\"\\f26c\"}.fa-contao:before{content:\"\\f26d\"}.fa-500px:before{content:\"\\f26e\"}.fa-amazon:before{content:\"\\f270\"}.fa-calendar-plus-o:before{content:\"\\f271\"}.fa-calendar-minus-o:before{content:\"\\f272\"}.fa-calendar-times-o:before{content:\"\\f273\"}.fa-calendar-check-o:before{content:\"\\f274\"}.fa-industry:before{content:\"\\f275\"}.fa-map-pin:before{content:\"\\f276\"}.fa-map-signs:before{content:\"\\f277\"}.fa-map-o:before{content:\"\\f278\"}.fa-map:before{content:\"\\f279\"}.fa-commenting:before{content:\"\\f27a\"}.fa-commenting-o:before{content:\"\\f27b\"}.fa-houzz:before{content:\"\\f27c\"}.fa-vimeo:before{content:\"\\f27d\"}.fa-black-tie:before{content:\"\\f27e\"}.fa-fonticons:before{content:\"\\f280\"}.fa-reddit-alien:before{content:\"\\f281\"}.fa-edge:before{content:\"\\f282\"}.fa-credit-card-alt:before{content:\"\\f283\"}.fa-codiepie:before{content:\"\\f284\"}.fa-modx:before{content:\"\\f285\"}.fa-fort-awesome:before{content:\"\\f286\"}.fa-usb:before{content:\"\\f287\"}.fa-product-hunt:before{content:\"\\f288\"}.fa-mixcloud:before{content:\"\\f289\"}.fa-scribd:before{content:\"\\f28a\"}.fa-pause-circle:before{content:\"\\f28b\"}.fa-pause-circle-o:before{content:\"\\f28c\"}.fa-stop-circle:before{content:\"\\f28d\"}.fa-stop-circle-o:before{content:\"\\f28e\"}.fa-shopping-bag:before{content:\"\\f290\"}.fa-shopping-basket:before{content:\"\\f291\"}.fa-hashtag:before{content:\"\\f292\"}.fa-bluetooth:before{content:\"\\f293\"}.fa-bluetooth-b:before{content:\"\\f294\"}.fa-percent:before{content:\"\\f295\"}.fa-gitlab:before{content:\"\\f296\"}.fa-wpbeginner:before{content:\"\\f297\"}.fa-wpforms:before{content:\"\\f298\"}.fa-envira:before{content:\"\\f299\"}.fa-universal-access:before{content:\"\\f29a\"}.fa-wheelchair-alt:before{content:\"\\f29b\"}.fa-question-circle-o:before{content:\"\\f29c\"}.fa-blind:before{content:\"\\f29d\"}.fa-audio-description:before{content:\"\\f29e\"}.fa-volume-control-phone:before{content:\"\\f2a0\"}.fa-braille:before{content:\"\\f2a1\"}.fa-assistive-listening-systems:before{content:\"\\f2a2\"}.fa-asl-interpreting:before,.fa-american-sign-language-interpreting:before{content:\"\\f2a3\"}.fa-deafness:before,.fa-hard-of-hearing:before,.fa-deaf:before{content:\"\\f2a4\"}.fa-glide:before{content:\"\\f2a5\"}.fa-glide-g:before{content:\"\\f2a6\"}.fa-signing:before,.fa-sign-language:before{content:\"\\f2a7\"}.fa-low-vision:before{content:\"\\f2a8\"}.fa-viadeo:before{content:\"\\f2a9\"}.fa-viadeo-square:before{content:\"\\f2aa\"}.fa-snapchat:before{content:\"\\f2ab\"}.fa-snapchat-ghost:before{content:\"\\f2ac\"}.fa-snapchat-square:before{content:\"\\f2ad\"}.fa-pied-piper:before{content:\"\\f2ae\"}.fa-first-order:before{content:\"\\f2b0\"}.fa-yoast:before{content:\"\\f2b1\"}.fa-themeisle:before{content:\"\\f2b2\"}.fa-google-plus-circle:before,.fa-google-plus-official:before{content:\"\\f2b3\"}.fa-fa:before,.fa-font-awesome:before{content:\"\\f2b4\"}.fa-handshake-o:before{content:\"\\f2b5\"}.fa-envelope-open:before{content:\"\\f2b6\"}.fa-envelope-open-o:before{content:\"\\f2b7\"}.fa-linode:before{content:\"\\f2b8\"}.fa-address-book:before{content:\"\\f2b9\"}.fa-address-book-o:before{content:\"\\f2ba\"}.fa-vcard:before,.fa-address-card:before{content:\"\\f2bb\"}.fa-vcard-o:before,.fa-address-card-o:before{content:\"\\f2bc\"}.fa-user-circle:before{content:\"\\f2bd\"}.fa-user-circle-o:before{content:\"\\f2be\"}.fa-user-o:before{content:\"\\f2c0\"}.fa-id-badge:before{content:\"\\f2c1\"}.fa-drivers-license:before,.fa-id-card:before{content:\"\\f2c2\"}.fa-drivers-license-o:before,.fa-id-card-o:before{content:\"\\f2c3\"}.fa-quora:before{content:\"\\f2c4\"}.fa-free-code-camp:before{content:\"\\f2c5\"}.fa-telegram:before{content:\"\\f2c6\"}.fa-thermometer-4:before,.fa-thermometer:before,.fa-thermometer-full:before{content:\"\\f2c7\"}.fa-thermometer-3:before,.fa-thermometer-three-quarters:before{content:\"\\f2c8\"}.fa-thermometer-2:before,.fa-thermometer-half:before{content:\"\\f2c9\"}.fa-thermometer-1:before,.fa-thermometer-quarter:before{content:\"\\f2ca\"}.fa-thermometer-0:before,.fa-thermometer-empty:before{content:\"\\f2cb\"}.fa-shower:before{content:\"\\f2cc\"}.fa-bathtub:before,.fa-s15:before,.fa-bath:before{content:\"\\f2cd\"}.fa-podcast:before{content:\"\\f2ce\"}.fa-window-maximize:before{content:\"\\f2d0\"}.fa-window-minimize:before{content:\"\\f2d1\"}.fa-window-restore:before{content:\"\\f2d2\"}.fa-times-rectangle:before,.fa-window-close:before{content:\"\\f2d3\"}.fa-times-rectangle-o:before,.fa-window-close-o:before{content:\"\\f2d4\"}.fa-bandcamp:before{content:\"\\f2d5\"}.fa-grav:before{content:\"\\f2d6\"}.fa-etsy:before{content:\"\\f2d7\"}.fa-imdb:before{content:\"\\f2d8\"}.fa-ravelry:before{content:\"\\f2d9\"}.fa-eercast:before{content:\"\\f2da\"}.fa-microchip:before{content:\"\\f2db\"}.fa-snowflake-o:before{content:\"\\f2dc\"}.fa-superpowers:before{content:\"\\f2dd\"}.fa-wpexplorer:before{content:\"\\f2de\"}.fa-meetup:before{content:\"\\f2e0\"}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}:host{display:block;font-family:var(--bhtp-ui-primary-font-family)}";

let Icon = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return (h("i", { class: `fa ${this.iconName}` }));
  }
};
Icon.style = iconComponentCss;

const materialIconComponentCss$3 = ":host{display:block}";

let BhtpUiIconBirthdayCake = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return h("svg", { id: "icon_birthday_cake", xmlns: "http://www.w3.org/2000/svg", width: "24.507", height: "29.953", viewBox: "0 0 24.507 29.953" }, h("g", { id: "cake", transform: "translate(-3)" }, h("path", { id: "Icon", d: "M124.061,4121.253H105v-4.084a4.68,4.68,0,0,0,3.268-1.375l1.483-1.458,1.458,1.458a4.824,4.824,0,0,0,6.656,0l1.47-1.457,1.457,1.458a4.679,4.679,0,0,0,3.269,1.375Zm0-6.127h0a2.667,2.667,0,0,1-1.838-.775l-2.9-2.9-2.912,2.9a2.73,2.73,0,0,1-3.771,0l-2.9-2.9-2.914,2.9a2.6,2.6,0,0,1-1.824.776v-4.765a1.361,1.361,0,0,1,1.362-1.361H122.7a1.361,1.361,0,0,1,1.362,1.361v4.765Z", transform: "translate(-99.277 -4094.023)", fill: "currentColor", opacity: "0.2" }), h("path", { id: "Icon-2", "data-name": "Icon", d: "M126.146,4127.953H104.362a1.362,1.362,0,0,1-1.362-1.362v-12.253a4.085,4.085,0,0,1,4.085-4.084h6.808v-2.723h2.723v2.723h6.808a4.085,4.085,0,0,1,4.085,4.084v12.253A1.362,1.362,0,0,1,126.146,4127.953Zm-15.671-9.64-1.484,1.457a4.679,4.679,0,0,1-3.268,1.375v4.084h19.061v-4.084a4.673,4.673,0,0,1-3.268-1.373l-1.457-1.457-1.472,1.457a4.826,4.826,0,0,1-6.658,0l-1.457-1.457Zm-3.39-5.337a1.361,1.361,0,0,0-1.362,1.361v4.765a2.6,2.6,0,0,0,1.824-.776l2.914-2.9,2.9,2.9a2.732,2.732,0,0,0,3.772,0l2.912-2.9h0l2.9,2.9a2.619,2.619,0,0,0,1.838.775v-4.765a1.361,1.361,0,0,0-1.362-1.361Zm8.169-6.808a2.723,2.723,0,0,1-2.723-2.723,2.573,2.573,0,0,1,.395-1.4l2.328-4.044,2.328,4.045a2.59,2.59,0,0,1,.395,1.4,2.723,2.723,0,0,1-2.722,2.722Z", transform: "translate(-100 -4098)", fill: "currentColor" })));
  }
};
BhtpUiIconBirthdayCake.style = materialIconComponentCss$3;

const materialIconComponentCss$2 = ":host{display:block}";

let BhtpUiIconCalendar = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return h("svg", { id: "icon_calendar", xmlns: "http://www.w3.org/2000/svg", width: "29", height: "31", viewBox: "0 0 29 31" }, h("g", { id: "event", transform: "translate(9 10)" }, h("rect", { id: "Icon", width: "23.541", height: "4.265", transform: "translate(-5.929 -4.418)", fill: "currentColor", opacity: "0.5" }), h("path", { id: "Icon-2", "data-name": "Icon", d: "M638.778,275H616.222A3.163,3.163,0,0,1,613,271.9l.016-21.7a3.162,3.162,0,0,1,3.206-3.1h1.611V244h3.222v3.1h12.889V244h3.222v3.1h1.611A3.163,3.163,0,0,1,642,250.2v21.7A3.163,3.163,0,0,1,638.778,275Zm-22.556-18.6v15.5h22.556V256.4Zm0-6.2v3.1h22.556v-3.1Zm19.333,18.6H627.5v-7.75h8.056Z", transform: "translate(-622 -254)", fill: "currentColor" })));
  }
};
BhtpUiIconCalendar.style = materialIconComponentCss$2;

const materialIconComponentCss$1 = ":host{display:block}";

let BhtpUiIconHelpOutline = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return h("svg", { id: "Icon_material-help-outline", "data-name": "Icon material-help-outline", xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, h("path", { id: "Icon_material-help-outline-2", "data-name": "Icon material-help-outline", d: "M13.8,22.2h2.4V19.8H13.8ZM15,3A12,12,0,1,0,27,15,12,12,0,0,0,15,3Zm0,21.6A9.6,9.6,0,1,1,24.6,15,9.613,9.613,0,0,1,15,24.6ZM15,7.8a4.8,4.8,0,0,0-4.8,4.8h2.4a2.4,2.4,0,0,1,4.8,0c0,2.4-3.6,2.1-3.6,6h2.4c0-2.7,3.6-3,3.6-6A4.8,4.8,0,0,0,15,7.8Z", transform: "translate(-3 -3)", fill: "currentColor" }), h("path", { id: "Path_5967", "data-name": "Path 5967", d: "M13.6,4a9.6,9.6,0,1,0,9.6,9.6A9.611,9.611,0,0,0,13.6,4Zm1.2,16.8H12.4V18.4h2.4Zm0-3.6H12.4c0-3.9,3.6-3.6,3.6-6a2.4,2.4,0,1,0-4.8,0H8.8a4.8,4.8,0,0,1,9.6,0C18.4,14.2,14.8,14.5,14.8,17.2Z", transform: "translate(-1.601 -1.6)", fill: "currentColor", opacity: "0.2" }));
  }
};
BhtpUiIconHelpOutline.style = materialIconComponentCss$1;

const materialIconComponentCss = ":host{display:block}";

let BhtpUiX = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return h("svg", { id: "icon_x", xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, h("g", { id: "x" }, h("path", { id: "x1", d: "M0 0h24v24H0z", fill: "none" }), h("path", { id: "x2", d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" })));
  }
};
BhtpUiX.style = materialIconComponentCss;

/*!
* tabbable 5.2.1
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var candidateSelectors = ['input', 'select', 'textarea', 'a[href]', 'button', '[tabindex]', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])', 'details>summary:first-of-type', 'details'];
var candidateSelector = /* #__PURE__ */candidateSelectors.join(',');
var matches = typeof Element === 'undefined' ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;

var getCandidates = function getCandidates(el, includeContainer, filter) {
  var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));

  if (includeContainer && matches.call(el, candidateSelector)) {
    candidates.unshift(el);
  }

  candidates = candidates.filter(filter);
  return candidates;
};

var isContentEditable = function isContentEditable(node) {
  return node.contentEditable === 'true';
};

var getTabindex = function getTabindex(node) {
  var tabindexAttr = parseInt(node.getAttribute('tabindex'), 10);

  if (!isNaN(tabindexAttr)) {
    return tabindexAttr;
  } // Browsers do not return `tabIndex` correctly for contentEditable nodes;
  // so if they don't have a tabindex attribute specifically set, assume it's 0.


  if (isContentEditable(node)) {
    return 0;
  } // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
  //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
  //  yet they are still part of the regular tab order; in FF, they get a default
  //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
  //  order, consider their tab index to be 0.


  if ((node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) {
    return 0;
  }

  return node.tabIndex;
};

var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};

var isInput = function isInput(node) {
  return node.tagName === 'INPUT';
};

var isHiddenInput = function isHiddenInput(node) {
  return isInput(node) && node.type === 'hidden';
};

var isDetailsWithSummary = function isDetailsWithSummary(node) {
  var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function (child) {
    return child.tagName === 'SUMMARY';
  });
  return r;
};

var getCheckedRadio = function getCheckedRadio(nodes, form) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked && nodes[i].form === form) {
      return nodes[i];
    }
  }
};

var isTabbableRadio = function isTabbableRadio(node) {
  if (!node.name) {
    return true;
  }

  var radioScope = node.form || node.ownerDocument;

  var queryRadios = function queryRadios(name) {
    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
  };

  var radioSet;

  if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') {
    radioSet = queryRadios(window.CSS.escape(node.name));
  } else {
    try {
      radioSet = queryRadios(node.name);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
      return false;
    }
  }

  var checked = getCheckedRadio(radioSet, node.form);
  return !checked || checked === node;
};

var isRadio = function isRadio(node) {
  return isInput(node) && node.type === 'radio';
};

var isNonTabbableRadio = function isNonTabbableRadio(node) {
  return isRadio(node) && !isTabbableRadio(node);
};

var isHidden = function isHidden(node, displayCheck) {
  if (getComputedStyle(node).visibility === 'hidden') {
    return true;
  }

  var isDirectSummary = matches.call(node, 'details>summary:first-of-type');
  var nodeUnderDetails = isDirectSummary ? node.parentElement : node;

  if (matches.call(nodeUnderDetails, 'details:not([open]) *')) {
    return true;
  }

  if (!displayCheck || displayCheck === 'full') {
    while (node) {
      if (getComputedStyle(node).display === 'none') {
        return true;
      }

      node = node.parentElement;
    }
  } else if (displayCheck === 'non-zero-area') {
    var _node$getBoundingClie = node.getBoundingClientRect(),
        width = _node$getBoundingClie.width,
        height = _node$getBoundingClie.height;

    return width === 0 && height === 0;
  }

  return false;
}; // form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset


var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
  if (isInput(node) || node.tagName === 'SELECT' || node.tagName === 'TEXTAREA' || node.tagName === 'BUTTON') {
    var parentNode = node.parentElement;

    while (parentNode) {
      if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
        // look for the first <legend> as an immediate child of the disabled
        //  <fieldset>: if the node is in that legend, it'll be enabled even
        //  though the fieldset is disabled; otherwise, the node is in a
        //  secondary/subsequent legend, or somewhere else within the fieldset
        //  (however deep nested) and it'll be disabled
        for (var i = 0; i < parentNode.children.length; i++) {
          var child = parentNode.children.item(i);

          if (child.tagName === 'LEGEND') {
            if (child.contains(node)) {
              return false;
            } // the node isn't in the first legend (in doc order), so no matter
            //  where it is now, it'll be disabled


            return true;
          }
        } // the node isn't in a legend, so no matter where it is now, it'll be disabled


        return true;
      }

      parentNode = parentNode.parentElement;
    }
  } // else, node's tabbable/focusable state should not be affected by a fieldset's
  //  enabled/disabled state


  return false;
};

var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
  if (node.disabled || isHiddenInput(node) || isHidden(node, options.displayCheck) || // For a details element with a summary, the summary element gets the focus
  isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
    return false;
  }

  return true;
};

var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
  if (!isNodeMatchingSelectorFocusable(options, node) || isNonTabbableRadio(node) || getTabindex(node) < 0) {
    return false;
  }

  return true;
};

var tabbable = function tabbable(el, options) {
  options = options || {};
  var regularTabbables = [];
  var orderedTabbables = [];
  var candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
  candidates.forEach(function (candidate, i) {
    var candidateTabindex = getTabindex(candidate);

    if (candidateTabindex === 0) {
      regularTabbables.push(candidate);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        node: candidate
      });
    }
  });
  var tabbableNodes = orderedTabbables.sort(sortOrderedTabbables).map(function (a) {
    return a.node;
  }).concat(regularTabbables);
  return tabbableNodes;
};

var focusableCandidateSelector = /* #__PURE__ */candidateSelectors.concat('iframe').join(',');

var isFocusable = function isFocusable(node, options) {
  options = options || {};

  if (!node) {
    throw new Error('No node provided');
  }

  if (matches.call(node, focusableCandidateSelector) === false) {
    return false;
  }

  return isNodeMatchingSelectorFocusable(options, node);
};

/*!
* focus-trap 6.7.1
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var activeFocusTraps = function () {
  var trapQueue = [];
  return {
    activateTrap: function activateTrap(trap) {
      if (trapQueue.length > 0) {
        var activeTrap = trapQueue[trapQueue.length - 1];

        if (activeTrap !== trap) {
          activeTrap.pause();
        }
      }

      var trapIndex = trapQueue.indexOf(trap);

      if (trapIndex === -1) {
        trapQueue.push(trap);
      } else {
        // move this existing trap to the front of the queue
        trapQueue.splice(trapIndex, 1);
        trapQueue.push(trap);
      }
    },
    deactivateTrap: function deactivateTrap(trap) {
      var trapIndex = trapQueue.indexOf(trap);

      if (trapIndex !== -1) {
        trapQueue.splice(trapIndex, 1);
      }

      if (trapQueue.length > 0) {
        trapQueue[trapQueue.length - 1].unpause();
      }
    }
  };
}();

var isSelectableInput = function isSelectableInput(node) {
  return node.tagName && node.tagName.toLowerCase() === 'input' && typeof node.select === 'function';
};

var isEscapeEvent = function isEscapeEvent(e) {
  return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
};

var isTabEvent = function isTabEvent(e) {
  return e.key === 'Tab' || e.keyCode === 9;
};

var delay = function delay(fn) {
  return setTimeout(fn, 0);
}; // Array.find/findIndex() are not supported on IE; this replicates enough
//  of Array.findIndex() for our needs


var findIndex = function findIndex(arr, fn) {
  var idx = -1;
  arr.every(function (value, i) {
    if (fn(value)) {
      idx = i;
      return false; // break
    }

    return true; // next
  });
  return idx;
};
/**
 * Get an option's value when it could be a plain value, or a handler that provides
 *  the value.
 * @param {*} value Option's value to check.
 * @param {...*} [params] Any parameters to pass to the handler, if `value` is a function.
 * @returns {*} The `value`, or the handler's returned value.
 */


var valueOrHandler = function valueOrHandler(value) {
  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }

  return typeof value === 'function' ? value.apply(void 0, params) : value;
};

var getActualTarget = function getActualTarget(event) {
  // NOTE: If the trap is _inside_ a shadow DOM, event.target will always be the
  //  shadow host. However, event.target.composedPath() will be an array of
  //  nodes "clicked" from inner-most (the actual element inside the shadow) to
  //  outer-most (the host HTML document). If we have access to composedPath(),
  //  then use its first element; otherwise, fall back to event.target (and
  //  this only works for an _open_ shadow DOM; otherwise,
  //  composedPath()[0] === event.target always).
  return event.target.shadowRoot && typeof event.composedPath === 'function' ? event.composedPath()[0] : event.target;
};

var createFocusTrap = function createFocusTrap(elements, userOptions) {
  var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;

  var config = _objectSpread2({
    returnFocusOnDeactivate: true,
    escapeDeactivates: true,
    delayInitialFocus: true
  }, userOptions);

  var state = {
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying the first and last tabbable nodes in all containers/groups in
    //  the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{ container: HTMLElement, firstTabbableNode: HTMLElement|null, lastTabbableNode: HTMLElement|null }>}
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: false,
    paused: false,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: undefined
  };
  var trap; // eslint-disable-line prefer-const -- some private functions reference it, and its methods reference private functions, so we must declare here and define later

  var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
    return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
  };

  var containersContain = function containersContain(element) {
    return !!(element && state.containers.some(function (container) {
      return container.contains(element);
    }));
  };
  /**
   * Gets the node for the given option, which is expected to be an option that
   *  can be either a DOM node, a string that is a selector to get a node, `false`
   *  (if a node is explicitly NOT given), or a function that returns any of these
   *  values.
   * @param {string} optionName
   * @returns {undefined | false | HTMLElement | SVGElement} Returns
   *  `undefined` if the option is not specified; `false` if the option
   *  resolved to `false` (node explicitly not given); otherwise, the resolved
   *  DOM node.
   * @throws {Error} If the option is set, not `false`, and is not, or does not
   *  resolve to a node.
   */


  var getNodeForOption = function getNodeForOption(optionName) {
    var optionValue = config[optionName];

    if (typeof optionValue === 'function') {
      for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        params[_key2 - 1] = arguments[_key2];
      }

      optionValue = optionValue.apply(void 0, params);
    }

    if (!optionValue) {
      if (optionValue === undefined || optionValue === false) {
        return optionValue;
      } // else, empty string (invalid), null (invalid), 0 (invalid)


      throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
    }

    var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point

    if (typeof optionValue === 'string') {
      node = doc.querySelector(optionValue); // resolve to node, or null if fails

      if (!node) {
        throw new Error("`".concat(optionName, "` as selector refers to no known node"));
      }
    }

    return node;
  };

  var getInitialFocusNode = function getInitialFocusNode() {
    var node = getNodeForOption('initialFocus'); // false explicitly indicates we want no initialFocus at all

    if (node === false) {
      return false;
    }

    if (node === undefined) {
      // option not specified: use fallback options
      if (containersContain(doc.activeElement)) {
        node = doc.activeElement;
      } else {
        var firstTabbableGroup = state.tabbableGroups[0];
        var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode; // NOTE: `fallbackFocus` option function cannot return `false` (not supported)

        node = firstTabbableNode || getNodeForOption('fallbackFocus');
      }
    }

    if (!node) {
      throw new Error('Your focus-trap needs to have at least one focusable element');
    }

    return node;
  };

  var updateTabbableNodes = function updateTabbableNodes() {
    state.tabbableGroups = state.containers.map(function (container) {
      var tabbableNodes = tabbable(container);

      if (tabbableNodes.length > 0) {
        return {
          container: container,
          firstTabbableNode: tabbableNodes[0],
          lastTabbableNode: tabbableNodes[tabbableNodes.length - 1]
        };
      }

      return undefined;
    }).filter(function (group) {
      return !!group;
    }); // remove groups with no tabbable nodes
    // throw if no groups have tabbable nodes and we don't have a fallback focus node either

    if (state.tabbableGroups.length <= 0 && !getNodeForOption('fallbackFocus') // returning false not supported for this option
    ) {
      throw new Error('Your focus-trap must have at least one container with at least one tabbable node in it at all times');
    }
  };

  var tryFocus = function tryFocus(node) {
    if (node === false) {
      return;
    }

    if (node === doc.activeElement) {
      return;
    }

    if (!node || !node.focus) {
      tryFocus(getInitialFocusNode());
      return;
    }

    node.focus({
      preventScroll: !!config.preventScroll
    });
    state.mostRecentlyFocusedNode = node;

    if (isSelectableInput(node)) {
      node.select();
    }
  };

  var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
    var node = getNodeForOption('setReturnFocus', previousActiveElement);
    return node ? node : node === false ? false : previousActiveElement;
  }; // This needs to be done on mousedown and touchstart instead of click
  // so that it precedes the focus event.


  var checkPointerDown = function checkPointerDown(e) {
    var target = getActualTarget(e);

    if (containersContain(target)) {
      // allow the click since it ocurred inside the trap
      return;
    }

    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      // immediately deactivate the trap
      trap.deactivate({
        // if, on deactivation, we should return focus to the node originally-focused
        //  when the trap was activated (or the configured `setReturnFocus` node),
        //  then assume it's also OK to return focus to the outside node that was
        //  just clicked, causing deactivation, as long as that node is focusable;
        //  if it isn't focusable, then return focus to the original node focused
        //  on activation (or the configured `setReturnFocus` node)
        // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
        //  which will result in the outside click setting focus to the node
        //  that was clicked, whether it's focusable or not; by setting
        //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
        //  on activation (or the configured `setReturnFocus` node)
        returnFocus: config.returnFocusOnDeactivate && !isFocusable(target)
      });
      return;
    } // This is needed for mobile devices.
    // (If we'll only let `click` events through,
    // then on mobile they will be blocked anyways if `touchstart` is blocked.)


    if (valueOrHandler(config.allowOutsideClick, e)) {
      // allow the click outside the trap to take place
      return;
    } // otherwise, prevent the click


    e.preventDefault();
  }; // In case focus escapes the trap for some strange reason, pull it back in.


  var checkFocusIn = function checkFocusIn(e) {
    var target = getActualTarget(e);
    var targetContained = containersContain(target); // In Firefox when you Tab out of an iframe the Document is briefly focused.

    if (targetContained || target instanceof Document) {
      if (targetContained) {
        state.mostRecentlyFocusedNode = target;
      }
    } else {
      // escaped! pull it back in to where it just left
      e.stopImmediatePropagation();
      tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
    }
  }; // Hijack Tab events on the first and last focusable nodes of the trap,
  // in order to prevent focus from escaping. If it escapes for even a
  // moment it can end up scrolling the page and causing confusion so we
  // kind of need to capture the action at the keydown phase.


  var checkTab = function checkTab(e) {
    var target = getActualTarget(e);
    updateTabbableNodes();
    var destinationNode = null;

    if (state.tabbableGroups.length > 0) {
      // make sure the target is actually contained in a group
      // NOTE: the target may also be the container itself if it's tabbable
      //  with tabIndex='-1' and was given initial focus
      var containerIndex = findIndex(state.tabbableGroups, function (_ref) {
        var container = _ref.container;
        return container.contains(target);
      });

      if (containerIndex < 0) {
        // target not found in any group: quite possible focus has escaped the trap,
        //  so bring it back in to...
        if (e.shiftKey) {
          // ...the last node in the last group
          destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
        } else {
          // ...the first node in the first group
          destinationNode = state.tabbableGroups[0].firstTabbableNode;
        }
      } else if (e.shiftKey) {
        // REVERSE
        // is the target the first tabbable node in a group?
        var startOfGroupIndex = findIndex(state.tabbableGroups, function (_ref2) {
          var firstTabbableNode = _ref2.firstTabbableNode;
          return target === firstTabbableNode;
        });

        if (startOfGroupIndex < 0 && state.tabbableGroups[containerIndex].container === target) {
          // an exception case where the target is the container itself, in which
          //  case, we should handle shift+tab as if focus were on the container's
          //  first tabbable node, and go to the last tabbable node of the LAST group
          startOfGroupIndex = containerIndex;
        }

        if (startOfGroupIndex >= 0) {
          // YES: then shift+tab should go to the last tabbable node in the
          //  previous group (and wrap around to the last tabbable node of
          //  the LAST group if it's the first tabbable node of the FIRST group)
          var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
          var destinationGroup = state.tabbableGroups[destinationGroupIndex];
          destinationNode = destinationGroup.lastTabbableNode;
        }
      } else {
        // FORWARD
        // is the target the last tabbable node in a group?
        var lastOfGroupIndex = findIndex(state.tabbableGroups, function (_ref3) {
          var lastTabbableNode = _ref3.lastTabbableNode;
          return target === lastTabbableNode;
        });

        if (lastOfGroupIndex < 0 && state.tabbableGroups[containerIndex].container === target) {
          // an exception case where the target is the container itself, in which
          //  case, we should handle tab as if focus were on the container's
          //  last tabbable node, and go to the first tabbable node of the FIRST group
          lastOfGroupIndex = containerIndex;
        }

        if (lastOfGroupIndex >= 0) {
          // YES: then tab should go to the first tabbable node in the next
          //  group (and wrap around to the first tabbable node of the FIRST
          //  group if it's the last tabbable node of the LAST group)
          var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;

          var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
          destinationNode = _destinationGroup.firstTabbableNode;
        }
      }
    } else {
      // NOTE: the fallbackFocus option does not support returning false to opt-out
      destinationNode = getNodeForOption('fallbackFocus');
    }

    if (destinationNode) {
      e.preventDefault();
      tryFocus(destinationNode);
    } // else, let the browser take care of [shift+]tab and move the focus

  };

  var checkKey = function checkKey(e) {
    if (isEscapeEvent(e) && valueOrHandler(config.escapeDeactivates, e) !== false) {
      e.preventDefault();
      trap.deactivate();
      return;
    }

    if (isTabEvent(e)) {
      checkTab(e);
      return;
    }
  };

  var checkClick = function checkClick(e) {
    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      return;
    }

    var target = getActualTarget(e);

    if (containersContain(target)) {
      return;
    }

    if (valueOrHandler(config.allowOutsideClick, e)) {
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();
  }; //
  // EVENT LISTENERS
  //


  var addListeners = function addListeners() {
    if (!state.active) {
      return;
    } // There can be only one listening focus trap at a time


    activeFocusTraps.activateTrap(trap); // Delay ensures that the focused element doesn't capture the event
    // that caused the focus trap activation.

    state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function () {
      tryFocus(getInitialFocusNode());
    }) : tryFocus(getInitialFocusNode());
    doc.addEventListener('focusin', checkFocusIn, true);
    doc.addEventListener('mousedown', checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener('touchstart', checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener('click', checkClick, {
      capture: true,
      passive: false
    });
    doc.addEventListener('keydown', checkKey, {
      capture: true,
      passive: false
    });
    return trap;
  };

  var removeListeners = function removeListeners() {
    if (!state.active) {
      return;
    }

    doc.removeEventListener('focusin', checkFocusIn, true);
    doc.removeEventListener('mousedown', checkPointerDown, true);
    doc.removeEventListener('touchstart', checkPointerDown, true);
    doc.removeEventListener('click', checkClick, true);
    doc.removeEventListener('keydown', checkKey, true);
    return trap;
  }; //
  // TRAP DEFINITION
  //


  trap = {
    activate: function activate(activateOptions) {
      if (state.active) {
        return this;
      }

      var onActivate = getOption(activateOptions, 'onActivate');
      var onPostActivate = getOption(activateOptions, 'onPostActivate');
      var checkCanFocusTrap = getOption(activateOptions, 'checkCanFocusTrap');

      if (!checkCanFocusTrap) {
        updateTabbableNodes();
      }

      state.active = true;
      state.paused = false;
      state.nodeFocusedBeforeActivation = doc.activeElement;

      if (onActivate) {
        onActivate();
      }

      var finishActivation = function finishActivation() {
        if (checkCanFocusTrap) {
          updateTabbableNodes();
        }

        addListeners();

        if (onPostActivate) {
          onPostActivate();
        }
      };

      if (checkCanFocusTrap) {
        checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
        return this;
      }

      finishActivation();
      return this;
    },
    deactivate: function deactivate(deactivateOptions) {
      if (!state.active) {
        return this;
      }

      clearTimeout(state.delayInitialFocusTimer); // noop if undefined

      state.delayInitialFocusTimer = undefined;
      removeListeners();
      state.active = false;
      state.paused = false;
      activeFocusTraps.deactivateTrap(trap);
      var onDeactivate = getOption(deactivateOptions, 'onDeactivate');
      var onPostDeactivate = getOption(deactivateOptions, 'onPostDeactivate');
      var checkCanReturnFocus = getOption(deactivateOptions, 'checkCanReturnFocus');

      if (onDeactivate) {
        onDeactivate();
      }

      var returnFocus = getOption(deactivateOptions, 'returnFocus', 'returnFocusOnDeactivate');

      var finishDeactivation = function finishDeactivation() {
        delay(function () {
          if (returnFocus) {
            tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
          }

          if (onPostDeactivate) {
            onPostDeactivate();
          }
        });
      };

      if (returnFocus && checkCanReturnFocus) {
        checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
        return this;
      }

      finishDeactivation();
      return this;
    },
    pause: function pause() {
      if (state.paused || !state.active) {
        return this;
      }

      state.paused = true;
      removeListeners();
      return this;
    },
    unpause: function unpause() {
      if (!state.paused || !state.active) {
        return this;
      }

      state.paused = false;
      updateTabbableNodes();
      addListeners();
      return this;
    },
    updateContainerElements: function updateContainerElements(containerElements) {
      var elementsAsArray = [].concat(containerElements).filter(Boolean);
      state.containers = elementsAsArray.map(function (element) {
        return typeof element === 'string' ? doc.querySelector(element) : element;
      });

      if (state.active) {
        updateTabbableNodes();
      }

      return this;
    }
  }; // initialize container elements

  trap.updateContainerElements(elements);
  return trap;
};

const modalComponentCss = ":host{display:block;font-family:var(--bhtp-ui-primary-font-family)}.bhtp-ui-modal-backdrop{position:fixed;top:0;left:0;z-index:2;width:100%;height:100%;display:flex;justify-content:center;align-items:center;background-color:rgba(0, 0, 0, 0.3)}.bhtp-ui-modal-backdrop .bhtp-ui-modal{position:relative;display:flex;flex-direction:column;font-family:var(--bhtp-ui-secondary-font-family);font-size:var(--bhtp-ui-reduced-font-size);background-color:var(--bhtp-ui-white-color);border:2px solid var(--bhtp-ui-text-primary-color);margin:2rem;padding:2rem;width:50%}.bhtp-ui-modal-buttons{padding-top:2.5rem;width:250px;margin-right:auto;margin-left:auto}@media (max-width: 599px){.bhtp-ui-modal-backdrop .bhtp-ui-modal{width:100%;margin:.5rem}}.bhtp-ui-modal-backdrop .bhtp-ui-modal .bhtp-ui-modal__title{font-family:Open Sans, ui-sans-serif, system-ui;font-size:2.25rem;text-align:center;width:100%;display:block;color:var(--bhtp-ui-primary-color);margin:0 0 1rem}.bhtp-ui-modal-backdrop .bhtp-ui-modal .bhtp-ui-modal__message{color:var(--bhtp-ui-text-primary-color);font-family:Open Sans, ui-sans-serif, system-ui;font-size:1.25rem}.bhtp-ui-modal-backdrop .bhtp-ui-modal bhtp-ui-button{margin-top:2rem}.bhtp-ui-modal-backdrop .bhtp-ui-modal bhtp-ui-button button{width:100%;font-size:var(--bhtp-ui-reduced-font-size)}.bhtp-ui-modal-backdrop .bhtp-ui-modal bhtp-ui-icon{display:flex;justify-content:center;align-items:center;font-size:var(--bhtp-ui-standard-font-size);margin-left:auto;width:2rem;height:2rem}.bhtp-ui-modal-close{position:absolute;top:0;right:0;padding:5px;margin:1px}.bhtp-ui-modal-close:hover{color:var(--bhtp-ui-text-primary-dark-color)}";

let Modal = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.modalClose = createEvent(this, "modalClose", 7);
    this.modalTitle = 'More Information';
    this.content = undefined;
    // if not using focus trap, the user can focus on elements outside the modal
    // eslint-disable-next-line @stencil-community/ban-default-true
    this.useFocusTrap = true;
    this.onKeyUp = (event) => {
      if (event.key === 'Escape' || event.keyCode === KeyCodes.ESCAPE) {
        this.closeModal();
      }
    };
  }
  get modalTitleId() {
    return `${this.modalId}-title`;
  }
  get modalMessageId() {
    return `${this.modalId}-message`;
  }
  componentWillLoad() {
    document.addEventListener('keyup', this.onKeyUp);
  }
  componentDidRender() {
    var _a;
    if (this.useFocusTrap) {
      setTimeout(() => {
        // Ackbar would be proud
        this.modalFocusTrap = createFocusTrap(this.backdropElement, { escapeDeactivates: false });
        this.modalFocusTrap.activate();
      }, 0);
    }
    if (this.content) {
      // Render modal content
      (_a = this.modal.querySelector('#modal-content')) === null || _a === void 0 ? void 0 : _a.appendChild(this.content);
    }
  }
  disconnectedCallback() {
    document.removeEventListener('keyup', this.onKeyUp);
    if (this.useFocusTrap) {
      this.modalFocusTrap.deactivate();
    }
  }
  render() {
    return (h("div", { class: "bhtp-ui-modal-backdrop", onClick: (event) => this.onBackdropClick(event), ref: (element) => this.backdropElement = element }, h("div", { id: this.modalId, class: "bhtp-ui-modal", role: "dialog", "aria-labelledby": this.modalTitleId, "aria-describedby": this.modalMessageId, "aria-modal": "true" }, h("bhtp-ui-icon-x", { class: "bhtp-ui-modal-close", slot: "button-icon", tabIndex: 1, onClick: () => this.onCloseClick(), onKeyDown: (event) => this.handleKeyDown(event) }), h("h2", { id: this.modalTitleId, class: "bhtp-ui-modal__title" }, this.modalTitle), h("div", { id: this.modalMessageId, class: "bhtp-ui-modal__message" }, this.message), h("div", { id: "modal-content" }), this.content === undefined &&
      h("div", { class: "bhtp-ui-modal-buttons" }, h("bhtp-ui-button", { tabIndex: 1, buttonType: "button", styleType: "success", text: "Okay", onClick: () => this.onOkClick(), onKeyDown: (event) => this.handleKeyDown(event) })))));
  }
  onCloseClick() {
    this.closeModal();
  }
  onBackdropClick(event) {
    // Only fire event if click came from backdrop, not a child
    if (event.target.classList.contains('bhtp-ui-modal-backdrop')) {
      this.closeModal();
    }
  }
  onOkClick() {
    this.closeModal();
  }
  closeModal() {
    if (this.useFocusTrap) {
      this.modalFocusTrap.deactivate();
    }
    this.modalClose.emit();
  }
  handleKeyDown(event) {
    const { keyCode } = event;
    switch (keyCode) {
      case KeyCodes.ENTER:
      case KeyCodes.SPACEBAR:
        event.preventDefault();
        this.closeModal();
        break;
    }
  }
  get modal() { return getElement(this); }
};
Modal.style = modalComponentCss;

const multiSelectDropdownInputComponentCss = ".a11y-hidden{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}.bhtp-ui-form-group__input{display:flex;align-items:center}@media (max-width: 599px){.bhtp-ui-form-group__input{flex-direction:column;align-items:stretch}.bhtp-ui-form-group__input.bhtp-ui-form-group__input--inline{flex-direction:row;align-items:center}.bhtp-ui-form-group__input .bhtp-ui-input{padding:0}.bhtp-ui-form-group__input .bhtp-ui-input-prompt{font-size:var(--bhtp-ui-reduced-font-size)}}.bhtp-ui-form-group__inline{display:flex;align-items:center}.bhtp-ui-input-prompt{color:var(--bhtp-ui-text-primary-color);margin-right:1rem;font-weight:bold}.bhtp-ui-input-prompt--post{margin:0 0 0 1rem}.bhtp-ui-input-prompt--center{margin:0 1rem}.bhtp-ui-input-prompt,.bhtp-ui-input{font-size:var(--bhtp-ui-standard-font-size)}.bhtp-ui-input-prompt-tooltip{margin-left:-1rem}.bhtp-ui-input{border:none;border-radius:0;border-bottom:1px solid var(--bhtp-ui-text-secondary-color);font-family:var(--bhtp-ui-primary-font-family);color:var(--bhtp-ui-text-input-color);background-color:transparent;padding:0 0.75rem 0.5rem;outline:none;box-sizing:border-box}.bhtp-ui-input::-moz-placeholder{color:var(--bhtp-ui-text-secondary-color);text-transform:lowercase;overflow:visible}.bhtp-ui-input:-ms-input-placeholder{color:var(--bhtp-ui-text-secondary-color);text-transform:lowercase;overflow:visible}.bhtp-ui-input::placeholder{color:var(--bhtp-ui-text-secondary-color);text-transform:lowercase;overflow:visible}@media (max-width: 599px){.bhtp-ui-input::-moz-placeholder{font-size:1rem}.bhtp-ui-input:-ms-input-placeholder{font-size:1rem}.bhtp-ui-input::placeholder{font-size:1rem}}.bhtp-ui-input.bhtp-ui-input--invalid{color:var(--bhtp-ui-danger-color)}.bhtp-ui-input.bhtp-ui-input--clear-right{padding-right:0}.bhtp-ui-icon-input{display:flex;align-items:stretch;border-bottom:1px solid var(--bhtp-ui-text-secondary-color);position:relative}.bhtp-ui-icon-input .bhtp-ui-input{border-bottom:none}.bhtp-ui-icon-input>bhtp-ui-icon{display:flex;align-items:center}.bhtp-ui-icon-input>bhtp-ui-icon i{color:var(--bhtp-ui-text-secondary-color)}@media (max-width: 599px){.bhtp-ui-icon-input>bhtp-ui-icon{margin-right:0.5rem}}button>bhtp-ui-icon{outline:none}.bhtp-ui-form-label-tooltip{display:flex;align-items:center}@media (max-width: 599px){.bhtp-ui-hide-only-mobile{display:none}.bhtp-ui-form-group.bhtp-ui-show-only-mobile{display:flex}}@media (min-width: 599px){.bhtp-ui-hide-only-mobile{display:flex}.bhtp-ui-form-group.bhtp-ui-show-only-mobile{display:none}}.bhtp-ui-multi-select-dropdown-input{position:relative}.bhtp-ui-multi-select-dropdown-input .bhtp-ui-multi-select-dropdown-menu{display:flex;flex-direction:column;align-items:flex-start;padding:0;margin:0;list-style:none;position:absolute;left:0;right:0;z-index:100;background-color:var(--bhtp-ui-white-color);border:1px solid var(--bhtp-ui-text-secondary-color);border-top:none;border-radius:0 0 5px 5px}.bhtp-ui-multi-select-dropdown-input .bhtp-ui-multi-select-dropdown-menu--allow-hover .bhtp-ui-multi-select-dropdown-item:hover{background-color:rgba(54, 79, 120, 0.2)}.bhtp-ui-multi-select-dropdown-input .bhtp-ui-multi-select-dropdown-item{border:none;width:100%}.bhtp-ui-multi-select-dropdown-input .bhtp-ui-multi-select-dropdown-item button{text-align:left;outline:none;border:none;color:var(--bhtp-ui-text-primary-color);font-family:var(--bhtp-ui-primary-font-family);font-size:var(--bhtp-ui-standard-font-size);width:100%;padding:0.25rem 0.5rem;background-color:transparent}.bhtp-ui-multi-select-dropdown-input .bhtp-ui-multi-select-dropdown-item.bhtp-ui-multi-select-dropdown-item--active{background-color:rgba(54, 79, 120, 0.2)}:host{display:block;font-family:var(--bhtp-ui-primary-font-family)}.bhtp-ui-multi-select-dropdown-input{display:flex;align-items:stretch;border-bottom:1px solid var(--bhtp-ui-text-secondary-color);position:relative;flex-grow:1}.bhtp-ui-multi-select-dropdown-input .bhtp-ui-input{width:100%;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border-bottom:none;text-overflow:ellipsis}.bhtp-ui-multi-select-dropdown-input .bhtp-ui-multi-select-dropdown-menu{top:calc(100% + 1px)}.bhtp-ui-multi-select-dropdown-input:focus-within{border-bottom:1px solid var(--bhtp-ui-primary-color)}bhtp-ui-icon.dropdown-icon{display:flex;align-items:center;cursor:pointer}bhtp-ui-icon.dropdown-icon i{color:var(--bhtp-ui-text-secondary-color)}.bhtp-ui-multi-select-dropdown-item button{display:flex;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.bhtp-ui-multi-select-dropdown-item button i{margin-right:0.5rem;width:1rem}";

let MultiSelectDropdownInput = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.itemsSelected = createEvent(this, "itemsSelected", 7);
    this.activeIndex = -1;
    this.selectedOptions = [];
    this.documentClickEventHandler = (event) => {
      var _a;
      if (!((_a = this.hostElement.shadowRoot) === null || _a === void 0 ? void 0 : _a.contains(event.composedPath()[0]))) {
        this.handleClose();
      }
    };
  }
  get listboxId() {
    return `${this.inputId}--listbox`;
  }
  get allowHoverClass() {
    return `bhtp-ui-multi-select-dropdown-menu--allow-hover`;
  }
  async focusInput() {
    this.inputRef.scrollIntoView({ block: "center" });
    setTimeout(() => {
      this.inputRef.focus();
    }, 100);
  }
  componentWillLoad() {
    if (this.value && this.value.length > 0) {
      this.text = this.value.join(', ');
    }
    this.createSelectedOptions(this.options);
  }
  render() {
    return (h("div", { class: "bhtp-ui-form-group__input" }, h("div", { class: "bhtp-ui-form-label-tooltip" }, h("span", { class: "bhtp-ui-input-prompt" }, this.prompt), h("label", { class: "a11y-hidden", htmlFor: this.inputId }, this.description), h("slot", { name: "prompt-tooltip" })), h("div", { class: `bhtp-ui-multi-select-dropdown-input ${this.hasFocus ? 'bhtp-ui-input__focused' : ''}`, role: "combobox", "aria-expanded": this.hasFocus, "aria-owns": this.listboxId, "aria-haspopup": "listbox" }, h("input", { id: this.inputId, class: "bhtp-ui-input", readonly: true, ref: (element) => this.inputRef = element, "aria-controls": this.listboxId, "aria-activedescendant": `suggestion-${this.activeIndex}`, "aria-required": (this.required === true).toString(), "aria-invalid": (this.isValid === false).toString(), onKeyDown: (event) => this.handleKeyDown(event), onBlur: (event) => this.handleBlur(event), placeholder: this.placeholder, value: this.text, onFocus: () => this.handleFocus() }), h("bhtp-ui-icon", { class: "dropdown-icon", iconName: "fa-chevron-down", onClick: (e) => this.handleIconClick(e) }), this.hasFocus &&
      h("ul", { id: this.listboxId, class: "bhtp-ui-multi-select-dropdown-menu", role: "listbox", onMouseMove: event => this.handleOptionsMouseMove(event) }, this.selectedOptions.map((option, index) => (h("li", { id: `suggestion-${index}`, class: `bhtp-ui-multi-select-dropdown-item` + (this.activeIndex == index ? (" " + `bhtp-ui-multi-select-dropdown-item--active`) : ""), key: index, role: "option", "data-value": option.value, "aria-selected": option.selected, onMouseMove: () => this.activeIndex = index }, h("button", { onClick: (event) => this.handleSelect(event, index), tabIndex: -1, type: "button" }, option.selected ?
        h("bhtp-ui-icon", { iconName: "fa-check-square" }) :
        h("bhtp-ui-icon", { iconName: "fa-square-o" }), option.value))))))));
  }
  handleSelect(event, selectedIndex) {
    event.preventDefault();
    if (selectedIndex >= 0 && selectedIndex < this.selectedOptions.length) {
      event.stopPropagation();
      const currentSelectedOptions = [...this.selectedOptions];
      currentSelectedOptions[selectedIndex].selected = !currentSelectedOptions[selectedIndex].selected;
      this.selectedOptions = currentSelectedOptions;
      const selectedOptionsValues = this.selectedOptions
        .filter((option) => option.selected)
        .map((option) => (option.value));
      this.text = selectedOptionsValues.join(', ');
      this.itemsSelected.emit(selectedOptionsValues);
      // Return focus to input so that arrow keys continue to function
      this.inputRef.focus();
    }
  }
  handleIconClick(e) {
    e.stopPropagation();
    if (this.hasFocus) {
      this.handleClose();
    }
    else {
      this.handleFocus();
    }
  }
  handleFocus() {
    if (!this.hasFocus) {
      this.hasFocus = true;
      document.addEventListener('click', this.documentClickEventHandler);
    }
  }
  handleBlur(event) {
    var _a;
    const hostContainsNewFocusedElement = (!((_a = this.hostElement.shadowRoot) === null || _a === void 0 ? void 0 : _a.contains(event.composedPath()[0]))) ||
      (isInternetExplorer11() && !this.hostElement.contains(document.activeElement));
    if (hostContainsNewFocusedElement) {
      this.handleClose();
    }
  }
  handleKeyDown(event) {
    const { keyCode } = event;
    switch (keyCode) {
      case KeyCodes.ARROW_UP:
      case KeyCodes.ARROW_DOWN:
        event.preventDefault();
        this.handleActivation(keyCode === KeyCodes.ARROW_DOWN);
        break;
      case KeyCodes.ENTER:
      case KeyCodes.SPACEBAR:
        event.preventDefault();
        this.handleSelect(event, this.activeIndex);
        break;
      case KeyCodes.ESCAPE:
      case KeyCodes.TAB:
        this.handleClose();
        break;
    }
  }
  handleActivation(next = true) {
    var _a;
    if (this.options && this.options.length > 0) {
      const optionsElement = (_a = this.hostElement.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(`#${this.listboxId}`);
      if (optionsElement) {
        optionsElement.classList.remove(this.allowHoverClass);
      }
      if (next && (this.activeIndex + 1) < this.options.length) {
        this.activeIndex += 1;
      }
      else if (next) {
        this.activeIndex = 0;
      }
      else if (!next && (this.activeIndex) > 0) {
        this.activeIndex -= 1;
      }
      else if (!next) {
        this.activeIndex = this.options.length - 1;
      }
    }
  }
  handleOptionsMouseMove(mouseEvent) {
    const ulElement = mouseEvent.target;
    ulElement.classList.add(this.allowHoverClass);
    const activeElement = ulElement.querySelector('.bhtp-ui-multi-select-dropdown-item--active');
    if (activeElement) {
      activeElement.classList.toggle('bhtp-ui-multi-select-dropdown-item--active');
    }
  }
  createSelectedOptions(options) {
    this.selectedOptions = options ?
      options.map((value) => ({ value, selected: Boolean(this.value && this.value.some(v => v === value)) })) :
      [];
  }
  handleClose() {
    this.hasFocus = false;
    this.activeIndex = -1;
    document.removeEventListener('click', this.documentClickEventHandler);
  }
  get hostElement() { return getElement(this); }
};
MultiSelectDropdownInput.style = multiSelectDropdownInputComponentCss;

const numberInputComponentCss = ".a11y-hidden{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}.bhtp-ui-form-group__input{display:flex;align-items:center}@media (max-width: 599px){.bhtp-ui-form-group__input{flex-direction:column;align-items:stretch}.bhtp-ui-form-group__input.bhtp-ui-form-group__input--inline{flex-direction:row;align-items:center}.bhtp-ui-form-group__input .bhtp-ui-input{padding:0}.bhtp-ui-form-group__input .bhtp-ui-input-prompt{font-size:var(--bhtp-ui-reduced-font-size)}}.bhtp-ui-form-group__inline{display:flex;align-items:center}.bhtp-ui-input-prompt{color:var(--bhtp-ui-text-primary-color);margin-right:1rem;font-weight:bold}.bhtp-ui-input-prompt--post{margin:0 0 0 1rem}.bhtp-ui-input-prompt--center{margin:0 1rem}.bhtp-ui-input-prompt,.bhtp-ui-input{font-size:var(--bhtp-ui-standard-font-size)}.bhtp-ui-input-prompt-tooltip{margin-left:-1rem}.bhtp-ui-input{border:none;border-radius:0;border-bottom:1px solid var(--bhtp-ui-text-secondary-color);font-family:var(--bhtp-ui-primary-font-family);color:var(--bhtp-ui-text-input-color);background-color:transparent;padding:0 0.75rem 0.5rem;outline:none;box-sizing:border-box}.bhtp-ui-input::-moz-placeholder{color:var(--bhtp-ui-text-secondary-color);text-transform:lowercase;overflow:visible}.bhtp-ui-input:-ms-input-placeholder{color:var(--bhtp-ui-text-secondary-color);text-transform:lowercase;overflow:visible}.bhtp-ui-input::placeholder{color:var(--bhtp-ui-text-secondary-color);text-transform:lowercase;overflow:visible}@media (max-width: 599px){.bhtp-ui-input::-moz-placeholder{font-size:1rem}.bhtp-ui-input:-ms-input-placeholder{font-size:1rem}.bhtp-ui-input::placeholder{font-size:1rem}}.bhtp-ui-input.bhtp-ui-input--invalid{color:var(--bhtp-ui-danger-color)}.bhtp-ui-input.bhtp-ui-input--clear-right{padding-right:0}.bhtp-ui-icon-input{display:flex;align-items:stretch;border-bottom:1px solid var(--bhtp-ui-text-secondary-color);position:relative}.bhtp-ui-icon-input .bhtp-ui-input{border-bottom:none}.bhtp-ui-icon-input>bhtp-ui-icon{display:flex;align-items:center}.bhtp-ui-icon-input>bhtp-ui-icon i{color:var(--bhtp-ui-text-secondary-color)}@media (max-width: 599px){.bhtp-ui-icon-input>bhtp-ui-icon{margin-right:0.5rem}}button>bhtp-ui-icon{outline:none}.bhtp-ui-form-label-tooltip{display:flex;align-items:center}@media (max-width: 599px){.bhtp-ui-hide-only-mobile{display:none}.bhtp-ui-form-group.bhtp-ui-show-only-mobile{display:flex}}@media (min-width: 599px){.bhtp-ui-hide-only-mobile{display:flex}.bhtp-ui-form-group.bhtp-ui-show-only-mobile{display:none}}:host{display:block;font-family:var(--bhtp-ui-primary-font-family)}input{box-shadow:none}input[type=\"number\"]::-webkit-inner-spin-button,input[type=\"number\"]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=\"number\"]{-moz-appearance:textfield}input:disabled{background-color:var(--bhtp-ui-text-input-disabled)}.bhtp-ui-steppers{display:flex;flex-direction:column}.bhtp-ui-stepper{background-color:transparent;border:none;font-size:0.5rem;flex-grow:1;padding:0 8px}.bhtp-ui-stepper bhtp-ui-icon i{color:var(--bhtp-ui-text-primary-color)}.bhtp-ui-stepper.disabled bhtp-ui-icon i{color:var(--bhtp-ui-text-secondary-color)}.bhtp-ui-icon-input:focus-within{border-bottom:1px solid var(--bhtp-ui-primary-color)}.bhtp-ui-input-container{display:flex}.bhtp-ui-input-container .bhtp-ui-input{border:none}";

let NumberInput = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.valueChanged = createEvent(this, "valueChanged", 7);
    this.value = 1;
    this.enableSteppers = false;
    // eslint-disable-next-line @stencil-community/ban-default-true
    this.inline = true;
    this.size = 3;
  }
  get allowStepUp() {
    return (this.value !== undefined && this.value !== null &&
      this.maxValue !== undefined && this.maxValue !== null &&
      this.value < this.maxValue);
  }
  get allowStepDown() {
    return (this.value !== undefined && this.value !== null &&
      this.minValue !== undefined && this.minValue !== null &&
      this.value > this.minValue);
  }
  async focusInput() {
    this.inputRef.scrollIntoView({ block: "center" });
    setTimeout(() => {
      this.inputRef.focus();
    }, 100);
  }
  render() {
    return (h("div", { class: `bhtp-ui-form-group__input ${this.inline ? 'bhtp-ui-form-group__input--inline' : ''}` }, h("div", { class: "bhtp-ui-form-label-tooltip" }, h("span", { class: "bhtp-ui-input-prompt" }, this.prePrompt), h("slot", { name: "prompt-tooltip" })), h("div", { class: "bhtp-ui-form-group__inline" }, h("div", { class: "bhtp-ui-icon-input" }, h("label", { class: "a11y-hidden", htmlFor: this.inputId }, this.description), this.iconName && h("bhtp-ui-icon", { iconName: this.iconName }), h("div", { class: "bhtp-ui-input-container" }, h("input", { id: this.inputId, class: `bhtp-ui-input bhtp-ui-input--clear-right${this.isValid === false && this.value ? ' bhtp-ui-input--invalid' : ''}`, type: "number", inputMode: "numeric", min: this.minValue, max: this.maxValue, value: this.value, size: this.size, "aria-required": (this.required === true).toString(), "aria-invalid": (this.isValid === false).toString(), "aria-disabled": (this.disabled === true).toString(), disabled: this.disabled, ref: (element) => this.inputRef = element, onKeyPress: (event) => this.handleKeyPress(event), onInput: (event) => this.handleOnInput(event) }), this.enableSteppers === true ?
      h("div", { class: "bhtp-ui-steppers" }, h("button", { class: `bhtp-ui-stepper bhtp-ui-stepper--up ${this.allowStepUp ? '' : 'disabled'}`, tabIndex: -1, type: "button", "aria-disabled": (this.allowStepUp === false).toString(), onClick: () => this.handleStepUp() }, h("bhtp-ui-icon", { iconName: "fa-chevron-up" })), h("button", { class: `bhtp-ui-stepper bhtp-ui-stepper--down ${this.allowStepDown ? '' : 'disabled'}`, tabIndex: -1, type: "button", "aria-disabled": (this.allowStepDown === false).toString(), onClick: () => this.handleStepDown() }, h("bhtp-ui-icon", { iconName: "fa-chevron-down" }))) : null))), this.postPrompt ?
      h("span", { class: "bhtp-ui-input-prompt bhtp-ui-input-prompt--post" }, this.postPrompt) :
      null));
  }
  handleStepUp() {
    if (this.allowStepUp) {
      this.value = this.value !== null && this.value !== undefined ? ++this.value : 1;
      this.valueChanged.emit(this.value);
    }
  }
  handleStepDown() {
    if (this.allowStepDown) {
      this.value = this.value !== null && this.value !== undefined ? --this.value : 1;
      this.valueChanged.emit(this.value);
    }
  }
  handleKeyPress(event) {
    if (!event.key.match('^[0-9]$')) {
      event.preventDefault();
    }
  }
  handleOnInput(event) {
    var _a;
    this.value = ((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value) || null;
    this.valueChanged.emit(this.value);
  }
};
NumberInput.style = numberInputComponentCss;

class TextInputPhoneMask {
  constructor(inputElement) {
    this.inputElement = inputElement;
    this.ignoreNextInput = false;
    this.handleKeyDown = (event) => {
      switch (event.key) {
        case "Left": // IE/Edge specific value
        case "ArrowLeft":
        case "Right": // IE/Edge specific value
        case "ArrowRight":
        case "Backspace":
        case "Del": // IE/Edge specific value
        case "Delete":
          this.ignoreNextInput = true;
          return;
      }
      if (event.key && event.key !== 'Tab' && !event.key.match(/\d/)) {
        event.preventDefault();
      }
    };
    this.handleInput = () => {
      if (this.ignoreNextInput === true) {
        this.ignoreNextInput = false;
      }
      else {
        let elementValue = this.inputElement.value;
        const cleanValue = elementValue.replace('(', '').replace(')', '').replace('-', '').replace(' ', '');
        // Remove slash if user types it
        if (cleanValue.length < 4) {
          elementValue = `(${cleanValue}`;
        }
        else if (cleanValue.length >= 4 && cleanValue.length < 7) {
          elementValue = `(${cleanValue.substr(0, 3)}) ${cleanValue.substr(3)}`;
        }
        else {
          elementValue = `(${cleanValue.substr(0, 3)}) ${cleanValue.substr(3, 3)}-${cleanValue.substr(6, 4)}`;
        }
        this.inputElement.value = elementValue;
      }
    };
  }
  static mask(inputElement) {
    const mask = new TextInputPhoneMask(inputElement);
    mask.attachListeners();
    return mask;
  }
  attachListeners() {
    this.inputElement.addEventListener('keydown', this.handleKeyDown);
    this.inputElement.addEventListener('input', this.handleInput);
  }
  removeListeners() {
    this.inputElement.removeEventListener('keydown', this.handleKeyDown);
    this.inputElement.removeEventListener('input', this.handleInput);
  }
}

const textInputComponentCss = ".a11y-hidden{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}.bhtp-ui-form-group__input{display:flex;align-items:center}@media (max-width: 599px){.bhtp-ui-form-group__input{flex-direction:column;align-items:stretch}.bhtp-ui-form-group__input.bhtp-ui-form-group__input--inline{flex-direction:row;align-items:center}.bhtp-ui-form-group__input .bhtp-ui-input{padding:0}.bhtp-ui-form-group__input .bhtp-ui-input-prompt{font-size:var(--bhtp-ui-reduced-font-size)}}.bhtp-ui-form-group__inline{display:flex;align-items:center}.bhtp-ui-input-prompt{color:var(--bhtp-ui-text-primary-color);margin-right:1rem;font-weight:bold}.bhtp-ui-input-prompt--post{margin:0 0 0 1rem}.bhtp-ui-input-prompt--center{margin:0 1rem}.bhtp-ui-input-prompt,.bhtp-ui-input{font-size:var(--bhtp-ui-standard-font-size)}.bhtp-ui-input-prompt-tooltip{margin-left:-1rem}.bhtp-ui-input{border:none;border-radius:0;border-bottom:1px solid var(--bhtp-ui-text-secondary-color);font-family:var(--bhtp-ui-primary-font-family);color:var(--bhtp-ui-text-input-color);background-color:transparent;padding:0 0.75rem 0.5rem;outline:none;box-sizing:border-box}.bhtp-ui-input::-moz-placeholder{color:var(--bhtp-ui-text-secondary-color);text-transform:lowercase;overflow:visible}.bhtp-ui-input:-ms-input-placeholder{color:var(--bhtp-ui-text-secondary-color);text-transform:lowercase;overflow:visible}.bhtp-ui-input::placeholder{color:var(--bhtp-ui-text-secondary-color);text-transform:lowercase;overflow:visible}@media (max-width: 599px){.bhtp-ui-input::-moz-placeholder{font-size:1rem}.bhtp-ui-input:-ms-input-placeholder{font-size:1rem}.bhtp-ui-input::placeholder{font-size:1rem}}.bhtp-ui-input.bhtp-ui-input--invalid{color:var(--bhtp-ui-danger-color)}.bhtp-ui-input.bhtp-ui-input--clear-right{padding-right:0}.bhtp-ui-icon-input{display:flex;align-items:stretch;border-bottom:1px solid var(--bhtp-ui-text-secondary-color);position:relative}.bhtp-ui-icon-input .bhtp-ui-input{border-bottom:none}.bhtp-ui-icon-input>bhtp-ui-icon{display:flex;align-items:center}.bhtp-ui-icon-input>bhtp-ui-icon i{color:var(--bhtp-ui-text-secondary-color)}@media (max-width: 599px){.bhtp-ui-icon-input>bhtp-ui-icon{margin-right:0.5rem}}button>bhtp-ui-icon{outline:none}.bhtp-ui-form-label-tooltip{display:flex;align-items:center}@media (max-width: 599px){.bhtp-ui-hide-only-mobile{display:none}.bhtp-ui-form-group.bhtp-ui-show-only-mobile{display:flex}}@media (min-width: 599px){.bhtp-ui-hide-only-mobile{display:flex}.bhtp-ui-form-group.bhtp-ui-show-only-mobile{display:none}}:host{display:block;font-family:var(--bhtp-ui-primary-font-family)}input{text-overflow:ellipsis}input:focus{border-bottom:1px solid var(--bhtp-ui-primary-color)}input:disabled{background-color:var(--bhtp-ui-text-input-disabled)}";

let TextInput = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.valueChanged = createEvent(this, "valueChanged", 7);
    this.value = '';
    this.debounceTime = 300;
  }
  async focusInput() {
    this.inputRef.scrollIntoView({ block: "center" });
    setTimeout(() => {
      this.inputRef.focus();
    }, 100);
  }
  componentWillRender() {
    this.phoneMask && this.phoneMask.removeListeners();
  }
  render() {
    return (h("div", { class: "bhtp-ui-form-group__input" }, h("div", { class: "bhtp-ui-form-label-tooltip" }, h("span", { class: "bhtp-ui-input-prompt" }, this.prompt), h("label", { class: "a11y-hidden", htmlFor: this.inputId }, this.description), h("slot", { name: "prompt-tooltip" })), h("div", { class: "bhtp-ui-input-container" }, h("input", { id: this.inputId, class: `bhtp-ui-input bhtp-ui-input--clear-right${this.isValid === false && this.value ? ' bhtp-ui-input--invalid' : ''}`, style: { 'width': `${this.widthRem}rem`, 'maxWidth': '100%' }, type: "text", inputMode: this.inputMode, value: this.value, placeholder: this.placeholder, "aria-required": (this.required === true).toString(), "aria-invalid": (this.isValid === false).toString(), "aria-disabled": (this.disabled === true).toString(), disabled: this.disabled, ref: (element) => {
        this.inputRef = element;
        this.phoneMask = this.mask === 'phone' ? TextInputPhoneMask.mask(element) : undefined;
      }, onKeyPress: (event) => this.handleKeyPress(event), onInput: (event) => this.handleOnInput(event) }))));
  }
  handleKeyPress(event) {
    if (this.inputPattern && !event.key.match(this.inputPattern)) {
      event.preventDefault();
    }
  }
  handleOnInput(event) {
    this.value = event.target.value;
    if (this.debounce) {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = window.setTimeout(() => {
        this.emitValueChanged();
      }, this.debounceTime);
    }
    else {
      this.emitValueChanged();
    }
  }
  emitValueChanged() {
    var _a;
    this.valueChanged.emit((_a = this.value) !== null && _a !== void 0 ? _a : null);
  }
};
TextInput.style = textInputComponentCss;

const tooltipModalComponentCss = ":host{display:block;font-family:var(--bhtp-ui-primary-font-family)}:host button{border:none;background-color:transparent;outline:none}:host button:hover .info-icon,:host button:focus .info-icon{color:var(--bhtp-ui-primary-color)}:host .info-icon{display:flex;justify-content:center;align-items:center;font-size:var(--bhtp-ui-standard-font-size);margin-left:auto;width:2rem;height:2rem;color:var(--bhtp-ui-secondary-color)}";

let TooltipModal = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return (h("button", { "aria-haspopup": "true", "aria-label": this.ariaLabel, type: "button", ref: (element) => this.buttonRef = element, onKeyDown: (e) => this.handleKeyDown(e, e.keyCode), onClick: (ev) => this.onIconClick(ev) }, h("bhtp-ui-icon-help-outline", { class: "info-icon" })));
  }
  onIconClick(event) {
    if (event) {
      event.preventDefault();
    }
    this.openModal();
  }
  handleKeyDown(event, keyCode) {
    if (keyCode == KeyCodes.ENTER) {
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }
      this.openModal();
    }
  }
  openModal() {
    const modalElement = document.createElement('bhtp-ui-modal');
    modalElement.modalId = this.modalId;
    modalElement.message = this.message;
    modalElement.addEventListener('modalClose', () => {
      modalElement.remove();
      // Return focus to button that opens modal once the modal is dismissed
      this.buttonRef.focus();
    });
    document.body.appendChild(modalElement);
  }
};
TooltipModal.style = tooltipModalComponentCss;

const typeaheadComponentCss = ".a11y-hidden{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}.bhtp-ui-form-group__input{display:flex;align-items:center}@media (max-width: 599px){.bhtp-ui-form-group__input{flex-direction:column;align-items:stretch}.bhtp-ui-form-group__input.bhtp-ui-form-group__input--inline{flex-direction:row;align-items:center}.bhtp-ui-form-group__input .bhtp-ui-input{padding:0}.bhtp-ui-form-group__input .bhtp-ui-input-prompt{font-size:var(--bhtp-ui-reduced-font-size)}}.bhtp-ui-form-group__inline{display:flex;align-items:center}.bhtp-ui-input-prompt{color:var(--bhtp-ui-text-primary-color);margin-right:1rem;font-weight:bold}.bhtp-ui-input-prompt--post{margin:0 0 0 1rem}.bhtp-ui-input-prompt--center{margin:0 1rem}.bhtp-ui-input-prompt,.bhtp-ui-input{font-size:var(--bhtp-ui-standard-font-size)}.bhtp-ui-input-prompt-tooltip{margin-left:-1rem}.bhtp-ui-input{border:none;border-radius:0;border-bottom:1px solid var(--bhtp-ui-text-secondary-color);font-family:var(--bhtp-ui-primary-font-family);color:var(--bhtp-ui-text-input-color);background-color:transparent;padding:0 0.75rem 0.5rem;outline:none;box-sizing:border-box}.bhtp-ui-input::-moz-placeholder{color:var(--bhtp-ui-text-secondary-color);text-transform:lowercase;overflow:visible}.bhtp-ui-input:-ms-input-placeholder{color:var(--bhtp-ui-text-secondary-color);text-transform:lowercase;overflow:visible}.bhtp-ui-input::placeholder{color:var(--bhtp-ui-text-secondary-color);text-transform:lowercase;overflow:visible}@media (max-width: 599px){.bhtp-ui-input::-moz-placeholder{font-size:1rem}.bhtp-ui-input:-ms-input-placeholder{font-size:1rem}.bhtp-ui-input::placeholder{font-size:1rem}}.bhtp-ui-input.bhtp-ui-input--invalid{color:var(--bhtp-ui-danger-color)}.bhtp-ui-input.bhtp-ui-input--clear-right{padding-right:0}.bhtp-ui-icon-input{display:flex;align-items:stretch;border-bottom:1px solid var(--bhtp-ui-text-secondary-color);position:relative}.bhtp-ui-icon-input .bhtp-ui-input{border-bottom:none}.bhtp-ui-icon-input>bhtp-ui-icon{display:flex;align-items:center}.bhtp-ui-icon-input>bhtp-ui-icon i{color:var(--bhtp-ui-text-secondary-color)}@media (max-width: 599px){.bhtp-ui-icon-input>bhtp-ui-icon{margin-right:0.5rem}}button>bhtp-ui-icon{outline:none}.bhtp-ui-form-label-tooltip{display:flex;align-items:center}@media (max-width: 599px){.bhtp-ui-hide-only-mobile{display:none}.bhtp-ui-form-group.bhtp-ui-show-only-mobile{display:flex}}@media (min-width: 599px){.bhtp-ui-hide-only-mobile{display:flex}.bhtp-ui-form-group.bhtp-ui-show-only-mobile{display:none}}.bhtp-ui-multi-select-dropdown-input{position:relative}.bhtp-ui-multi-select-dropdown-input .bhtp-ui-multi-select-dropdown-menu{display:flex;flex-direction:column;align-items:flex-start;padding:0;margin:0;list-style:none;position:absolute;left:0;right:0;z-index:100;background-color:var(--bhtp-ui-white-color);border:1px solid var(--bhtp-ui-text-secondary-color);border-top:none;border-radius:0 0 5px 5px}.bhtp-ui-multi-select-dropdown-input .bhtp-ui-multi-select-dropdown-menu--allow-hover .bhtp-ui-multi-select-dropdown-item:hover{background-color:rgba(54, 79, 120, 0.2)}.bhtp-ui-multi-select-dropdown-input .bhtp-ui-multi-select-dropdown-item{border:none;width:100%}.bhtp-ui-multi-select-dropdown-input .bhtp-ui-multi-select-dropdown-item button{text-align:left;outline:none;border:none;color:var(--bhtp-ui-text-primary-color);font-family:var(--bhtp-ui-primary-font-family);font-size:var(--bhtp-ui-standard-font-size);width:100%;padding:0.25rem 0.5rem;background-color:transparent}.bhtp-ui-multi-select-dropdown-input .bhtp-ui-multi-select-dropdown-item.bhtp-ui-multi-select-dropdown-item--active{background-color:rgba(54, 79, 120, 0.2)}:host{display:block;font-family:var(--bhtp-ui-primary-font-family)}bhtp-ui-typeahead input{width:100%}bhtp-ui-typeahead input:focus{border-bottom:1px solid var(--bhtp-ui-primary-color)}.bhtp-ui-typeahead-no-results{position:absolute}";

let BhtpTypeahead = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.selected = createEvent(this, "selected", 7);
    this.unselected = createEvent(this, "unselected", 7);
    this.activeIndex = -1;
    this.data = [];
    this.active = false;
    this.searchCompletedForInput = false;
    /**
     * The text is displayed by the form field for users
     */
    this.text = "";
    /**
     * The actual value of the form field
     */
    this.value = null;
    /**
     * The placeholder for the input field
     */
    this.placeholder = "";
    /**
     * Enable/Disable the input field
     */
    this.disabled = false;
    /**
     * The minimum input size for generating suggestions
     */
    this.minInput = 0;
    /**
     * The maximally shown suggestions in the list
     */
    this.maxSuggestions = 5;
    /**
     * Form validation: is the form input required
     */
    this.required = false;
    this.invalid = undefined;
    /**
     * id of the input field
     */
    this.inputId = "";
    /**
     * The class names, which should be set on the rendered html elements
     */
    this.cssClasses = {
      wrapper: "",
      input: "",
      suggestions: "suggestions",
      suggestion: "suggestion",
      active: "active"
    };
  }
  /**
   * Returns the `value` of the selected item
   */
  async getValue() {
    return this.value;
  }
  /**
   * Returns the `text` of the selected item
   */
  async getText() {
    return this.text;
  }
  /**
   * Clears the form field (suggestions and selection)
   */
  async clear() {
    this.handleClose();
  }
  async focusInput() {
    this.inputRef.scrollIntoView({ block: "center" });
    setTimeout(() => {
      this.inputRef.focus();
    }, 100);
  }
  get listboxId() {
    return `${this.inputId}-listbox`;
  }
  get allowHoverClass() {
    return `${this.cssClasses.suggestions}--allow-hover`;
  }
  // @ts-ignore
  handleKeyDown(event, keyCode) {
    if (keyCode == KeyCodes.ARROW_DOWN || keyCode == KeyCodes.ARROW_UP) {
      // @ts-ignore
      event.preventDefault();
      this.handleActivation(keyCode == KeyCodes.ARROW_DOWN);
    }
    else if (keyCode == KeyCodes.ENTER || (keyCode == KeyCodes.TAB && this.activeIndex >= 0)) { // enter or tab when there's a suggestion available
      // @ts-ignore
      if (keyCode == KeyCodes.ENTER) {
        event.preventDefault();
      }
      this.handleSelection(this.activeIndex, event, false);
    }
    else if (keyCode == KeyCodes.ESCAPE) {
      this.handleClose();
    }
  }
  // @ts-ignore
  handleKeyUp(keyCode, text) {
    if (this.text !== text) {
      this.searchCompletedForInput = false;
      this.clearSelection(true);
      this.prepareSuggestions(text);
    }
    this.active = true;
    this.text = text;
  }
  handleFocus(e) {
    e.preventDefault();
    this.active = true;
  }
  handleBlur(e) {
    if (this.activeIndex == -1) {
      e.preventDefault();
    }
    if (this.active) {
      if (this.value) {
        this.clearData();
      }
      else {
        if (this.activeIndex >= 0) {
          this.handleSelection(this.activeIndex, e, true);
        }
        this.handleClose();
      }
    }
  }
  handleClose() {
    if (!this.value) {
      this.clearSelection();
    }
    this.clearData();
  }
  handleActivation(next = true) {
    if (this.data.length > 0) {
      const suggestionsElement = this.hostElement.querySelector(`.${this.cssClasses.suggestions}`);
      if (suggestionsElement) {
        suggestionsElement.classList.remove(this.allowHoverClass);
      }
      if (next && (this.activeIndex + 1) < this.data.length) {
        this.activeIndex += 1;
      }
      else if (next) {
        this.activeIndex = 0;
      }
      else if (!next && (this.activeIndex) > 0) {
        this.activeIndex -= 1;
      }
      else if (!next) {
        this.activeIndex = this.data.length - 1;
      }
    }
  }
  // @ts-ignore
  handleSelection(index, event, skipFocus) {
    var _a;
    if (index >= 0 && index < this.data.length) {
      event.stopPropagation();
      this.text = this.data[index].text;
      this.value = this.data[index].value;
      this.selected.emit(this.data[index]);
      this.clearData();
      // Return focus to input after selection
      if (!skipFocus) {
        (_a = this.hostElement.querySelector(`#${this.inputId}`)) === null || _a === void 0 ? void 0 : _a.focus();
      }
    }
  }
  clearData() {
    this.data = [];
    this.activeIndex = -1;
    this.active = false;
    this.searchCompletedForInput = false;
  }
  clearSelection(clearOnlyValue = false) {
    if (this.value != "") {
      this.unselected.emit({
        text: this.text,
        value: this.value
      });
      this.value = "";
    }
    if (!clearOnlyValue) {
      this.text = "";
    }
  }
  // @ts-ignore
  async prepareSuggestions(text) {
    if (this.suggestionGenerator && text.length >= this.minInput) {
      let suggestions = await this.suggestionGenerator(text);
      suggestions.splice(this.maxSuggestions);
      this.data = suggestions;
      this.activeIndex = this.data.length > 0 ? 0 : -1;
      this.searchCompletedForInput = true;
    }
    else {
      this.data = [];
    }
  }
  onSuggestionsMouseMove(mouseEvent) {
    const ulElement = mouseEvent.target;
    ulElement.classList.add(this.allowHoverClass);
    const activeElement = ulElement.querySelector(`.${this.cssClasses.active}`);
    if (activeElement) {
      activeElement.classList.toggle(this.cssClasses.active);
    }
  }
  render() {
    var _a;
    return (h("div", { class: this.cssClasses.wrapper }, h("div", { role: "combobox", "aria-expanded": (this.data && this.data.length > 0).toString(), "aria-owns": this.listboxId, "aria-haspopup": "listbox" }, h("input", { type: "text", value: this.text, class: this.cssClasses.input, ref: (element) => this.inputRef = element, onKeyDown: (e) => this.handleKeyDown(e, e.keyCode),
      // @ts-ignore
      onKeyUp: (e) => this.handleKeyUp(e.keyCode, e.target['value']), onBlur: (e) => { this.handleBlur(e); }, onFocus: (e) => { this.handleFocus(e); }, inputMode: this.inputmode, id: this.inputId, "aria-controls": this.listboxId, "aria-activedescendant": `suggestion-${this.activeIndex}`, "aria-required": (this.required === true).toString(), "aria-invalid": (this.invalid === true).toString(), autocomplete: "off", disabled: this.disabled, placeholder: this.placeholder })), this.data && this.data.length > 0
      ? h("ul", { id: this.listboxId, class: this.cssClasses.suggestions, role: "listbox", onMouseMove: event => this.onSuggestionsMouseMove(event) }, this.data.map((suggestion, index) => {
        return (h("li", { id: `suggestion-${index}`, role: "option", onMouseMove: () => this.activeIndex = index, class: this.cssClasses.suggestion + (this.activeIndex == index ? (" " + this.cssClasses.active) : ""), "data-value": suggestion.value }, h("button", { onClick: (event) => this.handleSelection(index, event, false), tabIndex: -1, type: "button" }, suggestion.suggestion ? suggestion.suggestion : suggestion.text)));
      }))
      : this.searchCompletedForInput && ((_a = this.text) === null || _a === void 0 ? void 0 : _a.length) > 0 ? h("div", { class: "bhtp-ui-typeahead-no-results" }, "No Results") : ""));
  }
  get hostElement() { return getElement(this); }
};
BhtpTypeahead.style = typeaheadComponentCss;

export { QuoteCta as bhtp_quote_cta, Button as bhtp_ui_button, DateInput as bhtp_ui_date_input, DateRangeInput as bhtp_ui_date_range_input, DestinationInput as bhtp_ui_destination_input, DropdownInput as bhtp_ui_dropdown_input, FormError as bhtp_ui_form_error, Icon as bhtp_ui_icon, BhtpUiIconBirthdayCake as bhtp_ui_icon_birthday_cake, BhtpUiIconCalendar as bhtp_ui_icon_calendar, BhtpUiIconHelpOutline as bhtp_ui_icon_help_outline, BhtpUiX as bhtp_ui_icon_x, Modal as bhtp_ui_modal, MultiSelectDropdownInput as bhtp_ui_multi_select_dropdown_input, NumberInput as bhtp_ui_number_input, TextInput as bhtp_ui_text_input, TooltipModal as bhtp_ui_tooltip_modal, BhtpTypeahead as bhtp_ui_typeahead };
